
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("9zU5G", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6SsN4 = parcelRequire("6SsN4");


var $ixfCV = parcelRequire("ixfCV");


var $2tuSz = parcelRequire("2tuSz");

var $lUcpS = parcelRequire("lUcpS");


var $cP7Ln = parcelRequire("cP7Ln");


var $jp2Q3 = parcelRequire("jp2Q3");


var $d5gEx = parcelRequire("d5gEx");


var $eRfpr = parcelRequire("eRfpr");


var $kKnPE = parcelRequire("kKnPE");


var $1koI0 = parcelRequire("1koI0");








var $4nIKB = parcelRequire("4nIKB");


var $5wHqn = parcelRequire("5wHqn");


var $lfoFx = parcelRequire("lfoFx");


var $bPFqZ = parcelRequire("bPFqZ");








var $cbY7C = parcelRequire("cbY7C");




/**
 * Hook for managing delayed hover actions with timeout management.
 */ function $fbe210b577774235$export$beb151954e0eb9fa(callback, delay) {
    const timeoutRef = (0, $cozmU.useRef)(null);
    const callbackRef = (0, $cozmU.useRef)(callback);
    (0, $cozmU.useEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    const clear = (0, $cozmU.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);
    const schedule = (0, $cozmU.useCallback)(()=>{
        clear();
        timeoutRef.current = window.setTimeout(()=>{
            callbackRef.current();
        }, delay);
    }, [
        delay,
        clear
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>clear();
    }, [
        clear
    ]);
    return {
        schedule: schedule,
        clear: clear
    };
}


/**
 * Type guard to check if an event has a relatedTarget property.
 */ function $f8cd8f219c17c077$export$63ce2e5e32c4f6a0(event) {
    return 'relatedTarget' in event;
}
/**
 * Checks if the mouse is moving to an atlaskit portal or kudos modal
 * where we should prevent the popup from closing
 */ function $f8cd8f219c17c077$export$386001e6036bddcf(relatedTarget) {
    if (!(relatedTarget instanceof HTMLElement)) return false;
    const iframe = relatedTarget.closest('.atlaskit-portal')?.querySelector('iframe') || relatedTarget.closest('iframe');
    return iframe instanceof HTMLIFrameElement && iframe.src.includes('give-kudos');
}
/**
 * Returns the child portal if mouse is moving to a portal controlled by the parent popup.
 */ function $f8cd8f219c17c077$export$a5fb0bbf4bb0e26a(relatedTarget, parentPopupElement) {
    if (!(relatedTarget instanceof HTMLElement) || !parentPopupElement) return null;
    const portal = relatedTarget.closest('.atlaskit-portal');
    if (!portal) return null;
    for (const trigger of parentPopupElement.querySelectorAll('[aria-controls]')){
        const controlsId = trigger.getAttribute('aria-controls');
        if (controlsId && portal.querySelector(`#${controlsId}`)) return portal;
    }
    return null;
}


const $22229f34ce9f6ca7$var$HOVER_OPEN_DELAY = 800;
const $22229f34ce9f6ca7$var$HOVER_CLOSE_DELAY = 200;
function $22229f34ce9f6ca7$export$b8df9ab832b125ac({ onOpen: onOpen, onClose: onClose, isOpen: isOpen = false, isDisabled: isDisabled = false, openedByRef: openedByRef, delays: delays = {} }) {
    const { hoverOpen: hoverOpen = $22229f34ce9f6ca7$var$HOVER_OPEN_DELAY, hoverClose: hoverClose = $22229f34ce9f6ca7$var$HOVER_CLOSE_DELAY } = delays;
    const triggerNodeRef = (0, $cozmU.useRef)(null);
    const triggerListeners = (0, $cozmU.useRef)([]);
    const contentNodeRef = (0, $cozmU.useRef)(null);
    const contentListeners = (0, $cozmU.useRef)(new Map());
    const isOpenRef = (0, $cozmU.useRef)(isOpen);
    (0, $cozmU.useLayoutEffect)(()=>{
        isOpenRef.current = isOpen;
    }, [
        isOpen
    ]);
    const openDelay = (0, $fbe210b577774235$export$beb151954e0eb9fa)(()=>{
        if (isOpenRef.current) return;
        if (openedByRef) openedByRef.current = 'hover';
        onOpen();
    }, hoverOpen);
    const closeDelay = (0, $fbe210b577774235$export$beb151954e0eb9fa)(()=>{
        if (!isOpenRef.current) return;
        if (!openedByRef || openedByRef.current === 'hover') onClose?.();
    }, hoverClose);
    const openDelayRef = (0, $cozmU.useRef)(openDelay);
    const closeDelayRef = (0, $cozmU.useRef)(closeDelay);
    openDelayRef.current = openDelay;
    closeDelayRef.current = closeDelay;
    const handleTriggerEnter = (0, $cozmU.useCallback)(()=>{
        closeDelayRef.current.clear();
        openDelayRef.current.schedule();
    }, []);
    const handleTriggerLeave = (0, $cozmU.useCallback)(()=>{
        openDelayRef.current.clear();
        closeDelayRef.current.schedule();
    }, []);
    const triggerRef = (0, $cozmU.useCallback)((element)=>{
        if (element === triggerNodeRef.current) return;
        triggerListeners.current.forEach((unbind)=>unbind());
        triggerListeners.current = [];
        triggerNodeRef.current = element;
        if (element && !isDisabled) triggerListeners.current.push((0, $cbY7C.bind)(element, {
            type: 'mouseenter',
            listener: handleTriggerEnter
        }), (0, $cbY7C.bind)(element, {
            type: 'mouseleave',
            listener: handleTriggerLeave
        }));
    }, [
        handleTriggerEnter,
        handleTriggerLeave,
        isDisabled
    ]);
    const handleContentEnter = (0, $cozmU.useCallback)(()=>{
        closeDelayRef.current.clear();
    }, []);
    const cleanupContentListeners = (0, $cozmU.useCallback)(()=>{
        contentListeners.current.forEach((unbind)=>unbind());
        contentListeners.current.clear();
    }, []);
    const attachContentListeners = (0, $cozmU.useCallback)((element)=>{
        if (contentListeners.current.has(element)) return;
        const handleMouseLeave = (event)=>{
            if (!(0, $f8cd8f219c17c077$export$63ce2e5e32c4f6a0)(event)) return;
            const relatedTarget = event.relatedTarget;
            if ((0, $f8cd8f219c17c077$export$386001e6036bddcf)(relatedTarget)) return;
            const childPortal = (0, $f8cd8f219c17c077$export$a5fb0bbf4bb0e26a)(relatedTarget, contentNodeRef.current);
            if (childPortal) {
                attachContentListeners(childPortal);
                return;
            }
            closeDelayRef.current.schedule();
        };
        const unbindEnter = (0, $cbY7C.bind)(element, {
            type: 'mouseenter',
            listener: handleContentEnter
        });
        const unbindLeave = (0, $cbY7C.bind)(element, {
            type: 'mouseleave',
            listener: handleMouseLeave
        });
        contentListeners.current.set(element, ()=>{
            unbindEnter();
            unbindLeave();
        });
    }, [
        handleContentEnter
    ]);
    const contentRef = (0, $cozmU.useCallback)((element)=>{
        if (element === contentNodeRef.current) return;
        cleanupContentListeners();
        contentNodeRef.current = element;
        if (element && !isDisabled) attachContentListeners(element);
    }, [
        attachContentListeners,
        cleanupContentListeners,
        isDisabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        const listeners = contentListeners.current;
        const triggers = triggerListeners.current;
        return ()=>{
            openDelayRef.current.clear();
            closeDelayRef.current.clear();
            triggers.forEach((unbind)=>unbind());
            listeners.forEach((unbind)=>unbind());
        };
    }, []);
    return {
        triggerRef: triggerRef,
        contentRef: contentRef
    };
}








const $9d9cee0460225a57$var$PRELOAD_MAX_AGE = 300000;
const $9d9cee0460225a57$var$TIME_TO_INTENT = 200;
function $9d9cee0460225a57$export$e0cecaf2b8cc8d36({ load: load, onLoad: onLoad }) {
    const nodeRef = (0, $cozmU.useRef)(null);
    const eventListeners = (0, $cozmU.useRef)([]);
    const { loadAndOpen: loadAndOpen, preloadReference: preloadReference, cancelPreload: cancelPreload } = (0, $cozmU.useMemo)(()=>{
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const loadAndOpen = ()=>{
            clearPreloadTimeouts();
            onLoad(loadReference());
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $9d9cee0460225a57$var$PRELOAD_MAX_AGE);
            }, $9d9cee0460225a57$var$TIME_TO_INTENT);
        };
        return {
            loadAndOpen: loadAndOpen,
            preloadReference: preloadReference,
            cancelPreload: cancelPreload
        };
    }, [
        load,
        onLoad
    ]);
    const cleanUpEventListeners = (0, $cozmU.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $cozmU.useCallback)((element, type, callback)=>{
        const unbind = (0, $cbY7C.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $cozmU.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) {
                cancelPreload();
                cleanUpEventListeners();
            }
            if (element) {
                addEventListener(element, 'mouseenter', preloadReference);
                addEventListener(element, 'mouseleave', cancelPreload);
            }
            nodeRef.current = element;
        }
    }, [
        preloadReference,
        cancelPreload,
        addEventListener,
        cleanUpEventListeners
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return Object.assign(refCallback, {
        loadAndOpen: loadAndOpen
    });
}








function $7a1ca360af3a875a$export$186b93979375b734({ onOpen: onOpen, onClose: onClose, isOpen: isOpen = false, isDisabled: isDisabled = false, openedByRef: openedByRef }) {
    const nodeRef = (0, $cozmU.useRef)(null);
    const eventListeners = (0, $cozmU.useRef)([]);
    const handleOpen = (0, $cozmU.useCallback)(()=>{
        if (isOpen) onClose?.();
        else {
            if (openedByRef) openedByRef.current = 'click';
            onOpen();
        }
    }, [
        isOpen,
        onClose,
        openedByRef,
        onOpen
    ]);
    const keydownListener = (0, $cozmU.useCallback)((event)=>{
        if (event instanceof KeyboardEvent && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            handleOpen();
        }
    }, [
        handleOpen
    ]);
    const cleanUpEventListeners = (0, $cozmU.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $cozmU.useCallback)((element, type, callback)=>{
        const unbind = (0, $cbY7C.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $cozmU.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) cleanUpEventListeners();
            if (element) {
                if (!isDisabled) addEventListener(element, 'click', handleOpen);
                addEventListener(element, 'keydown', keydownListener);
            }
            nodeRef.current = element;
        }
    }, [
        handleOpen,
        keydownListener,
        addEventListener,
        cleanUpEventListeners,
        isDisabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return refCallback;
}


const $27e61bc51882f5fe$var$emptyEntryPointParams = {};
const $27e61bc51882f5fe$var$emptyEntryPointProps = {};
const $27e61bc51882f5fe$var$FallbackComponent = ({ fallback: fallback, onUnmount: onUnmount })=>{
    (0, $cozmU.useEffect)(()=>{
        return ()=>onUnmount();
    }, [
        onUnmount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, fallback || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), null));
};
function $27e61bc51882f5fe$export$afca832e0d04586a({ trigger: trigger, triggerMode: triggerMode, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, onError: onError, forcedReportErrorUFO: forcedReportErrorUFO, onOpen: onOpen, onClose: onClose, ...popupProps }) {
    const environmentProvider = (0, $d5gEx.useRelayEnvironmentProvider)();
    const id = (0, $cozmU.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [content, setContent] = (0, $cozmU.useState)(null);
    const updateRef = (0, $cozmU.useRef)(null);
    const openedByRef = (0, $cozmU.useRef)(null);
    const triggers = Array.isArray(triggerMode) ? triggerMode : [
        triggerMode
    ];
    const handleOpen = (0, $cozmU.useCallback)((method)=>{
        setIsOpen(true);
        if (method) onOpen?.(method);
    }, [
        onOpen
    ]);
    const handleClose = (0, $cozmU.useCallback)((event, currentLevel)=>{
        setIsOpen(false);
        onClose?.(event ?? null, currentLevel);
    }, [
        onClose
    ]);
    const load = (0, $cozmU.useCallback)(()=>(0, $6SsN4.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $27e61bc51882f5fe$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $cozmU.useCallback)(({ reference: entryPointReference })=>{
        if (isOpen) return;
        handleOpen(openedByRef.current);
        setContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bPFqZ.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($27e61bc51882f5fe$var$FallbackComponent, {
                fallback: fallback,
                onUnmount: ()=>updateRef.current?.()
            }),
            errorFallback: errorFallback,
            runtimeProps: {
                ...entryPointProps ?? $27e61bc51882f5fe$var$emptyEntryPointProps,
                onContentResized: ()=>{
                    updateRef.current?.();
                },
                onClose: handleClose
            },
            onError: onError,
            forcedError: forcedReportErrorUFO
        }));
    }, [
        setContent,
        id,
        isOpen,
        entryPointProps,
        fallback,
        forcedReportErrorUFO,
        errorFallback,
        handleOpen,
        onError,
        handleClose
    ]);
    const preloadRef = (0, $9d9cee0460225a57$export$e0cecaf2b8cc8d36)({
        load: load,
        onLoad: onLoad
    });
    const pressableRef = (0, $7a1ca360af3a875a$export$186b93979375b734)({
        onOpen: preloadRef.loadAndOpen,
        onClose: handleClose,
        isOpen: isOpen,
        isDisabled: !triggers.includes('click'),
        openedByRef: openedByRef
    });
    const { triggerRef: hoverTriggerRef, contentRef: hoverContentRef } = (0, $22229f34ce9f6ca7$export$b8df9ab832b125ac)({
        onOpen: preloadRef.loadAndOpen,
        onClose: handleClose,
        isOpen: isOpen,
        isDisabled: !triggers.includes('hover'),
        openedByRef: openedByRef
    });
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen) openedByRef.current = null;
    }, [
        isOpen
    ]);
    const popupTrigger = (0, $cozmU.useCallback)((triggerProps)=>{
        const mergedRef = (0, $4nIKB.mergeRefs)([
            preloadRef,
            pressableRef,
            hoverTriggerRef,
            triggerProps.ref
        ]);
        return trigger({
            ...triggerProps,
            ref: mergedRef
        });
    }, [
        trigger,
        preloadRef,
        pressableRef,
        hoverTriggerRef
    ]);
    const popupContent = (0, $cozmU.useCallback)(({ update: update })=>{
        updateRef.current = update;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: hoverContentRef,
            role: "none"
        }, content);
    }, [
        content,
        hoverContentRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.Popup), {
        ...popupProps,
        isOpen: isOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        content: popupContent
    });
}



var $bIiaK = parcelRequire("bIiaK");


var $9gll8 = parcelRequire("9gll8");


var $bXEsj = parcelRequire("bXEsj");


var $3Z1Pc = parcelRequire("3Z1Pc");


var $fxdou = parcelRequire("fxdou");

/* UserProfileCardTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");

const $e5738d39a9fd0a96$var$styles = {
    trigger: "_kkk2n7od _1e0c1nu9"
};
const $e5738d39a9fd0a96$export$d5e867b0afea0b23 = ({ trigger: trigger, triggerProps: triggerProps, children: children, ariaHideProfileTrigger: ariaHideProfileTrigger })=>{
    const hoverOnlyTrigger = Array.isArray(trigger) ? trigger.every((mode)=>mode === 'hover') : trigger === 'hover';
    const useNonInteractiveHoverTrigger = hoverOnlyTrigger;
    if (useNonInteractiveHoverTrigger) {
        const { 'aria-expanded': _ariaExpanded, ...nonDialogTriggerProps } = triggerProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            as: "span",
            ...nonDialogTriggerProps,
            testId: "user-profile-card-trigger-wrapper",
            xcss: $e5738d39a9fd0a96$var$styles.trigger,
            "aria-hidden": ariaHideProfileTrigger ? true : undefined,
            tabIndex: ariaHideProfileTrigger ? -1 : undefined
        }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
        ...triggerProps,
        testId: "user-profile-card-trigger-wrapper",
        xcss: $e5738d39a9fd0a96$var$styles.trigger,
        "aria-hidden": ariaHideProfileTrigger ? true : undefined,
        tabIndex: ariaHideProfileTrigger ? -1 : undefined
    }, children);
};


function $b98ac5af1bd78598$export$74fa5d03ff375804({ isVisible: isVisible, ...props }) {
    const hostRelayEnvironment = (0, $cozmU.useContext)((0, $6SsN4.ReactRelayContext))?.environment;
    if (isVisible === false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b98ac5af1bd78598$var$UserProfileCardWithTriggerInner, {
        ...props,
        hostRelayEnvironment: hostRelayEnvironment
    }));
}
/** Inner implementation of {@link UserProfileCardWithTrigger}. */ function $b98ac5af1bd78598$var$UserProfileCardWithTriggerInner({ hostRelayEnvironment: hostRelayEnvironment, userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId, trigger: trigger, placement: placement = 'bottom-start', shouldRenderToParent: shouldRenderToParent = false, children: children, testId: testId, townsquareApp: townsquareApp, onProfileClick: onProfileClick, agent: agent, actions: actions, ariaHideProfileTrigger: ariaHideProfileTrigger }) {
    const PopupTriggerWithHover = (0, $ixfCV.fg)('people-teams_migrate-popup-adaptor-package') ? (0, $cP7Ln.PopupTriggerWithHover) : (0, $27e61bc51882f5fe$export$afca832e0d04586a);
    const resolvedTriggerMode = trigger ?? 'click';
    const relayWrappedChildren = hostRelayEnvironment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6SsN4.RelayEnvironmentProvider), {
        environment: hostRelayEnvironment
    }, children) : children;
    const entryPointErrorFallback = (0, $cozmU.useCallback)((_props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Z1Pc.CardError), {
            testId: testId
        }), [
        testId
    ]);
    const getTestId = (0, $cozmU.useMemo)(()=>(0, $bXEsj.makeGetTestId)(userId, testId), [
        userId,
        testId
    ]);
    // `triggerMethod` is the actual open method ('click' | 'hover') reported by the popup
    // adapter. It stays `undefined` until the first open so we never report a trigger-mode
    // value (e.g. 'preload-on-hover') as if it were an open method. This is hoisted onto
    // `TeamsAppAnalyticsContext.attributes` below so every analytics event fired beneath
    // the popup picks it up automatically without each event having to attach it manually.
    const [triggerMethod, setTriggerMethod] = (0, $cozmU.useState)(undefined);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            cloudId: cloudId ?? '',
            townsquareApp: townsquareApp,
            onProfileClick: onProfileClick,
            getTestId: getTestId
        }), [
        cloudId,
        townsquareApp,
        onProfileClick,
        getTestId
    ]);
    const analyticsContextData = (0, $cozmU.useMemo)(()=>({
            source: 'userProfileCard',
            attributes: {
                cloudId: cloudId ?? '',
                userId: userId,
                viewerId: viewerId ?? '',
                // Only attach `method` once an actual open has occurred so SLO dashboards never
                // see a synthetic method on pre-open events (e.g. preload).
                ...triggerMethod !== undefined ? {
                    method: triggerMethod
                } : {}
            }
        }), [
        cloudId,
        viewerId,
        userId,
        triggerMethod
    ]);
    if (!userId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, relayWrappedChildren);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, relayWrappedChildren)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9gll8.UserProfileCardContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2tuSz.TeamsAppAnalyticsContext), {
        data: analyticsContextData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bIiaK.CardOpenTimerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b98ac5af1bd78598$var$UserProfileCardPopupWithAnalytics, {
        PopupTriggerWithHover: PopupTriggerWithHover,
        entryPointParams: {
            userId: userId,
            cloudId: cloudId,
            orgId: orgId,
            viewerId: viewerId
        },
        entryPointProps: {
            cloudId: cloudId ?? '',
            viewerId: viewerId,
            testId: testId,
            agent: agent,
            actions: actions
        },
        placement: placement,
        shouldRenderToParent: shouldRenderToParent,
        triggerMode: resolvedTriggerMode,
        errorFallback: entryPointErrorFallback,
        onTriggerMethodChange: setTriggerMethod,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e5738d39a9fd0a96$export$d5e867b0afea0b23), {
                trigger: resolvedTriggerMode,
                triggerProps: triggerProps,
                ariaHideProfileTrigger: ariaHideProfileTrigger
            }, relayWrappedChildren)
    })))));
}
function $b98ac5af1bd78598$var$UserProfileCardPopupWithAnalytics({ PopupTriggerWithHover: PopupTriggerWithHover, entryPointParams: entryPointParams, entryPointProps: entryPointProps, placement: placement, shouldRenderToParent: shouldRenderToParent, triggerMode: triggerMode, errorFallback: errorFallback, onTriggerMethodChange: onTriggerMethodChange, trigger: trigger }) {
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { markInteractionStart: markInteractionStart } = (0, $bIiaK.useCardOpenTimer)();
    const fireTriggeredRequest = (0, $kKnPE.useFireTriggeredRequest)();
    const handleOpen = (0, $cozmU.useCallback)((method)=>{
        // t=0 for all downstream `duration` measurements.
        markInteractionStart();
        onTriggerMethodChange(method);
        // `method` is attached inline because the context update from
        // `onTriggerMethodChange` has not propagated yet at this exact moment.
        fireEvent('ui.profilecard.triggered', {
            firedAt: (0, $eRfpr.firedAt)(),
            method: method
        });
        fireTriggeredRequest();
    }, [
        fireEvent,
        fireTriggeredRequest,
        markInteractionStart,
        onTriggerMethodChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PopupTriggerWithHover, {
        entryPoint: (0, $1koI0.entryPoint),
        placement: placement,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fxdou.CardLoading), {
            testId: entryPointProps.testId ?? ''
        }),
        errorFallback: errorFallback,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        shouldRenderToParent: shouldRenderToParent,
        shouldUseCaptureOnOutsideClick: true,
        triggerMode: triggerMode,
        onOpen: handleOpen,
        trigger: trigger,
        zIndex: (0, $jp2Q3.layers).modal()
    });
}
module.exports["UserProfileCardWithTrigger"] = $b98ac5af1bd78598$export$74fa5d03ff375804;

});

parcelRegister("g0RaX", function(module, exports) {
const $d415e99ed33e2323$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $d415e99ed33e2323$var$performanceAvailable = $d415e99ed33e2323$var$isPerformanceAvailable();
const $d415e99ed33e2323$var$initialPageTime = Date.now();
const $d415e99ed33e2323$export$e9faea7c41053334 = ()=>{
    if ($d415e99ed33e2323$var$performanceAvailable) return performance.now();
    return Date.now() - $d415e99ed33e2323$var$initialPageTime;
};
module.exports["getPageTime"] = $d415e99ed33e2323$export$e9faea7c41053334;

});

parcelRegister("1koI0", function(module, exports) {

var $7qZTr = parcelRequire("7qZTr");


var $ONTtp = parcelRequire("ONTtp");


var $i70Es = parcelRequire("i70Es");


var $454YE = parcelRequire("454YE");

const $0a94c1ac318e85a1$var$fetchPolicy = 'store-or-network';

const $0a94c1ac318e85a1$export$6333901e831d7af0 = (0, $ONTtp.createEntryPoint)({
    root: (0, $7qZTr.JSResourceForInteraction)(()=>(parcelRequire("7lnAX")), {
        moduleId: "0e8b22f8",
        moduleName: "UserProfileCardEntryPoint",
        priority: "interaction",
        moduleId: 'user-profile-card-entrypoint'
    }),
    getPreloadProps: ({ userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId })=>{
        const variables = (0, $i70Es.buildQueryVariables)({
            userId: userId,
            cloudId: cloudId,
            orgId: orgId,
            viewerId: viewerId
        });
        return {
            queries: {
                queryRef: {
                    parameters: $454YE.default,
                    variables: variables,
                    options: {
                        fetchPolicy: $0a94c1ac318e85a1$var$fetchPolicy
                    }
                }
            }
        };
    }
});
module.exports["entryPoint"] = $0a94c1ac318e85a1$export$6333901e831d7af0;

});

parcelRegister("i70Es", function(module, exports) {
/**
 * @generated SignedSource<<b67d3ed5d4d3c2f6f15ddbf9a2826490>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fc0ddde612e6bc48$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    }, v1 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v2 = {
        "kind": "ScalarField",
        "name": "jobTitle"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "base"
        },
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ], v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluencePageLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v4 /*: any*/ 
            }
        ],
        "type": "ConfluencePage"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluenceBlogPostLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v4 /*: any*/ 
            }
        ],
        "type": "ConfluenceBlogPost"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluenceWhiteboardLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v4 /*: any*/ 
            }
        ],
        "type": "ConfluenceWhiteboard"
    }, v8 = [
        {
            "concreteType": "ConfluenceCommentLinks",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": v4 /*: any*/ 
        },
        {
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ]
        }
    ], v9 = [
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v11 = [
        v10 /*: any*/ 
    ], v12 = [
        v10 /*: any*/ ,
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": v11 /*: any*/ 
        }
    ], v13 = [
        {
            "alias": "trelloUrl",
            "kind": "ScalarField",
            "name": "url"
        }
    ], v14 = [
        {
            "alias": "webUrl",
            "kind": "ScalarField",
            "name": "url"
        }
    ], v15 = [
        {
            "concreteType": "AssetsLinks",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "web"
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "orgId"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "skipKnowledgeDiscovery"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "userAri"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "userId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "userIdString"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "viewerId"
            }
        ],
        "kind": "Fragment",
        "name": "UserProfileCardRelay_query",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "accountId",
                        "variableName": "userId"
                    }
                ],
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "accountStatus"
                    },
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "email"
                            },
                            {
                                "concreteType": "AtlassianAccountUserExtendedProfile",
                                "kind": "LinkedField",
                                "name": "extendedProfile",
                                "plural": false,
                                "selections": [
                                    v2 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "department"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "location"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "organization"
                                    }
                                ]
                            }
                        ],
                        "type": "AtlassianAccountUser"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "appType"
                            }
                        ],
                        "type": "AppUser"
                    }
                ]
            },
            {
                "concreteType": "Activity",
                "kind": "LinkedField",
                "name": "activity",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "fields": [
                                    {
                                        "items": [
                                            {
                                                "kind": "Variable",
                                                "name": "actors.0",
                                                "variableName": "userAri"
                                            }
                                        ],
                                        "kind": "ListValue",
                                        "name": "actors"
                                    }
                                ],
                                "kind": "ObjectValue",
                                "name": "filter"
                            },
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 50
                            }
                        ],
                        "concreteType": "ActivityConnection",
                        "kind": "LinkedField",
                        "name": "workedOn",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ActivityItemEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "ActivityNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "ActivityObject",
                                                "kind": "LinkedField",
                                                "name": "object",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "data",
                                                        "plural": false,
                                                        "selections": [
                                                            v3 /*: any*/ ,
                                                            v5 /*: any*/ ,
                                                            v6 /*: any*/ ,
                                                            v7 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "ConfluenceDatabaseLinks",
                                                                        "kind": "LinkedField",
                                                                        "name": "links",
                                                                        "plural": false,
                                                                        "selections": v4 /*: any*/ 
                                                                    }
                                                                ],
                                                                "type": "ConfluenceDatabase"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "ConfluenceEmbedLinks",
                                                                        "kind": "LinkedField",
                                                                        "name": "links",
                                                                        "plural": false,
                                                                        "selections": v4 /*: any*/ 
                                                                    }
                                                                ],
                                                                "type": "ConfluenceEmbed"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v8 /*: any*/ ,
                                                                "type": "ConfluenceFooterComment"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v8 /*: any*/ ,
                                                                "type": "ConfluenceInlineComment"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v9 /*: any*/ ,
                                                                "type": "TownsquareGoal"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v9 /*: any*/ ,
                                                                "type": "TownsquareProject"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v9 /*: any*/ ,
                                                                "type": "TownsquareComment"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v11 /*: any*/ ,
                                                                "type": "JiraIssue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v12 /*: any*/ ,
                                                                "type": "JiraPlatformComment"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v12 /*: any*/ ,
                                                                "type": "JiraServiceManagementComment"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v13 /*: any*/ ,
                                                                "type": "TrelloBoard"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v13 /*: any*/ ,
                                                                "type": "TrelloCard"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v14 /*: any*/ ,
                                                                "type": "DevOpsDocument"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v9 /*: any*/ ,
                                                                "type": "ExternalDocument"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v9 /*: any*/ ,
                                                                "type": "DevOpsPullRequestDetails"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v9 /*: any*/ ,
                                                                "type": "ExternalPullRequest"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v14 /*: any*/ ,
                                                                "type": "DevOpsDesign"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v9 /*: any*/ ,
                                                                "type": "ExternalRemoteLink"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v9 /*: any*/ ,
                                                                "type": "MercuryFocusArea"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v9 /*: any*/ ,
                                                                "type": "MercuryPortfolio"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v9 /*: any*/ ,
                                                                "type": "RadarPosition"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v9 /*: any*/ ,
                                                                "type": "RadarView"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v9 /*: any*/ ,
                                                                "type": "CompassComponent"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "href"
                                                                    }
                                                                ],
                                                                "type": "BitbucketPullRequest"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "alias": "loomUrl",
                                                                        "kind": "ScalarField",
                                                                        "name": "url"
                                                                    }
                                                                ],
                                                                "type": "LoomVideo"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v15 /*: any*/ ,
                                                                "type": "AssetsObject"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v15 /*: any*/ ,
                                                                "type": "AssetsObjectType"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v15 /*: any*/ ,
                                                                "type": "AssetsSchema"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "condition": "skipKnowledgeDiscovery",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "KnowledgeDiscoveryQueryApi",
                        "kind": "LinkedField",
                        "name": "knowledgeDiscovery",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "accountId",
                                        "variableName": "userIdString"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "orgId",
                                        "variableName": "orgId"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "requestingUserId",
                                        "variableName": "viewerId"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "tenantId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "kind": "LinkedField",
                                "name": "singleUser",
                                "plural": false,
                                "selections": [
                                    v3 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "concreteType": "KnowledgeDiscoveryUserProfile",
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "KnowledgeDiscoveryUserManager",
                                                        "kind": "LinkedField",
                                                        "name": "manager",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "id"
                                                            },
                                                            v2 /*: any*/ ,
                                                            v1 /*: any*/ ,
                                                            v0 /*: any*/ 
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                                                        "kind": "LinkedField",
                                                        "name": "thirdPartyIntegrations",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "externalId"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "integrationId"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "product"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "KnowledgeDiscoverySingleUser"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$fc0ddde612e6bc48$var$node.hash = "8cfcb5da75258e3dadb27a7ca09a6356";
var $fc0ddde612e6bc48$export$2e2bcd8739ae039 = $fc0ddde612e6bc48$var$node;



var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");








var $9DHhW = parcelRequire("9DHhW");


var $ixfCV = parcelRequire("ixfCV");


var $4PAHv = parcelRequire("4PAHv");


var $3jT9F = parcelRequire("3jT9F");


var $fWkhK = parcelRequire("fWkhK");


var $bPFqZ = parcelRequire("bPFqZ");

function $39b35634554d0ec8$var$AgentCardRelay({ accountId: accountId, cloudId: cloudId, hideStarButton: hideStarButton, hideConversationStarters: hideConversationStarters, onChatClick: onChatClick, onConversationStartersClick: onConversationStartersClick, onViewProfile: onViewProfile, onDuplicate: onDuplicate, onCopyLink: onCopyLink, onEdit: onEdit, onDeleteAgent: onDeleteAgent, renderCTA: renderCTA, renderMoreActions: renderMoreActions }) {
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const entryPointReference = (0, $cozmU.useMemo)(()=>(0, $6SsN4.loadEntryPoint)({
            getEnvironment: ()=>environment
        }, (0, $3jT9F.agentProfileCardEntryPoint), {
            identityAccountId: accountId,
            cloudId: cloudId
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        accountId,
        cloudId
    ]);
    const handleConversationStarterClick = (0, $cozmU.useMemo)(()=>(prompt)=>onConversationStartersClick?.({
                message: prompt,
                type: 'static'
            }), [
        onConversationStartersClick
    ]);
    const handleDelete = (0, $cozmU.useMemo)(()=>onDeleteAgent ? (agentId)=>{
            onDeleteAgent(agentId);
        } : undefined, [
        onDeleteAgent
    ]);
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            action: 'mounted',
            actionSubject: 'agentCardRelay',
            eventType: 'operational',
            attributes: {
                source: 'agentCard'
            }
        }).fire();
        return ()=>{
            entryPointReference.dispose?.();
        };
    }, [
        entryPointReference,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fWkhK.AgentProfileCardSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bPFqZ.InternalEntryPointContainer), {
        id: "agent-profile-card",
        entryPointReference: entryPointReference,
        runtimeProps: {
            cloudId: cloudId,
            identityAccountId: accountId,
            hideStarButton: hideStarButton,
            hideConversationStarters: hideConversationStarters,
            onChatClick: onChatClick,
            onConversationStarterClick: handleConversationStarterClick,
            onViewProfile: onViewProfile,
            onDuplicate: onDuplicate,
            onCopyLink: onCopyLink,
            onEdit: onEdit,
            onDelete: handleDelete,
            renderCTA: renderCTA,
            renderMoreActions: renderMoreActions
        },
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fWkhK.AgentProfileCardSkeleton), null)
    }));
}
function $39b35634554d0ec8$export$4bb3d93416a668a2(props) {
    if ((0, $ixfCV.fg)('rovo_agent_profile_card_relay')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($39b35634554d0ec8$var$AgentCardRelay, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PAHv.AgentProfileCardResourced), props);
}



var $as9lu = parcelRequire("as9lu");


var $3Z1Pc = parcelRequire("3Z1Pc");


var $d35qR = parcelRequire("d35qR");

/* UserProfileCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $9EOlJ = parcelRequire("9EOlJ");


var $arQY7 = parcelRequire("arQY7");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $2tuSz = parcelRequire("2tuSz");

var $lUcpS = parcelRequire("lUcpS");


var $eRfpr = parcelRequire("eRfpr");


var $kKnPE = parcelRequire("kKnPE");


var $eW61a = parcelRequire("eW61a");


var $aIlZA = parcelRequire("aIlZA");




const $95df3807650703a0$export$2b163c291f77b3f9 = (bridge, url, app)=>{
    const sourceApp = app ?? 'teams';
    const buildUrlWithAnalyticsParams = (0, $aIlZA.default)({
        bridge: bridge,
        product: 'townsquare',
        subProduct: sourceApp
    });
    const isCrossAppMauEnabled = (0, $ixfCV.fg)('townsquare_teams_cross_app_mau');
    return app !== undefined && app !== 'teams' && isCrossAppMauEnabled ? buildUrlWithAnalyticsParams(url) : url;
};


const $583e2a6550f59f49$var$shouldOpenInSameTab = (townsquareApp)=>townsquareApp === 'teams' || townsquareApp === 'teams-isolated';
const $583e2a6550f59f49$export$a3989301a7f69ed7 = (userId, cloudId, townsquareApp)=>{
    const { href: rawHref, target: target, onNavigate: onNavigate } = (0, $eW61a.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId
        },
        cloudId: cloudId,
        shouldOpenInSameTab: $583e2a6550f59f49$var$shouldOpenInSameTab(townsquareApp)
    });
    // When no townsquareApp is provided, fall back to `'teams'` for the bridge string so
    // the analytics tag is always a real app name, never the literal `"undefined-customLink"`.
    const bridgeApp = townsquareApp ?? 'teams';
    const wrappedHref = (0, $95df3807650703a0$export$2b163c291f77b3f9)(`${bridgeApp}-customLink`, rawHref, townsquareApp);
    const href = townsquareApp ? wrappedHref : rawHref;
    const isCrossAppMauGateEnabled = Boolean(townsquareApp) && href !== rawHref;
    return {
        href: href,
        target: target,
        onNavigate: onNavigate,
        isCrossAppMauGateEnabled: isCrossAppMauGateEnabled
    };
};



var $bIiaK = parcelRequire("bIiaK");


var $9gll8 = parcelRequire("9gll8");

/** Appends `/work` to a profile URL, preserving any querystring. */ function $45508ebbf47750c1$export$f339ec3b489d28e5(href) {
    if (!href) return href;
    const [pathPart, queryPart] = href.split('?');
    const normalisedPath = pathPart.endsWith('/') ? `${pathPart}work` : `${pathPart}/work`;
    return queryPart === undefined ? normalisedPath : `${normalisedPath}?${queryPart}`;
}



var $bXEsj = parcelRequire("bXEsj");
















function $f6a1f04ce64d6d23$export$2ebec9f03312245c({ testId: testId, errorType: errorType }) {
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        fireEvent('ui.profilecard.rendered.error', {
            firedAt: (0, $eRfpr.firedAt)(),
            errorType: errorType,
            hasRetry: false
        });
    }, [
        fireEvent,
        errorType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Z1Pc.CardError), {
        testId: testId
    });
}



var $fxdou = parcelRequire("fxdou");





var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");




const $dc4ce11f77a04115$var$messages = (0, $kSwu1.defineMessages)({
    accountDeactivated: {
        id: "user-profile-card.DeactivatedStatus.accountDeactivated",
        defaultMessage: "Account deactivated"
    }
});
function $dc4ce11f77a04115$export$3b55902e173dd56e() {
    const intl = (0, $kSwu1.useIntl)();
    const { getTestId: getTestId } = (0, $cozmU.useContext)((0, $9gll8.UserProfileCardContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "neutral",
        testId: getTestId('account-status')
    }, intl.formatMessage($dc4ce11f77a04115$var$messages.accountDeactivated));
}









var $eKMV3 = parcelRequire("eKMV3");

var $7WEaj = parcelRequire("7WEaj");














var $buHp0 = parcelRequire("buHp0");




const $2066a53fd7da0b8e$export$c7eac394c4a88aeb = (townsquareApp)=>{
    // `fireCustomCrossAppAnalytic` needs raw `createAnalyticsEvent`, so this hook
    // intentionally owns the `@atlaskit/analytics-next` dependency.
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    return (0, $cozmU.useCallback)(()=>{
        if (!townsquareApp) return;
        (0, $buHp0.fireCustomCrossAppAnalytic)({
            tags: [
                'townsquare',
                'navigationExperiences'
            ],
            analyticsEventFireName: 'atlas',
            destinationApp: 'teams',
            bridge: `${townsquareApp}-customLink`,
            source: `townsquare-${townsquareApp}`,
            actionSubjectId: 'viewProfileLink',
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        townsquareApp,
        createAnalyticsEvent
    ]);
};












function $5ed6cd0d2efefbfe$export$b33fb54b08bb6422() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M7.71235 13.9487C7.71235 14.8109 7.0155 15.5078 6.15329 15.5078C5.29109 15.5078 4.59424 14.8109 4.59424 13.9487C4.59424 13.0865 5.29109 12.3896 6.15329 12.3896H7.71235V13.9487ZM8.49188 13.9487C8.49188 13.0865 9.18873 12.3896 10.0509 12.3896C10.9131 12.3896 11.61 13.0865 11.61 13.9487V17.8463C11.61 18.7085 10.9131 19.4054 10.0509 19.4054C9.18873 19.4054 8.49188 18.7085 8.49188 17.8463V13.9487Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M10.051 7.68879C9.18882 7.68879 8.49197 6.99194 8.49197 6.12973C8.49197 5.26753 9.18882 4.57068 10.051 4.57068C10.9132 4.57068 11.6101 5.26753 11.6101 6.12973V7.68879H10.051ZM10.051 8.48013C10.9132 8.48013 11.6101 9.17698 11.6101 10.0392C11.6101 10.9014 10.9132 11.5982 10.051 11.5982H6.14157C5.27937 11.5982 4.58252 10.9014 4.58252 10.0392C4.58252 9.17698 5.27937 8.48013 6.14157 8.48013H10.051Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.299 10.0392C16.299 9.17698 16.9959 8.48013 17.8581 8.48013C18.7203 8.48013 19.4171 9.17698 19.4171 10.0392C19.4171 10.9014 18.7203 11.5982 17.8581 11.5982H16.299V10.0392ZM15.5195 10.0392C15.5195 10.9014 14.8226 11.5982 13.9604 11.5982C13.0982 11.5982 12.4014 10.9014 12.4014 10.0392V6.12973C12.4014 5.26753 13.0982 4.57068 13.9604 4.57068C14.8226 4.57068 15.5195 5.26753 15.5195 6.12973V10.0392Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M13.9604 16.2873C14.8226 16.2873 15.5195 16.9841 15.5195 17.8463C15.5195 18.7085 14.8226 19.4054 13.9604 19.4054C13.0982 19.4054 12.4014 18.7085 12.4014 17.8463V16.2873H13.9604ZM13.9604 15.5078C13.0982 15.5078 12.4014 14.8109 12.4014 13.9487C12.4014 13.0865 13.0982 12.3896 13.9604 12.3896H17.8699C18.7321 12.3896 19.4289 13.0865 19.4289 13.9487C19.4289 14.8109 18.7321 15.5078 17.8699 15.5078H13.9604Z",
        fill: "#ECB22E"
    })));
}
function $5ed6cd0d2efefbfe$export$1bcbc9c337da86da() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M14.4626 10.3286H18.3371C18.7032 10.3286 18.9999 10.6308 18.9999 11.0036V14.5978C18.9999 15.9679 17.9093 17.0786 16.564 17.0786H16.5525C15.2072 17.0788 14.1164 15.9682 14.1162 14.5981C14.1162 14.598 14.1162 14.5979 14.1162 14.5978V10.6814C14.1162 10.4866 14.2713 10.3286 14.4626 10.3286Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M17.0815 9.61849C17.9484 9.61849 18.6512 8.90274 18.6512 8.01982C18.6512 7.13689 17.9484 6.42114 17.0815 6.42114C16.2145 6.42114 15.5117 7.13689 15.5117 8.01982C15.5117 8.90274 16.2145 9.61849 17.0815 9.61849Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M12.1976 9.61839C13.4499 9.61839 14.465 8.58453 14.465 7.3092C14.465 6.03386 13.4499 5 12.1976 5C10.9453 5 9.93018 6.03386 9.93018 7.3092C9.93018 8.58453 10.9453 9.61839 12.1976 9.61839Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M15.2211 10.3286H8.82556C8.46387 10.3377 8.17775 10.6434 8.18614 11.0118V15.1111C8.13564 17.3217 9.85286 19.156 12.0233 19.2101C14.1938 19.156 15.911 17.3217 15.8605 15.1111V11.0118C15.8689 10.6434 15.5828 10.3377 15.2211 10.3286Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.1",
        d: "M12.3718 10.3286V16.0732C12.37 16.3366 12.2133 16.5733 11.9741 16.6736C11.8979 16.7064 11.8161 16.7233 11.7334 16.7233H8.49271C8.44736 16.6061 8.4055 16.4888 8.37061 16.368C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.3718Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M12.0229 10.3286V16.4284C12.0229 16.5127 12.0063 16.596 11.9741 16.6736C11.8756 16.9172 11.6432 17.0768 11.3846 17.0786H8.65666C8.59736 16.9613 8.54154 16.8441 8.49271 16.7233C8.44387 16.6025 8.4055 16.4888 8.37061 16.368C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.0229Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M12.0229 10.3286V15.7179C12.0203 16.0759 11.736 16.3653 11.3845 16.368H8.37061C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.0229Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M11.6741 10.3286V15.7179C11.6714 16.0759 11.3872 16.3653 11.0357 16.368H8.37061C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H11.6741Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.1",
        d: "M12.3722 8.49216V9.61123C12.3129 9.61478 12.2571 9.61834 12.1978 9.61834C12.1385 9.61834 12.0827 9.61479 12.0234 9.61123C11.9056 9.60328 11.7889 9.58425 11.6746 9.55439C10.9682 9.38403 10.3846 8.8795 10.1048 8.1973C10.0567 8.08274 10.0193 7.96378 9.99316 7.84204H11.7338C12.0859 7.8434 12.3709 8.13367 12.3722 8.49216Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M12.0231 8.84739V9.6112C11.9053 9.60324 11.7886 9.58422 11.6742 9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.3847C11.7367 8.19862 12.0217 8.4889 12.0231 8.84739Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M12.0231 8.84739V9.6112C11.9053 9.60324 11.7886 9.58422 11.6742 9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.3847C11.7367 8.19862 12.0217 8.4889 12.0231 8.84739Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M11.6742 8.84739V9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.0359C11.3879 8.19863 11.6729 8.48891 11.6742 8.84739Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M4.63941 8.19727H11.0349C11.3881 8.19727 11.6744 8.48882 11.6744 8.84846V15.3618C11.6744 15.7214 11.3881 16.013 11.0349 16.013H4.63941C4.28627 16.013 4 15.7214 4 15.3618V8.84846C4 8.48882 4.28628 8.19727 4.63941 8.19727Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M9.51986 10.6761H8.24137V14.2216H7.42685V10.6761H6.1543V9.98828H9.51986V10.6761Z",
        fill: "white"
    }));
}


const $aa9a50e7a58f2aaa$export$ebea5317ff1808bf = {
    slack: (0, $5ed6cd0d2efefbfe$export$b33fb54b08bb6422),
    teams: (0, $5ed6cd0d2efefbfe$export$1bcbc9c337da86da)
};
function $aa9a50e7a58f2aaa$export$5a867b7c6687d757(integration) {
    return $aa9a50e7a58f2aaa$export$ebea5317ff1808bf[integration];
}


const $9fb9b153af9bf64e$export$596e547f4ce626bc = (integrationId, user)=>{
    if (!integrationId || !user) return;
    const isSlack = integrationId === 'slack';
    const isMsTeams = integrationId === 'teams';
    if (isSlack) {
        const openDmUrl = $9fb9b153af9bf64e$export$9eb522d6e073fba0(user);
        if (openDmUrl) return {
            integration: 'slack',
            openDmUrl: openDmUrl
        };
    } else if (isMsTeams) {
        const openDmUrl = $9fb9b153af9bf64e$export$198aa8f5b10ebb27(user);
        if (openDmUrl) return {
            integration: 'teams',
            openDmUrl: openDmUrl
        };
    }
};
const $9fb9b153af9bf64e$export$9eb522d6e073fba0 = (user)=>{
    const externalId = user?.externalId;
    if (!externalId) return;
    return `https://slack.com/app_redirect?channel=${externalId}`;
};
const $9fb9b153af9bf64e$export$198aa8f5b10ebb27 = (user)=>{
    const email = user?.email;
    if (!email) return;
    return `https://teams.microsoft.com/l/chat/0/0?users=${email}`;
};


const $8b78f8e317e74b4e$var$normalizeProductKey = (product)=>product.trim().toLowerCase();
/**
 * Keeps the first row for each `product` (case-insensitive). Order matches the input array.
 */ function $8b78f8e317e74b4e$var$uniqueRowsByFirstOccurrence(integrations = []) {
    const seen = new Set();
    const out = [];
    for (const row of integrations){
        const key = $8b78f8e317e74b4e$var$normalizeProductKey(row.product);
        if (seen.has(key)) continue;
        seen.add(key);
        out.push(row);
    }
    return out;
}
const $8b78f8e317e74b4e$export$cf50127c50537c52 = [
    'slack',
    'teams'
];
function $8b78f8e317e74b4e$export$523ecfa1815bea06(integrations, email, integrationIdOrder = $8b78f8e317e74b4e$export$cf50127c50537c52) {
    const rows = $8b78f8e317e74b4e$var$uniqueRowsByFirstOccurrence(integrations ? [
        ...integrations
    ] : []);
    for (const id of integrationIdOrder){
        const row = rows.find((r)=>r.integrationId === id);
        if (!row) continue;
        const entry = {
            email: email,
            externalId: row.externalId,
            integrationId: row.integrationId,
            product: row.product
        };
        const dm = (0, $9fb9b153af9bf64e$export$596e547f4ce626bc)(row.integrationId, {
            email: entry.email,
            externalId: entry.externalId
        });
        if (dm) return {
            entry: entry,
            dm: dm
        };
    }
    return undefined;
}









var $1sCHt = parcelRequire("1sCHt");


var $6TaGl = parcelRequire("6TaGl");


var $9d7Pd = parcelRequire("9d7Pd");


var $8oBbn = parcelRequire("8oBbn");


var $6IL1T = parcelRequire("6IL1T");


var $8FgJC = parcelRequire("8FgJC");


var $5wHqn = parcelRequire("5wHqn");





var $jp2Q3 = parcelRequire("jp2Q3");










const $e73bf856672907cd$var$messages = (0, $kSwu1.defineMessages)({
    actionMenuLabel: {
        id: "user-profile-card.ActionMenu.actionMenuLabel",
        defaultMessage: "More actions for {name}"
    }
});
function $e73bf856672907cd$export$ed57a210b9d13bb6({ items: items, name: name }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpen, setOpen] = (0, $cozmU.useState)(false);
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $bIiaK.useCardOpenTimer)();
    const { getTestId: getTestId } = (0, $cozmU.useContext)((0, $9gll8.UserProfileCardContext));
    // Stable callbacks so the inner `Popup` and `IconButton` don't see prop churn each render.
    const handleClose = (0, $cozmU.useCallback)(()=>setOpen(false), []);
    const handleTriggerClick = (0, $cozmU.useCallback)(()=>setOpen((open)=>!open), []);
    const fireActionClick = (0, $cozmU.useCallback)((itemId, hasHref, hasOnClick, index)=>{
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: hasHref,
            hasOnClick: hasOnClick,
            index: index,
            actionId: itemId
        });
    }, [
        fireEvent,
        getDurationSinceInteraction
    ]);
    if (items.length === 0) return null;
    const renderItem = (item, index)=>{
        if (item.kind === 'link') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8oBbn.default), {
            key: item.id,
            href: item.href,
            target: item.target,
            rel: item.target === '_blank' ? 'noopener noreferrer' : undefined,
            testId: getTestId(`menu-item-${item.id}`),
            onClick: (event)=>{
                fireActionClick(item.id, true, Boolean(item.onClick), index);
                item.onClick?.(event);
                setOpen(false);
            }
        }, item.label);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            key: item.id,
            testId: getTestId(`menu-item-${item.id}`),
            onClick: (event)=>{
                fireActionClick(item.id, false, true, index);
                item.onClick(event);
                setOpen(false);
            }
        }, item.label);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        isOpen: isOpen,
        onClose: handleClose,
        placement: "right-start",
        // The host card sits at `layers.modal()` (510) — use `layers.tooltip()` (700) so the
        // action-menu popup stacks above it. `tooltip()` is the conventional next-layer-up in
        // ADS and is forward-compatible with the upcoming top-layer popup mode.
        zIndex: (0, $jp2Q3.layers).tooltip(),
        testId: getTestId('action-menu'),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
                spacing: "cozy"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, items.map(renderItem))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                label: formatMessage($e73bf856672907cd$var$messages.actionMenuLabel, {
                    name: name
                }),
                onClick: handleTriggerClick,
                isSelected: isOpen,
                testId: getTestId('action-menu-trigger')
            })
    });
}









var $bR0Tl = parcelRequire("bR0Tl");


var $6nl31 = parcelRequire("6nl31");

var $as0eE = parcelRequire("as0eE");

const $4f68084afcb13ad1$var$messages = (0, $kSwu1.defineMessages)({
    giveKudosLabel: {
        id: "user-profile-card.useKudosMenuItem.giveKudosLabel",
        defaultMessage: "Give kudos"
    }
});
/**
 * Stable analytics source attributed to kudos drawer events fired from this card.
 */ const $4f68084afcb13ad1$var$ANALYTICS_SOURCE = 'user-profile-card';
function $4f68084afcb13ad1$export$e739febab83b2399({ accountId: accountId, cloudId: cloudId, viewerId: viewerId }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const onClose = (0, $cozmU.useCallback)(()=>setIsOpen(false), []);
    const onOpen = (0, $cozmU.useCallback)(()=>setIsOpen(true), []);
    const recipient = (0, $cozmU.useMemo)(()=>({
            type: (0, $as0eE.KudosType).INDIVIDUAL,
            recipientId: accountId
        }), [
        accountId
    ]);
    const label = formatMessage($4f68084afcb13ad1$var$messages.giveKudosLabel);
    const menuItem = (0, $cozmU.useMemo)(()=>({
            kind: 'button',
            id: 'give-kudos',
            label: label,
            onClick: onOpen
        }), [
        label,
        onOpen
    ]);
    const teamCentralBaseUrl = (0, $bR0Tl.getATLContextUrl)('home');
    const suppressed = !teamCentralBaseUrl || !!viewerId && viewerId === accountId;
    if (suppressed) return {
        menuItem: null,
        launcher: null
    };
    const launcher = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6nl31.GiveKudosLauncherLazy), {
        isOpen: isOpen,
        onClose: onClose,
        recipient: recipient,
        analyticsSource: $4f68084afcb13ad1$var$ANALYTICS_SOURCE,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId
    }));
    return {
        menuItem: menuItem,
        launcher: launcher
    };
}


const $d60be53616d0626a$var$messages = (0, $kSwu1.defineMessages)({
    viewProfile: {
        id: "user-profile-card.action-bar.view-profile",
        defaultMessage: "View profile"
    },
    sendMessageLabel: {
        id: "user-profile-card.action-bar.send-message-label",
        defaultMessage: "Message"
    }
});
function $d60be53616d0626a$export$223875819fd7cf93({ profileData: profileData, cloudId: cloudId, actions: actions, viewerId: viewerId, isDeactivated: isDeactivated = false }) {
    const intl = (0, $kSwu1.useIntl)();
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $bIiaK.useCardOpenTimer)();
    const { townsquareApp: townsquareApp, onProfileClick: onProfileClick, getTestId: getTestId } = (0, $cozmU.useContext)((0, $9gll8.UserProfileCardContext));
    const { accountId: accountId, thirdPartyIntegrations: thirdPartyIntegrations, email: email } = profileData;
    const { href: href, target: target, onNavigate: onNavigate, isCrossAppMauGateEnabled: isCrossAppMauGateEnabled } = (0, $583e2a6550f59f49$export$a3989301a7f69ed7)(accountId, cloudId, townsquareApp);
    const fireCrossAppProfileAnalytic = (0, $2066a53fd7da0b8e$export$c7eac394c4a88aeb)(townsquareApp);
    const externalMessage = (0, $cozmU.useMemo)(()=>(0, $8b78f8e317e74b4e$export$523ecfa1815bea06)(thirdPartyIntegrations, email), [
        email,
        thirdPartyIntegrations
    ]);
    const handleThirdPartyMessageClick = (0, $cozmU.useCallback)(()=>{
        // Reuse the existing `@atlaskit/profilecard` clicked.action event so the SLO dashboards
        // see a single click-event surface for both profile-card packages. `index` and `hasOnClick`
        // are required by that schema but are not meaningful for user-profile-card actions, so we
        // always send `index: 0` and `hasOnClick: true`.
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: Boolean(externalMessage?.dm.openDmUrl),
            hasOnClick: true,
            index: 0,
            actionId: 'thirdPartyMessage'
        });
    }, [
        fireEvent,
        getDurationSinceInteraction,
        externalMessage
    ]);
    const handleViewProfileClick = (0, $cozmU.useCallback)((event)=>{
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: Boolean(href),
            hasOnClick: true,
            index: 0,
            actionId: 'viewProfile'
        });
        if (isCrossAppMauGateEnabled) fireCrossAppProfileAnalytic();
        onProfileClick?.(accountId);
        onNavigate?.(event);
    }, [
        fireEvent,
        getDurationSinceInteraction,
        href,
        onNavigate,
        onProfileClick,
        isCrossAppMauGateEnabled,
        fireCrossAppProfileAnalytic,
        accountId
    ]);
    const menuItems = (0, $cozmU.useMemo)(()=>{
        const visible = (actions ?? []).filter((action)=>!action.shouldRender || action.shouldRender(profileData));
        return visible.map((action, index)=>{
            const id = action.id ?? `action-${index}`;
            if (action.link) return {
                kind: 'link',
                id: id,
                label: action.label,
                href: action.link,
                target: action.target,
                onClick: action.callback ? (event, ...args)=>{
                    const isBasicClick = !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
                    if (isBasicClick) {
                        event.preventDefault();
                        action.callback?.(event, ...args);
                    }
                } : undefined
            };
            return {
                kind: 'button',
                id: id,
                label: action.label,
                onClick: (event, ...args)=>action.callback?.(event, ...args)
            };
        });
    }, [
        actions,
        profileData
    ]);
    const { menuItem: kudosMenuItem, launcher: kudosLauncher } = (0, $4f68084afcb13ad1$export$e739febab83b2399)({
        accountId: accountId,
        cloudId: cloudId,
        viewerId: viewerId
    });
    const allMenuItems = (0, $cozmU.useMemo)(// Deactivated accounts only surface the "View profile" button - no custom actions or kudos.
    ()=>isDeactivated ? [] : kudosMenuItem ? [
            ...menuItems,
            kudosMenuItem
        ] : menuItems, [
        isDeactivated,
        menuItems,
        kudosMenuItem
    ]);
    const hasActionMenu = allMenuItems.length > 0;
    // Without an accountId there is nothing to show. We allow rendering when there is no profile
    // link as long as the action menu has content - so consumers using the card without Teams
    // navigation can still surface custom actions / kudos.
    if (!accountId || !href && !hasActionMenu) return null;
    const inline = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.100",
        alignBlock: "center"
    }, !isDeactivated && externalMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
        href: externalMessage.dm.openDmUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: handleThirdPartyMessageClick,
        icon: (0, $aa9a50e7a58f2aaa$export$5a867b7c6687d757)(externalMessage.dm.integration),
        label: intl.formatMessage($d60be53616d0626a$var$messages.sendMessageLabel),
        isTooltipDisabled: false
    }), accountId && href && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        href: href,
        appearance: "default",
        target: target,
        onClick: handleViewProfileClick,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        testId: getTestId('view-profile-button')
    }, intl.formatMessage($d60be53616d0626a$var$messages.viewProfile)), hasActionMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e73bf856672907cd$export$ed57a210b9d13bb6), {
        items: allMenuItems,
        name: profileData.name
    }));
    // When there's no kudos launcher to portal-mount, return the bare `<Inline>` element so that
    // callers which expected the legacy single-element return tree continue to see one node (and
    // no extra fragment wrapper). The fragment form is only used when we actually need to render
    // the launcher sibling.
    if (isDeactivated || !kudosLauncher) return inline;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, inline, kudosLauncher);
}





















const $cd67a816341628e9$var$messages = (0, $kSwu1.defineMessages)({
    managerHeading: {
        id: "user-profile-card.ManagerSection.managerHeading",
        defaultMessage: "Manager"
    }
});
function $cd67a816341628e9$export$2992b481dad9fb03({ manager: manager }) {
    const intl = (0, $kSwu1.useIntl)();
    const { getTestId: getTestId } = (0, $cozmU.useContext)((0, $9gll8.UserProfileCardContext));
    const { name: name, avatarUrl: avatarUrl, jobTitle: jobTitle } = manager;
    if (!name) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.075",
        testId: getTestId('manager')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        as: "p",
        weight: "medium",
        size: "small",
        color: "color.text"
    }, intl.formatMessage($cd67a816341628e9$var$messages.managerHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        src: avatarUrl ?? undefined,
        name: name,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        size: "small",
        maxLines: 1
    }, name), jobTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        size: "small",
        color: "color.text.subtlest",
        maxLines: 1
    }, jobTitle))));
}
















var $3Luzz = parcelRequire("3Luzz");

const $00b2d1a91d1fd509$var$messages = (0, $kSwu1.defineMessages)({
    recentWorkHeading: {
        id: "user-profile-card.recent-work.heading",
        defaultMessage: "Recent work"
    }
});
function $00b2d1a91d1fd509$export$5981f4ad4928b105({ recentWorkData: recentWorkData, testId: testId, viewAllUrl: viewAllUrl, onLinkClick: onLinkClick, onViewAllLinkClick: onViewAllLinkClick }) {
    const intl = (0, $kSwu1.useIntl)();
    if (recentWorkData.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        as: "p",
        weight: "medium",
        size: "small",
        color: "color.text"
    }, intl.formatMessage($00b2d1a91d1fd509$var$messages.recentWorkHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Luzz.LinkList), {
        urls: recentWorkData,
        size: "compact",
        maxSources: 3,
        showExpand: false,
        viewAllUrl: viewAllUrl,
        onViewAllLinkClick: onViewAllLinkClick,
        onLinkClick: onLinkClick
    })));
}


const $ceb1b60f3799900e$var$styles = {
    root: "_1bsb1gwv _1ul95x59 _80om73ad _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _bfhkhp5a",
    deactivatedAvatar: "_kdam1r8n"
}; /**
    * Presentational profile card displaying a user's core information and recent work.
    * Renders avatar, name, pronouns, job title, department, location, manager, and recent-work items.
    *
    * Shows a loading skeleton when `isLoading` is true or `profileData` is undefined.
    * Displays an error state when profile data is missing or `name` is not provided.
    *
    * Recent-work previews require a `SmartCardProvider` from `@atlaskit/link-provider`
    * in scope (already provided by every Atlassian product shell).
    */ 
function $ceb1b60f3799900e$export$7bf40cd2a197df2d({ profileData: profileData, recentWorkData: recentWorkData, isLoading: isLoading = false, testId: testId = 'user-profile-card', cloudId: cloudId, error: error, actions: actions, viewerId: viewerId }) {
    const outerContext = (0, $cozmU.useContext)((0, $9gll8.UserProfileCardContext));
    const userId = profileData?.accountId ?? '';
    const localGetTestId = (0, $cozmU.useMemo)(()=>(0, $bXEsj.makeGetTestId)(userId, testId), [
        userId,
        testId
    ]); // Forward outer values so trigger-wrapped + standalone consumers see the same shape;
    // fall back to a local getTestId factory when there is no outer provider.
    const contextValue = (0, $cozmU.useMemo)(()=>({
            ...outerContext,
            cloudId: cloudId,
            getTestId: outerContext.getTestId !== (0, $9gll8.defaultGetTestId) ? outerContext.getTestId : localGetTestId
        }), [
        cloudId,
        localGetTestId,
        outerContext
    ]);
    const analyticsData = {
        source: 'userProfileCard',
        attributes: {
            cloudId: cloudId,
            userId: userId,
            hasManager: Boolean(profileData?.manager),
            hasRecentWork: Boolean(recentWorkData?.length),
            hasThirdPartyIntegrations: Boolean(profileData?.thirdPartyIntegrations?.length)
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2tuSz.TeamsAppAnalyticsContext), {
        data: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9gll8.UserProfileCardContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bIiaK.CardOpenTimerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ceb1b60f3799900e$var$UserProfileCardErrorBoundary, {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ceb1b60f3799900e$var$UserProfileCardContent, {
        profileData: profileData,
        recentWorkData: recentWorkData,
        isLoading: isLoading,
        testId: testId,
        cloudId: cloudId,
        error: error,
        actions: actions,
        viewerId: viewerId
    })))));
}
function $ceb1b60f3799900e$var$UserProfileCardErrorBoundary({ children: children, testId: testId }) {
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const handleError = (0, $cozmU.useCallback)((_error)=>{
        // `default` (not `renderError`) - schema only allows `default | NotFound`.
        fireEvent('ui.profilecard.rendered.error', {
            firedAt: (0, $eRfpr.firedAt)(),
            errorType: 'default',
            hasRetry: false
        });
    }, [
        fireEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        onError: handleError,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Z1Pc.CardError), {
            testId: testId
        })
    }, children);
}
function $ceb1b60f3799900e$var$UserProfileCardContent({ profileData: profileData, recentWorkData: recentWorkData, isLoading: isLoading, testId: testId, cloudId: cloudId, error: error, actions: actions, viewerId: viewerId }) {
    const { getTestId: getTestId } = (0, $cozmU.useContext)((0, $9gll8.UserProfileCardContext));
    const hasProfileData = Boolean(profileData && profileData.name);
    (0, $kKnPE.useFireRequestSucceeded)(!isLoading && hasProfileData);
    (0, $kKnPE.useFireRequestFailed)(!isLoading && !hasProfileData ? error ?? null : undefined);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fxdou.CardLoading), {
        testId: testId
    });
    if (!profileData || !profileData.name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f6a1f04ce64d6d23$export$2ebec9f03312245c), {
        testId: testId,
        errorType: "NotFound"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ceb1b60f3799900e$var$UserProfileCardRenderedContent, {
        profileData: profileData,
        recentWorkData: recentWorkData,
        testId: testId,
        cloudId: cloudId,
        getTestId: getTestId,
        actions: actions,
        viewerId: viewerId
    });
} // Success-only render. Split out so `useFireContentRendered` mounts (and fires)
// only when the user actually sees the content - not on loading or error.
function $ceb1b60f3799900e$var$UserProfileCardRenderedContent({ profileData: profileData, recentWorkData: recentWorkData, testId: testId, cloudId: cloudId, getTestId: getTestId, actions: actions, viewerId: viewerId }) {
    (0, $kKnPE.useFireContentRendered)(profileData);
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $bIiaK.useCardOpenTimer)();
    const { townsquareApp: townsquareApp } = (0, $cozmU.useContext)((0, $9gll8.UserProfileCardContext));
    const { href: profileHref } = (0, $583e2a6550f59f49$export$a3989301a7f69ed7)(profileData.accountId, cloudId, townsquareApp);
    const viewAllUrl = (0, $45508ebbf47750c1$export$f339ec3b489d28e5)(profileHref);
    const handleRecentWorkViewAllClick = (0, $cozmU.useCallback)(()=>{
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: Boolean(viewAllUrl),
            hasOnClick: true,
            index: 0,
            actionId: 'recentWorkViewAll'
        });
    }, [
        fireEvent,
        getDurationSinceInteraction,
        viewAllUrl
    ]);
    const handleRecentWorkLinkClick = (0, $cozmU.useCallback)((url, index)=>{
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: Boolean(url),
            hasOnClick: true,
            index: index,
            actionId: 'recentWorkLink'
        });
    }, [
        fireEvent,
        getDurationSinceInteraction
    ]);
    const { name: name, pronouns: pronouns, avatarUrl: avatarUrl, jobTitle: jobTitle, department: department, location: location, localTime: localTime, manager: manager } = profileData; // Deactivated (inactive/closed) accounts get a reduced experience: greyed-out avatar, only the
    // "View profile" action, a status lozenge, and no manager / recent-work sections.
    const isDeactivated = profileData.accountStatus === 'inactive' || profileData.accountStatus === 'closed';
    const subtitleParts = [
        jobTitle,
        department
    ].filter(Boolean);
    const subtitle = subtitleParts.join(` \u2022 `);
    const locationLine = localTime && location ? `${location} \u2013 ${localTime}` : location ?? undefined;
    const hasRecentWork = Boolean(recentWorkData?.length);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $ceb1b60f3799900e$var$styles.root,
        testId: testId,
        role: "region",
        "aria-label": name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.150",
        testId: "profilecard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        spread: "space-between",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: isDeactivated ? $ceb1b60f3799900e$var$styles.deactivatedAvatar : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        src: avatarUrl ?? undefined,
        name: name,
        size: "xlarge",
        testId: getTestId('avatar')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d60be53616d0626a$export$223875819fd7cf93), {
        profileData: profileData,
        cloudId: cloudId,
        actions: actions,
        viewerId: viewerId,
        isDeactivated: isDeactivated
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.100",
        alignBlock: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "medium",
        testId: getTestId('name')
    }, name), pronouns && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        size: "small",
        color: "color.text.subtlest",
        testId: getTestId('pronouns')
    }, pronouns)), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        maxLines: 2,
        size: "small",
        color: "color.text.subtlest",
        testId: getTestId('subtitle')
    }, subtitle), locationLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        maxLines: 1,
        size: "small",
        color: "color.text.subtlest",
        testId: getTestId('location')
    }, locationLine), isDeactivated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dc4ce11f77a04115$export$3b55902e173dd56e), null)))), !isDeactivated && manager && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cd67a816341628e9$export$2992b481dad9fb03), {
        manager: manager
    }), !isDeactivated && hasRecentWork && recentWorkData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $00b2d1a91d1fd509$export$5981f4ad4928b105), {
        recentWorkData: recentWorkData,
        testId: getTestId('recent-work'),
        viewAllUrl: viewAllUrl,
        onViewAllLinkClick: handleRecentWorkViewAllClick,
        onLinkClick: handleRecentWorkLinkClick
    })));
}


/**
 * Derives a canonical URL for a recent-activity object, covering every
 * URL-bearing activity type returned by the full profile-page query.
 * Returns a single-element array (for `flatMap`) or an empty array when the
 * object type has no resolvable URL.
 */ function $12851398953afe33$var$extractActivityUrl(objectData) {
    if (!objectData) return [];
    switch(objectData.__typename){
        case 'ConfluencePage':
        case 'ConfluenceBlogPost':
        case 'ConfluenceWhiteboard':
        case 'ConfluenceDatabase':
        case 'ConfluenceEmbed':
        case 'ConfluenceFooterComment':
        case 'ConfluenceInlineComment':
            return objectData.links?.base && objectData.links?.webUi ? [
                `${objectData.links.base}${objectData.links.webUi}`
            ] : [];
        case 'JiraIssue':
        case 'JiraPlatformComment':
        case 'JiraServiceManagementComment':
        case 'DevOpsDocument':
        case 'DevOpsDesign':
            return objectData.webUrl ? [
                objectData.webUrl
            ] : [];
        case 'TrelloBoard':
        case 'TrelloCard':
            return objectData.trelloUrl ? [
                objectData.trelloUrl
            ] : [];
        case 'TownsquareGoal':
        case 'TownsquareProject':
        case 'TownsquareComment':
        case 'ExternalDocument':
        case 'DevOpsPullRequestDetails':
        case 'ExternalPullRequest':
        case 'ExternalRemoteLink':
        case 'MercuryFocusArea':
        case 'MercuryPortfolio':
        case 'RadarPosition':
        case 'RadarView':
        case 'CompassComponent':
            return objectData.url ? [
                objectData.url
            ] : [];
        case 'BitbucketPullRequest':
            return objectData.href ? [
                objectData.href
            ] : [];
        case 'LoomVideo':
            return objectData.loomUrl ? [
                objectData.loomUrl
            ] : [];
        case 'AssetsObject':
        case 'AssetsObjectType':
        case 'AssetsSchema':
            return objectData.links?.web ? [
                objectData.links.web
            ] : [];
        default:
            return [];
    }
}
/**
 * Computes the de-duplication key for a recent-activity object, mirroring the
 * full profile page's `deduplicateId` behaviour:
 * - Confluence comments de-duplicate on their container (page/blog/whiteboard),
 *   so multiple comments on the same page collapse to a single entry
 *   (equivalent to `deduplicateId: ['container.id']`).
 * - Jira comments de-duplicate on their parent issue
 *   (equivalent to `deduplicateId: ['issue.id']`).
 * - Everything else de-duplicates on its own URL
 *   (equivalent to `deduplicateId: ['objectId']`).
 *
 * Falls back to the object's own URL when the container/issue is unavailable.
 */ function $12851398953afe33$var$getActivityDedupeKey(objectData) {
    const ownUrl = $12851398953afe33$var$extractActivityUrl(objectData)[0] ?? '';
    if (!objectData) return ownUrl;
    switch(objectData.__typename){
        case 'ConfluenceFooterComment':
        case 'ConfluenceInlineComment':
            {
                const container = objectData.container;
                const containerUrl = container && 'links' in container && container.links?.base && container.links?.webUi ? `${container.links.base}${container.links.webUi}` : '';
                return containerUrl || ownUrl;
            }
        case 'JiraPlatformComment':
        case 'JiraServiceManagementComment':
            return objectData.issue?.webUrl || ownUrl;
        default:
            return ownUrl;
    }
}
/**
 * Renders a user profile card from a Relay fragment.
 *
 * The fragment is colocated: it contains the user's base profile (name, avatar,
 * email, extendedProfile) and the supplemental data (manager, third-party
 * integrations, recent work) in one spread, so everything fetches in a single
 * round-trip.
 *
 * Recent-work previews need a `SmartCardProvider` from `@atlaskit/link-provider`
 * in scope. Atlassian product shells provide this by default.
 *
 * @example
 * ```tsx
 * const data = useLazyLoadQuery<MyQuery>(
 *   graphql`
 *     query MyQuery($userId: ID!, $cloudId: String!, $orgId: String!, $viewerId: String!) {
 *       ...UserProfileCardRelay_query @arguments(
 *         userId: $userId, cloudId: $cloudId, orgId: $orgId, viewerId: $viewerId
 *       )
 *     }
 *   `,
 *   buildQueryVariables({ userId, cloudId, orgId, viewerId }),
 * );
 * return <UserProfileCardRelay queryFragment={data} cloudId={cloudId} />;
 * ```
 */ function $12851398953afe33$export$8d4b90914bf8e85e({ queryFragment: queryFragment, cloudId: cloudId, testId: testId, isLoading: isLoading, agent: agent, actions: actions, viewerId: viewerId }) {
    const data = (0, $6SsN4.useFragment)((0, $fc0ddde612e6bc48$export$2e2bcd8739ae039), queryFragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($12851398953afe33$var$UserProfileCardRelayContent, {
        data: data,
        cloudId: cloudId,
        testId: testId,
        isLoading: isLoading,
        agent: agent,
        actions: actions,
        viewerId: viewerId
    });
}
function $12851398953afe33$var$UserProfileCardRelayContent({ data: data, cloudId: cloudId, testId: testId, isLoading: isLoading, agent: agent, actions: actions, viewerId: viewerId }) {
    const user = data.user;
    const accountId = user?.accountId ?? '';
    const rawSingleUser = data.knowledgeDiscovery?.singleUser;
    const knowledgeSingleUser = rawSingleUser && 'user' in rawSingleUser ? rawSingleUser : null;
    const rawManager = knowledgeSingleUser?.user?.manager;
    const recentWorkData = (0, $cozmU.useMemo)(()=>{
        const edges = data.activity?.workedOn?.edges ?? [];
        // De-duplicate by the profile page's `deduplicateId` key (comments collapse
        // onto their container/issue), keeping the first occurrence, then resolve
        // each survivor to its display URL and cap to the first 3 links.
        const seenKeys = new Set();
        const urls = [];
        for (const edge of edges){
            const objectData = edge?.node?.object?.data;
            const displayUrl = $12851398953afe33$var$extractActivityUrl(objectData)[0];
            if (!displayUrl) continue;
            const dedupeKey = $12851398953afe33$var$getActivityDedupeKey(objectData);
            if (seenKeys.has(dedupeKey)) continue;
            seenKeys.add(dedupeKey);
            urls.push(displayUrl);
            if (urls.length === 3) break;
        }
        return urls.length ? urls : undefined;
    }, [
        data.activity?.workedOn?.edges
    ]);
    const appType = user && 'appType' in user ? user.appType : null;
    const isAgent = typeof appType === 'string' && appType.toLowerCase() === 'agent';
    const profileData = (0, $cozmU.useMemo)(()=>{
        if (!user || isAgent) return null;
        const knowledge = knowledgeSingleUser?.user;
        const manager = rawManager?.id ? {
            id: rawManager.id,
            name: rawManager.name,
            avatarUrl: rawManager.picture,
            jobTitle: rawManager.jobTitle
        } : null;
        const thirdPartyIntegrations = knowledge?.thirdPartyIntegrations?.filter((integration)=>Boolean(integration?.externalId && integration?.integrationId && integration?.product)).map((integration)=>({
                externalId: integration.externalId,
                integrationId: integration.integrationId,
                product: integration.product
            }));
        return {
            accountId: user.accountId,
            accountStatus: user.accountStatus,
            name: user.name ?? '',
            avatarUrl: user.picture,
            email: user.email,
            jobTitle: user.extendedProfile?.jobTitle,
            department: user.extendedProfile?.department,
            location: user.extendedProfile?.location,
            organization: user.extendedProfile?.organization,
            manager: manager,
            thirdPartyIntegrations: thirdPartyIntegrations?.length ? thirdPartyIntegrations : null
        };
    }, [
        user,
        isAgent,
        knowledgeSingleUser,
        rawManager
    ]);
    if (!accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Z1Pc.CardError), {
        testId: testId
    });
    if (isAgent) {
        if (!agent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Z1Pc.CardError), {
            testId: testId
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d35qR.CardPopupWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39b35634554d0ec8$export$4bb3d93416a668a2), {
            ...agent,
            accountId: accountId,
            cloudId: cloudId
        }));
    }
    if (!profileData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Z1Pc.CardError), {
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d35qR.CardPopupWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ceb1b60f3799900e$export$7bf40cd2a197df2d), {
        cloudId: cloudId,
        testId: testId,
        isLoading: isLoading,
        profileData: profileData,
        recentWorkData: recentWorkData,
        actions: actions,
        viewerId: viewerId
    }));
}
function $12851398953afe33$export$9a3cee82e7cc08ff({ userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId }) {
    const skipKnowledgeDiscovery = !cloudId || !orgId || !viewerId;
    return {
        userId: userId,
        userIdString: userId,
        cloudId: cloudId ?? '',
        orgId: orgId ?? '',
        viewerId: viewerId ?? '',
        userAri: (0, $as9lu.IdentityUserAri).create({
            userId: userId
        }).toString(),
        skipKnowledgeDiscovery: skipKnowledgeDiscovery
    };
}
module.exports["UserProfileCardRelay"] = $12851398953afe33$export$8d4b90914bf8e85e;
module.exports["buildQueryVariables"] = $12851398953afe33$export$9a3cee82e7cc08ff;

});

parcelRegister("3jT9F", function(module, exports) {

var $9JsfF = parcelRequire("9JsfF");


var $7qZTr = parcelRequire("7qZTr");


var $ONTtp = parcelRequire("ONTtp");


var $3P7Ao = parcelRequire("3P7Ao");

function $13071ff81ef7f67c$var$resolveQueryVariables(params) {
    if ('identityAccountId' in params) {
        const identityAccountId = params.identityAccountId.startsWith('ari:cloud:identity::user/') ? params.identityAccountId : `ari:cloud:identity::user/${params.identityAccountId}`;
        return {
            agentAri: '',
            identityAccountId: identityAccountId,
            cloudId: params.cloudId,
            fetchByIdentity: true
        };
    }
    const agentAri = 'agentAri' in params ? params.agentAri : (0, $9JsfF.RovoAgentAri).create({
        activationId: params.activationId,
        agentId: params.agentId
    }).toString();
    return {
        agentAri: agentAri,
        identityAccountId: '',
        cloudId: '',
        fetchByIdentity: false
    };
}

const $13071ff81ef7f67c$export$cf39f5e5e131a6dd = (0, $ONTtp.createEntryPoint)({
    root: (0, $7qZTr.JSResourceForInteraction)(()=>(parcelRequire("bD8M4")), {
        moduleId: "dc6e5a58",
        moduleName: "AgentProfileCardContainer",
        priority: "interaction",
        moduleId: 'conversation-assistant-agent_agent-profile-card'
    }),
    getPreloadProps: (params)=>{
        const queryVariables = $13071ff81ef7f67c$var$resolveQueryVariables(params);
        return {
            queries: {
                agentProfileCardQuery: {
                    parameters: (0, $3P7Ao.default),
                    variables: queryVariables,
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});
module.exports["agentProfileCardEntryPoint"] = $13071ff81ef7f67c$export$cf39f5e5e131a6dd;

});

parcelRegister("9JsfF", function(module, exports) {
// src/rovo/agent/types.ts
var $d60690bf70aab450$export$474f4563a5282a33 = "rovo", $d60690bf70aab450$export$541c04ced4758f83 = "agent";



var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/rovo/agent/manifest.ts
var $715e3b359aec9d4d$var$rovoAgentAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $d60690bf70aab450$export$474f4563a5282a33),
    resourceType: (0, $d60690bf70aab450$export$541c04ced4758f83),
    resourceIdSlug: "activation/{activationId}/{agentId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        agentId: /[a-zA-Z0-9\-]+/
    }
};
// src/rovo/agent/index.ts
var $715e3b359aec9d4d$export$eaa394a67f27c50 = class _RovoAgentAri extends (0, $1gKSA.RegisteredAri) {
    get activationId() {
        return this._activationId;
    }
    get agentId() {
        return this._agentId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $715e3b359aec9d4d$var$rovoAgentAriStaticOpts.qualifier,
            platformQualifier: $715e3b359aec9d4d$var$rovoAgentAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $715e3b359aec9d4d$var$rovoAgentAriStaticOpts.resourceOwner,
            resourceType: $715e3b359aec9d4d$var$rovoAgentAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.agentId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                agentId: opts.agentId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $715e3b359aec9d4d$var$rovoAgentAriStaticOpts);
        return new _RovoAgentAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $715e3b359aec9d4d$var$rovoAgentAriStaticOpts);
        return new _RovoAgentAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            agentId: this.agentId
        };
    }
    constructor(opts){
        super(opts), this._activationId = opts.resourceIdSegmentValues.activationId, this._agentId = opts.resourceIdSegmentValues.agentId;
    }
};
module.exports["RovoAgentAri"] = $715e3b359aec9d4d$export$eaa394a67f27c50;

});

parcelRegister("3P7Ao", function(module, exports) {
/**
 * @generated SignedSource<<44c292346f22c43228b71daa22e1bc4d>>
 * @relayHash 89c3db6f08f38ab8e7c0f8ff0efa27d3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID be6d5d4905180f46e0aa18144e23657fa272f344fb4b17eedbf817cd2879e5da
const $cfa90136d687f07f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "agentAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fetchByIdentity"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "identityAccountId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "agentAri"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = [
        v5 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                {
                    "fragment": {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "AgentProfileCard_agentRef"
                            }
                        ],
                        "type": "AgentStudioAssistant"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "AgentProfileCard_agentRef"
                }
            ],
            "type": "AgentStudioAssistant"
        }
    ], v9 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "identityAccountId"
        }
    ], v10 = [
        v5 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "description"
                },
                {
                    "kind": "ScalarField",
                    "name": "icon"
                },
                {
                    "kind": "ScalarField",
                    "name": "identityAccountId"
                },
                {
                    "kind": "ScalarField",
                    "name": "externalConfigReference"
                },
                {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                },
                {
                    "kind": "ScalarField",
                    "name": "conversationStarters"
                },
                {
                    "kind": "ScalarField",
                    "name": "creatorType"
                },
                {
                    "kind": "ScalarField",
                    "name": "forgeCreator"
                },
                {
                    "kind": "LinkedField",
                    "name": "creator",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accountStatus"
                                }
                            ],
                            "type": "AtlassianAccountUser"
                        },
                        v6 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "authoringTeam",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "displayName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "profileUrl"
                        },
                        v6 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "AgentStudioAgentPermissions",
                    "kind": "LinkedField",
                    "name": "permissions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "canEdit"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canDelete"
                        }
                    ]
                }
            ],
            "type": "AgentStudioAssistant"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                v6 /*: any*/ 
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "AgentProfileCardContainerQuery",
            "selections": [
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentById",
                            "plural": false,
                            "selections": v8 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentByIdentityAccountId",
                            "plural": false,
                            "selections": v8 /*: any*/ 
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "AgentProfileCardContainerQuery",
            "selections": [
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentById",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentByIdentityAccountId",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "be6d5d4905180f46e0aa18144e23657fa272f344fb4b17eedbf817cd2879e5da",
            "metadata": {},
            "name": "AgentProfileCardContainerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$cfa90136d687f07f$var$node.hash = "7f56b7d6645b9220c953a6792948a3ba";
var $cfa90136d687f07f$export$2e2bcd8739ae039 = $cfa90136d687f07f$var$node;
module.exports["default"] = $cfa90136d687f07f$export$2e2bcd8739ae039;

});

parcelRegister("bD8M4", function(module, exports) {

let $877a249e5322c93e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $877a249e5322c93e$var$load("6wr18"),
    $877a249e5322c93e$var$load("cmmpX"),
    $877a249e5322c93e$var$load("fcsnw"),
    $877a249e5322c93e$var$load("72fV2"),
    $877a249e5322c93e$var$load("ffEVr"),
    $877a249e5322c93e$var$load("6uvkG"),
    $877a249e5322c93e$var$load("7EorR"),
    $877a249e5322c93e$var$load("jqoep"),
    $877a249e5322c93e$var$load("hhss7"),
    $877a249e5322c93e$var$load("8jBNC")
]).then(()=>parcelRequire('kzpDl'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("fWkhK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");

const $fd925b40062fea78$var$styles = {
    card: "_2rko1mok _1reo15vq _18m915vq _1bsbnklw _bfhk1bhr",
    body: "_ca0qxy5q _19bvpxbi _u5f3pxbi _n3tdpxbi"
};
const $fd925b40062fea78$export$406245d651cacfa7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "96px",
            borderRadius: 0
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $fd925b40062fea78$var$styles.card
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            xcss: $fd925b40062fea78$var$styles.body,
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "160px",
            height: "20px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "120px",
            height: "16px"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "48px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "32px"
        })));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $fd925b40062fea78$var$styles.card
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "96px",
        borderRadius: 0
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        xcss: $fd925b40062fea78$var$styles.body,
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "160px",
        height: "20px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "120px",
        height: "16px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "48px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "32px"
    })));
};
module.exports["AgentProfileCardSkeleton"] = $fd925b40062fea78$export$406245d651cacfa7;

});

parcelRegister("3Z1Pc", function(module, exports) {
/* CardError.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $d35qR = parcelRequire("d35qR");

const $fd4a3a1c380784ee$var$messages = (0, $kSwu1.defineMessages)({
    errorTitle: {
        id: "user-profile-card.error.title",
        defaultMessage: "Something went wrong and we couldn't load this profile."
    },
    errorDescription: {
        id: "user-profile-card.error.description",
        defaultMessage: "Try again in a few moments."
    }
});
const $fd4a3a1c380784ee$var$styles = {
    body: "_ca0q1ejb _n3td1ejb _19bv1ejb _u5f31ejb _y3gn1h6o"
}; /**
    * Error fallback when the entry point fails to render or profile data is missing.
    */ 
function $fd4a3a1c380784ee$export$f7f7efdefcc02999({ testId: testId }) {
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d35qR.CardPopupWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        testId: testId,
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.100",
        xcss: $fd4a3a1c380784ee$var$styles.body
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        weight: "semibold",
        color: "color.text.subtlest"
    }, intl.formatMessage($fd4a3a1c380784ee$var$messages.errorTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        size: "small",
        color: "color.text.subtlest"
    }, intl.formatMessage($fd4a3a1c380784ee$var$messages.errorDescription)))));
}
module.exports["CardError"] = $fd4a3a1c380784ee$export$f7f7efdefcc02999;

});

parcelRegister("fxdou", function(module, exports) {
/* CardLoading.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");


var $kKnPE = parcelRequire("kKnPE");


var $d35qR = parcelRequire("d35qR");

const $c8358ec2650d268a$var$styles = {
    inner: "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp",
    text: "_19pk12x7",
    fill: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
    linkRow: "_5wra1l7x _t6vde4h9 _1p3lnqa1 _mowc1l7x _hr4je4h9 _1apgnqa1 _1i531l7x _uwhke4h9 _15a5nqa1 _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
    linkRowFirst: "_13li1qi0 _qrwq1qi0",
    linkRowLast: "_1o3i1l7x _1doce4h9 _1il9nqa1 _mrkb1qi0 _1o0z1qi0"
};
function $c8358ec2650d268a$var$HeaderSkeleton() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        spread: "space-between",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "96px",
        height: "96px",
        borderRadius: "var(--ds-radius-full, 9999px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "32px",
        height: "32px",
        borderRadius: "var(--ds-radius-medium, 6px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "96px",
        height: "32px",
        borderRadius: "var(--ds-radius-medium, 6px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "32px",
        height: "32px",
        borderRadius: "var(--ds-radius-medium, 6px)"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.150",
        xcss: $c8358ec2650d268a$var$styles.text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "45%",
        height: "20px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "80%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "50%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    })));
}
function $c8358ec2650d268a$var$ManagerSectionSkeleton() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "60px",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "24px",
        height: "24px",
        borderRadius: "var(--ds-radius-full, 9999px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.050",
        xcss: $c8358ec2650d268a$var$styles.fill
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "45%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "65%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }))));
}
function $c8358ec2650d268a$var$LinkRowSkeleton({ first: first, last: last, titleWidth: titleWidth, subtitleWidth: subtitleWidth = '30%' }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($c8358ec2650d268a$var$styles.linkRow, first && $c8358ec2650d268a$var$styles.linkRowFirst, last && $c8358ec2650d268a$var$styles.linkRowLast)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.100",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: $c8358ec2650d268a$var$styles.fill
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "36px",
        height: "36px",
        borderRadius: "var(--ds-radius-large, 8px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        xcss: $c8358ec2650d268a$var$styles.fill,
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: titleWidth,
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: subtitleWidth,
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "32px",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    })));
}
function $c8358ec2650d268a$var$RecentWorkSectionSkeleton() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "90px",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c8358ec2650d268a$var$LinkRowSkeleton, {
        first: true,
        titleWidth: "70%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c8358ec2650d268a$var$LinkRowSkeleton, {
        titleWidth: "50%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c8358ec2650d268a$var$LinkRowSkeleton, {
        last: true,
        titleWidth: "65%"
    })));
} /**
   * Loading state shown while the profile card entry chunk resolves. Mirrors the
   * populated card layout:
   *
   * - Header: 96px avatar + action buttons (icon + "View profile") above the
   *   name + pronouns, subtitle (up to 2 lines), and location.
   * - Manager: heading + 24px avatar with name and job title lines.
   * - Recent work: heading + 3 bordered link rows that mirror the compact
   *   `LinkList` rendering used in `RecentWorkSection`.
   *
   * Keeping the skeleton shape close to the populated layout minimises the
   * perceived layout jump when data resolves. Fires `rendered.spinner` on mount
   * so the event only emits when the spinner is actually on screen.
   */ 
function $c8358ec2650d268a$export$5d25853fd6bdf402({ testId: testId }) {
    (0, $kKnPE.useFireRenderedSpinner)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d35qR.CardPopupWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        testId: testId,
        role: "status"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.200",
        xcss: $c8358ec2650d268a$var$styles.inner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c8358ec2650d268a$var$HeaderSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c8358ec2650d268a$var$ManagerSectionSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c8358ec2650d268a$var$RecentWorkSectionSkeleton, null))));
}
module.exports["CardLoading"] = $c8358ec2650d268a$export$5d25853fd6bdf402;

});

parcelRegister("3Luzz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $5HApy = parcelRequire("5HApy");











var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $eKMV3 = parcelRequire("eKMV3");


var $w6R6I = parcelRequire("w6R6I");


var $ixfCV = parcelRequire("ixfCV");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $a9aSv = parcelRequire("a9aSv");


var $l8wPz = parcelRequire("l8wPz");

var $4yYAm = parcelRequire("4yYAm");

var $i1503 = parcelRequire("i1503");

var $jdA6O = parcelRequire("jdA6O");

const $9e11ded08cccb06b$export$533f831a441a4b64 = 4;


const $809cafaeca2ec47b$export$bfdc42a78eb8bcc6 = (onLinkClick, url, idx)=>{
    if (!onLinkClick) return {
        onClick: undefined,
        onAuxClick: undefined,
        onContextMenu: undefined
    };
    return {
        onClick: ()=>onLinkClick(url, idx),
        onAuxClick: (e)=>{
            if (e.button === 1) onLinkClick(url, idx, {
                isAuxClick: true
            });
        },
        onContextMenu: (_e)=>onLinkClick(url, idx, {
                isContextMenu: true
            })
    };
};












var $i1t43 = parcelRequire("i1t43");







const $40d719e5f34e2f0d$export$fdef7686f3aefbe0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { urls: urls, onLinkClick: onLinkClick, testIdPrefix: testIdPrefix } = t0;
    let t1;
    if ($[0] !== onLinkClick || $[1] !== testIdPrefix || $[2] !== urls) {
        let t2;
        if ($[4] !== onLinkClick || $[5] !== testIdPrefix) {
            t2 = (url, idx)=>{
                const { onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu } = (0, $809cafaeca2ec47b$export$bfdc42a78eb8bcc6)(onLinkClick, url, idx);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                    key: `${url}-${idx}-errored-fallback`,
                    testId: `${testIdPrefix}-errored-fallback-item-${idx}`,
                    onAuxClick: onAuxClick,
                    onContextMenu: onContextMenu
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: url,
                    onClick: onClick,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, url));
            };
            $[4] = onLinkClick;
            $[5] = testIdPrefix;
            $[6] = t2;
        } else t2 = $[6];
        t1 = urls.map(t2);
        $[0] = onLinkClick;
        $[1] = testIdPrefix;
        $[2] = urls;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.100"
        }, t1);
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ urls: urls, onLinkClick: onLinkClick, testIdPrefix: testIdPrefix })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.100"
    }, urls.map((url, idx)=>{
        const { onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu } = (0, $809cafaeca2ec47b$export$bfdc42a78eb8bcc6)(onLinkClick, url, idx);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            key: `${url}-${idx}-errored-fallback`,
            testId: `${testIdPrefix}-errored-fallback-item-${idx}`,
            onAuxClick: onAuxClick,
            onContextMenu: onContextMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: url,
            onClick: onClick,
            target: "_blank",
            rel: "noopener noreferrer"
        }, url));
    }));
};


/**
 * Module-level memory of which link-list URLs have previously resolved
 * successfully via Smart Card.
 *
 * Why this exists:
 * The link-list items keep their "resolved" status in local React state and show
 * a skeleton overlay until the underlying Smart Card fires `onResolve`. That state
 * is tied to the component's mount lifetime, and the `SmartCardProvider` used by
 * the link list keeps its resolution store tied to its own mount lifetime too.
 *
 * Some consumers re-mount the link-list subtree very frequently while content
 * streams in (for example the inline Lumina link list in SAIN is re-rendered
 * on every streamed chunk, and the Rovo Extension chat panel re-mounts its tree as
 * the answer streams). Every remount would otherwise reset the local `resolved`
 * flag back to `false` and flash the loading skeleton again, producing a visible
 * resolved <-> loading flicker.
 *
 * By remembering, at module scope, that a given URL has resolved at least once, we
 * can initialise the per-item `resolved` state to `true` on a fresh mount. The
 * Smart Card still re-resolves in the background (typically synchronously from its
 * own warm store), but the user no longer sees the skeleton flash.
 *
 * This is intentionally a process-wide set keyed by URL: the same URL resolving to
 * the same content is stable, and the worst case for a stale entry is that we
 * briefly render the resolved layout for a URL that is being re-fetched — which is
 * exactly the non-flickering behaviour we want.
 *
 * Memory bound:
 * To avoid unbounded growth over a long session with many unique source URLs, the
 * set is capped at `MAX_RESOLVED_URLS` entries with simple FIFO eviction (the
 * oldest inserted URL is dropped once the cap is exceeded). `Set` preserves
 * insertion order, so the first entry is always the oldest. Evicting an old URL is
 * harmless: at worst it will show its skeleton once more the next time it appears,
 * then be re-cached.
 *
 * SSR safety:
 * In Node.js the module cache is per-process, not per-request, so a shared set
 * would otherwise leak one user's resolved URLs into another user's server render.
 * The streaming skeleton flicker this cache prevents is a purely client-side,
 * interactive concern (there is no streaming during SSR), so all reads and writes
 * are gated behind a client-only check. On the server the cache is effectively
 * empty and `hasUrlResolved` always returns `false`, meaning a server-rendered
 * item starts in its normal unresolved state and no cross-request state is shared.
 */ const $2e7811d8106740bc$var$isClient = typeof window !== 'undefined';
/**
 * Maximum number of resolved URLs to remember. Kept comfortably above the number
 * of unique sources a user is likely to see in a session, while bounding memory to
 * a small, fixed footprint (a few hundred short strings).
 */ const $2e7811d8106740bc$var$MAX_RESOLVED_URLS = 500;
const $2e7811d8106740bc$var$resolvedUrls = new Set();
const $2e7811d8106740bc$export$16ad849210e30509 = (url)=>$2e7811d8106740bc$var$isClient && url !== undefined && $2e7811d8106740bc$var$resolvedUrls.has(url);
const $2e7811d8106740bc$export$4221f35a82bb4741 = (url)=>{
    if (!$2e7811d8106740bc$var$isClient || url === undefined || $2e7811d8106740bc$var$resolvedUrls.has(url)) return;
    // FIFO eviction: drop the oldest entry once the cap is reached so the set stays
    // bounded over long sessions. `Set` iterates in insertion order, so the first
    // value is the oldest.
    if ($2e7811d8106740bc$var$resolvedUrls.size >= $2e7811d8106740bc$var$MAX_RESOLVED_URLS) {
        const oldest = $2e7811d8106740bc$var$resolvedUrls.values().next().value;
        if (oldest !== undefined) $2e7811d8106740bc$var$resolvedUrls.delete(oldest);
    }
    $2e7811d8106740bc$var$resolvedUrls.add(url);
};
const $2e7811d8106740bc$export$85e4c24706d1f5ed = ()=>{
    $2e7811d8106740bc$var$resolvedUrls.clear();
};











const $51eae9382efab009$export$9441241ba5515b77 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = new Set();
        $[0] = t0;
    } else t0 = $[0];
    const [erroredIndices, setErroredIndices] = (0, $cozmU.useState)(t0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (idx)=>setErroredIndices((prev)=>new Set(prev).add(idx));
        $[1] = t1;
    } else t1 = $[1];
    const markErrored = t1;
    let t2;
    if ($[2] !== erroredIndices) {
        t2 = {
            erroredIndices: erroredIndices,
            markErrored: markErrored
        };
        $[2] = erroredIndices;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ()=>{
    const [erroredIndices, setErroredIndices] = (0, $cozmU.useState)(new Set());
    const markErrored = (idx)=>setErroredIndices((prev)=>new Set(prev).add(idx));
    return {
        erroredIndices: erroredIndices,
        markErrored: markErrored
    };
};


const $29001a291e34995f$var$styles = {
    root: "_5wra1l7x _t6vde4h9 _1p3lnqa1 _mowc1l7x _hr4je4h9 _1apgnqa1 _kqswh2mm _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _irr31dpa",
    rootCompact: "_ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
    linkWrapperUnresolved: "_1tke8vuz",
    linkWrapperUnresolvedCompact: "_1tke1ylp",
    unresolvedSkeletonOverlay: "_1r04idpf _2rko1qi0 _kqswstnw _bfhkhfxm _1pbykb7n",
    borderTop: "_1i531l7x _uwhke4h9 _15a5nqa1",
    borderTopRounded: "_13li1qi0 _qrwq1qi0",
    borderBottomRounded: "_1o3i1l7x _1doce4h9 _1il9nqa1 _mrkb1qi0 _1o0z1qi0",
    loadingContainer: "_ca0qutpp _19bvutpp",
    loadingSkeletonRows: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
    expandWrapper: "_1h6d1l7x _189ee4h9 _1dqonqa1 _ca0qu2gc _u5f3utpp _19bvutpp _n3tdu2gc _4t3i1ylp"
};
const $29001a291e34995f$var$unboundedStyles = {
    unboundedTitleWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1ul91w81",
    unboundedTitleBlock: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1ul9idpf _1rguze3t _1sy51mok _8e0ku2gc _1a40u2gc _12yxu2gc _1qamu2gc _1em3i8nm _18tpr5cr",
    unboundedMetadataWrapper: "_1de7glyw",
    metadataStateSlot: "_1o9zidpf _1e0c1txw _1bahesu3 _18u0utpp",
    metadataPrioritySlot: "_1o9zidpf _18u0u2gc"
};
const $29001a291e34995f$var$messages = (0, $kSwu1.defineMessages)({
    link_list_expand: {
        id: "smart_knowledge_card.link_list_compact_expand",
        defaultMessage: "Show more"
    },
    link_list_collapse: {
        id: "smart_knowledge_card.link_list_compact_collapse",
        defaultMessage: "Show less"
    },
    link_list_view_all: {
        id: "smart_knowledge_card.link_list_compact_view_all",
        defaultMessage: "View all"
    }
});
const $29001a291e34995f$var$LinkListCompactComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(37);
    const { url: url, idx: idx, borderTopRounded: borderTopRounded, borderBottomRounded: borderBottomRounded, onError: onError, onLinkClick: onLinkClick, size: t1 } = t0;
    const size = t1 === undefined ? "default" : t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $ixfCV.fg)("kd_link_list_streaming_flicker_fix");
        $[0] = t2;
    } else t2 = $[0];
    const isStreamingFlickerFixEnabled = t2;
    let t3;
    if ($[1] !== url) {
        t3 = ()=>isStreamingFlickerFixEnabled ? (0, $2e7811d8106740bc$export$16ad849210e30509)(url) : false;
        $[1] = url;
        $[2] = t3;
    } else t3 = $[2];
    const [resolved, setResolved] = (0, $cozmU.useState)(t3);
    let t4;
    if ($[3] !== url) {
        t4 = ()=>{
            if (isStreamingFlickerFixEnabled) (0, $2e7811d8106740bc$export$4221f35a82bb4741)(url);
            setResolved(true);
        };
        $[3] = url;
        $[4] = t4;
    } else t4 = $[4];
    const handleResolve = t4;
    let t5;
    if ($[5] !== onError) {
        t5 = ()=>{
            setResolved(true);
            onError();
        };
        $[5] = onError;
        $[6] = t5;
    } else t5 = $[6];
    const handleError = t5;
    let t6;
    if ($[7] !== idx || $[8] !== onLinkClick || $[9] !== url) {
        t6 = (0, $809cafaeca2ec47b$export$bfdc42a78eb8bcc6)(onLinkClick, url, idx);
        $[7] = idx;
        $[8] = onLinkClick;
        $[9] = url;
        $[10] = t6;
    } else t6 = $[10];
    const { onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu } = t6;
    const isCompact = size === "compact";
    const t7 = isCompact && $29001a291e34995f$var$styles.rootCompact;
    const t8 = borderTopRounded && $29001a291e34995f$var$styles.borderTopRounded;
    const t9 = borderBottomRounded && $29001a291e34995f$var$styles.borderBottomRounded;
    const t10 = !resolved && $29001a291e34995f$var$styles.linkWrapperUnresolved;
    const t11 = !resolved && isCompact && $29001a291e34995f$var$styles.linkWrapperUnresolvedCompact;
    let t12;
    if ($[11] !== t10 || $[12] !== t11 || $[13] !== t7 || $[14] !== t8 || $[15] !== t9) {
        t12 = (0, $w6R6I.cx)($29001a291e34995f$var$styles.root, t7, $29001a291e34995f$var$styles.borderTop, t8, t9, t10, t11);
        $[11] = t10;
        $[12] = t11;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
        $[16] = t12;
    } else t12 = $[16];
    const t13 = `link-list-compact-item-${idx}${borderTopRounded ? "-top-rounded" : ""}${borderBottomRounded ? "-bottom-rounded" : ""}`;
    const t14 = isCompact ? (0, $4yYAm.SmartLinkSize).Small : (0, $4yYAm.SmartLinkSize).Medium;
    let t15;
    if ($[17] !== t14) {
        t15 = {
            theme: (0, $4yYAm.SmartLinkTheme).Black,
            clickableContainer: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true,
            size: t14,
            removeBlockRestriction: true
        };
        $[17] = t14;
        $[18] = t15;
    } else t15 = $[18];
    let t16;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $29001a291e34995f$var$unboundedStyles.unboundedTitleBlock
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
            maxLines: 1,
            showActionOnHover: true,
            subtitle: [
                {
                    name: (0, $4yYAm.ElementName).Provider,
                    hideIcon: true
                },
                {
                    name: (0, $4yYAm.ElementName).ModifiedOn
                }
            ],
            position: (0, $4yYAm.SmartLinkPosition).Center
        }));
        $[19] = t16;
    } else t16 = $[19];
    let t17;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            alignBlock: "center",
            xcss: $29001a291e34995f$var$unboundedStyles.unboundedTitleWrapper
        }, t16, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $29001a291e34995f$var$unboundedStyles.metadataStateSlot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1503.default), {
            maxLines: 1,
            primary: [
                {
                    name: (0, $4yYAm.ElementName).State
                }
            ]
        })));
        $[20] = t17;
    } else t17 = $[20];
    let t18;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            spread: "space-between",
            alignBlock: "center"
        }, t17, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            alignBlock: "center",
            xcss: $29001a291e34995f$var$unboundedStyles.unboundedMetadataWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $29001a291e34995f$var$unboundedStyles.metadataPrioritySlot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1503.default), {
            maxLines: 1,
            primary: [
                {
                    name: (0, $4yYAm.ElementName).Priority
                }
            ]
        }))));
        $[21] = t18;
    } else t18 = $[21];
    let t19;
    if ($[22] !== handleError || $[23] !== handleResolve || $[24] !== onClick || $[25] !== t15 || $[26] !== url) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
            appearance: "block",
            url: url,
            onClick: onClick,
            ui: t15,
            onError: handleError,
            onResolve: handleResolve
        }, t18);
        $[22] = handleError;
        $[23] = handleResolve;
        $[24] = onClick;
        $[25] = t15;
        $[26] = url;
        $[27] = t19;
    } else t19 = $[27];
    let t20;
    if ($[28] !== resolved) {
        t20 = !resolved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: (0, $w6R6I.cx)($29001a291e34995f$var$styles.unresolvedSkeletonOverlay, $29001a291e34995f$var$styles.loadingContainer),
            testId: "unresolved-loading-skeleton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "16px",
            height: "16px",
            borderRadius: "var(--ds-radius-small, 4px)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            xcss: $29001a291e34995f$var$styles.loadingSkeletonRows,
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "40%",
            height: "12px",
            borderRadius: "var(--ds-radius-small, 4px)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "70%",
            height: "12px",
            borderRadius: "var(--ds-radius-small, 4px)"
        }))));
        $[28] = resolved;
        $[29] = t20;
    } else t20 = $[29];
    let t21;
    if ($[30] !== onAuxClick || $[31] !== onContextMenu || $[32] !== t12 || $[33] !== t13 || $[34] !== t19 || $[35] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: t12,
            testId: t13,
            onAuxClick: onAuxClick,
            onContextMenu: onContextMenu
        }, t19, t20);
        $[30] = onAuxClick;
        $[31] = onContextMenu;
        $[32] = t12;
        $[33] = t13;
        $[34] = t19;
        $[35] = t20;
        $[36] = t21;
    } else t21 = $[36];
    return t21;
} : ({ url: url, idx: idx, borderTopRounded: borderTopRounded, borderBottomRounded: borderBottomRounded, onError: onError, onLinkClick: onLinkClick, size: size = 'default' })=>{
    // When enabled, initialise from the module-level cache so a previously-resolved
    // URL does not flash its loading skeleton when this item is re-mounted (e.g.
    // while a Search AI answer or Rovo Extension chat streams in). See
    // `resolved-url-cache.ts`. When the gate is off, behave exactly as before.
    const isStreamingFlickerFixEnabled = (0, $ixfCV.fg)('kd_link_list_streaming_flicker_fix');
    const [resolved, setResolved] = (0, $cozmU.useState)(()=>isStreamingFlickerFixEnabled ? (0, $2e7811d8106740bc$export$16ad849210e30509)(url) : false);
    const handleResolve = ()=>{
        if (isStreamingFlickerFixEnabled) (0, $2e7811d8106740bc$export$4221f35a82bb4741)(url);
        setResolved(true);
    };
    const handleError = ()=>{
        // Dismiss the skeleton on error, but do not record the URL as resolved so a
        // later remount can still attempt a fresh resolve from a clean state.
        setResolved(true);
        onError();
    };
    const { onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu } = (0, $809cafaeca2ec47b$export$bfdc42a78eb8bcc6)(onLinkClick, url, idx);
    const isCompact = size === 'compact';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($29001a291e34995f$var$styles.root, isCompact && $29001a291e34995f$var$styles.rootCompact, $29001a291e34995f$var$styles.borderTop, borderTopRounded && $29001a291e34995f$var$styles.borderTopRounded, borderBottomRounded && $29001a291e34995f$var$styles.borderBottomRounded, !resolved && $29001a291e34995f$var$styles.linkWrapperUnresolved, !resolved && isCompact && $29001a291e34995f$var$styles.linkWrapperUnresolvedCompact),
        testId: `link-list-compact-item-${idx}${borderTopRounded ? '-top-rounded' : ''}${borderBottomRounded ? '-bottom-rounded' : ''}`,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
        appearance: "block",
        url: url,
        onClick: onClick,
        ui: {
            theme: (0, $4yYAm.SmartLinkTheme).Black,
            clickableContainer: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true,
            size: isCompact ? (0, $4yYAm.SmartLinkSize).Small : (0, $4yYAm.SmartLinkSize).Medium,
            removeBlockRestriction: true
        },
        onError: handleError,
        onResolve: handleResolve
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        alignBlock: "center",
        xcss: $29001a291e34995f$var$unboundedStyles.unboundedTitleWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $29001a291e34995f$var$unboundedStyles.unboundedTitleBlock
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
        maxLines: 1,
        showActionOnHover: true,
        subtitle: [
            {
                name: (0, $4yYAm.ElementName).Provider,
                hideIcon: true
            },
            {
                name: (0, $4yYAm.ElementName).ModifiedOn
            }
        ],
        position: (0, $4yYAm.SmartLinkPosition).Center
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $29001a291e34995f$var$unboundedStyles.metadataStateSlot
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1503.default), {
        maxLines: 1,
        primary: [
            {
                name: (0, $4yYAm.ElementName).State
            }
        ]
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        alignBlock: "center",
        xcss: $29001a291e34995f$var$unboundedStyles.unboundedMetadataWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $29001a291e34995f$var$unboundedStyles.metadataPrioritySlot
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1503.default), {
        maxLines: 1,
        primary: [
            {
                name: (0, $4yYAm.ElementName).Priority
            }
        ]
    }))))), !resolved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($29001a291e34995f$var$styles.unresolvedSkeletonOverlay, $29001a291e34995f$var$styles.loadingContainer),
        testId: "unresolved-loading-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "16px",
        height: "16px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        xcss: $29001a291e34995f$var$styles.loadingSkeletonRows,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "40%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "70%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    })))));
};
const $29001a291e34995f$export$1fbb558f111cbbf9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    const { urls: urls, onLinkClick: onLinkClick, size: size, maxSources: t1, expandedMaxSources: expandedMaxSources, showExpand: t2, viewAllUrl: viewAllUrl, onViewAllLinkClick: onViewAllLinkClick } = t0;
    const maxSources = t1 === undefined ? (0, $9e11ded08cccb06b$export$533f831a441a4b64) : t1;
    const showExpand = t2 === undefined ? true : t2;
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const { erroredIndices: erroredIndices, markErrored: markErrored } = (0, $51eae9382efab009$export$9441241ba5515b77)();
    const safeMaxSources = maxSources >= 1 ? maxSources : (0, $9e11ded08cccb06b$export$533f831a441a4b64);
    let T0;
    let showExpandToggle;
    let showViewAll;
    let t3;
    let t4;
    let t5;
    if ($[0] !== erroredIndices || $[1] !== expandedMaxSources || $[2] !== isExpanded || $[3] !== markErrored || $[4] !== onLinkClick || $[5] !== safeMaxSources || $[6] !== showExpand || $[7] !== size || $[8] !== urls || $[9] !== viewAllUrl) {
        t5 = Symbol.for("react.early_return_sentinel");
        bb0: {
            let t6;
            if ($[16] !== erroredIndices) {
                t6 = (i_0)=>!erroredIndices.has(i_0);
                $[16] = erroredIndices;
                $[17] = t6;
            } else t6 = $[17];
            const visibleIndices = urls.map($29001a291e34995f$var$_temp).filter(t6);
            const expandedCap = expandedMaxSources !== undefined && expandedMaxSources > safeMaxSources ? expandedMaxSources : undefined;
            const hasMore = showExpand && visibleIndices.length > safeMaxSources;
            const renderedIndices = isExpanded ? expandedCap !== undefined ? visibleIndices.slice(0, expandedCap) : visibleIndices : visibleIndices.slice(0, safeMaxSources);
            const firstVisibleIdx = renderedIndices[0] ?? -1;
            const lastVisibleIdx = renderedIndices[renderedIndices.length - 1] ?? -1;
            const allUrlsErrored = urls.length > 0 && erroredIndices.size === urls.length;
            if (allUrlsErrored) {
                let t7;
                if ($[18] !== onLinkClick || $[19] !== urls) {
                    t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $40d719e5f34e2f0d$export$fdef7686f3aefbe0), {
                        urls: urls,
                        onLinkClick: onLinkClick,
                        testIdPrefix: "link-list-compact"
                    });
                    $[18] = onLinkClick;
                    $[19] = urls;
                    $[20] = t7;
                } else t7 = $[20];
                t5 = t7;
                break bb0;
            }
            showViewAll = !!viewAllUrl && (!hasMore || isExpanded);
            showExpandToggle = hasMore && !showViewAll;
            const hasFooter = showExpandToggle || showViewAll;
            T0 = (0, $dinVW.default);
            t3 = "space.0";
            t4 = renderedIndices.map((originalIdx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($29001a291e34995f$var$LinkListCompactComponent, {
                    key: `${urls[originalIdx]}-${originalIdx}`,
                    url: urls[originalIdx],
                    idx: originalIdx,
                    borderTopRounded: originalIdx === firstVisibleIdx,
                    borderBottomRounded: originalIdx === lastVisibleIdx && !hasFooter,
                    onError: ()=>markErrored(originalIdx),
                    onLinkClick: onLinkClick,
                    size: size
                }));
        }
        $[0] = erroredIndices;
        $[1] = expandedMaxSources;
        $[2] = isExpanded;
        $[3] = markErrored;
        $[4] = onLinkClick;
        $[5] = safeMaxSources;
        $[6] = showExpand;
        $[7] = size;
        $[8] = urls;
        $[9] = viewAllUrl;
        $[10] = T0;
        $[11] = showExpandToggle;
        $[12] = showViewAll;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
    } else {
        T0 = $[10];
        showExpandToggle = $[11];
        showViewAll = $[12];
        t3 = $[13];
        t4 = $[14];
        t5 = $[15];
    }
    if (t5 !== Symbol.for("react.early_return_sentinel")) return t5;
    let t6;
    if ($[21] !== isExpanded || $[22] !== showExpandToggle) {
        t6 = showExpandToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            xcss: (0, $w6R6I.cx)($29001a291e34995f$var$styles.expandWrapper, $29001a291e34995f$var$styles.borderBottomRounded),
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: ()=>setIsExpanded(!isExpanded)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            color: "color.text.subtlest"
        }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $29001a291e34995f$var$messages.link_list_collapse) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $29001a291e34995f$var$messages.link_list_expand))));
        $[21] = isExpanded;
        $[22] = showExpandToggle;
        $[23] = t6;
    } else t6 = $[23];
    let t7;
    if ($[24] !== onViewAllLinkClick || $[25] !== showViewAll || $[26] !== viewAllUrl) {
        t7 = showViewAll && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            xcss: (0, $w6R6I.cx)($29001a291e34995f$var$styles.expandWrapper, $29001a291e34995f$var$styles.borderBottomRounded),
            alignBlock: "center",
            testId: "link-list-compact-view-all"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            appearance: "subtle",
            href: viewAllUrl,
            onClick: onViewAllLinkClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            color: "color.text.subtlest"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $29001a291e34995f$var$messages.link_list_view_all))));
        $[24] = onViewAllLinkClick;
        $[25] = showViewAll;
        $[26] = viewAllUrl;
        $[27] = t7;
    } else t7 = $[27];
    let t8;
    if ($[28] !== T0 || $[29] !== t3 || $[30] !== t4 || $[31] !== t6 || $[32] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            space: t3
        }, t4, t6, t7);
        $[28] = T0;
        $[29] = t3;
        $[30] = t4;
        $[31] = t6;
        $[32] = t7;
        $[33] = t8;
    } else t8 = $[33];
    return t8;
} : ({ urls: urls, onLinkClick: onLinkClick, size: size, maxSources: maxSources = (0, $9e11ded08cccb06b$export$533f831a441a4b64), expandedMaxSources: expandedMaxSources, showExpand: showExpand = true, viewAllUrl: viewAllUrl, onViewAllLinkClick: onViewAllLinkClick })=>{
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const { erroredIndices: erroredIndices, markErrored: markErrored } = (0, $51eae9382efab009$export$9441241ba5515b77)(); // Clamp `maxSources` to a sensible positive integer. The prop is typed as
    // `number`, so a caller can pass `0` (renders nothing until "Show more"
    // click) or a negative number (`slice(0, -1)` would silently drop the
    // last item). Falling back to `DEFAULT_MAX_SOURCES` keeps the API
    // forgiving without changing the documented happy-path behaviour.
    const safeMaxSources = maxSources >= 1 ? maxSources : (0, $9e11ded08cccb06b$export$533f831a441a4b64); // All non-errored original indices, preserving original positions
    const visibleIndices = urls.map((_, i)=>i).filter((i_0)=>!erroredIndices.has(i_0));
    const expandedCap = expandedMaxSources !== undefined && expandedMaxSources > safeMaxSources ? expandedMaxSources : undefined; // Only show the expand/collapse button when showExpand is true and there are
    // more items than safeMaxSources. When showExpand is false all items up to
    // safeMaxSources are shown immediately with no toggle.
    const hasMore = showExpand && visibleIndices.length > safeMaxSources;
    const renderedIndices = isExpanded ? expandedCap !== undefined ? visibleIndices.slice(0, expandedCap) : visibleIndices : visibleIndices.slice(0, safeMaxSources);
    const firstVisibleIdx = renderedIndices[0] ?? -1;
    const lastVisibleIdx = renderedIndices[renderedIndices.length - 1] ?? -1; // In the edge case that every url has errored, rather than rendering nothing
    // (which looks broken given the surrounding context), fall back to rendering
    // each URL as a plain ADS link so the user still sees the links
    const allUrlsErrored = urls.length > 0 && erroredIndices.size === urls.length;
    if (allUrlsErrored) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $40d719e5f34e2f0d$export$fdef7686f3aefbe0), {
        urls: urls,
        onLinkClick: onLinkClick,
        testIdPrefix: "link-list-compact"
    });
    const showViewAll = !!viewAllUrl && (!hasMore || isExpanded);
    const showExpandToggle = hasMore && !showViewAll;
    const hasFooter = showExpandToggle || showViewAll;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.0"
    }, renderedIndices.map((originalIdx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($29001a291e34995f$var$LinkListCompactComponent, {
            key: `${urls[originalIdx]}-${originalIdx}`,
            url: urls[originalIdx],
            idx: originalIdx,
            borderTopRounded: originalIdx === firstVisibleIdx,
            borderBottomRounded: originalIdx === lastVisibleIdx && !hasFooter,
            onError: ()=>markErrored(originalIdx),
            onLinkClick: onLinkClick,
            size: size
        })), showExpandToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        xcss: (0, $w6R6I.cx)($29001a291e34995f$var$styles.expandWrapper, $29001a291e34995f$var$styles.borderBottomRounded),
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: ()=>setIsExpanded(!isExpanded)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text.subtlest"
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $29001a291e34995f$var$messages.link_list_collapse) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $29001a291e34995f$var$messages.link_list_expand)))), showViewAll && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        xcss: (0, $w6R6I.cx)($29001a291e34995f$var$styles.expandWrapper, $29001a291e34995f$var$styles.borderBottomRounded),
        alignBlock: "center",
        testId: "link-list-compact-view-all"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        appearance: "subtle",
        href: viewAllUrl,
        onClick: onViewAllLinkClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $29001a291e34995f$var$messages.link_list_view_all)))));
};
function $29001a291e34995f$var$_temp(_, i) {
    return i;
}



















































const $572cabcf6e7462ad$var$styles = {
    root: "_5wra1l7x _t6vde4h9 _1p3lnqa1 _mowc1l7x _hr4je4h9 _1apgnqa1 _kqswh2mm _ca0qutpp _u5f3pxbi _n3tdutpp _19bvpxbi _irr31dpa",
    linkWrapperUnresolved: "_1tke1ex1",
    unresolvedSkeletonOverlay: "_1r04idpf _2rko1qi0 _kqswstnw _bfhkhfxm _1pbykb7n",
    borderTop: "_1i531l7x _uwhke4h9 _15a5nqa1",
    borderTopRounded: "_13li1qi0 _qrwq1qi0",
    borderBottomRounded: "_1o3i1l7x _1doce4h9 _1il9nqa1 _mrkb1qi0 _1o0z1qi0",
    loadingContainer: "_ca0qutpp _19bvutpp",
    loadingSkeletonRows: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
    expandWrapper: "_1h6d1l7x _189ee4h9 _1dqonqa1 _ca0qu2gc _u5f3utpp _19bvutpp _n3tdu2gc _4t3i1ylp"
};
const $572cabcf6e7462ad$var$unboundedStyles = {
    unboundedTitleWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1ul91w81",
    unboundedTitleBlock: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1ul9idpf _1rguze3t _1sy51mok _8e0ku2gc _1a40u2gc _12yxu2gc _1qamu2gc _1em3i8nm _18tpr5cr _1bac1mp2 _13bou2gc",
    hideTitleStyles: "_u4a7glyw _502wglyw",
    unboundedMetadataWrapper: "_1de7glyw",
    metadataModifiedOnSlot: "_1bsb1w81 _1o9zidpf _18u0utpp",
    metadataStateSlot: "_1o9zidpf _1e0c1txw _1bahesu3 _18u0utpp",
    metadataPrioritySlot: "_1bsbzwfg _1o9zidpf _18u0u2gc",
    metadataAuthorSlot: "_1bsb1wqb _1o9zidpf _18u0pxbi",
    previewSlot: "_1bsb1tcg _1o9zidpf"
};
const $572cabcf6e7462ad$var$messages = (0, $kSwu1.defineMessages)({
    link_list_expand: {
        id: "smart_knowledge_card.link_list_full_expand",
        defaultMessage: "Show more"
    },
    link_list_collapse: {
        id: "smart_knowledge_card.link_list_full_collapse",
        defaultMessage: "Show less"
    },
    link_list_view_all: {
        id: "smart_knowledge_card.link_list_full_view_all",
        defaultMessage: "View all"
    }
});
const $572cabcf6e7462ad$var$LinkListFullComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(37);
    const { url: url, idx: idx, borderTopRounded: borderTopRounded, borderBottomRounded: borderBottomRounded, onError: onError, onLinkClick: onLinkClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $ixfCV.fg)("kd_link_list_streaming_flicker_fix");
        $[0] = t1;
    } else t1 = $[0];
    const isStreamingFlickerFixEnabled = t1;
    let t2;
    if ($[1] !== url) {
        t2 = ()=>isStreamingFlickerFixEnabled ? (0, $2e7811d8106740bc$export$16ad849210e30509)(url) : false;
        $[1] = url;
        $[2] = t2;
    } else t2 = $[2];
    const [resolved, setResolved] = (0, $cozmU.useState)(t2);
    let t3;
    if ($[3] !== url) {
        t3 = ()=>{
            if (isStreamingFlickerFixEnabled) (0, $2e7811d8106740bc$export$4221f35a82bb4741)(url);
            setResolved(true);
        };
        $[3] = url;
        $[4] = t3;
    } else t3 = $[4];
    const handleResolve = t3;
    let t4;
    if ($[5] !== onError) {
        t4 = ()=>{
            setResolved(true);
            onError();
        };
        $[5] = onError;
        $[6] = t4;
    } else t4 = $[6];
    const handleError = t4;
    let t5;
    if ($[7] !== idx || $[8] !== onLinkClick || $[9] !== url) {
        t5 = (0, $809cafaeca2ec47b$export$bfdc42a78eb8bcc6)(onLinkClick, url, idx);
        $[7] = idx;
        $[8] = onLinkClick;
        $[9] = url;
        $[10] = t5;
    } else t5 = $[10];
    const { onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu } = t5;
    const t6 = borderTopRounded && $572cabcf6e7462ad$var$styles.borderTopRounded;
    const t7 = borderBottomRounded && $572cabcf6e7462ad$var$styles.borderBottomRounded;
    const t8 = !resolved && $572cabcf6e7462ad$var$styles.linkWrapperUnresolved;
    let t9;
    if ($[11] !== t6 || $[12] !== t7 || $[13] !== t8) {
        t9 = (0, $w6R6I.cx)($572cabcf6e7462ad$var$styles.root, $572cabcf6e7462ad$var$styles.borderTop, t6, t7, t8);
        $[11] = t6;
        $[12] = t7;
        $[13] = t8;
        $[14] = t9;
    } else t9 = $[14];
    const t10 = `link-list-full-item-${idx}${borderTopRounded ? "-top-rounded" : ""}${borderBottomRounded ? "-bottom-rounded" : ""}`;
    let t11;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = {
            theme: (0, $4yYAm.SmartLinkTheme).Black,
            clickableContainer: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true,
            size: (0, $4yYAm.SmartLinkSize).Medium,
            removeBlockRestriction: true
        };
        $[15] = t11;
    } else t11 = $[15];
    let t12;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $572cabcf6e7462ad$var$unboundedStyles.unboundedTitleBlock
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
            maxLines: 1,
            showActionOnHover: true,
            subtitle: [
                {
                    name: (0, $4yYAm.ElementName).Provider,
                    hideIcon: true
                },
                {
                    name: (0, $4yYAm.ElementName).CreatedBy
                }
            ],
            position: (0, $4yYAm.SmartLinkPosition).Center
        }));
        $[16] = t12;
    } else t12 = $[16];
    let t13;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            alignBlock: "center",
            xcss: $572cabcf6e7462ad$var$unboundedStyles.unboundedTitleWrapper
        }, t12, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $572cabcf6e7462ad$var$unboundedStyles.metadataStateSlot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1503.default), {
            maxLines: 1,
            primary: [
                {
                    name: (0, $4yYAm.ElementName).State
                }
            ]
        })));
        $[17] = t13;
    } else t13 = $[17];
    let t14;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $572cabcf6e7462ad$var$unboundedStyles.metadataAuthorSlot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1503.default), {
            maxLines: 1,
            primary: [
                {
                    name: (0, $4yYAm.ElementName).AuthorGroup
                }
            ]
        }));
        $[18] = t14;
    } else t14 = $[18];
    let t15;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $572cabcf6e7462ad$var$unboundedStyles.metadataModifiedOnSlot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1503.default), {
            maxLines: 1,
            primary: [
                {
                    name: (0, $4yYAm.ElementName).ModifiedOn
                }
            ]
        }));
        $[19] = t15;
    } else t15 = $[19];
    let t16;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $572cabcf6e7462ad$var$unboundedStyles.metadataPrioritySlot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1503.default), {
            maxLines: 1,
            primary: [
                {
                    name: (0, $4yYAm.ElementName).Priority
                }
            ]
        }));
        $[20] = t16;
    } else t16 = $[20];
    let t17;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = (0, $w6R6I.cx)($572cabcf6e7462ad$var$unboundedStyles.hideTitleStyles, $572cabcf6e7462ad$var$unboundedStyles.previewSlot);
        $[21] = t17;
    } else t17 = $[21];
    let t18;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            spread: "space-between",
            alignBlock: "center"
        }, t13, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            alignBlock: "center",
            xcss: $572cabcf6e7462ad$var$unboundedStyles.unboundedMetadataWrapper
        }, t14, t15, t16, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: t17
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
            maxLines: 1,
            actions: [
                {
                    name: (0, $4yYAm.ActionName).PreviewAction,
                    hideContent: true
                }
            ],
            showActionOnHover: true,
            position: (0, $4yYAm.SmartLinkPosition).Center
        }))));
        $[22] = t18;
    } else t18 = $[22];
    let t19;
    if ($[23] !== handleError || $[24] !== handleResolve || $[25] !== onClick || $[26] !== url) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
            appearance: "block",
            url: url,
            onClick: onClick,
            ui: t11,
            onError: handleError,
            onResolve: handleResolve
        }, t18);
        $[23] = handleError;
        $[24] = handleResolve;
        $[25] = onClick;
        $[26] = url;
        $[27] = t19;
    } else t19 = $[27];
    let t20;
    if ($[28] !== resolved) {
        t20 = !resolved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: (0, $w6R6I.cx)($572cabcf6e7462ad$var$styles.unresolvedSkeletonOverlay, $572cabcf6e7462ad$var$styles.loadingContainer),
            testId: "unresolved-loading-skeleton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "16px",
            height: "16px",
            borderRadius: "var(--ds-radius-small, 4px)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            xcss: $572cabcf6e7462ad$var$styles.loadingSkeletonRows,
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "40%",
            height: "12px",
            borderRadius: "var(--ds-radius-small, 4px)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "70%",
            height: "12px",
            borderRadius: "var(--ds-radius-small, 4px)"
        }))));
        $[28] = resolved;
        $[29] = t20;
    } else t20 = $[29];
    let t21;
    if ($[30] !== onAuxClick || $[31] !== onContextMenu || $[32] !== t10 || $[33] !== t19 || $[34] !== t20 || $[35] !== t9) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: t9,
            testId: t10,
            onAuxClick: onAuxClick,
            onContextMenu: onContextMenu
        }, t19, t20);
        $[30] = onAuxClick;
        $[31] = onContextMenu;
        $[32] = t10;
        $[33] = t19;
        $[34] = t20;
        $[35] = t9;
        $[36] = t21;
    } else t21 = $[36];
    return t21;
} : ({ url: url, idx: idx, borderTopRounded: borderTopRounded, borderBottomRounded: borderBottomRounded, onError: onError, onLinkClick: onLinkClick })=>{
    // When enabled, initialise from the module-level cache so a previously-resolved
    // URL does not flash its loading skeleton when this item is re-mounted (e.g.
    // while a Search AI answer or Rovo Extension chat streams in). See
    // `resolved-url-cache.ts`. When the gate is off, behave exactly as before.
    const isStreamingFlickerFixEnabled = (0, $ixfCV.fg)('kd_link_list_streaming_flicker_fix');
    const [resolved, setResolved] = (0, $cozmU.useState)(()=>isStreamingFlickerFixEnabled ? (0, $2e7811d8106740bc$export$16ad849210e30509)(url) : false);
    const handleResolve = ()=>{
        if (isStreamingFlickerFixEnabled) (0, $2e7811d8106740bc$export$4221f35a82bb4741)(url);
        setResolved(true);
    };
    const handleError = ()=>{
        // Dismiss the skeleton on error, but do not record the URL as resolved so a
        // later remount can still attempt a fresh resolve from a clean state.
        setResolved(true);
        onError();
    };
    const { onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu } = (0, $809cafaeca2ec47b$export$bfdc42a78eb8bcc6)(onLinkClick, url, idx);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($572cabcf6e7462ad$var$styles.root, $572cabcf6e7462ad$var$styles.borderTop, borderTopRounded && $572cabcf6e7462ad$var$styles.borderTopRounded, borderBottomRounded && $572cabcf6e7462ad$var$styles.borderBottomRounded, !resolved && $572cabcf6e7462ad$var$styles.linkWrapperUnresolved),
        testId: `link-list-full-item-${idx}${borderTopRounded ? '-top-rounded' : ''}${borderBottomRounded ? '-bottom-rounded' : ''}`,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
        appearance: "block",
        url: url,
        onClick: onClick,
        ui: {
            theme: (0, $4yYAm.SmartLinkTheme).Black,
            clickableContainer: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true,
            size: (0, $4yYAm.SmartLinkSize).Medium,
            removeBlockRestriction: true
        },
        onError: handleError,
        onResolve: handleResolve
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        alignBlock: "center",
        xcss: $572cabcf6e7462ad$var$unboundedStyles.unboundedTitleWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $572cabcf6e7462ad$var$unboundedStyles.unboundedTitleBlock
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
        maxLines: 1,
        showActionOnHover: true,
        subtitle: [
            {
                name: (0, $4yYAm.ElementName).Provider,
                hideIcon: true
            },
            {
                name: (0, $4yYAm.ElementName).CreatedBy
            }
        ],
        position: (0, $4yYAm.SmartLinkPosition).Center
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $572cabcf6e7462ad$var$unboundedStyles.metadataStateSlot
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1503.default), {
        maxLines: 1,
        primary: [
            {
                name: (0, $4yYAm.ElementName).State
            }
        ]
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        alignBlock: "center",
        xcss: $572cabcf6e7462ad$var$unboundedStyles.unboundedMetadataWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $572cabcf6e7462ad$var$unboundedStyles.metadataAuthorSlot
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1503.default), {
        maxLines: 1,
        primary: [
            {
                name: (0, $4yYAm.ElementName).AuthorGroup
            }
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $572cabcf6e7462ad$var$unboundedStyles.metadataModifiedOnSlot
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1503.default), {
        maxLines: 1,
        primary: [
            {
                name: (0, $4yYAm.ElementName).ModifiedOn
            }
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $572cabcf6e7462ad$var$unboundedStyles.metadataPrioritySlot
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1503.default), {
        maxLines: 1,
        primary: [
            {
                name: (0, $4yYAm.ElementName).Priority
            }
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($572cabcf6e7462ad$var$unboundedStyles.hideTitleStyles, $572cabcf6e7462ad$var$unboundedStyles.previewSlot)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
        maxLines: 1,
        actions: [
            {
                name: (0, $4yYAm.ActionName).PreviewAction,
                hideContent: true
            }
        ],
        showActionOnHover: true,
        position: (0, $4yYAm.SmartLinkPosition).Center
    }))))), !resolved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($572cabcf6e7462ad$var$styles.unresolvedSkeletonOverlay, $572cabcf6e7462ad$var$styles.loadingContainer),
        testId: "unresolved-loading-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "16px",
        height: "16px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        xcss: $572cabcf6e7462ad$var$styles.loadingSkeletonRows,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "40%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "70%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    })))));
};
const $572cabcf6e7462ad$export$984f8adc5ac31b30 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(33);
    const { urls: urls, onLinkClick: onLinkClick, maxSources: t1, expandedMaxSources: expandedMaxSources, showExpand: t2, viewAllUrl: viewAllUrl, onViewAllLinkClick: onViewAllLinkClick } = t0;
    const maxSources = t1 === undefined ? (0, $9e11ded08cccb06b$export$533f831a441a4b64) : t1;
    const showExpand = t2 === undefined ? true : t2;
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const { erroredIndices: erroredIndices, markErrored: markErrored } = (0, $51eae9382efab009$export$9441241ba5515b77)();
    const safeMaxSources = maxSources >= 1 ? maxSources : (0, $9e11ded08cccb06b$export$533f831a441a4b64);
    let T0;
    let showExpandToggle;
    let showViewAll;
    let t3;
    let t4;
    let t5;
    if ($[0] !== erroredIndices || $[1] !== expandedMaxSources || $[2] !== isExpanded || $[3] !== markErrored || $[4] !== onLinkClick || $[5] !== safeMaxSources || $[6] !== showExpand || $[7] !== urls || $[8] !== viewAllUrl) {
        t5 = Symbol.for("react.early_return_sentinel");
        bb0: {
            let t6;
            if ($[15] !== erroredIndices) {
                t6 = (i_0)=>!erroredIndices.has(i_0);
                $[15] = erroredIndices;
                $[16] = t6;
            } else t6 = $[16];
            const visibleIndices = urls.map($572cabcf6e7462ad$var$_temp).filter(t6);
            const expandedCap = expandedMaxSources !== undefined && expandedMaxSources > safeMaxSources ? expandedMaxSources : undefined;
            const hasMore = showExpand && visibleIndices.length > safeMaxSources;
            const renderedIndices = isExpanded ? expandedCap !== undefined ? visibleIndices.slice(0, expandedCap) : visibleIndices : visibleIndices.slice(0, safeMaxSources);
            const firstVisibleIdx = renderedIndices[0] ?? -1;
            const lastVisibleIdx = renderedIndices[renderedIndices.length - 1] ?? -1;
            const allUrlsErrored = urls.length > 0 && erroredIndices.size === urls.length;
            if (allUrlsErrored) {
                let t7;
                if ($[17] !== onLinkClick || $[18] !== urls) {
                    t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $40d719e5f34e2f0d$export$fdef7686f3aefbe0), {
                        urls: urls,
                        onLinkClick: onLinkClick,
                        testIdPrefix: "link-list-full"
                    });
                    $[17] = onLinkClick;
                    $[18] = urls;
                    $[19] = t7;
                } else t7 = $[19];
                t5 = t7;
                break bb0;
            }
            showViewAll = !!viewAllUrl && (!hasMore || isExpanded);
            showExpandToggle = hasMore && !showViewAll;
            const hasFooter = showExpandToggle || showViewAll;
            T0 = (0, $dinVW.default);
            t3 = "space.0";
            t4 = renderedIndices.map((originalIdx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($572cabcf6e7462ad$var$LinkListFullComponent, {
                    key: `${urls[originalIdx]}-${originalIdx}`,
                    url: urls[originalIdx],
                    idx: originalIdx,
                    borderTopRounded: originalIdx === firstVisibleIdx,
                    borderBottomRounded: originalIdx === lastVisibleIdx && !hasFooter,
                    onError: ()=>markErrored(originalIdx),
                    onLinkClick: onLinkClick
                }));
        }
        $[0] = erroredIndices;
        $[1] = expandedMaxSources;
        $[2] = isExpanded;
        $[3] = markErrored;
        $[4] = onLinkClick;
        $[5] = safeMaxSources;
        $[6] = showExpand;
        $[7] = urls;
        $[8] = viewAllUrl;
        $[9] = T0;
        $[10] = showExpandToggle;
        $[11] = showViewAll;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
    } else {
        T0 = $[9];
        showExpandToggle = $[10];
        showViewAll = $[11];
        t3 = $[12];
        t4 = $[13];
        t5 = $[14];
    }
    if (t5 !== Symbol.for("react.early_return_sentinel")) return t5;
    let t6;
    if ($[20] !== isExpanded || $[21] !== showExpandToggle) {
        t6 = showExpandToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            xcss: (0, $w6R6I.cx)($572cabcf6e7462ad$var$styles.expandWrapper, $572cabcf6e7462ad$var$styles.borderBottomRounded),
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: ()=>setIsExpanded(!isExpanded)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            color: "color.text.subtlest"
        }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $572cabcf6e7462ad$var$messages.link_list_collapse) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $572cabcf6e7462ad$var$messages.link_list_expand))));
        $[20] = isExpanded;
        $[21] = showExpandToggle;
        $[22] = t6;
    } else t6 = $[22];
    let t7;
    if ($[23] !== onViewAllLinkClick || $[24] !== showViewAll || $[25] !== viewAllUrl) {
        t7 = showViewAll && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            xcss: (0, $w6R6I.cx)($572cabcf6e7462ad$var$styles.expandWrapper, $572cabcf6e7462ad$var$styles.borderBottomRounded),
            alignBlock: "center",
            testId: "link-list-full-view-all"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            appearance: "subtle",
            href: viewAllUrl,
            onClick: onViewAllLinkClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            color: "color.text.subtlest"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $572cabcf6e7462ad$var$messages.link_list_view_all))));
        $[23] = onViewAllLinkClick;
        $[24] = showViewAll;
        $[25] = viewAllUrl;
        $[26] = t7;
    } else t7 = $[26];
    let t8;
    if ($[27] !== T0 || $[28] !== t3 || $[29] !== t4 || $[30] !== t6 || $[31] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            space: t3
        }, t4, t6, t7);
        $[27] = T0;
        $[28] = t3;
        $[29] = t4;
        $[30] = t6;
        $[31] = t7;
        $[32] = t8;
    } else t8 = $[32];
    return t8;
} : ({ urls: urls, onLinkClick: onLinkClick, maxSources: maxSources = (0, $9e11ded08cccb06b$export$533f831a441a4b64), expandedMaxSources: expandedMaxSources, showExpand: showExpand = true, viewAllUrl: viewAllUrl, onViewAllLinkClick: onViewAllLinkClick })=>{
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const { erroredIndices: erroredIndices, markErrored: markErrored } = (0, $51eae9382efab009$export$9441241ba5515b77)(); // Clamp `maxSources` to a sensible positive integer — same defensive logic
    // as link-list-compact to keep the API forgiving.
    const safeMaxSources = maxSources >= 1 ? maxSources : (0, $9e11ded08cccb06b$export$533f831a441a4b64); // All non-errored original indices, preserving original positions
    const visibleIndices = urls.map((_, i)=>i).filter((i_0)=>!erroredIndices.has(i_0));
    const expandedCap = expandedMaxSources !== undefined && expandedMaxSources > safeMaxSources ? expandedMaxSources : undefined; // Only show the expand/collapse button when showExpand is true and there are
    // more items than safeMaxSources. When showExpand is false all items up to
    // safeMaxSources are shown immediately with no toggle.
    const hasMore = showExpand && visibleIndices.length > safeMaxSources;
    const renderedIndices = isExpanded ? expandedCap !== undefined ? visibleIndices.slice(0, expandedCap) : visibleIndices : visibleIndices.slice(0, safeMaxSources);
    const firstVisibleIdx = renderedIndices[0] ?? -1;
    const lastVisibleIdx = renderedIndices[renderedIndices.length - 1] ?? -1; // In the edge case that every url has errored, rather than rendering nothing
    // (which looks broken given the surrounding context), fall back to rendering
    // each URL as a plain ADS link so the user still sees the links
    const allUrlsErrored = urls.length > 0 && erroredIndices.size === urls.length;
    if (allUrlsErrored) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $40d719e5f34e2f0d$export$fdef7686f3aefbe0), {
        urls: urls,
        onLinkClick: onLinkClick,
        testIdPrefix: "link-list-full"
    });
    const showViewAll = !!viewAllUrl && (!hasMore || isExpanded);
    const showExpandToggle = hasMore && !showViewAll;
    const hasFooter = showExpandToggle || showViewAll;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.0"
    }, renderedIndices.map((originalIdx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($572cabcf6e7462ad$var$LinkListFullComponent, {
            key: `${urls[originalIdx]}-${originalIdx}`,
            url: urls[originalIdx],
            idx: originalIdx,
            borderTopRounded: originalIdx === firstVisibleIdx,
            borderBottomRounded: originalIdx === lastVisibleIdx && !hasFooter,
            onError: ()=>markErrored(originalIdx),
            onLinkClick: onLinkClick
        })), showExpandToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        xcss: (0, $w6R6I.cx)($572cabcf6e7462ad$var$styles.expandWrapper, $572cabcf6e7462ad$var$styles.borderBottomRounded),
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: ()=>setIsExpanded(!isExpanded)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text.subtlest"
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $572cabcf6e7462ad$var$messages.link_list_collapse) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $572cabcf6e7462ad$var$messages.link_list_expand)))), showViewAll && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        xcss: (0, $w6R6I.cx)($572cabcf6e7462ad$var$styles.expandWrapper, $572cabcf6e7462ad$var$styles.borderBottomRounded),
        alignBlock: "center",
        testId: "link-list-full-view-all"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        appearance: "subtle",
        href: viewAllUrl,
        onClick: onViewAllLinkClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $572cabcf6e7462ad$var$messages.link_list_view_all)))));
};
function $572cabcf6e7462ad$var$_temp(_, i) {
    return i;
}


const $1df145661bc5b3be$var$containerRoot = null;
const $1df145661bc5b3be$var$showCompact = null;
const $1df145661bc5b3be$var$showFull = null;
const $1df145661bc5b3be$export$533f831a441a4b64 = 4;
const $1df145661bc5b3be$export$bec64ed398b2de33 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { urls: urls, onLinkClick: onLinkClick, size: size, maxSources: maxSources, expandedMaxSources: expandedMaxSources, showExpand: showExpand, viewAllUrl: viewAllUrl, onViewAllLinkClick: onViewAllLinkClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1bsb1osq _7cca15wb _1f381bi7"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_1e0c1ule _1h0uglyw"
        ]);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== expandedMaxSources || $[3] !== maxSources || $[4] !== onLinkClick || $[5] !== onViewAllLinkClick || $[6] !== showExpand || $[7] !== size || $[8] !== urls || $[9] !== viewAllUrl) {
        t3 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t2
        }, /*#__PURE__*/ $cozmU.createElement((0, $29001a291e34995f$export$1fbb558f111cbbf9), {
            urls: urls,
            onLinkClick: onLinkClick,
            size: size,
            maxSources: maxSources,
            expandedMaxSources: expandedMaxSources,
            showExpand: showExpand,
            viewAllUrl: viewAllUrl,
            onViewAllLinkClick: onViewAllLinkClick
        }));
        $[2] = expandedMaxSources;
        $[3] = maxSources;
        $[4] = onLinkClick;
        $[5] = onViewAllLinkClick;
        $[6] = showExpand;
        $[7] = size;
        $[8] = urls;
        $[9] = viewAllUrl;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_1e0cglyw _1h0u1ule"
        ]);
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== expandedMaxSources || $[13] !== maxSources || $[14] !== onLinkClick || $[15] !== onViewAllLinkClick || $[16] !== showExpand || $[17] !== urls || $[18] !== viewAllUrl) {
        t5 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t4
        }, /*#__PURE__*/ $cozmU.createElement((0, $572cabcf6e7462ad$export$984f8adc5ac31b30), {
            urls: urls,
            onLinkClick: onLinkClick,
            maxSources: maxSources,
            expandedMaxSources: expandedMaxSources,
            showExpand: showExpand,
            viewAllUrl: viewAllUrl,
            onViewAllLinkClick: onViewAllLinkClick
        }));
        $[12] = expandedMaxSources;
        $[13] = maxSources;
        $[14] = onLinkClick;
        $[15] = onViewAllLinkClick;
        $[16] = showExpand;
        $[17] = urls;
        $[18] = viewAllUrl;
        $[19] = t5;
    } else t5 = $[19];
    let t6;
    if ($[20] !== t3 || $[21] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t1
        }, /*#__PURE__*/ $cozmU.createElement((0, $5HApy.SmartCardProvider), null, t3, t5));
        $[20] = t3;
        $[21] = t5;
        $[22] = t6;
    } else t6 = $[22];
    return t6;
} : ({ urls: urls, onLinkClick: onLinkClick, size: size, maxSources: maxSources, expandedMaxSources: expandedMaxSources, showExpand: showExpand, viewAllUrl: viewAllUrl, onViewAllLinkClick: onViewAllLinkClick })=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1bsb1osq _7cca15wb _1f381bi7"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1e0c1ule _1h0uglyw"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $29001a291e34995f$export$1fbb558f111cbbf9), {
        urls: urls,
        onLinkClick: onLinkClick,
        size: size,
        maxSources: maxSources,
        expandedMaxSources: expandedMaxSources,
        showExpand: showExpand,
        viewAllUrl: viewAllUrl,
        onViewAllLinkClick: onViewAllLinkClick
    })), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1e0cglyw _1h0u1ule"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $572cabcf6e7462ad$export$984f8adc5ac31b30), {
        urls: urls,
        onLinkClick: onLinkClick,
        maxSources: maxSources,
        expandedMaxSources: expandedMaxSources,
        showExpand: showExpand,
        viewAllUrl: viewAllUrl,
        onViewAllLinkClick: onViewAllLinkClick
    }))));
};
module.exports["LinkList"] = $1df145661bc5b3be$export$bec64ed398b2de33;

});

parcelRegister("l8wPz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $gTPfK = parcelRequire("gTPfK");

var $lzgC6 = parcelRequire("lzgC6");


var $6GOAK = parcelRequire("6GOAK");





var $9EOlJ = parcelRequire("9EOlJ");


var $6cFsl = parcelRequire("6cFsl");


var $kHija = parcelRequire("kHija");


var $ixfCV = parcelRequire("ixfCV");


var $6Vsq4 = parcelRequire("6Vsq4");


var $jdqmT = parcelRequire("jdqmT");


var $16kNn = parcelRequire("16kNn");


var $1smAh = parcelRequire("1smAh");


var $4abK1 = parcelRequire("4abK1");


var $98Qqv = parcelRequire("98Qqv");


var $1384B = parcelRequire("1384B");


const $6108acbd43407f01$export$a7690c318cd6a95e = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(0, $16kNn.importWithRetry)(()=>(parcelRequire("gGqlT"))));
function $6108acbd43407f01$export$e00a7788e30dc998(props) {
    (0, $6cFsl.di)($6108acbd43407f01$export$a7690c318cd6a95e);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $cozmU.useState)(()=>props.id ? props.id : (0, (/*@__PURE__*/$parcel$interopDefault($kHija)))());
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        // ComponentWillUnmount
        return ()=>{
            (0, $98Qqv.clearMarks)(id);
            (0, $98Qqv.clearMeasures)(id);
        };
    }, [
        id
    ]);
    const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, placeholder: placeholder, fallbackComponent: fallbackComponent, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt, disablePreviewPanel: disablePreviewPanel } = props;
    const isFlexibleUi = (0, $4abK1.isFlexibleUiCard)(children, ui);
    const analyticsContext = (0, $1smAh.useSmartLinkAnalyticsContext)({
        display: isFlexibleUi ? 'flexible' : appearance,
        id: id,
        url: url ?? ''
    });
    const errorHandler = (0, $cozmU.useCallback)((error, info)=>{
        const { componentStack: componentStack } = info;
        const errorInfo = {
            componentStack: componentStack
        };
        // NB: APIErrors are thrown in response to Object Resolver Service. We do not
        // fire an event for these, as they do not cover failed UI render events.
        // The rest of the errors caught here are unexpected, and correlate
        // to the reliability of the smart-card front-end components.
        // Likewise, chunk loading errors are not caused by a failure of smart-card rendering.
        if (error.name === 'ChunkLoadError') fireEvent('operational.smartLink.chunkLoadFailed', {
            ...analyticsContext?.attributes,
            display: appearance,
            error: error,
            errorInfo: errorInfo,
            definitionId: null
        });
        else if (error.name !== 'APIError') {
            (0, $jdqmT.startUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $jdqmT.failUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $jdqmT.failUfoExperience)('smart-link-authenticated', id || 'NULL');
            fireEvent('ui.smartLink.renderFailed', {
                ...analyticsContext?.attributes,
                display: isFlexibleUi ? 'flexible' : appearance,
                id: id ?? null,
                error: error,
                errorInfo: errorInfo
            });
        }
        onError && onError({
            status: 'errored',
            url: url ?? '',
            err: error
        });
    }, [
        analyticsContext?.attributes,
        appearance,
        fireEvent,
        id,
        isFlexibleUi,
        onError,
        url
    ]);
    if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
    const defaultFallBackComponent = ()=>null;
    const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
    const ErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FallbackComponent, null);
    // FlexibleCards always need full ORS data regardless of appearance prop,
    // because they render custom blocks (TitleBlock etc.) requiring complete response.
    // Override appearance to 'block' for all FlexibleCards when FG is enabled.
    const effectiveAppearance = isFlexibleUi && (0, $ixfCV.fg)('platform_smartlink_inline_resolve_optimization') ? 'block' : appearance;
    const cardWithUrlProps = {
        id: id,
        url: url,
        appearance: effectiveAppearance,
        onClick: onClick,
        isSelected: isSelected,
        isHovered: isHovered,
        frameStyle: frameStyle,
        container: container,
        onResolve: onResolve,
        onError: onError,
        testId: testId,
        actionOptions: actionOptions,
        inheritDimensions: inheritDimensions,
        platform: platform,
        embedIframeRef: embedIframeRef,
        embedIframeUrlType: embedIframeUrlType,
        inlinePreloaderStyle: inlinePreloaderStyle,
        ui: ui,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        placeholder: placeholder,
        removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
        resolvingPlaceholder: resolvingPlaceholder,
        truncateInline: truncateInline,
        CompetitorPrompt: CompetitorPrompt,
        disablePreviewPanel: disablePreviewPanel
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        FallbackComponent: ErrorFallback,
        onError: errorHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1384B.LoadingCardLink), cardWithUrlProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6108acbd43407f01$export$a7690c318cd6a95e, cardWithUrlProps, children)));
}


class $d596ea86ef004430$var$PlainCard extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6108acbd43407f01$export$e00a7788e30dc998), this.props);
        return this.props.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            locale: "en"
        }, content);
    }
}
const $d596ea86ef004430$export$60332b2344f7fe41 = (0, $gTPfK.default)((0, $6GOAK.context))((0, $lzgC6.default)()((0, $kSwu1.injectIntl)($d596ea86ef004430$var$PlainCard, {
    enforceContext: false
})));
module.exports["Card"] = $d596ea86ef004430$export$60332b2344f7fe41;

});

parcelRegister("16kNn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $ixfCV = parcelRequire("ixfCV");


var $fcaWu = parcelRequire("fcaWu");


var $4yYAm = parcelRequire("4yYAm");


var $1VjCT = parcelRequire("1VjCT");

const $cf28b62f923f1c16$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($cf28b62f923f1c16$export$e6c5ffa684aac4d7() || $cf28b62f923f1c16$export$d8de0cd37d316fdf(evt) || $cf28b62f923f1c16$export$5b1771037ab7c451(evt));
const $cf28b62f923f1c16$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
const $cf28b62f923f1c16$export$d8de0cd37d316fdf = (event)=>{
    return (0, $ixfCV.fg)('platform-smart-card-shift-key') ? event.metaKey || event.ctrlKey || event.shiftKey : event.metaKey || event.ctrlKey;
};
const $cf28b62f923f1c16$export$5b1771037ab7c451 = (event)=>event.button === 1;
const $cf28b62f923f1c16$export$4d685c85ebc7a1e3 = (fileMimeType, showIconLabel)=>{
    if (!fileMimeType) return;
    let icon = $cf28b62f923f1c16$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "Zuvzb",
        name: "Icon",
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    if ((0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y')) {
        const descriptorLabel = icon[1] || ''; // NAVX-4354: Combine into const [importCb] = icon; above
        const label = showIconLabel ?? true ? descriptorLabel : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            testId: "document-file-format-icon",
            label: label
        });
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        testId: "document-file-format-icon"
    });
};
























































































const $cf28b62f923f1c16$export$92d31eb5326761b6 = ()=>{
    return {
        // IconTile wrappers (@atlaskit/icon/core/* wrapped in <IconTile> with color)
        [(0, $4yYAm.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("2jRrx")))
        },
        [(0, $4yYAm.IconType).Audio]: {
            default: ()=>(parcelRequire("bvcyI"))
        },
        [(0, $4yYAm.IconType).Code]: {
            default: ()=>(parcelRequire("hc68Z"))
        },
        [(0, $4yYAm.IconType).File]: {
            default: ()=>(parcelRequire("hCYYB"))
        },
        [(0, $4yYAm.IconType).Folder]: {
            default: ()=>(parcelRequire("b3Fnp"))
        },
        [(0, $4yYAm.IconType).Generic]: {
            default: ()=>(parcelRequire("hCYYB"))
        },
        [(0, $4yYAm.IconType).Image]: {
            default: ()=>(parcelRequire("iz1Wf"))
        },
        [(0, $4yYAm.IconType).Presentation]: {
            default: ()=>(parcelRequire("7aEvo"))
        },
        [(0, $4yYAm.IconType).Spreadsheet]: {
            default: ()=>(parcelRequire("in8Hx"))
        },
        [(0, $4yYAm.IconType).Video]: {
            default: ()=>(parcelRequire("ltObF"))
        },
        // @atlaskit/icon/core/* (plain monochrome icons)
        [(0, $4yYAm.IconType).Project]: {
            default: ()=>Promise.resolve((parcelRequire("fBqzD")))
        },
        [(0, $4yYAm.IconType).Template]: {
            default: ()=>Promise.resolve((parcelRequire("kkFbH")))
        },
        [(0, $4yYAm.IconType).Forbidden]: {
            default: ()=>Promise.resolve((parcelRequire("4efpo")))
        },
        [(0, $4yYAm.IconType).Default]: {
            default: ()=>Promise.resolve((parcelRequire("kTb7m")))
        },
        [(0, $4yYAm.IconType).Error]: {
            default: ()=>Promise.resolve((parcelRequire("24dy7")))
        },
        // @atlaskit/icon/core/* (badge icons)
        [(0, $4yYAm.IconType).Attachment]: {
            default: ()=>Promise.resolve((parcelRequire("gxI48")))
        },
        [(0, $4yYAm.IconType).CheckItem]: {
            default: ()=>Promise.resolve((parcelRequire("iAaYd")))
        },
        [(0, $4yYAm.IconType).Component]: {
            default: ()=>(parcelRequire("bOKLW"))
        },
        [(0, $4yYAm.IconType).Comment]: {
            default: ()=>Promise.resolve((parcelRequire("eDtFr")))
        },
        [(0, $4yYAm.IconType).View]: {
            default: ()=>Promise.resolve((parcelRequire("a79Sy")))
        },
        [(0, $4yYAm.IconType).React]: {
            default: ()=>Promise.resolve((parcelRequire("c8bBH")))
        },
        [(0, $4yYAm.IconType).Vote]: {
            default: ()=>Promise.resolve((parcelRequire("f6cdQ")))
        },
        [(0, $4yYAm.IconType).PriorityUndefined]: {
            default: ()=>Promise.resolve((parcelRequire("kyJuy")))
        },
        [(0, $4yYAm.IconType).ProgrammingLanguage]: {
            default: ()=>Promise.resolve((parcelRequire("6YkHb")))
        },
        [(0, $4yYAm.IconType).Subscriber]: {
            default: ()=>Promise.resolve((parcelRequire("fBqzD")))
        },
        [(0, $4yYAm.IconType).SubTasksProgress]: {
            default: ()=>Promise.resolve((parcelRequire("lSw2p")))
        },
        // @atlaskit/icon-file-type/glyph/* (file type icons with 16/24 size variants)
        [(0, $4yYAm.IconType).Archive]: {
            default: ()=>(parcelRequire("8KvsV")),
            large: ()=>(parcelRequire("infyS"))
        },
        [(0, $4yYAm.IconType).Executable]: {
            default: ()=>(parcelRequire("kKj89")),
            large: ()=>(parcelRequire("jH9Kl"))
        },
        [(0, $4yYAm.IconType).GIF]: {
            default: ()=>(parcelRequire("1N5Ke")),
            large: ()=>(parcelRequire("hNtm1"))
        },
        [(0, $4yYAm.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("7KlQ2")),
            large: ()=>(parcelRequire("h2ScA"))
        },
        [(0, $4yYAm.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("4D6tQ")),
            large: ()=>(parcelRequire("5t4l8"))
        },
        [(0, $4yYAm.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("30pMN")),
            large: ()=>(parcelRequire("22LPp"))
        },
        [(0, $4yYAm.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("hbVly")),
            large: ()=>(parcelRequire("4UzML"))
        },
        [(0, $4yYAm.IconType).MSExcel]: {
            default: ()=>(parcelRequire("5eRas")),
            large: ()=>(parcelRequire("7oGQO"))
        },
        [(0, $4yYAm.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("bmQsw")),
            large: ()=>(parcelRequire("8e6lY"))
        },
        [(0, $4yYAm.IconType).MSWord]: {
            default: ()=>(parcelRequire("3tCrI")),
            large: ()=>(parcelRequire("60b70"))
        },
        [(0, $4yYAm.IconType).PDF]: {
            default: ()=>(parcelRequire("eiZGU")),
            large: ()=>(parcelRequire("iBf9z"))
        },
        [(0, $4yYAm.IconType).Sketch]: {
            default: ()=>(parcelRequire("ldRXm")),
            large: ()=>(parcelRequire("dJIeK"))
        },
        // Keep blog/live-document out of the lazy map on purpose.
        // These icons should be present in SSR markup so hydration does not cause
        // a visible empty-state-then-pop-in transition in Smart Link consumers.
        [(0, $4yYAm.IconType).Branch]: {
            default: ()=>(parcelRequire("7t6Dm")),
            large: ()=>(parcelRequire("jsJnf")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $4yYAm.IconType).Commit]: {
            default: ()=>(parcelRequire("duHmw")),
            large: ()=>(parcelRequire("aQVr4")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $4yYAm.IconType).PullRequest]: {
            default: ()=>(parcelRequire("gXlTT")),
            large: ()=>(parcelRequire("1ChPv")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $4yYAm.IconType).Repo]: {
            default: ()=>(parcelRequire("5RVCA")),
            large: ()=>(parcelRequire("8CdxX")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $4yYAm.IconType).Bug]: {
            default: ()=>(parcelRequire("j55Vn")),
            large: ()=>(parcelRequire("99NnD")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $4yYAm.IconType).Change]: {
            default: ()=>(parcelRequire("eY8PF")),
            large: ()=>(parcelRequire("j2Hlo")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $4yYAm.IconType).Epic]: {
            default: ()=>(parcelRequire("f37yM")),
            large: ()=>(parcelRequire("a5N9p")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $4yYAm.IconType).Incident]: {
            default: ()=>(parcelRequire("ejH6V")),
            large: ()=>(parcelRequire("8TcgT")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $4yYAm.IconType).Problem]: {
            default: ()=>(parcelRequire("9moVO")),
            large: ()=>(parcelRequire("itIA9")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $4yYAm.IconType).ServiceRequest]: {
            default: ()=>(parcelRequire("7xZuu")),
            large: ()=>(parcelRequire("8T3P5")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $4yYAm.IconType).Story]: {
            default: ()=>(parcelRequire("jvfZM")),
            large: ()=>(parcelRequire("gSpIm")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $4yYAm.IconType).SubTask]: {
            default: ()=>(parcelRequire("f6nAm")),
            large: ()=>(parcelRequire("4Fqpf")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $4yYAm.IconType).Task]: {
            default: ()=>(parcelRequire("8myMn")),
            large: ()=>(parcelRequire("90g3C")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        // @atlaskit/logo/* (product logos)
        [(0, $4yYAm.IconType).Confluence]: {
            default: ()=>Promise.resolve((parcelRequire("9Q3yl"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                        default: ConfluenceIcon
                    }))
        },
        [(0, $4yYAm.IconType).Jira]: {
            default: ()=>(parcelRequire("ikUqI")).then(({ JiraIcon: JiraIcon })=>({
                        default: JiraIcon
                    }))
        },
        // Local priority icons (custom SVG components)
        [(0, $4yYAm.IconType).PriorityBlocker]: {
            default: ()=>(parcelRequire("6Rrir"))
        },
        [(0, $4yYAm.IconType).PriorityCritical]: {
            default: ()=>(parcelRequire("axzmT"))
        },
        [(0, $4yYAm.IconType).PriorityHigh]: {
            default: ()=>(parcelRequire("hu5AB"))
        },
        [(0, $4yYAm.IconType).PriorityHighest]: {
            default: ()=>(parcelRequire("ivBzr"))
        },
        [(0, $4yYAm.IconType).PriorityLow]: {
            default: ()=>(parcelRequire("8eL3s"))
        },
        [(0, $4yYAm.IconType).PriorityLowest]: {
            default: ()=>(parcelRequire("jRI2o"))
        },
        [(0, $4yYAm.IconType).PriorityMajor]: {
            default: ()=>(parcelRequire("Dv6V4"))
        },
        [(0, $4yYAm.IconType).PriorityMedium]: {
            default: ()=>(parcelRequire("jvVtM"))
        },
        [(0, $4yYAm.IconType).PriorityMinor]: {
            default: ()=>(parcelRequire("gEo4s"))
        },
        [(0, $4yYAm.IconType).PriorityTrivial]: {
            default: ()=>(parcelRequire("jIg9v"))
        }
    };
};
const $cf28b62f923f1c16$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $1VjCT.default)(fileFormat);
    if (!iconDescriptor?.icon) return null;
    const lazyIcons = $cf28b62f923f1c16$export$92d31eb5326761b6();
    if ((0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y')) return [
        lazyIcons[iconDescriptor.icon]?.default,
        iconDescriptor.label ?? ''
    ];
    else return [
        lazyIcons[iconDescriptor.icon]?.default
    ];
};
const $cf28b62f923f1c16$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
const $cf28b62f923f1c16$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
const $cf28b62f923f1c16$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
const $cf28b62f923f1c16$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $cf28b62f923f1c16$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await $cf28b62f923f1c16$export$e772c8ff12451969(interval);
            return $cf28b62f923f1c16$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};
const $cf28b62f923f1c16$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $cf28b62f923f1c16$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
const $cf28b62f923f1c16$export$4470f298c61a79da = (previewUrl, themeState)=>{
    try {
        const url = new URL(previewUrl);
        url.searchParams.append('themeState', (0, $fcaWu.themeObjectToString)(themeState));
        return url.href;
    } catch  {
        return previewUrl;
    }
};
const $cf28b62f923f1c16$export$d2b8fb9e780e17e7 = (size)=>size && [
        (0, $4yYAm.SmartLinkSize).Large,
        (0, $4yYAm.SmartLinkSize).XLarge
    ].includes(size);
const $cf28b62f923f1c16$export$6a4545d6b336c401 = (type)=>!!(type && type.includes('Profile'));
const $cf28b62f923f1c16$export$8793edee2d425525 = ()=>undefined;
module.exports["isSpecialEvent"] = $cf28b62f923f1c16$export$efca2c4705678489;
module.exports["isSpecialKey"] = $cf28b62f923f1c16$export$d8de0cd37d316fdf;
module.exports["isSpecialClick"] = $cf28b62f923f1c16$export$5b1771037ab7c451;
module.exports["getIconForFileType"] = $cf28b62f923f1c16$export$4d685c85ebc7a1e3;
module.exports["getLazyIcons"] = $cf28b62f923f1c16$export$92d31eb5326761b6;
module.exports["getIframeSandboxAttribute"] = $cf28b62f923f1c16$export$9b7e6a102056a387;
module.exports["handleOnClick"] = $cf28b62f923f1c16$export$ffccab2ae3d093ef;
module.exports["isIntersectionObserverSupported"] = $cf28b62f923f1c16$export$6c837641a9ab03cb;
module.exports["importWithRetry"] = $cf28b62f923f1c16$export$aacbf48ace518c5a;
module.exports["downloadUrl"] = $cf28b62f923f1c16$export$8a96edb1c96563f4;
module.exports["openUrl"] = $cf28b62f923f1c16$export$a238cfe4a10e6279;
module.exports["getPreviewUrlWithTheme"] = $cf28b62f923f1c16$export$4470f298c61a79da;
module.exports["isIconSizeLarge"] = $cf28b62f923f1c16$export$d2b8fb9e780e17e7;
module.exports["isProfileType"] = $cf28b62f923f1c16$export$6a4545d6b336c401;
module.exports["noop"] = $cf28b62f923f1c16$export$8793edee2d425525;

});

parcelRegister("1VjCT", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $4yYAm = parcelRequire("4yYAm");

const $58ae73a79d15b91a$var$extractFileFormatIcon = (fileFormat)=>{
    const getIconDescriptor = (icon, label)=>(0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y') ? {
            icon: icon,
            label: label
        } : {
            icon: icon
        };
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return getIconDescriptor((0, $4yYAm.IconType).Folder, 'folder');
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return getIconDescriptor((0, $4yYAm.IconType).Document, 'document');
        case 'application/pdf':
            return getIconDescriptor((0, $4yYAm.IconType).PDF, 'pdf');
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return getIconDescriptor((0, $4yYAm.IconType).Presentation, 'presentation');
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return getIconDescriptor((0, $4yYAm.IconType).Spreadsheet, 'spreadsheet');
        // Google Drive
        case 'application/vnd.google-apps.document':
            return getIconDescriptor((0, $4yYAm.IconType).GoogleDocs, 'google document');
        case 'application/vnd.google-apps.form':
            return getIconDescriptor((0, $4yYAm.IconType).GoogleForms, 'google form');
        case 'application/vnd.google-apps.spreadsheet':
            return getIconDescriptor((0, $4yYAm.IconType).GoogleSheets, 'google sheet');
        case 'application/vnd.google-apps.presentation':
            return getIconDescriptor((0, $4yYAm.IconType).GoogleSlides, 'google slide');
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return getIconDescriptor((0, $4yYAm.IconType).MSExcel, 'excel spreadsheet');
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return getIconDescriptor((0, $4yYAm.IconType).MSPowerpoint, 'powerpoint');
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return getIconDescriptor((0, $4yYAm.IconType).MSWord, 'word document');
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return getIconDescriptor((0, $4yYAm.IconType).Image, 'image');
        case 'image/gif':
            return getIconDescriptor((0, $4yYAm.IconType).GIF, 'gif');
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return getIconDescriptor((0, $4yYAm.IconType).Audio, 'audio');
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return getIconDescriptor((0, $4yYAm.IconType).Video, 'video');
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return getIconDescriptor((0, $4yYAm.IconType).Code, 'code');
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return getIconDescriptor((0, $4yYAm.IconType).Archive, 'archive');
        case 'application/dmg':
            return getIconDescriptor((0, $4yYAm.IconType).Executable, 'disk image');
        case 'application/sketch':
            return getIconDescriptor((0, $4yYAm.IconType).Sketch, 'sketch');
        case 'application/octet-stream':
            return getIconDescriptor((0, $4yYAm.IconType).Generic, 'file');
        case 'application/invision.prototype':
            return getIconDescriptor((0, $4yYAm.IconType).Generic, 'file');
        default:
            return undefined;
    }
};
var $58ae73a79d15b91a$export$2e2bcd8739ae039 = $58ae73a79d15b91a$var$extractFileFormatIcon;
module.exports["default"] = $58ae73a79d15b91a$export$2e2bcd8739ae039;

});

parcelRegister("bvcyI", function(module, exports) {

let $85fc54e6b663bd09$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $85fc54e6b663bd09$var$load("gkVge"),
    $85fc54e6b663bd09$var$load("kGKln")
]).then(()=>parcelRequire('aKPSY'));

});

parcelRegister("hc68Z", function(module, exports) {

let $c84852b61c694686$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c84852b61c694686$var$load("6wr18"),
    $c84852b61c694686$var$load("ffEVr"),
    $c84852b61c694686$var$load("bAe4U")
]).then(()=>parcelRequire('h2YSA'));

});

parcelRegister("hCYYB", function(module, exports) {

let $cd5548ea4e420c5a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cd5548ea4e420c5a$var$load("6wr18"),
    $cd5548ea4e420c5a$var$load("ffEVr"),
    $cd5548ea4e420c5a$var$load("1pJPT")
]).then(()=>parcelRequire('ipz0N'));

});

parcelRegister("b3Fnp", function(module, exports) {

let $80d0120e31aabe05$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $80d0120e31aabe05$var$load("6wr18"),
    $80d0120e31aabe05$var$load("ffEVr"),
    $80d0120e31aabe05$var$load("bsuUF")
]).then(()=>parcelRequire('6CIfi'));

});

parcelRegister("iz1Wf", function(module, exports) {

let $037cdad5f1808a44$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $037cdad5f1808a44$var$load("6wr18"),
    $037cdad5f1808a44$var$load("ffEVr"),
    $037cdad5f1808a44$var$load("g36gj")
]).then(()=>parcelRequire('ae0Qi'));

});

parcelRegister("7aEvo", function(module, exports) {

let $5388e315b58f69ad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5388e315b58f69ad$var$load("6wr18"),
    $5388e315b58f69ad$var$load("ffEVr"),
    $5388e315b58f69ad$var$load("duEFL")
]).then(()=>parcelRequire('f49me'));

});

parcelRegister("in8Hx", function(module, exports) {

let $d6011fdf467654b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d6011fdf467654b7$var$load("6wr18"),
    $d6011fdf467654b7$var$load("ffEVr"),
    $d6011fdf467654b7$var$load("6fJCf")
]).then(()=>parcelRequire('jBJvN'));

});

parcelRegister("ltObF", function(module, exports) {

let $fa333c899ef52dd3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fa333c899ef52dd3$var$load("6wr18"),
    $fa333c899ef52dd3$var$load("ffEVr"),
    $fa333c899ef52dd3$var$load("14QdI")
]).then(()=>parcelRequire('8Lnna'));

});

parcelRegister("bOKLW", function(module, exports) {

let $89a8a5347591510c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $89a8a5347591510c$var$load("9ZAcQ").then(()=>parcelRequire('gF3RM'));

});

parcelRegister("8KvsV", function(module, exports) {

let $65eb06ff5571b2cc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $65eb06ff5571b2cc$var$load("5JWJI").then(()=>parcelRequire('iqehY'));

});

parcelRegister("infyS", function(module, exports) {

let $d606722c1dde4e4e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d606722c1dde4e4e$var$load("5JWJI").then(()=>parcelRequire('9TA3F'));

});

parcelRegister("kKj89", function(module, exports) {

let $f1a6f16f6403b629$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1a6f16f6403b629$var$load("aQ5uu").then(()=>parcelRequire('3OVVx'));

});

parcelRegister("jH9Kl", function(module, exports) {

let $e56997ec3ac6dc2c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e56997ec3ac6dc2c$var$load("aQ5uu").then(()=>parcelRequire('jTyNF'));

});

parcelRegister("1N5Ke", function(module, exports) {

let $14ded2ce3ce05390$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $14ded2ce3ce05390$var$load("geXPZ").then(()=>parcelRequire('EhIdb'));

});

parcelRegister("hNtm1", function(module, exports) {

let $cf4dc864b8d1c362$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cf4dc864b8d1c362$var$load("geXPZ").then(()=>parcelRequire('gCL8n'));

});

parcelRegister("7KlQ2", function(module, exports) {

let $5a3dc4e9d091ba35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a3dc4e9d091ba35$var$load("b4nm1").then(()=>parcelRequire('hmd8r'));

});

parcelRegister("h2ScA", function(module, exports) {

let $c68caaf277d94ac1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c68caaf277d94ac1$var$load("b4nm1").then(()=>parcelRequire('l8FBD'));

});

parcelRegister("4D6tQ", function(module, exports) {

let $35efd4ccf002d2a8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $35efd4ccf002d2a8$var$load("jfYeU").then(()=>parcelRequire('lLxTI'));

});

parcelRegister("5t4l8", function(module, exports) {

let $3fb306fbb619c67f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3fb306fbb619c67f$var$load("jfYeU").then(()=>parcelRequire('cSPDT'));

});

parcelRegister("30pMN", function(module, exports) {

let $23055fbb4908668b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $23055fbb4908668b$var$load("kYkz1").then(()=>parcelRequire('kUQwC'));

});

parcelRegister("22LPp", function(module, exports) {

let $17d0de54722123d7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $17d0de54722123d7$var$load("kYkz1").then(()=>parcelRequire('lhYzt'));

});

parcelRegister("hbVly", function(module, exports) {

let $c83ff29c592bd62f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c83ff29c592bd62f$var$load("5kI0b").then(()=>parcelRequire('1G3Dq'));

});

parcelRegister("4UzML", function(module, exports) {

let $393826a85003934f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $393826a85003934f$var$load("5kI0b").then(()=>parcelRequire('3Ll8s'));

});

parcelRegister("5eRas", function(module, exports) {

let $3d078090de5174e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3d078090de5174e1$var$load("3i44s").then(()=>parcelRequire('1kVaD'));

});

parcelRegister("7oGQO", function(module, exports) {

let $562c0391ce984de1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $562c0391ce984de1$var$load("3i44s").then(()=>parcelRequire('67SYT'));

});

parcelRegister("bmQsw", function(module, exports) {

let $846a710eb4b35adb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $846a710eb4b35adb$var$load("4QwAJ").then(()=>parcelRequire('aeJll'));

});

parcelRegister("8e6lY", function(module, exports) {

let $5fd48f2b4743c564$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5fd48f2b4743c564$var$load("4QwAJ").then(()=>parcelRequire('6lknI'));

});

parcelRegister("3tCrI", function(module, exports) {

let $2881e71a7d44971f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2881e71a7d44971f$var$load("fHlIz").then(()=>parcelRequire('8If3N'));

});

parcelRegister("60b70", function(module, exports) {

let $45eb5cc32d998b84$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $45eb5cc32d998b84$var$load("fHlIz").then(()=>parcelRequire('fGSwx'));

});

parcelRegister("eiZGU", function(module, exports) {

let $a6a299b1e4e47c5f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a6a299b1e4e47c5f$var$load("aaRXj").then(()=>parcelRequire('8B1YK'));

});

parcelRegister("iBf9z", function(module, exports) {

let $d8a76fd6b50df6a9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d8a76fd6b50df6a9$var$load("aaRXj").then(()=>parcelRequire('90EXt'));

});

parcelRegister("ldRXm", function(module, exports) {

let $f734aa7c232eacf4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f734aa7c232eacf4$var$load("6OMo6").then(()=>parcelRequire('AzmWu'));

});

parcelRegister("dJIeK", function(module, exports) {

let $a001cad5375096fd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a001cad5375096fd$var$load("6OMo6").then(()=>parcelRequire('8BODT'));

});

parcelRegister("7t6Dm", function(module, exports) {

let $57006329b0bc9a93$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $57006329b0bc9a93$var$load("6wr18"),
    $57006329b0bc9a93$var$load("ffEVr"),
    $57006329b0bc9a93$var$load("aFLSJ")
]).then(()=>parcelRequire('iMQz5'));

});

parcelRegister("jsJnf", function(module, exports) {

let $e2b3d43217e721e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e2b3d43217e721e1$var$load("6wr18"),
    $e2b3d43217e721e1$var$load("ffEVr"),
    $e2b3d43217e721e1$var$load("aFLSJ")
]).then(()=>parcelRequire('f7FiQ'));

});

parcelRegister("duHmw", function(module, exports) {

let $9d2fb68e04e8e7a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9d2fb68e04e8e7a4$var$load("6wr18"),
    $9d2fb68e04e8e7a4$var$load("ffEVr"),
    $9d2fb68e04e8e7a4$var$load("3Cky6")
]).then(()=>parcelRequire('39Mwn'));

});

parcelRegister("aQVr4", function(module, exports) {

let $7e6b50379560811c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7e6b50379560811c$var$load("6wr18"),
    $7e6b50379560811c$var$load("ffEVr"),
    $7e6b50379560811c$var$load("3Cky6")
]).then(()=>parcelRequire('6gVpf'));

});

parcelRegister("gXlTT", function(module, exports) {

let $c58325007db064ed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c58325007db064ed$var$load("6wr18"),
    $c58325007db064ed$var$load("ffEVr"),
    $c58325007db064ed$var$load("39XCn")
]).then(()=>parcelRequire('gITbz'));

});

parcelRegister("1ChPv", function(module, exports) {

let $12d72bae2090e27c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $12d72bae2090e27c$var$load("6wr18"),
    $12d72bae2090e27c$var$load("ffEVr"),
    $12d72bae2090e27c$var$load("39XCn")
]).then(()=>parcelRequire('lvsY2'));

});

parcelRegister("5RVCA", function(module, exports) {

let $445e99693cc22e4e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $445e99693cc22e4e$var$load("6wr18"),
    $445e99693cc22e4e$var$load("ffEVr"),
    $445e99693cc22e4e$var$load("kG5Ju")
]).then(()=>parcelRequire('3CYX0'));

});

parcelRegister("8CdxX", function(module, exports) {

let $645c616a73e875d0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $645c616a73e875d0$var$load("6wr18"),
    $645c616a73e875d0$var$load("ffEVr"),
    $645c616a73e875d0$var$load("kG5Ju")
]).then(()=>parcelRequire('2z1Cx'));

});

parcelRegister("j55Vn", function(module, exports) {

let $de431466ddbc1ea0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $de431466ddbc1ea0$var$load("6wr18"),
    $de431466ddbc1ea0$var$load("ffEVr"),
    $de431466ddbc1ea0$var$load("4N1MY")
]).then(()=>parcelRequire('fHe6f'));

});

parcelRegister("99NnD", function(module, exports) {

let $6aab422f6512c9dc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6aab422f6512c9dc$var$load("6wr18"),
    $6aab422f6512c9dc$var$load("ffEVr"),
    $6aab422f6512c9dc$var$load("4N1MY")
]).then(()=>parcelRequire('ix7Nw'));

});

parcelRegister("eY8PF", function(module, exports) {

let $ae5d8538e2b1e6a9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ae5d8538e2b1e6a9$var$load("6wr18"),
    $ae5d8538e2b1e6a9$var$load("ffEVr"),
    $ae5d8538e2b1e6a9$var$load("il8bj")
]).then(()=>parcelRequire('ahlZa'));

});

parcelRegister("j2Hlo", function(module, exports) {

let $ddcfd373104ef90d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ddcfd373104ef90d$var$load("6wr18"),
    $ddcfd373104ef90d$var$load("ffEVr"),
    $ddcfd373104ef90d$var$load("il8bj")
]).then(()=>parcelRequire('lfmf4'));

});

parcelRegister("f37yM", function(module, exports) {

let $af4d001497becc1e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $af4d001497becc1e$var$load("6wr18"),
    $af4d001497becc1e$var$load("ffEVr"),
    $af4d001497becc1e$var$load("aIze1")
]).then(()=>parcelRequire('6MsAF'));

});

parcelRegister("a5N9p", function(module, exports) {

let $75907f57f5ec24c2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $75907f57f5ec24c2$var$load("6wr18"),
    $75907f57f5ec24c2$var$load("ffEVr"),
    $75907f57f5ec24c2$var$load("aIze1")
]).then(()=>parcelRequire('bht3M'));

});

parcelRegister("ejH6V", function(module, exports) {

let $a6c447e90d918ccf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a6c447e90d918ccf$var$load("6wr18"),
    $a6c447e90d918ccf$var$load("ffEVr"),
    $a6c447e90d918ccf$var$load("7rqWx")
]).then(()=>parcelRequire('38zdI'));

});

parcelRegister("8TcgT", function(module, exports) {

let $678cfaa208640d00$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $678cfaa208640d00$var$load("6wr18"),
    $678cfaa208640d00$var$load("ffEVr"),
    $678cfaa208640d00$var$load("7rqWx")
]).then(()=>parcelRequire('tBrWH'));

});

parcelRegister("9moVO", function(module, exports) {

let $6d098204d7643aa5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6d098204d7643aa5$var$load("6wr18"),
    $6d098204d7643aa5$var$load("ffEVr"),
    $6d098204d7643aa5$var$load("jw3lv")
]).then(()=>parcelRequire('cVpj0'));

});

parcelRegister("itIA9", function(module, exports) {

let $d73d84854886bfaf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d73d84854886bfaf$var$load("6wr18"),
    $d73d84854886bfaf$var$load("ffEVr"),
    $d73d84854886bfaf$var$load("jw3lv")
]).then(()=>parcelRequire('e9ExL'));

});

parcelRegister("7xZuu", function(module, exports) {

let $57eb5042297dc78b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $57eb5042297dc78b$var$load("6wr18"),
    $57eb5042297dc78b$var$load("ffEVr"),
    $57eb5042297dc78b$var$load("cvcNg")
]).then(()=>parcelRequire('S7fVP'));

});

parcelRegister("8T3P5", function(module, exports) {

let $67866cf71443d7d2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $67866cf71443d7d2$var$load("6wr18"),
    $67866cf71443d7d2$var$load("ffEVr"),
    $67866cf71443d7d2$var$load("cvcNg")
]).then(()=>parcelRequire('2hwbE'));

});

parcelRegister("jvfZM", function(module, exports) {

let $e32d51ebd2ceaabd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e32d51ebd2ceaabd$var$load("6wr18"),
    $e32d51ebd2ceaabd$var$load("ffEVr"),
    $e32d51ebd2ceaabd$var$load("jXM1T")
]).then(()=>parcelRequire('bvjEB'));

});

parcelRegister("gSpIm", function(module, exports) {

let $c495a2de92f273d8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c495a2de92f273d8$var$load("6wr18"),
    $c495a2de92f273d8$var$load("ffEVr"),
    $c495a2de92f273d8$var$load("jXM1T")
]).then(()=>parcelRequire('bnm2b'));

});

parcelRegister("f6nAm", function(module, exports) {

let $afe9b61e1a0aa105$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $afe9b61e1a0aa105$var$load("6wr18"),
    $afe9b61e1a0aa105$var$load("ffEVr"),
    $afe9b61e1a0aa105$var$load("4zz48")
]).then(()=>parcelRequire('jMFOf'));

});

parcelRegister("4Fqpf", function(module, exports) {

let $365f7980cfa3706a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $365f7980cfa3706a$var$load("6wr18"),
    $365f7980cfa3706a$var$load("ffEVr"),
    $365f7980cfa3706a$var$load("4zz48")
]).then(()=>parcelRequire('h3uhG'));

});

parcelRegister("8myMn", function(module, exports) {

let $616b5b41539023df$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $616b5b41539023df$var$load("6wr18"),
    $616b5b41539023df$var$load("ffEVr"),
    $616b5b41539023df$var$load("iZR3N")
]).then(()=>parcelRequire('a5G9M'));

});

parcelRegister("90g3C", function(module, exports) {

let $68e091c9a3c7e630$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $68e091c9a3c7e630$var$load("6wr18"),
    $68e091c9a3c7e630$var$load("ffEVr"),
    $68e091c9a3c7e630$var$load("iZR3N")
]).then(()=>parcelRequire('glDuG'));

});

parcelRegister("ikUqI", function(module, exports) {

let $d595de0e350d3e88$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d595de0e350d3e88$var$load("6d0iA").then(()=>parcelRequire('kfIvf'));

});

parcelRegister("6Rrir", function(module, exports) {

let $4fecddd6d059d6bc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4fecddd6d059d6bc$var$load("dLlEf").then(()=>parcelRequire('4BUQa'));

});

parcelRegister("axzmT", function(module, exports) {

let $7ac86bd7e8159ef3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7ac86bd7e8159ef3$var$load("lTD4q").then(()=>parcelRequire('9pjdU'));

});

parcelRegister("hu5AB", function(module, exports) {

let $cba992ed98f3f721$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cba992ed98f3f721$var$load("bS9St").then(()=>parcelRequire('6FjBd'));

});

parcelRegister("ivBzr", function(module, exports) {

let $d79843f7ae595d77$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d79843f7ae595d77$var$load("2h70j").then(()=>parcelRequire('KBRug'));

});

parcelRegister("8eL3s", function(module, exports) {

let $5ff421a7d963b984$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5ff421a7d963b984$var$load("5QGlM").then(()=>parcelRequire('cE6CC'));

});

parcelRegister("jRI2o", function(module, exports) {

let $e765207d0c63adc0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e765207d0c63adc0$var$load("byTC2").then(()=>parcelRequire('4CWUM'));

});

parcelRegister("Dv6V4", function(module, exports) {

let $076bc68d1d77800d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $076bc68d1d77800d$var$load("idWEh").then(()=>parcelRequire('drfxQ'));

});

parcelRegister("jvVtM", function(module, exports) {

let $e34d7fbe06f843d4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e34d7fbe06f843d4$var$load("2H6qb").then(()=>parcelRequire('fnUY6'));

});

parcelRegister("gEo4s", function(module, exports) {

let $c1f30dbea68431bc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c1f30dbea68431bc$var$load("g7Lpi").then(()=>parcelRequire('74BpP'));

});

parcelRegister("jIg9v", function(module, exports) {

let $e59ea7e9f8765cbf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e59ea7e9f8765cbf$var$load("bmmHV").then(()=>parcelRequire('hayQy'));

});

parcelRegister("4abK1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");



var $0e6ecfe32bfe345f$exports = {};
$parcel$export($0e6ecfe32bfe345f$exports, "FooterBlock", () => (parcelRequire("aKJEB")).default);
$parcel$export($0e6ecfe32bfe345f$exports, "MetadataBlock", () => (parcelRequire("i1503")).default);
$parcel$export($0e6ecfe32bfe345f$exports, "PreviewBlock", () => (parcelRequire("voDgt")).default);
$parcel$export($0e6ecfe32bfe345f$exports, "SnippetBlock", () => (parcelRequire("es2gJ")).default);
$parcel$export($0e6ecfe32bfe345f$exports, "TitleBlock", () => (parcelRequire("jdA6O")).default);
$parcel$export($0e6ecfe32bfe345f$exports, "CustomBlock", () => (parcelRequire("3qg1D")).default);
$parcel$export($0e6ecfe32bfe345f$exports, "InternalFooterBlock", () => (parcelRequire("hSS22")).default);
$parcel$export($0e6ecfe32bfe345f$exports, "AISummaryBlock", () => (parcelRequire("i9PP7")).default);
$parcel$export($0e6ecfe32bfe345f$exports, "AIFooterBlock", () => (parcelRequire("8v3AV")).default);
$parcel$export($0e6ecfe32bfe345f$exports, "ResolvedHoverCardFooterBlock", () => (parcelRequire("l7FKw")).default);
$parcel$export($0e6ecfe32bfe345f$exports, "ActionBlock", () => (parcelRequire("9PQfP")).default);

var $aKJEB = parcelRequire("aKJEB");


var $i1503 = parcelRequire("i1503");


var $voDgt = parcelRequire("voDgt");


var $es2gJ = parcelRequire("es2gJ");


var $jdA6O = parcelRequire("jdA6O");


var $3qg1D = parcelRequire("3qg1D");


var $hSS22 = parcelRequire("hSS22");


var $i9PP7 = parcelRequire("i9PP7");


var $8v3AV = parcelRequire("8v3AV");


var $l7FKw = parcelRequire("l7FKw");


var $9PQfP = parcelRequire("9PQfP");




var $li470 = parcelRequire("li470");

const $6743bd4e81ad74b7$export$3c94e0f4719f5c2a = (children, ui)=>{
    if (ui?.removeBlockRestriction) return children && (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children)?.length > 0 ? true : false;
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children).some((child)=>$6743bd4e81ad74b7$export$df0092b19156b140(child))) return true;
    return false;
};
const $6743bd4e81ad74b7$export$14ff825bfe645006 = (node)=>{
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) return true;
    else if (typeof node.type !== 'string' && node.type?.name === 'CC' && node.props.children) return true;
    return false;
};
const $6743bd4e81ad74b7$export$b56fc89cf6e7d1e9 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(node)) return false;
    if ($6743bd4e81ad74b7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $6743bd4e81ad74b7$export$b56fc89cf6e7d1e9(child);
        });
        return isChildrenValid;
    }
    if (Object.values($0e6ecfe32bfe345f$exports).some((type)=>type === node.type)) return true;
    return false;
};
const $6743bd4e81ad74b7$export$d7fc505bb0bd5756 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(node)) return false;
    if (Object.values($li470).some((type)=>type === node.type)) return true;
    if ($6743bd4e81ad74b7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $6743bd4e81ad74b7$export$d7fc505bb0bd5756(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $6743bd4e81ad74b7$export$df0092b19156b140 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(node)) return false;
    if (node.type === (0, $jdA6O.default)) return true;
    if ($6743bd4e81ad74b7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $6743bd4e81ad74b7$export$df0092b19156b140(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $6743bd4e81ad74b7$export$c0547b4405cae584 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(node)) return false;
    if (node.type === (0, $voDgt.default)) return true;
    if ($6743bd4e81ad74b7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $6743bd4e81ad74b7$export$c0547b4405cae584(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $6743bd4e81ad74b7$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(node) && node.type === (0, $aKJEB.default);
module.exports["isFlexibleUiCard"] = $6743bd4e81ad74b7$export$3c94e0f4719f5c2a;
module.exports["isStyleCacheProvider"] = $6743bd4e81ad74b7$export$14ff825bfe645006;
module.exports["isFlexibleUiBlock"] = $6743bd4e81ad74b7$export$b56fc89cf6e7d1e9;
module.exports["isFlexibleUiElement"] = $6743bd4e81ad74b7$export$d7fc505bb0bd5756;
module.exports["isFlexibleUiPreviewBlock"] = $6743bd4e81ad74b7$export$c0547b4405cae584;

});

parcelRegister("aKJEB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $hSS22 = parcelRequire("hSS22");

/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $8a36bd3253a439cd$var$FooterBlock = ({ testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    const cardContext = (0, $9PA4G.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $4yYAm.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSS22.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId
    });
};
var $8a36bd3253a439cd$export$2e2bcd8739ae039 = $8a36bd3253a439cd$var$FooterBlock;
module.exports["default"] = $8a36bd3253a439cd$export$2e2bcd8739ae039;

});

parcelRegister("9PA4G", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $e8448976eac6bdb2$export$13dde4423ab71d62 = (0, $cozmU.createContext)(undefined);
const $e8448976eac6bdb2$export$a8c4167e4e9f26ab = ()=>(0, $cozmU.useContext)($e8448976eac6bdb2$export$13dde4423ab71d62);
const $e8448976eac6bdb2$export$61d7957a243df7aa = ()=>$e8448976eac6bdb2$export$a8c4167e4e9f26ab()?.data;
const $e8448976eac6bdb2$export$e6b5ad18b56e8f51 = ()=>$e8448976eac6bdb2$export$a8c4167e4e9f26ab()?.ui;
module.exports["FlexibleCardContext"] = $e8448976eac6bdb2$export$13dde4423ab71d62;
module.exports["useFlexibleCardContext"] = $e8448976eac6bdb2$export$a8c4167e4e9f26ab;
module.exports["useFlexibleUiContext"] = $e8448976eac6bdb2$export$61d7957a243df7aa;
module.exports["useFlexibleUiOptionContext"] = $e8448976eac6bdb2$export$e6b5ad18b56e8f51;

});

parcelRegister("hSS22", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $a3Cph = parcelRequire("a3Cph");


var $1LXnB = parcelRequire("1LXnB");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $fCf6x = parcelRequire("fCf6x");


var $3M4EV = parcelRequire("3M4EV");


var $3qg1D = parcelRequire("3qg1D");


var $knKT4 = parcelRequire("knKT4");


var $1xR0T = parcelRequire("1xR0T");

const $5fa216af8f5b31f0$var$actionGroupStyles = null;
const $5fa216af8f5b31f0$var$safariStyles = null;
const $5fa216af8f5b31f0$var$providerStyles = null;
const $5fa216af8f5b31f0$var$rovoActionStyles = null;
const $5fa216af8f5b31f0$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $4yYAm.SmartLinkSize).Medium, hideProvider: hideProvider, isPreviewBlockErrored: isPreviewBlockErrored } = props;
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const rovoChatAction = context?.actions?.[(0, $4yYAm.ActionName).RovoChatAction];
    const isRovoActionsEnabled = (0, $cozmU.useMemo)(()=>{
        return !!rovoChatAction && rovoChatAction.product === 'CONFLUENCE' && actions?.some((action)=>action.name === 'RovoChatAction');
    }, [
        rovoChatAction,
        actions
    ]);
    const hasPreview = isRovoActionsEnabled && !!context?.preview && !isPreviewBlockErrored;
    const hasActions = (0, $cozmU.useMemo)(()=>(0, $1xR0T.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]); // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $cozmU.useMemo)(()=>(0, $a3Cph.browser)(), []);
    const onDropdownOpenChange = (0, $cozmU.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]); // WidthObserver fires whenever the footer's available width changes.
    const [containerWidth, setContainerWidth] = (0, $cozmU.useState)(undefined);
    return /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, !hideProvider && /*#__PURE__*/ $cozmU.createElement((0, $fCf6x.default), {
        appearance: "subtle",
        testId: `${testId}-provider`,
        hideLabel: hasPreview,
        className: (0, $hekY6.default)([
            isRovoActionsEnabled && "_1wpz1h6o"
        ])
    }), actions && hasActions ? /*#__PURE__*/ $cozmU.createElement((0, $knKT4.default), {
        testId: "smart-element-group-actions",
        align: (0, $4yYAm.SmartLinkAlignment).Right,
        direction: (0, $4yYAm.SmartLinkDirection).Horizontal,
        width: (0, $4yYAm.SmartLinkWidth).Flexible,
        className: (0, $hekY6.default)([
            size === (0, $4yYAm.SmartLinkSize).XLarge && "_c71lxy5q",
            safari && "_4t3i1osq",
            isRovoActionsEnabled && "_kqswh2mm"
        ])
    }, !!rovoChatAction && rovoChatAction?.product === 'CONFLUENCE' && /*#__PURE__*/ $cozmU.createElement((0, $1LXnB.default), {
        setWidth: setContainerWidth,
        offscreen: true
    }), /*#__PURE__*/ $cozmU.createElement((0, $3M4EV.default), {
        onDropdownOpenChange: onDropdownOpenChange,
        items: actions,
        appearance: isRovoActionsEnabled ? 'subtle' : 'default',
        size: isRovoActionsEnabled ? (0, $4yYAm.SmartLinkSize).Small : size,
        containerWidth: isRovoActionsEnabled ? containerWidth : undefined
    })) : null);
};
var $5fa216af8f5b31f0$export$2e2bcd8739ae039 = $5fa216af8f5b31f0$var$FooterBlockResolvedView;
module.exports["default"] = $5fa216af8f5b31f0$export$2e2bcd8739ae039;

});

parcelRegister("8QLAc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cMyWi = parcelRequire("cMyWi");

const $e955061c8afbfdff$var$useRovoConfig = ()=>{
    const { rovoOptions: rovoOptions, product: product } = (0, $cMyWi.useSmartLinkContext)();
    return (0, $cozmU.useMemo)(()=>({
            rovoOptions: rovoOptions,
            product: product
        }), [
        rovoOptions,
        product
    ]);
};
var $e955061c8afbfdff$export$2e2bcd8739ae039 = $e955061c8afbfdff$var$useRovoConfig;
module.exports["default"] = $e955061c8afbfdff$export$2e2bcd8739ae039;

});

parcelRegister("88149", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2Fmt9 = parcelRequire("2Fmt9");


var $ixfCV = parcelRequire("ixfCV");


var $4yYAm = parcelRequire("4yYAm");


var $16kNn = parcelRequire("16kNn");

/**
 * Maps IconTile appearance to the icon glyph color token to use when rendering
 * a standalone icon (without a tile background).
 */ const $407e0bb5517fa1a2$var$appearanceToStandaloneIconColor = {
    blue: "var(--ds-icon-accent-blue, #357DE8)",
    blueBold: "var(--ds-icon-accent-blue, #357DE8)",
    gray: "var(--ds-icon-accent-gray, #7D818A)",
    grayBold: "var(--ds-icon-accent-gray, #7D818A)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E06C00)",
    orangeBold: "var(--ds-icon-accent-orange, #E06C00)",
    purple: "var(--ds-icon-accent-purple, #AF59E1)",
    purpleBold: "var(--ds-icon-accent-purple, #AF59E1)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
const $407e0bb5517fa1a2$export$3acc3fb10995f020 = (size)=>{
    if ((0, $ixfCV.fg)('platform_sl_icons_refactor')) switch(size){
        case (0, $4yYAm.SmartLinkSize).Small:
        case (0, $4yYAm.SmartLinkSize).Medium:
            return undefined;
        case (0, $4yYAm.SmartLinkSize).XLarge:
        case (0, $4yYAm.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
    switch(size){
        case (0, $4yYAm.SmartLinkSize).XLarge:
        case (0, $4yYAm.SmartLinkSize).Large:
            return 'small';
        default:
            // SmartLinkSize.Small, SmartLinkSize.Medium, and undefined all
            // previously mapped to size="16" which has been removed. Render
            // the icon directly (no tile) for these sizes.
            return undefined;
    }
};
const $407e0bb5517fa1a2$export$28dd5ad82647c000 = (ObjectIcon, ObjectTileIcon)=>{
    return ({ size: size, ...props })=>{
        if ((0, $16kNn.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ObjectTileIcon, {
            ...props,
            size: "small"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ObjectIcon, props);
    };
};
const $407e0bb5517fa1a2$export$87c3646d0e299cfe = (Icon, appearance)=>{
    return ({ size: size, isTiledIcon: isTiledIcon, ...props })=>{
        const tileSize = $407e0bb5517fa1a2$export$3acc3fb10995f020(size);
        if (tileSize === undefined) {
            // size="16" has been removed — render the icon directly without a tile,
            // using the appearance-derived color so it still matches the intended style.
            const label = props.label ?? '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                role: label ? 'img' : undefined,
                "aria-label": label || undefined,
                "data-testid": props.testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                color: $407e0bb5517fa1a2$var$appearanceToStandaloneIconColor[appearance],
                label: ""
            }));
        }
        const { shape: _shape, UNSAFE_circleReplacementComponent: _unsafe, ...tileProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Fmt9.IconTile), {
            appearance: appearance,
            icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                    ...iconProps,
                    spacing: "spacious"
                }) : Icon,
            size: tileSize,
            ...tileProps
        });
    };
};
module.exports["transformSmartLinkSizeToIconTileSize"] = $407e0bb5517fa1a2$export$3acc3fb10995f020;
module.exports["renderIconPerSize"] = $407e0bb5517fa1a2$export$28dd5ad82647c000;
module.exports["renderIconTile"] = $407e0bb5517fa1a2$export$87c3646d0e299cfe;

});

parcelRegister("lYcSC", function(module, exports) {
// This file is the FG-OFF fallback for platform_sl_icons_refactor.
// Delete this file when platform_sl_icons_refactor is cleaned up.

var $iW3KC = parcelRequire("iW3KC");


var $ai0Ge = parcelRequire("ai0Ge");


var $88149 = parcelRequire("88149");

const $e72e4900a096031d$var$BlogIconWithColor = (0, $88149.renderIconPerSize)((0, $iW3KC.default), (0, $ai0Ge.default));
$e72e4900a096031d$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $e72e4900a096031d$export$2e2bcd8739ae039 = $e72e4900a096031d$var$BlogIconWithColor;
module.exports["default"] = $e72e4900a096031d$export$2e2bcd8739ae039;

});

parcelRegister("2jRrx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $hMaHH = parcelRequire("hMaHH");


var $88149 = parcelRequire("88149");

const $1e952d673c6be6e0$var$PageIconWithColor = (0, $88149.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), 'blueBold');
$1e952d673c6be6e0$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $1e952d673c6be6e0$export$2e2bcd8739ae039 = $1e952d673c6be6e0$var$PageIconWithColor;
module.exports["default"] = $1e952d673c6be6e0$export$2e2bcd8739ae039;

});

parcelRegister("66hVV", function(module, exports) {
// This file is the FG-OFF fallback for platform_sl_icons_refactor.
// Delete this file when platform_sl_icons_refactor is cleaned up.

var $7pJjg = parcelRequire("7pJjg");


var $dipyx = parcelRequire("dipyx");


var $88149 = parcelRequire("88149");

const $ac3693948c0eb166$var$LiveDocumentIconWithColor = (0, $88149.renderIconPerSize)((0, $7pJjg.default), (0, $dipyx.default));
$ac3693948c0eb166$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $ac3693948c0eb166$export$2e2bcd8739ae039 = $ac3693948c0eb166$var$LiveDocumentIconWithColor;
module.exports["default"] = $ac3693948c0eb166$export$2e2bcd8739ae039;

});

parcelRegister("3M4EV", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $7joZr = parcelRequire("7joZr");


var $1sCHt = parcelRequire("1sCHt");


var $7ZB0A = parcelRequire("7ZB0A");


var $3vgx3 = parcelRequire("3vgx3");


var $6TaGl = parcelRequire("6TaGl");


var $ixfCV = parcelRequire("ixfCV");


var $lpNn5 = parcelRequire("lpNn5");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $9PA4G = parcelRequire("9PA4G");


var $8QLAc = parcelRequire("8QLAc");


var $edVsK = parcelRequire("edVsK");


var $acUNT = parcelRequire("acUNT");


var $1xR0T = parcelRequire("1xR0T");





var $7K8i3 = parcelRequire("7K8i3");

const $1a85ac9775b31ba0$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $cozmU.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $7K8i3 ? $7K8i3[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $1a85ac9775b31ba0$export$2e2bcd8739ae039 = $1a85ac9775b31ba0$var$ActionGroupItem;


const $1f94c9c7d09c94b8$var$styles = null;
const $1f94c9c7d09c94b8$var$FULL_ACTIONS_SIZE = 450;
const $1f94c9c7d09c94b8$var$REDUCED_ACTIONS_SIZE = 360;
const $1f94c9c7d09c94b8$var$ICON_ONLY_ACTIONS_SIZE = 200;
const $1f94c9c7d09c94b8$var$OVERFLOW_ONLY_ACTIONS_SIZE = 100;
const $1f94c9c7d09c94b8$var$renderActionItems = (items = [], size = (0, $4yYAm.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ $cozmU.createElement((0, $1a85ac9775b31ba0$export$2e2bcd8739ae039), {
            item: item,
            key: idx,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        })); /**
                                                                                                                                                                                                                                                                                                                                                                                                            * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
                                                                                                                                                                                                                                                                                                                                                                                                            * preferences.
                                                                                                                                                                                                                                                                                                                                                                                                            * @internal
                                                                                                                                                                                                                                                                                                                                                                                                            * @param {ActionGroupProps} ActionGroupProps
                                                                                                                                                                                                                                                                                                                                                                                                            * @see Action
                                                                                                                                                                                                                                                                                                                                                                                                            */ 
const $1f94c9c7d09c94b8$var$ActionGroup = ({ items: items = [], size: size = (0, $4yYAm.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange, containerWidth: containerWidth = Infinity })=>{
    (0, $6cFsl.di)((0, $3vgx3.default));
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const ui = (0, $9PA4G.useFlexibleUiOptionContext)();
    const { product: product } = (0, $8QLAc.default)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const renderableActionItems = (0, $cozmU.useMemo)(()=>(0, $1xR0T.filterActionItems)(items, context, product), [
        context,
        items,
        product
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const rovoChatAction = context?.actions?.[(0, $4yYAm.ActionName).RovoChatAction];
    const isRovoActionsEnabled = (0, $cozmU.useMemo)(()=>{
        return !!rovoChatAction && rovoChatAction.product === 'CONFLUENCE' && items.some((action)=>action.name === 'RovoChatAction');
    }, [
        rovoChatAction,
        items
    ]);
    const onOpenChange = (0, $cozmU.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $cozmU.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $cozmU.useMemo)(()=>{
        if (isRovoActionsEnabled) {
            const rovoActions = [
                ...containerWidth >= $1f94c9c7d09c94b8$var$REDUCED_ACTIONS_SIZE ? renderableActionItems.slice(0, visibleButtonsNum - 1) : [],
                ...containerWidth >= $1f94c9c7d09c94b8$var$OVERFLOW_ONLY_ACTIONS_SIZE ? [
                    {
                        name: (0, $4yYAm.ActionName).RovoChatAction,
                        prompts: [
                            (0, $edVsK.RovoChatPromptKey).ASK_ROVO_ANYTHING
                        ],
                        iconSize: 'small',
                        cardAppearance: (0, $4yYAm.CardDisplay).Block,
                        hideContent: containerWidth < $1f94c9c7d09c94b8$var$FULL_ACTIONS_SIZE && containerWidth >= $1f94c9c7d09c94b8$var$REDUCED_ACTIONS_SIZE || containerWidth < $1f94c9c7d09c94b8$var$ICON_ONLY_ACTIONS_SIZE && containerWidth >= $1f94c9c7d09c94b8$var$OVERFLOW_ONLY_ACTIONS_SIZE
                    },
                    {
                        name: (0, $4yYAm.ActionName).CopyLinkAction,
                        hideContent: true,
                        iconSize: 'small'
                    },
                    {
                        name: (0, $4yYAm.ActionName).PreviewAction,
                        hideContent: true,
                        iconSize: 'small'
                    }
                ] : []
            ];
            return $1f94c9c7d09c94b8$var$renderActionItems(rovoActions, size, appearance, false, onActionItemClick);
        }
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $1f94c9c7d09c94b8$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum,
        isRovoActionsEnabled,
        containerWidth
    ]);
    const moreActionDropdown = (0, $cozmU.useMemo)(()=>{
        let actionItems;
        if (isRovoActionsEnabled && containerWidth < $1f94c9c7d09c94b8$var$OVERFLOW_ONLY_ACTIONS_SIZE) actionItems = [
            ...renderableActionItems,
            {
                name: (0, $4yYAm.ActionName).RovoChatAction,
                prompts: [
                    (0, $edVsK.RovoChatPromptKey).ASK_ROVO_ANYTHING
                ],
                iconSize: 'small',
                cardAppearance: (0, $4yYAm.CardDisplay).Block
            },
            {
                name: (0, $4yYAm.ActionName).CopyLinkAction,
                iconSize: 'small'
            },
            {
                name: (0, $4yYAm.ActionName).PreviewAction,
                iconSize: 'small'
            }
        ];
        else if (isRovoActionsEnabled && containerWidth < $1f94c9c7d09c94b8$var$REDUCED_ACTIONS_SIZE) actionItems = renderableActionItems;
        else actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $acUNT.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).more_actions);
            const moreIconAppearance = appearance !== 'subtle' ? 'default' : appearance;
            return /*#__PURE__*/ $cozmU.createElement((0, $3vgx3.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span"
                    }, (0, $ixfCV.fg)('navx-5343-sl-action-block-styling-fixes') ? /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                        ...props,
                        spacing: size === (0, $4yYAm.SmartLinkSize).XLarge ? 'default' : 'compact',
                        testId: "action-group-more-button",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                        ref: triggerRef,
                        label: "more",
                        color: "currentColor",
                        ...isRovoActionsEnabled ? {
                            appearance: moreIconAppearance
                        } : {}
                    }) : /*#__PURE__*/ $cozmU.createElement((0, $7ZB0A.default), {
                        ...props,
                        spacing: isRovoActionsEnabled ? size === (0, $4yYAm.SmartLinkSize).XLarge ? 'default' : 'compact' : spacing,
                        testId: "action-group-more-button",
                        iconBefore: moreIcon,
                        ref: triggerRef,
                        ...isRovoActionsEnabled ? {
                            appearance: appearance
                        } : {}
                    })),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex
            }, $1f94c9c7d09c94b8$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick));
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum,
        isRovoActionsEnabled,
        containerWidth
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_1e0c116y _dzc21h6o _1ilq1i6y",
            "actions-button-group"
        ]),
        "data-action-open": isOpen
    }, /*#__PURE__*/ $cozmU.createElement((0, $7joZr.default), null, actionButtons, moreActionDropdown)) : null;
};
var $1f94c9c7d09c94b8$export$2e2bcd8739ae039 = $1f94c9c7d09c94b8$var$ActionGroup;
module.exports["default"] = $1f94c9c7d09c94b8$export$2e2bcd8739ae039;

});

parcelRegister("edVsK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9UcmI = parcelRequire("9UcmI");


var $mfdwv = parcelRequire("mfdwv");


var $f0b2F = parcelRequire("f0b2F");


var $bLfHG = parcelRequire("bLfHG");


var $bltJZ = parcelRequire("bltJZ");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");

/* ai-chapter-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $hekY6 = parcelRequire("hekY6");

const $5d1eb2b6c0e657fd$var$style = {
    foreignObject: "_11q7hndj _4t3i1osq _1bsb1osq _tzy4kb7n"
};
const $5d1eb2b6c0e657fd$var$AiChapterIcon = (props)=>/*#__PURE__*/ $cozmU.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $cozmU.createElement("g", {
        clipPath: "url(#paint0_angular_1804_15128_clip_path)",
        "data-figma-skip-parse": "true"
    }, /*#__PURE__*/ $cozmU.createElement("g", {
        transform: "matrix(0.008 -0.00939228 0.0100184 0.0075 12 12.5)"
    }, /*#__PURE__*/ $cozmU.createElement("foreignObject", {
        x: "-1047.5",
        y: "-1047.5",
        width: "2095.01",
        height: "2095.01"
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $5d1eb2b6c0e657fd$var$style.foreignObject
        ])
    })))), /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 6.5V16.5H11.2495V18H5.375C4.61561 18 4 17.3844 4 16.625V6.375C4 5.6175 4.61251 5 5.37379 5L8.8749 5.00001C10.1576 5.00001 11.2947 5.6232 11.9999 6.58333C12.7053 5.62319 13.8425 5.00001 15.1251 5.00001L18.6253 5C19.3874 5 20 5.61967 20 6.37637V12.25H18.5V6.50082L15.1251 6.50001C13.8134 6.50001 12.7499 7.56337 12.7499 8.87496V14H11.2499V8.87498C11.2499 7.56332 10.1866 6.50001 8.8749 6.50001L5.5 6.5ZM17.2495 10H14.4995V8.5H17.2495V10ZM6.75049 8.50001H9.50049V10H6.75049V8.50001ZM6.75049 11H9.50049V12.5H6.75049V11ZM15.7945 13.4943C15.9025 13.1982 16.184 13.0013 16.4991 13.0013C16.8142 13.0013 17.0962 13.1982 17.2042 13.4943L17.8193 15.1807L19.5057 15.7958C19.8017 15.9038 19.9987 16.1853 19.9987 16.5004C19.9987 16.8155 19.8017 17.0975 19.5057 17.2055L17.8193 17.8206L17.2042 19.507C17.0962 19.803 16.8147 20 16.4996 20C16.1845 20 15.9025 19.803 15.7945 19.507L15.1794 17.8206L13.493 17.2055C13.197 17.0975 13 16.816 13 16.5009C13 16.1858 13.197 15.9038 13.493 15.7958L15.1794 15.1807L15.7945 13.4943Z",
        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":16.000001907348633,"m01":20.036861419677734,"m02":-6.0184345245361328,"m10":-18.784559249877930,"m11":15.000002861022949,"m12":14.392276763916016},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    }), /*#__PURE__*/ $cozmU.createElement("defs", null, /*#__PURE__*/ $cozmU.createElement("clipPath", {
        id: "paint0_angular_1804_15128_clip_path"
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 6.5V16.5H11.2495V18H5.375C4.61561 18 4 17.3844 4 16.625V6.375C4 5.6175 4.61251 5 5.37379 5L8.8749 5.00001C10.1576 5.00001 11.2947 5.6232 11.9999 6.58333C12.7053 5.62319 13.8425 5.00001 15.1251 5.00001L18.6253 5C19.3874 5 20 5.61967 20 6.37637V12.25H18.5V6.50082L15.1251 6.50001C13.8134 6.50001 12.7499 7.56337 12.7499 8.87496V14H11.2499V8.87498C11.2499 7.56332 10.1866 6.50001 8.8749 6.50001L5.5 6.5ZM17.2495 10H14.4995V8.5H17.2495V10ZM6.75049 8.50001H9.50049V10H6.75049V8.50001ZM6.75049 11H9.50049V12.5H6.75049V11ZM15.7945 13.4943C15.9025 13.1982 16.184 13.0013 16.4991 13.0013C16.8142 13.0013 17.0962 13.1982 17.2042 13.4943L17.8193 15.1807L19.5057 15.7958C19.8017 15.9038 19.9987 16.1853 19.9987 16.5004C19.9987 16.8155 19.8017 17.0975 19.5057 17.2055L17.8193 17.8206L17.2042 19.507C17.0962 19.803 16.8147 20 16.4996 20C16.1845 20 15.9025 19.803 15.7945 19.507L15.1794 17.8206L13.493 17.2055C13.197 17.0975 13 16.816 13 16.5009C13 16.1858 13.197 15.9038 13.493 15.7958L15.1794 15.1807L15.7945 13.4943Z"
    }))));
$5d1eb2b6c0e657fd$var$AiChapterIcon.displayName = 'AiChapterIcon';
var $5d1eb2b6c0e657fd$export$2e2bcd8739ae039 = $5d1eb2b6c0e657fd$var$AiChapterIcon;


/* ai-search-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $11b5a217c0474393$var$style = {
    foreignObject: "_11q7hndj _4t3i1osq _1bsb1osq _tzy4kb7n"
};
const $11b5a217c0474393$var$AiSearchIcon = (props)=>/*#__PURE__*/ $cozmU.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $cozmU.createElement("g", {
        clipPath: "url(#paint0_angular_1804_8080_clip_path)",
        "data-figma-skip-parse": "true"
    }, /*#__PURE__*/ $cozmU.createElement("g", {
        transform: "matrix(0.00701514 -0.00941124 0.00878508 0.00751514 12.0151 11.5151)"
    }, /*#__PURE__*/ $cozmU.createElement("foreignObject", {
        x: "-1058.95",
        y: "-1058.95",
        width: "2117.91",
        height: "2117.91"
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $11b5a217c0474393$var$style.foreignObject
        ])
    })))), /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M10 6.6123C7.9961 7.0671 6.5 8.85847 6.5 11C6.5 13.4853 8.51472 15.5 11 15.5C12.2428 15.5 13.3665 14.9968 14.1816 14.1816C14.7712 13.5921 15.1959 12.8407 15.3867 12H16.917C16.7489 12.9977 16.3336 13.9117 15.7383 14.6777L19.0303 17.9697L17.9697 19.0303L14.6777 15.7383C13.662 16.5276 12.3862 17 11 17C7.68629 17 5 14.3137 5 11C5 8.02706 7.16237 5.56013 10 5.08398V6.6123Z",
        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":14.030276298522949,"m01":17.570167541503906,"m02":-3.7850868701934814,"m10":-18.822471618652344,"m11":15.030277252197266,"m12":13.411232948303223},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    }), /*#__PURE__*/ $cozmU.createElement("g", {
        clipPath: "url(#paint1_angular_1804_8080_clip_path)",
        "data-figma-skip-parse": "true"
    }, /*#__PURE__*/ $cozmU.createElement("g", {
        transform: "matrix(0.00701514 -0.00941124 0.00878508 0.00751514 12.0151 11.5151)"
    }, /*#__PURE__*/ $cozmU.createElement("foreignObject", {
        x: "-1058.95",
        y: "-1058.95",
        width: "2117.91",
        height: "2117.91"
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $11b5a217c0474393$var$style.foreignObject
        ])
    })))), /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M18 7.25C18 7.56523 17.803 7.84705 17.5068 7.95508L16.2217 8.42383C16.0833 8.4744 15.9744 8.58332 15.9238 8.72168L15.4551 10.0068C15.3471 10.3029 15.0653 10.5 14.75 10.5C14.4348 10.5 14.1529 10.303 14.0449 10.0068L13.5762 8.72168C13.5256 8.58332 13.4167 8.4744 13.2783 8.42383L11.9932 7.95508C11.7338 7.86049 11.5505 7.63274 11.5088 7.36621L11.5 7.25L11.5088 7.13379C11.5505 6.86715 11.734 6.63947 11.9932 6.54492L13.2783 6.07617C13.4167 6.0256 13.5256 5.91668 13.5762 5.77832L14.0449 4.49316L14.0938 4.38672C14.2242 4.15114 14.4736 4.00036 14.749 4L14.8652 4.00879C15.0941 4.04428 15.2941 4.18415 15.4062 4.38672L15.4551 4.49316L15.9238 5.77832C15.9744 5.91668 16.0833 6.0256 16.2217 6.07617L17.5068 6.54492C17.8031 6.65301 18 6.93494 18 7.25Z",
        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":14.030276298522949,"m01":17.570167541503906,"m02":-3.7850868701934814,"m10":-18.822471618652344,"m11":15.030277252197266,"m12":13.411232948303223},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    }), /*#__PURE__*/ $cozmU.createElement("defs", null, /*#__PURE__*/ $cozmU.createElement("clipPath", {
        id: "paint0_angular_1804_8080_clip_path"
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M10 6.6123C7.9961 7.0671 6.5 8.85847 6.5 11C6.5 13.4853 8.51472 15.5 11 15.5C12.2428 15.5 13.3665 14.9968 14.1816 14.1816C14.7712 13.5921 15.1959 12.8407 15.3867 12H16.917C16.7489 12.9977 16.3336 13.9117 15.7383 14.6777L19.0303 17.9697L17.9697 19.0303L14.6777 15.7383C13.662 16.5276 12.3862 17 11 17C7.68629 17 5 14.3137 5 11C5 8.02706 7.16237 5.56013 10 5.08398V6.6123Z"
    })), /*#__PURE__*/ $cozmU.createElement("clipPath", {
        id: "paint1_angular_1804_8080_clip_path"
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M18 7.25C18 7.56523 17.803 7.84705 17.5068 7.95508L16.2217 8.42383C16.0833 8.4744 15.9744 8.58332 15.9238 8.72168L15.4551 10.0068C15.3471 10.3029 15.0653 10.5 14.75 10.5C14.4348 10.5 14.1529 10.303 14.0449 10.0068L13.5762 8.72168C13.5256 8.58332 13.4167 8.4744 13.2783 8.42383L11.9932 7.95508C11.7338 7.86049 11.5505 7.63274 11.5088 7.36621L11.5 7.25L11.5088 7.13379C11.5505 6.86715 11.734 6.63947 11.9932 6.54492L13.2783 6.07617C13.4167 6.0256 13.5256 5.91668 13.5762 5.77832L14.0449 4.49316L14.0938 4.38672C14.2242 4.15114 14.4736 4.00036 14.749 4L14.8652 4.00879C15.0941 4.04428 15.2941 4.18415 15.4062 4.38672L15.4551 4.49316L15.9238 5.77832C15.9744 5.91668 16.0833 6.0256 16.2217 6.07617L17.5068 6.54492C17.8031 6.65301 18 6.93494 18 7.25Z"
    }))));
$11b5a217c0474393$var$AiSearchIcon.displayName = 'AiSearchIcon';
var $11b5a217c0474393$export$2e2bcd8739ae039 = $11b5a217c0474393$var$AiSearchIcon;


/**
 * This is a simplified version of html to adf conversion,
 * used specifically for SL RovoChatAction prompt message,
 * and does not support all ADF offered via @atlaskit/adf-utils
 *
 * Support: p, ul, li, text, b, strong, code, inlineCard (replace a hyperlink)
 */ 
var $751cc = parcelRequire("751cc");

var $gxFDR = parcelRequire("gxFDR");

var $4AavA = parcelRequire("4AavA");

var $fGQsh = parcelRequire("fGQsh");

var $gHMgs = parcelRequire("gHMgs");

var $c8cGy = parcelRequire("c8cGy");

var $iO4QI = parcelRequire("iO4QI");

var $bWF3R = parcelRequire("bWF3R");

const $018fcbc360e870ab$var$INLINE_TAG_NAMES = [
    'b',
    'strong',
    'code',
    'a',
    'inlineCard'
];
const $018fcbc360e870ab$var$BLOCK_TAG_NAMES = [
    'p',
    'ul',
    'ol',
    'li'
];
/**
 *   Group      Captures                Example
 *  ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *   match[1]   Self-closing tag name   br from <br/> or <img src="x"/>
 *   match[2]   Opening tag name        div from <div> or <div class="x">
 *   match[3]   Closing tag name        div from </div>
 *   match[4]   Text content            Hello world
 */ const $018fcbc360e870ab$var$htmlRegex = /<\s*(\w+)[^>]*?\s*\/\s*>|<\s*(\w+)[^>]*>|<\s*\/\s*(\w+)\s*>|([^<]+)/g;
const $018fcbc360e870ab$var$decodeHtmlEntities = (text = '')=>{
    return text.replace(/&nbsp;/g, ' ').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#39;/g, "'");
};
const $018fcbc360e870ab$var$tokenizeHtml = (html)=>{
    const tokens = [];
    let match;
    while((match = $018fcbc360e870ab$var$htmlRegex.exec(html)) !== null){
        const selfClosingTag = match[1];
        const openingTag = match[2];
        const closingTag = match[3];
        const textContent = match[4];
        if (selfClosingTag) tokens.push({
            type: 'selfClosing',
            tagName: selfClosingTag.toLowerCase()
        });
        else if (openingTag) tokens.push({
            type: 'open',
            tagName: openingTag.toLowerCase()
        });
        else if (closingTag) tokens.push({
            type: 'close',
            tagName: closingTag.toLowerCase()
        });
        else if (textContent) {
            if (textContent?.trim()) tokens.push({
                type: 'text',
                content: $018fcbc360e870ab$var$decodeHtmlEntities(textContent)
            });
        }
    }
    return tokens;
};
const $018fcbc360e870ab$var$buildListItem = (content = [])=>{
    // Check if content has only text/inline elements
    const hasOnlyInlineContent = content.every((node)=>node.type === 'text' || node.type === 'hardBreak' || !node.type);
    if (hasOnlyInlineContent) // Wrap text content in a paragraph
    return (0, $gHMgs.listItem)([
        (0, $c8cGy.paragraph)(...content)
    ]);
    // Content has block elements (like nested lists), use as-is
    return (0, $gHMgs.listItem)(content);
};
const $018fcbc360e870ab$var$blockToAdf = (tagName, content = [])=>{
    switch(tagName){
        case 'p':
            return (0, $c8cGy.paragraph)(...content);
        case 'ul':
            return (0, $bWF3R.bulletList)(...content);
        case 'li':
            return $018fcbc360e870ab$var$buildListItem(content);
    }
};
const $018fcbc360e870ab$var$inlineToAdf = (tagName, content)=>{
    switch(tagName){
        case 'b':
        case 'strong':
            return (0, $751cc.strong)(content);
        case 'code':
            return (0, $gxFDR.code)(content);
        case 'a':
        case 'inlineCard':
            return (0, $fGQsh.inlineCard)({
                url: content
            });
        default:
            return (0, $iO4QI.text)(content);
    }
};
const $018fcbc360e870ab$var$parseTokensToAdf = (tokens)=>{
    const stack = [
        {
            type: 'root',
            content: []
        }
    ];
    let currentMarks = [];
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        const current = stack[stack.length - 1];
        switch(token.type){
            case 'text':
                if (token.content) {
                    const inlineAdfNode = $018fcbc360e870ab$var$inlineToAdf(currentMarks?.[0]?.type, token.content);
                    current.content.push(inlineAdfNode);
                }
                break;
            case 'open':
                if ($018fcbc360e870ab$var$INLINE_TAG_NAMES.includes(token.tagName)) currentMarks.push({
                    type: token.tagName
                });
                else if ($018fcbc360e870ab$var$BLOCK_TAG_NAMES.includes(token.tagName)) stack.push({
                    type: token.tagName,
                    content: []
                });
                break;
            case 'close':
                // Inline formatting
                if (token.tagName && $018fcbc360e870ab$var$INLINE_TAG_NAMES.includes(token.tagName)) currentMarks = currentMarks.filter((m)=>m.type !== token.tagName);
                else if (stack.length > 1) {
                    const closed = stack.pop();
                    const parent = stack[stack.length - 1];
                    const adfNode = $018fcbc360e870ab$var$blockToAdf(closed?.type, closed?.content);
                    if (adfNode) parent.content.push(adfNode);
                }
                break;
        }
    }
    // Return root content
    return stack[0].content;
};
/**
 * Convert HTML string to ADF format
 *
 * This is a simplified version specific for RovoChatAction prompt message
 * and does not support all ADF offered via @atlaskit/adf-utils
 */ const $018fcbc360e870ab$var$htmlToAdf = (html)=>{
    try {
        const tokens = $018fcbc360e870ab$var$tokenizeHtml(html);
        const adfContent = $018fcbc360e870ab$var$parseTokensToAdf(tokens);
        return (0, $4AavA.doc)(...adfContent);
    } catch  {
        return html;
    }
};
var $018fcbc360e870ab$export$2e2bcd8739ae039 = $018fcbc360e870ab$var$htmlToAdf;


var $77626c1968cfb017$export$a9f8723a23072cb8 = /*#__PURE__*/ function(RovoChatPromptKey) {
    RovoChatPromptKey["SUMMARIZE_LINK"] = "summarize-link";
    RovoChatPromptKey["KEY_HIGHLIGHTS"] = "key-highlights";
    RovoChatPromptKey["ASK_ROVO_ANYTHING"] = "ask-rovo-anything";
    RovoChatPromptKey["IDENTIFY_KEY_POINTS"] = "identify-key-points";
    RovoChatPromptKey["IDENTIFY_KEY_TRENDS"] = "identify-key-trends";
    RovoChatPromptKey["FIND_OPEN_QUESTIONS"] = "find-open-questions";
    RovoChatPromptKey["HIGHLIGHT_RELEVANT_CONTENT"] = "highlight-relevant-content";
    RovoChatPromptKey["SUMMARIZE_THIS_FOR_ME"] = "summarize-this-for-me";
    RovoChatPromptKey["ASK_A_SPECIFIC_QUESTION"] = "ask-a-specific-question";
    RovoChatPromptKey["SHOW_ME_WHATS_RELEVANT"] = "show-me-whats-relevant";
    RovoChatPromptKey["SUMMARIZE_DOCUMENT"] = "summarize-document";
    RovoChatPromptKey["SUMMARIZE_PRESENTATION"] = "summarize-presentation";
    RovoChatPromptKey["EXPLAIN_CODE"] = "explain-code";
    RovoChatPromptKey["CATCH_UP"] = "catch-up";
    RovoChatPromptKey["SALESFORCE_PREP"] = "salesforce-prep";
    return RovoChatPromptKey;
}({});
const $77626c1968cfb017$var$getContext = (intl, product)=>{
    switch(product){
        case 'CONFLUENCE':
            return {
                contextLong: intl.formatMessage((0, $dM7c5.messages).rovo_prompt_context_confluence_page)
            };
        case 'JSW':
        case 'JWM':
        case 'JSM':
        case 'JPD':
            return {
                contextLong: intl.formatMessage((0, $dM7c5.messages).rovo_prompt_context_jira_work_item)
            };
    }
};
const $77626c1968cfb017$export$35d7b8e732470f9f = ({ promptKey: promptKey, intl: intl, url: url = '', product: product, iconSize: iconSize, cardAppearance: cardAppearance, provider: provider })=>{
    const { contextLong: contextLong } = $77626c1968cfb017$var$getContext(intl, product) ?? {
        contextLong: intl.formatMessage((0, $dM7c5.messages).rovo_prompt_context_generic)
    };
    switch(promptKey){
        case "summarize-link":
            const label_summarize = intl.formatMessage((0, $dM7c5.messages).ai_summarize);
            const html_summarize = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_summarize, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                    label: label_summarize,
                    size: iconSize
                }),
                content: label_summarize,
                tooltipMessage: label_summarize,
                data: {
                    name: label_summarize,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_summarize),
                    mode: {
                        fastModeEnabled: true
                    }
                }
            };
        case "summarize-this-for-me":
            const label_summarize_this_for_me = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_button_summarize_this);
            const html_summarize_this_for_me = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_summarize, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
                    label: label_summarize_this_for_me
                }),
                content: label_summarize_this_for_me,
                tooltipMessage: label_summarize_this_for_me,
                data: {
                    name: label_summarize_this_for_me,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_summarize_this_for_me),
                    mode: {
                        fastModeEnabled: true
                    }
                }
            };
        case "highlight-relevant-content":
            const label_highlight_relevant_content = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_button_highlight_relevant_content);
            const html_highlight_relevant_content = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_highlight_relevant_content, {
                context: contextLong,
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5d1eb2b6c0e657fd$export$2e2bcd8739ae039), null),
                content: label_highlight_relevant_content,
                tooltipMessage: label_highlight_relevant_content,
                data: {
                    name: label_highlight_relevant_content,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_highlight_relevant_content),
                    mode: {
                        fastModeEnabled: true
                    }
                }
            };
        case "ask-rovo-anything":
            const label_ask_rovo_anything = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_button_ask_rovo_anything);
            const prompt_ask_rovo_anything = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_ask_rovo_anything, {
                url: url
            });
            return {
                icon: cardAppearance === (0, $4yYAm.CardDisplay).Block && !!product && product === 'CONFLUENCE' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
                    label: label_ask_rovo_anything,
                    size: 'xxsmall',
                    shouldUseHexLogo: true
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $11b5a217c0474393$export$2e2bcd8739ae039), null),
                content: label_ask_rovo_anything,
                tooltipMessage: label_ask_rovo_anything,
                data: {
                    name: label_ask_rovo_anything,
                    dialogues: [],
                    prompt: prompt_ask_rovo_anything,
                    isPromptPlaceholder: true,
                    placeholderType: 'generic'
                }
            };
        case "ask-a-specific-question":
            const label_ask_a_specific_question = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_button_ask_a_specific_question);
            const prompt_ask_a_specific_question = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_ask_rovo_anything, {
                url: url
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bLfHG))), {
                    label: label_ask_a_specific_question
                }),
                content: label_ask_a_specific_question,
                tooltipMessage: label_ask_a_specific_question,
                data: {
                    name: label_ask_a_specific_question,
                    dialogues: [],
                    prompt: prompt_ask_a_specific_question,
                    isPromptPlaceholder: true,
                    placeholderType: 'generic'
                }
            };
        case "key-highlights":
            const label_key_highlights = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_button_key_highlights);
            const html_key_highlights = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_key_highlights, {
                context: contextLong,
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                    label: label_key_highlights,
                    size: iconSize
                }),
                content: label_key_highlights,
                tooltipMessage: label_key_highlights,
                data: {
                    name: label_key_highlights,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_key_highlights)
                }
            };
        case "show-me-whats-relevant":
            const label_show_me_whats_relevant = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_button_show_me_whats_relevant);
            const html_show_me_whats_relevant = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_highlight_relevant_content, {
                context: contextLong,
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9UcmI))), {
                    label: label_show_me_whats_relevant
                }),
                content: label_show_me_whats_relevant,
                tooltipMessage: label_show_me_whats_relevant,
                data: {
                    name: label_show_me_whats_relevant,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_show_me_whats_relevant)
                }
            };
        case "identify-key-trends":
            const label_identify_key_trends = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_button_identify_key_trends);
            const html_identify_key_trends = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_identify_key_trends, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                    label: label_identify_key_trends,
                    size: iconSize
                }),
                content: label_identify_key_trends,
                tooltipMessage: label_identify_key_trends,
                data: {
                    name: label_identify_key_trends,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_identify_key_trends)
                }
            };
        case "identify-key-points":
            const label_identify_key_points = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_button_identify_key_points);
            const html_identify_key_points = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_identify_key_points, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                    label: label_identify_key_points,
                    size: iconSize
                }),
                content: label_identify_key_points,
                tooltipMessage: label_identify_key_points,
                data: {
                    name: label_identify_key_points,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_identify_key_points)
                }
            };
        case "find-open-questions":
            const label_find_open_questions = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_button_find_open_questions);
            const html_find_open_questions = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_find_open_questions, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                    label: label_find_open_questions,
                    size: iconSize
                }),
                content: label_find_open_questions,
                tooltipMessage: label_find_open_questions,
                data: {
                    name: label_find_open_questions,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_find_open_questions)
                }
            };
        case "summarize-document":
            const label_summarize_document = intl.formatMessage((0, $dM7c5.messages).ai_summarize);
            const html_summarize_document = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_summarize_document, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                content: label_summarize_document,
                tooltipMessage: label_summarize_document,
                data: {
                    name: label_summarize_document,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_summarize_document)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
                    label: label_summarize_document,
                    size: iconSize
                })
            };
        case "summarize-presentation":
            const label_summarize_presentation = intl.formatMessage((0, $dM7c5.messages).ai_summarize);
            const html_summarize_presentation = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_summarize_presentation, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                content: label_summarize_presentation,
                tooltipMessage: label_summarize_presentation,
                data: {
                    name: label_summarize_presentation,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_summarize_presentation)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
                    label: label_summarize_presentation,
                    size: iconSize
                })
            };
        case "explain-code":
            const label_explain_code = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_button_explain_code);
            const html_explain_code = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_explain_code, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                content: label_explain_code,
                tooltipMessage: label_explain_code,
                data: {
                    name: label_explain_code,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_explain_code)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
                    label: label_explain_code,
                    size: iconSize
                })
            };
        case "catch-up":
            const label_catch_up = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_button_catch_up);
            const html_catch_up = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_catch_up, {
                url: url,
                provider: provider
            }, {
                ignoreTag: true
            });
            return {
                content: label_catch_up,
                tooltipMessage: label_catch_up,
                data: {
                    name: label_catch_up,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_catch_up)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
                    label: label_catch_up,
                    size: iconSize
                })
            };
        case "salesforce-prep":
            const label_overview = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_button_salesforce_prep);
            const html_overview = intl.formatMessage((0, $dM7c5.messages).rovo_prompt_message_salesforce_prep, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                content: label_overview,
                tooltipMessage: label_overview,
                data: {
                    name: label_overview,
                    dialogues: [],
                    prompt: (0, $018fcbc360e870ab$export$2e2bcd8739ae039)(html_overview)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
                    label: label_overview,
                    size: iconSize
                })
            };
    }
};
module.exports["RovoChatPromptKey"] = $77626c1968cfb017$export$a9f8723a23072cb8;
module.exports["getPromptAction"] = $77626c1968cfb017$export$35d7b8e732470f9f;

});

parcelRegister("751cc", function(module, exports) {

var $9udAq = parcelRequire("9udAq");

const $162dded746a4fc65$export$59ae2c325a998f89 = (maybeNode)=>(0, $9udAq.applyMark)({
        type: 'strong'
    }, maybeNode);
module.exports["strong"] = $162dded746a4fc65$export$59ae2c325a998f89;

});

parcelRegister("fGQsh", function(module, exports) {
const $857a268d3f29ba58$export$cbf8224b64e0d942 = (attrs)=>({
        type: 'inlineCard',
        attrs: attrs
    });
module.exports["inlineCard"] = $857a268d3f29ba58$export$cbf8224b64e0d942;

});

parcelRegister("bWF3R", function(module, exports) {
const $8a197a39985804ad$export$a140c94e5ea26bee = (...content)=>({
        type: 'bulletList',
        content: content
    });
module.exports["bulletList"] = $8a197a39985804ad$export$a140c94e5ea26bee;

});

parcelRegister("1xR0T", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $4abK1 = parcelRequire("4abK1");


var $li470 = parcelRequire("li470");


var $3M4EV = parcelRequire("3M4EV");


var $knKT4 = parcelRequire("knKT4");

const $44bad6257c01e35a$export$f942619ce67b1a41 = {
    [(0, $4yYAm.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).AppliedToComponentsCount]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).Location]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).Preview]: [
        'block'
    ],
    [(0, $4yYAm.ElementName).Priority]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).Provider]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).Snippet]: [
        'block'
    ],
    [(0, $4yYAm.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).State]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).TeamMemberCount]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).Title]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).UserAttributes]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).VoteCount]: [
        'inline'
    ],
    [(0, $4yYAm.ElementName).HostName]: [
        'inline'
    ]
};
const $44bad6257c01e35a$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $4yYAm.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $4yYAm.SmartLinkSize).Large:
            return 1;
        case (0, $4yYAm.SmartLinkSize).Medium:
            return 0.5;
        case (0, $4yYAm.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $44bad6257c01e35a$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(node) && node.type === (0, $3M4EV.default);
const $44bad6257c01e35a$var$isElementDisplayValid = (name, display)=>{
    return $44bad6257c01e35a$export$f942619ce67b1a41[name]?.includes(display) ?? false;
};
const $44bad6257c01e35a$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $44bad6257c01e35a$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(node) && ((0, $4abK1.isFlexibleUiElement)(node) || node.type === (0, $knKT4.default));
const $44bad6257c01e35a$export$adbd04236f07a7d8 = (items = [], context, product)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $4yYAm.ActionName).DeleteAction:
            case (0, $4yYAm.ActionName).EditAction:
            case (0, $4yYAm.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $4yYAm.ActionName)[item.name]);
            case (0, $4yYAm.ActionName).RovoChatAction:
                if (!!product && product === 'CONFLUENCE') return Boolean((0, $4yYAm.ActionName)[item.name]);
                // same as default case below
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $44bad6257c01e35a$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, (child)=>{
        if ($44bad6257c01e35a$var$isElementOrElementGroup(child) || $44bad6257c01e35a$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $44bad6257c01e35a$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $li470[name];
        const typedProps = props;
        if (Element && $44bad6257c01e35a$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Element, {
                key: idx,
                ...typedProps
            });
            if (!$44bad6257c01e35a$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};
module.exports["filterActionItems"] = $44bad6257c01e35a$export$adbd04236f07a7d8;
module.exports["renderChildren"] = $44bad6257c01e35a$export$cd762ccf1a583d69;
module.exports["renderElementItems"] = $44bad6257c01e35a$export$9678d3ca18bd7526;

});

parcelRegister("cZnAt", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $acUNT = parcelRequire("acUNT");

const $9dbbb345bb1a9bb1$var$baseStyle = null;
const $9dbbb345bb1a9bb1$var$fontOverrideStyleMap = {
    'font.body': "_11c8fhey",
    'font.body.large': "_11c81d4k",
    'font.body.small': "_11c8wadc"
};
const $9dbbb345bb1a9bb1$export$79422073c7118b5b = ({ content: content, maxLines: maxLines = 1, message: message, name: name, className: className, testId: testId = 'smart-element-text', hideFormat: hideFormat = false, color: color, fontSize: fontSize })=>{
    if (!message && !content) return null;
    const dynamicCss = null;
    const formattedContent = hideFormat && content ? content : (0, $acUNT.getFormattedMessage)(message) || content;
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_11c8wadc _1reo15vq _18m915vq _syazazsu _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            fontSize !== undefined && $9dbbb345bb1a9bb1$var$fontOverrideStyleMap[fontSize],
            "_1yyjr31u _102k1dud",
            className
        ]),
        style: {
            color: color,
            "--_1erfju8": (0, $9aYkv.default)(maxLines)
        }
    }, formattedContent);
};
var $9dbbb345bb1a9bb1$export$2e2bcd8739ae039 = $9dbbb345bb1a9bb1$export$79422073c7118b5b;
const $9dbbb345bb1a9bb1$export$b9738bf28fb14829 = (descriptor, context)=>{
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        },
        content: context
    } : undefined;
};
const $9dbbb345bb1a9bb1$export$f12aecc78be3c7bb = (content)=>{
    return content ? {
        content: content
    } : undefined;
};
module.exports["default"] = $9dbbb345bb1a9bb1$export$2e2bcd8739ae039;
module.exports["toFormattedTextProps"] = $9dbbb345bb1a9bb1$export$b9738bf28fb14829;
module.exports["toTextProps"] = $9dbbb345bb1a9bb1$export$f12aecc78be3c7bb;

});

parcelRegister("LvVJP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $jJP7n = parcelRequire("jJP7n");

const $738e3a2399fcd2d8$var$CommentCountElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $jJP7n.toBadgeProps)(context.commentCount?.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $cozmU.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        icon: (0, $4yYAm.IconType).Comment,
        ...data,
        ...restProps,
        name: (0, $4yYAm.ElementName).CommentCount
    }) : null;
};
var $738e3a2399fcd2d8$export$2e2bcd8739ae039 = $738e3a2399fcd2d8$var$CommentCountElement;
module.exports["default"] = $738e3a2399fcd2d8$export$2e2bcd8739ae039;

});

parcelRegister("eWtDJ", function(module, exports) {
/**
 * The enum that describes Smart Link action types
 */ var $ef78d43ddf94efaf$export$6324b7946ad663e9 = /*#__PURE__*/ function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    return SmartLinkActionType;
}({});
class $ef78d43ddf94efaf$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = void 0;
        this.errorCode = errorCode;
    }
}
module.exports["SmartLinkActionType"] = $ef78d43ddf94efaf$export$6324b7946ad663e9;
module.exports["InvokeError"] = $ef78d43ddf94efaf$export$d4d72202bff63658;

});

parcelRegister("hsIfr", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ixfCV = parcelRequire("ixfCV");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $bt1e6 = parcelRequire("bt1e6");

const $21ed2e6b0c1568e5$var$excludedResourceTypes = [
    '0',
    'unknown',
    'unsupported',
    'REDACTED'
];
const $21ed2e6b0c1568e5$var$manualMapping = {
    jswBoard: 'Jira Software Board',
    calendarJsw: 'Jira Software Calendar',
    kbArticle: 'Knowledge Base Article',
    pull: 'Pull Request',
    repo: 'Repository'
};
/**
 * Splits a resolver `resourceType` token into human-oriented words.
 * Prefers kebab-case (`-`) when present; otherwise splits camelCase / PascalCase.
 */ function $21ed2e6b0c1568e5$var$splitIntoWords(resourceType) {
    if (resourceType.includes('-')) return resourceType.split('-').map((w)=>w.trim()).filter(Boolean);
    const spaced = resourceType.replace(/([a-z\d])([A-Z])/g, '$1 $2').replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2');
    return spaced.split(/\s+/).filter(Boolean);
}
function $21ed2e6b0c1568e5$var$titleCaseWord(word) {
    if (!word) return word;
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}
function $21ed2e6b0c1568e5$export$3422b5d26145468d(resourceType) {
    const trimmed = resourceType?.trim();
    if (!trimmed) return undefined;
    if ($21ed2e6b0c1568e5$var$excludedResourceTypes.includes(trimmed)) return undefined;
    const manual = $21ed2e6b0c1568e5$var$manualMapping[trimmed];
    if (manual !== undefined) return manual;
    const words = $21ed2e6b0c1568e5$var$splitIntoWords(trimmed);
    if (words.length === 0) return undefined;
    return words.map($21ed2e6b0c1568e5$var$titleCaseWord).join(' ');
} // Following are unique resourceType values for the past week (at the the time of writing) for reference:
 // page
 // issue
 // 0
 // (none)
 // unknown
 // file
 // space
 // message
 // jswBoard
 // video
 // card
 // project
 // board
 // repository
 // whiteboard
 // channel
 // pull-request
 // mergeRequest
 // database
 // pullRequest
 // singlePortalPage
 // folder
 // dashboard
 // requestCreateForm
 // commit
 // jql
 // blog
 // version
 // backlog
 // undefinedLink
 // branch
 // report
 // planTimeline
 // sharepointFile
 // comment
 // roadmap
 // idea
 // case
 // opportunity
 // account
 // list
 // issues
 // view
 // workItem
 // link
 // block
 // kbArticle
 // form
 // summary
 // task
 // search
 // visitor
 // public-link
 // user
 // playlist
 // prototype
 // deal
 // screen
 // pipeline
 // contact
 // incident
 // sheet
 // featureFlag
 // release
 // switcheroo-flag
 // single-calendar
 // repo
 // formBuilder
 // proformaForm
 // object
 // tiny
 // document
 // sharedFile
 // campaign
 // table
 // compassComponent
 // timeline
 // boardInvite
 // action
 // embed
 // objectType
 // calendar
 // calendarJsw
 // publishedView
 // template
 // gist
 // recording
 // plan
 // planDependencies
 // epic
 // oneDriveFile
 // chart
 // capability
 // artboard
 // planCalendar
 // planSummary
 // projectTeamTag
 // planProgram
 // compassComponentSearchQuery
 // feature
 // workspace
 // company
 // insight
 // customer
 // Page
 // schema
 // dependency
 // note
 // article
 // snippet
 // tag
 // goal
 // security
 // collaborationGroup
 // envelope
 // code
 // boardView
 // compassScorecard
 // invoice
 // theme
 // customWorkspaceView
 // risk
 // reel
 // deployments
 // objective
 // ask
 // compassMetricDefinition
 // compassComponentAnnouncement
 // portals
 // asks
 // breadcrumbChart
 // Chart
 // slide
 // unsupported
 // remote-link
 // pull
 // REDACTED
 // compassComponentScorecard
 // forms
 // sante
 // zoom


const $7d6821988c87783f$var$LinkIconElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    if (!context) return null;
    if ((0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y')) {
        const linkIconProps = (0, $bt1e6.toLinkIconProps)(context?.linkIcon, context.type);
        if (!linkIconProps) return null;
        const label = (0, $21ed2e6b0c1568e5$export$3422b5d26145468d)(context.meta?.resourceType) ?? linkIconProps.label?.trim() ?? props.label;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bt1e6.default), {
            ...linkIconProps,
            ...props,
            label: label,
            name: (0, $4yYAm.ElementName).LinkIcon
        });
    }
    const data = (0, $bt1e6.toLinkIconProps)(context?.linkIcon, context.type);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bt1e6.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).LinkIcon
    }) : null;
};
var $7d6821988c87783f$export$2e2bcd8739ae039 = $7d6821988c87783f$var$LinkIconElement;
module.exports["default"] = $7d6821988c87783f$export$2e2bcd8739ae039;

});

parcelRegister("bt1e6", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kTb7m = parcelRequire("kTb7m");


var $ixfCV = parcelRequire("ixfCV");


var $iMnC5 = parcelRequire("iMnC5");


var $9NPFC = parcelRequire("9NPFC");


var $4yYAm = parcelRequire("4yYAm");


var $16kNn = parcelRequire("16kNn");


var $aGLwK = parcelRequire("aGLwK");


var $5IVlB = parcelRequire("5IVlB");


var $acUNT = parcelRequire("acUNT");

const $4650c18fe752ae49$var$styles = {
    container: "_1ul91ns9",
    iconWrapperStyle: "_1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $4650c18fe752ae49$var$positionStyleMap = {
    center: "_1wpz1h6o",
    top: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1y6m"
};
const $4650c18fe752ae49$var$customRenderStyleMap = {
    xlarge: "_1reo15vq _18m915vq _11c810sd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km1q9y _1xjx1osq _e2oo1osq _102kz42d",
    large: "_1reo15vq _18m915vq _11c810sd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km1q9y _1xjx1osq _e2oo1osq _102kz42d",
    medium: "_1reo15vq _18m915vq _11c81e3o _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km1q9y _1xjx1osq _e2oo1osq _102kptym",
    small: "_1reo15vq _18m915vq _11c81e3o _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km1q9y _1xjx1osq _e2oo1osq _102kptym"
};
const $4650c18fe752ae49$var$renderAtlaskitIcon = (icon, testId, size = (0, $4yYAm.SmartLinkSize).Medium, label, isTiledIcon)=>{
    if (icon) return /*#__PURE__*/ $cozmU.createElement((0, $5IVlB.default), {
        icon: icon,
        testId: `${testId}-icon`,
        ...(0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y') ? {
            label: label
        } : {
            'aria-hidden': true,
            label: ''
        },
        size: size,
        isTiledIcon: isTiledIcon
    });
};
const $4650c18fe752ae49$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $4650c18fe752ae49$var$widthFromSize = (size, isTiledIcon)=>{
    switch(size){
        case (0, $4yYAm.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $4yYAm.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $4yYAm.SmartLinkSize).Medium:
            return isTiledIcon ? "var(--ds-space-250, 20px)" : "var(--ds-space-200, 16px)";
        case (0, $4yYAm.SmartLinkSize).Small:
            return "var(--ds-space-200, 16px)";
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $4650c18fe752ae49$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $4yYAm.SmartLinkSize).Medium, appearance, hideLoadingSkeleton, label)=>{
    const width = size === (0, $4yYAm.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ $cozmU.createElement((0, $aGLwK.default), {
        ...(0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y') ? {
            label: label
        } : {},
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        width: width,
        height: width,
        appearance: appearance,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
};
const $4650c18fe752ae49$var$renderImageIconNew = (defaultIcon, url, testId, size = (0, $4yYAm.SmartLinkSize).Medium, appearance, hideLoadingSkeleton, label, isTiledIcon = false)=>{
    const width = $4650c18fe752ae49$var$widthFromSize(size, isTiledIcon);
    if (url) return /*#__PURE__*/ $cozmU.createElement((0, $aGLwK.default), {
        ...(0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y') ? {
            label: label
        } : {},
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        width: width,
        height: width,
        appearance: appearance,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
}; /**
    * A base element that displays an Icon or favicon.
    * @internal
    * @param props - The props necessary for the Icon element.
    * @see LinkIcon
    */ 
const $4650c18fe752ae49$var$IconElement = ({ icon: icon, overrideIcon: overrideIcon, label: labelProp, name: name, position: position = (0, $4yYAm.SmartLinkPosition).Top, className: className, render: render, size: size = (0, $4yYAm.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url, appearance: appearance = 'square', hideLoadingSkeleton: hideLoadingSkeleton, isTiledIcon: isTiledIcon })=>{
    const label = (0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y') ? labelProp ?? '' : labelProp ?? 'Link';
    const element = (0, $cozmU.useMemo)(()=>{
        const defaultIcon = $4650c18fe752ae49$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || ((0, $ixfCV.fg)('platform_sl_3p_preauth_better_hovercard_killswitch') ? $4650c18fe752ae49$var$renderImageIconNew(defaultIcon, url, testId, size, appearance, hideLoadingSkeleton, (0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y') ? label : undefined, isTiledIcon) : $4650c18fe752ae49$var$renderImageIcon(defaultIcon, url, testId, size, appearance, hideLoadingSkeleton, (0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y') ? label : undefined)) || $4650c18fe752ae49$var$renderAtlaskitIcon(icon, testId, size, (0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y') ? label : undefined, isTiledIcon) || defaultIcon;
    }, [
        label,
        testId,
        overrideIcon,
        render,
        url,
        size,
        appearance,
        hideLoadingSkeleton,
        icon,
        isTiledIcon
    ]);
    const width = (0, $acUNT.getIconWidth)(size);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $4650c18fe752ae49$var$styles.container,
            $4650c18fe752ae49$var$positionStyleMap[position],
            render && $4650c18fe752ae49$var$customRenderStyleMap[size],
            className
        ])
    }, isTiledIcon ? /*#__PURE__*/ $cozmU.createElement((0, $9NPFC.default), {
        size: size,
        hasBorder: true,
        backgroundColor: "white",
        label: label,
        testId: `${testId}-tile`
    }, element) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $4650c18fe752ae49$var$styles.iconWrapperStyle,
        testId: `${testId}-box`,
        style: {
            width: width,
            height: width
        }
    }, element));
};
var $4650c18fe752ae49$export$2e2bcd8739ae039 = $4650c18fe752ae49$var$IconElement;
const $4650c18fe752ae49$export$6d33abd591a3f700 = (data, type)=>{
    const isDataLinkIcon = (_data)=>{
        return typeof _data === 'object' && _data !== null && ('icon' in _data || 'url' in _data);
    };
    if (!isDataLinkIcon(data)) return typeof data === 'object' ? data : undefined;
    const isImageRound = (0, $16kNn.isProfileType)(type);
    return {
        ...data,
        appearance: isImageRound ? 'round' : 'square'
    };
};
module.exports["default"] = $4650c18fe752ae49$export$2e2bcd8739ae039;
module.exports["toLinkIconProps"] = $4650c18fe752ae49$export$6d33abd591a3f700;

});

parcelRegister("7sCIj", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $9ox4X = parcelRequire("9ox4X");

const $540439c5c0836204$var$ModifiedOnElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $9ox4X.toDateTimeProps)('modified', context.modifiedOn) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $cozmU.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ox4X.default), {
        ...data,
        ...restProps,
        name: (0, $4yYAm.ElementName).ModifiedOn
    }) : null;
};
var $540439c5c0836204$export$2e2bcd8739ae039 = $540439c5c0836204$var$ModifiedOnElement;
module.exports["default"] = $540439c5c0836204$export$2e2bcd8739ae039;

});

parcelRegister("4GRqQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $9PA4G = parcelRequire("9PA4G");


var $cZnAt = parcelRequire("cZnAt");

const $4e3bd94b37ff918f$var$OwnedByElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const { onRender: onRender, textPrefix: textPrefix = 'owned_by', ...restProps } = props || {};
    const data = context ? (0, $cZnAt.toFormattedTextProps)((0, $dM7c5.messages)[textPrefix], context?.ownedBy) : null;
    (0, $cozmU.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZnAt.default), {
        ...data,
        ...restProps,
        name: (0, $4yYAm.ElementName).OwnedBy
    }) : null;
};
var $4e3bd94b37ff918f$export$2e2bcd8739ae039 = $4e3bd94b37ff918f$var$OwnedByElement;
module.exports["default"] = $4e3bd94b37ff918f$export$2e2bcd8739ae039;

});

parcelRegister("cl3v4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $le41x = parcelRequire("le41x");

const $2fe0b095cba40ed1$var$OwnedByGroupElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $le41x.toAvatarGroupProps)(context.ownedByGroup, false) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $cozmU.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $le41x.default), {
        ...data,
        ...restProps,
        name: (0, $4yYAm.ElementName).OwnedByGroup
    }) : null;
};
var $2fe0b095cba40ed1$export$2e2bcd8739ae039 = $2fe0b095cba40ed1$var$OwnedByGroupElement;
module.exports["default"] = $2fe0b095cba40ed1$export$2e2bcd8739ae039;

});

parcelRegister("eIk5O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $jJP7n = parcelRequire("jJP7n");

const $548f8e726ba13f87$var$ReactCountElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $jJP7n.toBadgeProps)(context.reactCount?.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $cozmU.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        icon: (0, $4yYAm.IconType).React,
        ...data,
        ...restProps,
        name: (0, $4yYAm.ElementName).ReactCount
    }) : null;
};
var $548f8e726ba13f87$export$2e2bcd8739ae039 = $548f8e726ba13f87$var$ReactCountElement;
module.exports["default"] = $548f8e726ba13f87$export$2e2bcd8739ae039;

});

parcelRegister("fIakH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $jdGU5 = parcelRequire("jdGU5");

const $28a8d06450508f14$var$TitleElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? context?.linkTitle : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdGU5.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).Title
    }) : null;
};
var $28a8d06450508f14$export$2e2bcd8739ae039 = $28a8d06450508f14$var$TitleElement;
module.exports["default"] = $28a8d06450508f14$export$2e2bcd8739ae039;

});

parcelRegister("knKT4", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4yYAm = parcelRequire("4yYAm");


var $1xR0T = parcelRequire("1xR0T");

const $e3640315f11416b3$var$alignmentStyleMap = {
    right: "_1dthh9n0 _r291h9n0 _1bahesu3 _y3gnusic",
    left: "_1dthv2br _r291v2br _1bah1y6m _y3gn1e5h"
};
const $e3640315f11416b3$var$baseStyleBySize = {
    xlarge: "_zulpv47k _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    large: "_zulppxbi _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    medium: "_zulpu2gc _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    small: "_zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf"
};
const $e3640315f11416b3$var$baseStyleByDirection = {
    horizontal: "_2lx2vrvc _4cvr1h6o",
    vertical: "_2lx21bp4 _4cvr1y6m"
};
const $e3640315f11416b3$var$baseStyles = null;
const $e3640315f11416b3$var$widthStyle = {
    flexible: "_16jlkb7n _1o9z11wp _i0dlf1ug",
    'fit-to-content': ""
};
const $e3640315f11416b3$var$positionStyle = {
    top: "_1wpz1y6m",
    center: ""
};
const $e3640315f11416b3$var$horizontalStyleBase = null;
const $e3640315f11416b3$var$horizontalStyleByHeight = {
    xlarge: "_1e0ccj1k _102k125z",
    large: "_1e0ccj1k _102k125z",
    medium: "_1e0ccj1k _102kz42d",
    small: "_1e0ccj1k _102kz42d"
};
const $e3640315f11416b3$var$gapStylesLeft = {
    xlarge: "_7yhbv47k _m6ukidpf",
    large: "_7yhbpxbi _m6ukidpf",
    medium: "_7yhbu2gc _m6ukidpf",
    small: "_7yhb1b66 _m6ukidpf"
};
const $e3640315f11416b3$var$gapStylesRight = {
    xlarge: "_24rcv47k _3dveidpf",
    large: "_24rcpxbi _3dveidpf",
    medium: "_24rcu2gc _3dveidpf",
    small: "_24rc1b66 _3dveidpf"
};
const $e3640315f11416b3$var$minWidthStyle = null; /**
                             * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
                             * preferences.
                             * @internal
                             * @param {ActionGroupProps} ActionGroupProps
                             * @see Action
                             */ 
const $e3640315f11416b3$var$ElementGroup = ({ align: align = (0, $4yYAm.SmartLinkAlignment).Left, children: children, direction: direction = (0, $4yYAm.SmartLinkDirection).Horizontal, size: size = (0, $4yYAm.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $4yYAm.SmartLinkWidth).FitToContent, position: position = (0, $4yYAm.SmartLinkPosition).Center, className: className })=>{
    const isHorizontal = direction === (0, $4yYAm.SmartLinkDirection).Horizontal;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-smart-element-group": true,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $e3640315f11416b3$var$baseStyleBySize[size],
            $e3640315f11416b3$var$baseStyleByDirection[direction],
            "_fiawglyw",
            $e3640315f11416b3$var$alignmentStyleMap[align],
            "_1ul99by0",
            $e3640315f11416b3$var$widthStyle[width],
            isHorizontal && "_1reo15vq _18m915vq _1e0c1ule _s7n4nkob _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _1aaynkob _15tynkob _1iu61nu9 _166k1nu9 _1div1nu9 _bmfb1nu9",
            isHorizontal && $e3640315f11416b3$var$horizontalStyleByHeight[size],
            isHorizontal && align === (0, $4yYAm.SmartLinkAlignment).Left && $e3640315f11416b3$var$gapStylesLeft[size],
            isHorizontal && align === (0, $4yYAm.SmartLinkAlignment).Right && $e3640315f11416b3$var$gapStylesRight[size],
            $e3640315f11416b3$var$positionStyle[position],
            className
        ])
    }, (0, $1xR0T.renderChildren)(children, size));
};
var $e3640315f11416b3$export$2e2bcd8739ae039 = $e3640315f11416b3$var$ElementGroup;
module.exports["default"] = $e3640315f11416b3$export$2e2bcd8739ae039;

});

parcelRegister("9U5KN", function(module, exports) {

let $735dce9471e245da$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $735dce9471e245da$var$load("6wr18"),
    $735dce9471e245da$var$load("ffEVr"),
    $735dce9471e245da$var$load("hTwYJ")
]).then(()=>parcelRequire('ez6j0'));

});

parcelRegister("bC5Km", function(module, exports) {

let $8747b37e82602029$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8747b37e82602029$var$load("6wr18"),
    $8747b37e82602029$var$load("ffEVr"),
    $8747b37e82602029$var$load("9PVXs")
]).then(()=>parcelRequire('kV5QU'));

});

parcelRegister("8Mb1e", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");

const $8c688acf6816af13$var$styles = {
    button: "_1e0c1bgi",
    padding: "_18zrutpp",
    message: "_1rjcze3t _18zrze3t"
};
const $8c688acf6816af13$var$UnresolvedAction = ({ testId: testId = 'unresolved-action', hasPadding: hasPadding = false })=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context?.actions?.[(0, $4yYAm.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const hasAction = onClick !== undefined;
    const message = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: (0, $w6R6I.cx)($8c688acf6816af13$var$styles.message, hasPadding && $8c688acf6816af13$var$styles.padding)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...descriptor,
        values: values
    }));
    return hasAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $8c688acf6816af13$var$styles.button
    }, message) : message;
};
var $8c688acf6816af13$export$2e2bcd8739ae039 = $8c688acf6816af13$var$UnresolvedAction;
module.exports["default"] = $8c688acf6816af13$export$2e2bcd8739ae039;

});

parcelRegister("euBHF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jawC3 = parcelRequire("jawC3");


var $6Vsq4 = parcelRequire("6Vsq4");


var $jdqmT = parcelRequire("jdqmT");


var $9H66G = parcelRequire("9H66G");





var $kSwu1 = parcelRequire("kSwu1");

// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $kHija = parcelRequire("kHija");


var $4B79C = parcelRequire("4B79C");

const $159f3c59185b84a6$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $159f3c59185b84a6$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $159f3c59185b84a6$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $159f3c59185b84a6$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $159f3c59185b84a6$export$ff2962de2b2c930f = (product)=>{
    if ($159f3c59185b84a6$var$isJiraProduct(product)) return $159f3c59185b84a6$var$AiMateJiraXProduct[product];
    return product;
};


async function* $0cffe7e1a4751a42$export$e45226161c660403(response) {
    const reader = (0, $159f3c59185b84a6$export$f6383c3ea1307da9)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}


class $69acbcf5fb261283$export$fcec967a4b7ebd84 extends Error {
    constructor(error){
        super(error);
    }
}
const $69acbcf5fb261283$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];



const $e542134bf344ced2$var$CONVO_AI_ENDPOINT = 'assist/api/ai/v2/ai-feature/smartlinksummary/stream';
class $e542134bf344ced2$export$73e4b807d5bd74b6 {
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($kHija)))();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.content;
                if (chunk.type === 'ERROR') throw new (0, $69acbcf5fb261283$export$fcec967a4b7ebd84)(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof (0, $69acbcf5fb261283$export$fcec967a4b7ebd84) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.config = void 0;
        this.url = void 0;
        this.ari = void 0;
        this.locale = void 0;
        this.subscribedStateSetters = new Set();
        this.onStart = void 0;
        this.onSuccess = void 0;
        this.onError = void 0;
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $4B79C.getBaseUrl)(envKey);
                return (0, $159f3c59185b84a6$export$4c25481b843feb0b)(baseUrl, $e542134bf344ced2$var$CONVO_AI_ENDPOINT);
            }
            return (0, $159f3c59185b84a6$export$4c25481b843feb0b)('/gateway/api/', $e542134bf344ced2$var$CONVO_AI_ENDPOINT);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'smartlink_summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown',
                    locale: this.locale
                },
                ai_feature_input: {
                    content_url: this.url,
                    content_ari: this.ari,
                    locale: this.locale
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $0cffe7e1a4751a42$export$e45226161c660403)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $159f3c59185b84a6$export$ff2962de2b2c930f)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.locale = props.locale;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
}



var $lPEt0 = parcelRequire("lPEt0");

const $423f9ef2c5e6a9fb$var$AI_SUMMARY_CACHE_SIZE = 100;
const $423f9ef2c5e6a9fb$export$6979339b6d41707e = new (0, $lPEt0.LRUMap)($423f9ef2c5e6a9fb$var$AI_SUMMARY_CACHE_SIZE);


const $a7221ae92bb029e9$export$becd8f2eba1bbd96 = (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $cozmU.useState)((0, $423f9ef2c5e6a9fb$export$6979339b6d41707e).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    const { locale: locale } = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $423f9ef2c5e6a9fb$export$6979339b6d41707e).get(url)) (0, $423f9ef2c5e6a9fb$export$6979339b6d41707e).set(url, new (0, $e542134bf344ced2$export$73e4b807d5bd74b6)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            locale: locale,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $423f9ef2c5e6a9fb$export$6979339b6d41707e).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey,
        locale
    ]);
    const summariseUrl = ()=>{
        return (0, $423f9ef2c5e6a9fb$export$6979339b6d41707e).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};



var $lBXKn = parcelRequire("lBXKn");

const $ef9452ea85dab480$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $ef9452ea85dab480$var$useAISummaryAction = (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $lBXKn.useAISummaryConfig)();
    const cardState = (0, $9H66G.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $jawC3.extractAri)(data);
    const dataUrl = data && (0, $jawC3.extractLink)(data) || '';
    const onStart = (0, $cozmU.useCallback)((id)=>{
        (0, $jdqmT.startUfoExperience)($ef9452ea85dab480$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $cozmU.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $jdqmT.succeedUfoExperience)($ef9452ea85dab480$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $cozmU.useCallback)((id, reason)=>{
        /**
			 * Errors should only be counted to the SLO if they are not due to acceptable use violations
			 * HIPAA content detected or exceeding context length.
			 */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $jdqmT.failUfoExperience)($ef9452ea85dab480$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $a7221ae92bb029e9$export$becd8f2eba1bbd96)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $ef9452ea85dab480$export$2e2bcd8739ae039 = $ef9452ea85dab480$var$useAISummaryAction;
module.exports["default"] = $ef9452ea85dab480$export$2e2bcd8739ae039;

});

parcelRegister("lBXKn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cMyWi = parcelRequire("cMyWi");

const $866680c7620d2426$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $cMyWi.useSmartLinkContext)();
    return (0, $cozmU.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};
module.exports["useAISummaryConfig"] = $866680c7620d2426$export$4480af2c00aa7ebe;

});

parcelRegister("lOOiS", function(module, exports) {

var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");

const $afdb175848d4f371$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
const $afdb175848d4f371$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $dM7c5.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $4yYAm.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $dM7c5.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $dM7c5.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $dM7c5.messages).ai_summary_error_generic_rebrand,
                url: (0, $4yYAm.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};
module.exports["getIsAISummaryEnabled"] = $afdb175848d4f371$export$d439c74cb206ff29;
module.exports["getAISummaryErrorMessage"] = $afdb175848d4f371$export$cd2e891d7f87074d;

});

parcelRegister("hsgLh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $iMnC5 = parcelRequire("iMnC5");

const $a4b4c858d51f1d19$var$styles = {
    wrapper: "_c71lidpf _p12fidpf _kqswstnw"
};
const $a4b4c858d51f1d19$export$3e100bc08448f36c = ({ children: children })=>{
    const onClick = (0, $cozmU.useCallback)((e)=>{
        // Prevent click events from bubbling up
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        as: "span",
        role: "none",
        xcss: $a4b4c858d51f1d19$var$styles.wrapper,
        onClick: onClick
    }, children);
};


const $d3ed0ddb142a7bfb$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $d3ed0ddb142a7bfb$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($d3ed0ddb142a7bfb$var$FALLBACK_API);
const $d3ed0ddb142a7bfb$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $cozmU.useState)(null);
    const api = (0, $cozmU.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
                    fallback: null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a4b4c858d51f1d19$export$3e100bc08448f36c), null, modal))),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $cozmU.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $cozmU.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d3ed0ddb142a7bfb$export$f4c0a0f23ba57f8c.Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallbackRender: fallbackRender,
        onReset: onReset
    }, element));
};
const $d3ed0ddb142a7bfb$export$1fd7f5f21a6d6cb8 = ()=>(0, $cozmU.useContext)($d3ed0ddb142a7bfb$export$f4c0a0f23ba57f8c);
module.exports["SmartLinkModalProvider"] = $d3ed0ddb142a7bfb$export$bb4eb02a83e1a0f8;
module.exports["useSmartLinkModal"] = $d3ed0ddb142a7bfb$export$1fd7f5f21a6d6cb8;

});

parcelRegister("5M5Ho", function(module, exports) {

let $4345db1991bf4d1a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4345db1991bf4d1a$var$load("6wr18"),
    $4345db1991bf4d1a$var$load("kHXvF"),
    $4345db1991bf4d1a$var$load("iWnyc"),
    $4345db1991bf4d1a$var$load("ffEVr"),
    $4345db1991bf4d1a$var$load("hhss7"),
    $4345db1991bf4d1a$var$load("Wowvf"),
    $4345db1991bf4d1a$var$load("eRhBr"),
    $4345db1991bf4d1a$var$load("7EorR"),
    $4345db1991bf4d1a$var$load("9zzZg")
]).then(()=>parcelRequire('aoCnl'));

});

parcelRegister("4ZDKy", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $130CJ = parcelRequire("130CJ");


var $aflIU = parcelRequire("aflIU");


var $8QLAc = parcelRequire("8QLAc");

const $3bcafe2f183f4da0$var$SMART_LINK_TO_ROVO_SOURCE = 'smart-link';
const $3bcafe2f183f4da0$var$useRovoChat = ()=>{
    const { rovoOptions: config } = (0, $8QLAc.default)();
    const { publishWithPostMessage: publishWithPostMessage } = (0, $130CJ.useRovoPostMessageToPubsub)();
    const isRovoChatEnabled = (0, $aflIU.getIsRovoChatEnabled)(config);
    const sendPromptMessage = (0, $cozmU.useCallback)((data)=>{
        publishWithPostMessage({
            targetWindow: window.parent ?? window,
            payload: {
                type: 'chat-new',
                source: $3bcafe2f183f4da0$var$SMART_LINK_TO_ROVO_SOURCE,
                data: {
                    dialogues: [],
                    ...data,
                    agentId: undefined
                },
                openChat: true,
                openChatMode: 'sidebar'
            },
            onAcknowledgeTimeout: ()=>{
            // NAVX-3599: Add analytics event
            }
        });
    }, [
        publishWithPostMessage
    ]);
    return (0, $cozmU.useMemo)(()=>({
            isRovoChatEnabled: isRovoChatEnabled,
            sendPromptMessage: sendPromptMessage
        }), [
        isRovoChatEnabled,
        sendPromptMessage
    ]);
};
var $3bcafe2f183f4da0$export$2e2bcd8739ae039 = $3bcafe2f183f4da0$var$useRovoChat;
module.exports["default"] = $3bcafe2f183f4da0$export$2e2bcd8739ae039;

});

parcelRegister("2rTmu", function(module, exports) {

let $1c890c16cec4a0c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1c890c16cec4a0c5$var$load("lOm4J"),
    $1c890c16cec4a0c5$var$load("bU9L5"),
    $1c890c16cec4a0c5$var$load("hhss7"),
    $1c890c16cec4a0c5$var$load("eRhBr"),
    $1c890c16cec4a0c5$var$load("ikMj1")
]).then(()=>parcelRequire('bvLmn'));

});

parcelRegister("3qg1D", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4yYAm = parcelRequire("4yYAm");


var $1xR0T = parcelRequire("1xR0T");

const $95a1d8811810ae49$var$baseBlockStyles = null;
const $95a1d8811810ae49$var$highlightRemoveStyles = null;
const $95a1d8811810ae49$var$gapStyles = {
    xlarge: "_zulpv47k _1ljqv47k",
    large: "_zulppxbi _1ljqpxbi",
    medium: "_zulpu2gc _1ljqu2gc",
    small: "_zulp1b66 _1ljq1b66"
};
const $95a1d8811810ae49$var$directionStyles = {
    vertical: "_2lx21bp4 _4cvr1y6m",
    horizontal: "_2lx2vrvc _4cvr1h6o"
}; /**
    * A block represents a collection of elements and actions that are arranged
    * in a row. All elements and actions should be contained within a Block.
    * @internal
    * @param {ActionGroupProps} ActionGroupProps
    * @see Action
    */ 
const $95a1d8811810ae49$var$Block = ({ children: children, direction: direction = (0, $4yYAm.SmartLinkDirection).Horizontal, size: size = (0, $4yYAm.SmartLinkSize).Medium, testId: testId = 'smart-block', className: className, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd, style: style, placeholderId: placeholderId })=>{
    (0, $cozmU.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1uzp1mp2 _a6bx1l7x _e4i5bjq5 _1gu2dgkc _5b7tuxlv _17aedgkc",
            "_12ji1snc _1qu2agmp _12y310yn _12ji1kw7 _syaz1kw7 _18ql1j28 _1ifmglyw _181uglyw _1rkwglyw _te17glyw _uiztglyw",
            $95a1d8811810ae49$var$directionStyles[direction],
            $95a1d8811810ae49$var$gapStyles[size],
            className
        ]),
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef,
        style: style,
        "data-ssr-placeholder": placeholderId,
        "data-ssr-placeholder-replace": placeholderId
    }, (0, $1xR0T.renderChildren)(children, size));
};
var $95a1d8811810ae49$export$2e2bcd8739ae039 = $95a1d8811810ae49$var$Block;
module.exports["default"] = $95a1d8811810ae49$export$2e2bcd8739ae039;

});

parcelRegister("i1503", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $3qg1D = parcelRequire("3qg1D");


var $knKT4 = parcelRequire("knKT4");


var $1xR0T = parcelRequire("1xR0T");

const $a9bb71ed919d2ffd$var$DEFAULT_MAX_LINES = 2;
const $a9bb71ed919d2ffd$var$MAXIMUM_MAX_LINES = 2;
const $a9bb71ed919d2ffd$var$MINIMUM_MAX_LINES = 1;
const $a9bb71ed919d2ffd$var$truncateStyles = {
    '1': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54",
    '2': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjcs5v _sudp1e54"
};
const $a9bb71ed919d2ffd$var$sizeStyles = {
    xlarge: "_102k8vuz",
    large: "_102k8vuz",
    medium: "_102kckbl",
    small: "_102kckbl"
};
const $a9bb71ed919d2ffd$var$getMaxLines = (maxLines)=>{
    if (maxLines > $a9bb71ed919d2ffd$var$MAXIMUM_MAX_LINES) return $a9bb71ed919d2ffd$var$DEFAULT_MAX_LINES;
    if (maxLines < $a9bb71ed919d2ffd$var$MINIMUM_MAX_LINES) return $a9bb71ed919d2ffd$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $a9bb71ed919d2ffd$var$ElementItemRenderer = ({ align: align = (0, $4yYAm.SmartLinkAlignment).Left, items: items = [], display: display = 'inline', size: size = (0, $4yYAm.SmartLinkSize).Medium, maxLines: maxLines = $a9bb71ed919d2ffd$var$DEFAULT_MAX_LINES })=>{
    const elements = (0, $1xR0T.renderElementItems)(items, display);
    return elements && /*#__PURE__*/ $cozmU.createElement((0, $knKT4.default), {
        align: align,
        direction: (0, $4yYAm.SmartLinkDirection).Horizontal,
        width: (0, $4yYAm.SmartLinkWidth).Flexible,
        size: size,
        className: (0, $hekY6.default)([
            $a9bb71ed919d2ffd$var$truncateStyles[maxLines],
            $a9bb71ed919d2ffd$var$sizeStyles[size]
        ])
    }, elements);
}; /**
    * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
    * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
    * @public
    * @param {MetadataBlockProps} MetadataBlockProps
    * @see Block
    */ 
const $a9bb71ed919d2ffd$var$MetadataBlock = ({ maxLines: maxLines = $a9bb71ed919d2ffd$var$DEFAULT_MAX_LINES, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    const cardContext = (0, $9PA4G.useFlexibleCardContext)();
    if (primary.length === 0 && secondary.length === 0 || cardContext?.status !== (0, $4yYAm.SmartLinkStatus).Resolved) return null;
    const size = blockProps?.size ?? cardContext?.ui?.size ?? (0, $4yYAm.SmartLinkSize).Medium;
    const maxLinesTotal = $a9bb71ed919d2ffd$var$getMaxLines(maxLines);
    return /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        ...blockProps,
        size: size,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ $cozmU.createElement($a9bb71ed919d2ffd$var$ElementItemRenderer, {
        items: primary,
        size: size,
        maxLines: maxLinesTotal
    }), /*#__PURE__*/ $cozmU.createElement($a9bb71ed919d2ffd$var$ElementItemRenderer, {
        align: (0, $4yYAm.SmartLinkAlignment).Right,
        items: secondary,
        size: size,
        maxLines: maxLinesTotal
    }));
};
var $a9bb71ed919d2ffd$export$2e2bcd8739ae039 = $a9bb71ed919d2ffd$var$MetadataBlock;
module.exports["default"] = $a9bb71ed919d2ffd$export$2e2bcd8739ae039;

});

parcelRegister("voDgt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9PA4G = parcelRequire("9PA4G");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $hekY6 = parcelRequire("hekY6");


var $4yYAm = parcelRequire("4yYAm");


var $khRQO = parcelRequire("khRQO");


var $3qg1D = parcelRequire("3qg1D");

const $162c9c59097b1dcb$var$previewBlockStyleCommon = null;
const $162c9c59097b1dcb$var$ignoreContainerPaddingStyle = null; /**
                                           * Represents a resolved PreviewBlock, which typically contains media or other large format content.
                                           * @public
                                           * @param {PreviewBlock} PreviewBlock
                                           * @see Block
                                           */ 
const $162c9c59097b1dcb$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, placement: placement, testId: testId, overrideUrl: overrideUrl, style: style, className: className, ...blockProps })=>{
    const [dynamicStyles, setDynamicStyles] = (0, $cozmU.useState)(style ?? {});
    const updateStyles = (0, $cozmU.useCallback)(()=>{
        if (placement === (0, $4yYAm.MediaPlacement).Left || placement === (0, $4yYAm.MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? '0px' : 'var(--container-padding)';
            const newStyle = {
                ...style,
                position: 'absolute',
                top: containerPadding,
                bottom: containerPadding,
                width: `calc(var(--preview-block-width) - ${containerPadding})`,
                ...placement === (0, $4yYAm.MediaPlacement).Left ? {
                    left: containerPadding
                } : {},
                ...placement === (0, $4yYAm.MediaPlacement).Right ? {
                    right: containerPadding
                } : {}
            };
            setDynamicStyles(newStyle);
        } else if (ignoreContainerPadding) setDynamicStyles({
            ...style
        });
    }, [
        ignoreContainerPadding,
        placement,
        style
    ]); // Should be useLayoutEffect to avoid flicker.
    // Styles should be set before paint.
    (0, $cozmU.useLayoutEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        placement,
        updateStyles,
        className
    ]);
    const handleOnLoad = (0, $cozmU.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $cozmU.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        style: dynamicStyles,
        className: (0, $hekY6.default)([
            placement && "_1t26n7od _ze72n7od _10aa1osq _rjuj1osq _mr051dfr",
            !placement && ignoreContainerPadding && "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9",
            className
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $khRQO.default), {
        onError: handleOnError,
        onLoad: handleOnLoad,
        overrideUrl: overrideUrl
    }));
};
var $162c9c59097b1dcb$export$2e2bcd8739ae039 = $162c9c59097b1dcb$var$PreviewBlockResolvedView;


/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $573950a3d3f757c4$var$PreviewBlock = ({ testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    const ui = (0, $9PA4G.useFlexibleUiOptionContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $162c9c59097b1dcb$export$2e2bcd8739ae039), {
        ...blockProps,
        size: blockProps.size ?? ui?.size,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
var $573950a3d3f757c4$export$2e2bcd8739ae039 = $573950a3d3f757c4$var$PreviewBlock;
module.exports["default"] = $573950a3d3f757c4$export$2e2bcd8739ae039;

});

parcelRegister("es2gJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $9ojsk = parcelRequire("9ojsk");


var $s4fzU = parcelRequire("s4fzU");


var $acUNT = parcelRequire("acUNT");


var $3qg1D = parcelRequire("3qg1D");

const $a551202d4fb14617$var$DEFAULT_MAX_LINES = 3;
const $a551202d4fb14617$var$MAXIMUM_MAX_LINES = 6;
const $a551202d4fb14617$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlockProps} SnippetBlockProps
 * @see Block
 */ const $a551202d4fb14617$var$SnippetBlock = ({ maxLines: maxLines = $a551202d4fb14617$var$DEFAULT_MAX_LINES, testId: testId = 'smart-block-snippet', text: text, isHidden: isHidden = false, showFooter: showFooter = true, ...blockProps })=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const renderers = (0, $9ojsk.useSmartLinkRenderers)();
    const enableSnippetRenderer = (0, $9PA4G.useFlexibleUiOptionContext)()?.enableSnippetRenderer;
    const cardContext = (0, $9PA4G.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $4yYAm.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $acUNT.getMaxLines)(maxLines, $a551202d4fb14617$var$DEFAULT_MAX_LINES, $a551202d4fb14617$var$MAXIMUM_MAX_LINES, $a551202d4fb14617$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    const snippet = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $s4fzU.default), {
        maxLines: snippetMaxLines,
        content: text
    });
    if (!enableSnippetRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3qg1D.default), {
        ...blockProps,
        size: blockProps.size ?? cardContext?.ui?.size,
        testId: `${testId}-${statusTestId}-view`
    }, snippet);
    const SnippetReplacement = renderers?.snippet;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3qg1D.default), {
        ...blockProps,
        size: blockProps.size ?? cardContext?.ui?.size,
        testId: `${testId}-${statusTestId}-view`
    }, SnippetReplacement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SnippetReplacement, {
        fallbackText: (text || context?.snippet) ?? '',
        fallbackComponent: snippet,
        contentId: context?.meta?.objectId ?? '',
        contentType: context?.meta?.resourceType ?? '',
        cloudId: context?.meta?.tenantId ?? '',
        maxLines: snippetMaxLines,
        isHidden: isHidden,
        showFooter: showFooter
    }) : snippet);
};
var $a551202d4fb14617$export$2e2bcd8739ae039 = $a551202d4fb14617$var$SnippetBlock;
module.exports["default"] = $a551202d4fb14617$export$2e2bcd8739ae039;

});

parcelRegister("9ojsk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cMyWi = parcelRequire("cMyWi");

const $1b16e3a991f1098a$export$c3514c024fefef57 = ()=>{
    const context = (0, $cMyWi.useSmartLinkContext)();
    let renderers = context?.renderers;
    renderers = (0, $cozmU.useMemo)(()=>renderers, [
        renderers
    ]);
    return renderers;
};
module.exports["useSmartLinkRenderers"] = $1b16e3a991f1098a$export$c3514c024fefef57;

});

parcelRegister("jdA6O", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4yYAm = parcelRequire("4yYAm");


var $3tPPd = parcelRequire("3tPPd");


var $9PA4G = parcelRequire("9PA4G");


var $fIakH = parcelRequire("fIakH");


var $3M4EV = parcelRequire("3M4EV");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $iMnC5 = parcelRequire("iMnC5");








var $8Mb1e = parcelRequire("8Mb1e");


var $hsIfr = parcelRequire("hsIfr");


var $3qg1D = parcelRequire("3qg1D");


var $knKT4 = parcelRequire("knKT4");

const $035d7ae6638db71e$var$styles = {
    titleBoxCard: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
};
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $035d7ae6638db71e$var$TitleBlockErroredView = ({ actionGroup: actionGroup, hideRetry: hideRetry, retry: _retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, CompetitorPrompt: CompetitorPrompt, ...blockProps })=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const showRetry = !hideRetry && Boolean(context?.actions?.[(0, $4yYAm.InternalActionName).UnresolvedAction]);
    const competitorPrompt = CompetitorPrompt && context?.url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CompetitorPrompt, {
        sourceUrl: context?.url,
        linkType: 'card'
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3qg1D.default), {
        ...blockProps,
        testId: `${testId}-errored-view`
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hsIfr.default), {
        overrideIcon: icon,
        position: position
    }), competitorPrompt ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $035d7ae6638db71e$var$styles.titleBoxCard
    }, title, competitorPrompt) : title, showRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $knKT4.default), {
        align: (0, $4yYAm.SmartLinkAlignment).Right
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Mb1e.default), {
        testId: testId
    })), actionGroup);
};
var $035d7ae6638db71e$export$2e2bcd8739ae039 = $035d7ae6638db71e$var$TitleBlockErroredView;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 





















var $1xR0T = parcelRequire("1xR0T");

const $656aa9cb921f908d$var$style = null;
const $656aa9cb921f908d$var$styles = {
    titleBox: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
}; /**
    * This renders a fully resolved TitleBlock.
    * This should render when a Smart Link returns a valid response.
    * @see TitleBlock
    */ 
const $656aa9cb921f908d$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: _text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...blockProps })=>{
    const { size: size } = blockProps;
    const metadataElements = (0, $1xR0T.renderElementItems)(metadata);
    const subtitleElements = (0, $1xR0T.renderElementItems)(subtitle);
    return /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`
    }, !hideIcon && /*#__PURE__*/ $cozmU.createElement((0, $hsIfr.default), {
        overrideIcon: icon,
        position: position,
        size: size,
        hideLoadingSkeleton: hideIconLoadingSkeleton
    }), /*#__PURE__*/ $cozmU.createElement((0, $knKT4.default), {
        direction: (0, $4yYAm.SmartLinkDirection).Vertical,
        width: (0, $4yYAm.SmartLinkWidth).Flexible,
        size: blockProps.size,
        className: (0, $hekY6.default)([
            "_zulp1b66"
        ])
    }, CompetitorPrompt && url ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $656aa9cb921f908d$var$styles.titleBox
    }, title, /*#__PURE__*/ $cozmU.createElement(CompetitorPrompt, {
        sourceUrl: url,
        linkType: 'card'
    })) : title, subtitleElements && /*#__PURE__*/ $cozmU.createElement((0, $knKT4.default), {
        direction: (0, $4yYAm.SmartLinkDirection).Horizontal
    }, subtitleElements)), metadataElements && /*#__PURE__*/ $cozmU.createElement((0, $knKT4.default), {
        direction: (0, $4yYAm.SmartLinkDirection).Horizontal,
        align: (0, $4yYAm.SmartLinkAlignment).Right,
        position: metadataPosition ?? (0, $4yYAm.SmartLinkPosition).Center,
        size: blockProps.size
    }, metadataElements), actionGroup);
};
var $656aa9cb921f908d$export$2e2bcd8739ae039 = $656aa9cb921f908d$var$TitleBlockResolvedView;


/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 






var $htZ7r = parcelRequire("htZ7r");





var $acUNT = parcelRequire("acUNT");




/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $7b9919bccb7f62e8$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, icon: icon, position: position, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $4yYAm.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $acUNT.getIconWidth)(size);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3qg1D.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`
    }, !hideIcon && icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hsIfr.default), {
        overrideIcon: icon,
        position: position,
        size: size,
        hideLoadingSkeleton: true
    }), !hideIcon && !icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        style: {
            width: iconWidth,
            height: iconWidth
        },
        "data-testid": `${testId}-icon`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $htZ7r.LoadingSkeleton), {
        width: iconWidth,
        height: iconWidth,
        testId: `${testId}-icon-loading`
    })), title, actionGroup);
};
var $7b9919bccb7f62e8$export$2e2bcd8739ae039 = $7b9919bccb7f62e8$var$TitleBlockResolvingView;


const $62d1ba92b0d6cb12$var$actionStyles = null;
const $62d1ba92b0d6cb12$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $4yYAm.SmartLinkStatus).Pending:
        case (0, $4yYAm.SmartLinkStatus).Resolving:
            return 0, $7b9919bccb7f62e8$export$2e2bcd8739ae039;
        case (0, $4yYAm.SmartLinkStatus).Resolved:
            return 0, $656aa9cb921f908d$export$2e2bcd8739ae039;
        case (0, $4yYAm.SmartLinkStatus).Unauthorized:
        case (0, $4yYAm.SmartLinkStatus).Forbidden:
        case (0, $4yYAm.SmartLinkStatus).NotFound:
        case (0, $4yYAm.SmartLinkStatus).Errored:
        case (0, $4yYAm.SmartLinkStatus).Fallback:
        default:
            return 0, $035d7ae6638db71e$export$2e2bcd8739ae039;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingViewNew
 * @see TitleBlockResolvedViewNew
 * @see TitleBlockErroredViewNew
 */ const $62d1ba92b0d6cb12$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, className: className, anchorRef: anchorRef, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...props })=>{
    const cardContext = (0, $9PA4G.useFlexibleCardContext)();
    const { status: status = (0, $4yYAm.SmartLinkStatus).Fallback, ui: ui } = cardContext || {};
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $cozmU.useState)(false);
    const onDropdownOpenChange = (0, $cozmU.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ $cozmU.createElement((0, $3M4EV.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $3tPPd.useMouseDownEvent)();
    const title = /*#__PURE__*/ $cozmU.createElement((0, $fIakH.default), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: ui?.theme,
        anchorRef: anchorRef,
        ...overrideText
    });
    const Component = $62d1ba92b0d6cb12$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ $cozmU.createElement(Component, {
        ...props,
        actionGroup: actionGroup,
        className: (0, $hekY6.default)([
            showActionOnHover && !actionDropdownOpen && "_1bfhidpf _wn5xkb7n _h157kb7n",
            className
        ]),
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        hideRetry: hideRetry,
        icon: icon,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton,
        size: props.size ?? ui?.size,
        CompetitorPrompt: CompetitorPrompt,
        url: url
    });
};
var $62d1ba92b0d6cb12$export$2e2bcd8739ae039 = $62d1ba92b0d6cb12$var$TitleBlock;
module.exports["default"] = $62d1ba92b0d6cb12$export$2e2bcd8739ae039;

});

parcelRegister("i9PP7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $bltJZ = parcelRequire("bltJZ");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");





var $dM7c5 = parcelRequire("dM7c5");


var $euBHF = parcelRequire("euBHF");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $303LV = parcelRequire("303LV");

/* ulist.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $d4e1b4926b40177f$var$listStyles = null;
const $d4e1b4926b40177f$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
        ...props,
        className: (0, $hekY6.default)([
            "_19bvv47k _bozgv47k"
        ])
    }, children);
var $d4e1b4926b40177f$export$2e2bcd8739ae039 = $d4e1b4926b40177f$var$UList;


const $3e46263f264d9f6a$var$baseStyle = null;
const $3e46263f264d9f6a$var$textStyle = null; /**
                         * A component to render a response from AI in markdown text.
                         * @internal
                         * @param {AISummaryProps} AISummaryProps
                         */ 
const $3e46263f264d9f6a$var$AISummary = ({ content: content = '', className: className, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $303LV.default), {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_11c8wadc _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            "_syazazsu",
            className
        ]),
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $d4e1b4926b40177f$export$2e2bcd8739ae039)
            },
            disableParsingRawHTML: true
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $3e46263f264d9f6a$export$2e2bcd8739ae039 = $3e46263f264d9f6a$var$AISummary;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $a1ZzW = parcelRequire("a1ZzW");


var $i1t43 = parcelRequire("i1t43");












const $47feb9defb26f66c$var$styles = {
    aiFooterWrapper: "_ca0q1b66"
};
const $47feb9defb26f66c$var$AIFooter = ()=>/*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        alignBlock: "center",
        space: "space.050",
        xcss: $47feb9defb26f66c$var$styles.aiFooterWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
        label: "",
        color: "var(--ds-text-subtle, #505258)",
        size: "small"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        size: "small"
    }, /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
        href: (0, $4yYAm.CONTENT_URL_ROVO),
        appearance: "subtle",
        target: "_blank"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).ai_disclaimer))));
var $47feb9defb26f66c$export$2e2bcd8739ae039 = $47feb9defb26f66c$var$AIFooter;



var $oYjIk = parcelRequire("oYjIk");


var $3qg1D = parcelRequire("3qg1D");





var $6Vsq4 = parcelRequire("6Vsq4");

const $c0fca600a4237d32$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $c0fca600a4237d32$export$2e2bcd8739ae039 = $c0fca600a4237d32$var$AIEventSummaryViewed;


/* ellipses.tsx generated by @compiled/babel-plugin v0.36.1 */ // Copied from platform/packages/ai-mate/rovo-platform-ui-components/src/ui/primitives/ellipses-animation/EllipsesAnimation.tsx






const $47538ce06fe09831$var$animation = null;
const $47538ce06fe09831$var$animation1 = null;
const $47538ce06fe09831$var$animation2 = null;
const $47538ce06fe09831$var$dot1 = null;
const $47538ce06fe09831$var$dot2 = null;
const $47538ce06fe09831$var$dot3 = null;
const $47538ce06fe09831$var$animatedOpacity = null;
const $47538ce06fe09831$export$c0e6915bcce7d1d0 = ({ isAnimated: isAnimated = true })=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        width: "10",
        height: "2",
        viewBox: "0 0 10 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $cozmU.createElement("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            isAnimated && "",
            isAnimated && "_y44v1gpk",
            isAnimated && $47538ce06fe09831$var$animatedOpacity
        ]),
        d: "M0.0800781 2V0.414062H1.67969V2H0.0800781Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ $cozmU.createElement("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            isAnimated && "",
            isAnimated && "_y44v18gg",
            isAnimated && $47538ce06fe09831$var$animatedOpacity
        ]),
        d: "M3.83984 2V0.414062H5.43945V2H3.83984Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ $cozmU.createElement("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            isAnimated && "",
            isAnimated && "_y44voqx9",
            isAnimated && $47538ce06fe09831$var$animatedOpacity
        ]),
        d: "M7.59961 2V0.414062H9.19922V2H7.59961Z",
        fill: "#FCA700"
    }));
};


const $9da33f5667df82ae$var$styles = null;
const $9da33f5667df82ae$var$newStyles = {
    iconWrapper: "_19bv1b66 _u5f3utpp _1e0c1txw _4cvr1h6o",
    placeholderWrapper: "_1e0c1txw _4cvr1h6o",
    summaryWrapper: "_ca0q1b66 _1e0c1txw",
    ellipsesContainer: "_19bv1b66"
};
const $9da33f5667df82ae$var$AISummaryBlockResolvedView = (props)=>{
    (0, $6cFsl.di)((0, $euBHF.default), (0, $3e46263f264d9f6a$export$2e2bcd8739ae039));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $euBHF.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $cozmU.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, placeholder);
    return /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        ...props,
        direction: (0, $4yYAm.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        className: (0, $hekY6.default)([
            "_1reoewfl _18m9ewfl"
        ])
    }, status === 'done' && /*#__PURE__*/ $cozmU.createElement((0, $c0fca600a4237d32$export$2e2bcd8739ae039), {
        fromCache: isSummarisedOnMountRef.current
    }), /*#__PURE__*/ $cozmU.createElement((0, $oYjIk.default), {
        minHeight: minHeight,
        show: showAISummary,
        showTransition: !isSummarisedOnMountRef.current
    }, /*#__PURE__*/ $cozmU.createElement((0, $3e46263f264d9f6a$export$2e2bcd8739ae039), {
        testId: `${testId}-ai-summary`,
        minHeight: minHeight,
        content: content
    })));
};
const $9da33f5667df82ae$export$3570243fee4941c9 = (props)=>{
    (0, $6cFsl.di)((0, $euBHF.default), (0, $3e46263f264d9f6a$export$2e2bcd8739ae039));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $euBHF.default)(url);
    const isSummarisedOnMountRef = (0, $cozmU.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (status === 'error') return null;
     // Show summary when there is content to display
    if (content && content !== '') return /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        ...props,
        direction: (0, $4yYAm.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        className: (0, $hekY6.default)([
            "_1reoewfl _18m9ewfl"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        xcss: $9da33f5667df82ae$var$newStyles.summaryWrapper
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $9da33f5667df82ae$var$newStyles.iconWrapper
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $bltJZ.RovoIcon), {
        shouldUseHexLogo: true,
        size: "xxsmall"
    })), status === 'done' && /*#__PURE__*/ $cozmU.createElement((0, $c0fca600a4237d32$export$2e2bcd8739ae039), {
        fromCache: isSummarisedOnMountRef.current
    }), /*#__PURE__*/ $cozmU.createElement((0, $oYjIk.default), {
        minHeight: minHeight,
        show: true,
        showTransition: !isSummarisedOnMountRef.current
    }, /*#__PURE__*/ $cozmU.createElement((0, $3e46263f264d9f6a$export$2e2bcd8739ae039), {
        testId: `${testId}-ai-summary`,
        minHeight: minHeight,
        content: content
    }), status === 'done' && /*#__PURE__*/ $cozmU.createElement((0, $47feb9defb26f66c$export$2e2bcd8739ae039), null))));
     // Show loading state on initial request where content hasn't returned yet.
    if (status === 'loading') return /*#__PURE__*/ $cozmU.createElement((0, $oYjIk.default), {
        minHeight: minHeight,
        show: true,
        showTransition: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        testId: `${testId}-placeholder`,
        xcss: $9da33f5667df82ae$var$newStyles.placeholderWrapper
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $9da33f5667df82ae$var$newStyles.iconWrapper
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $bltJZ.RovoIcon), {
        shouldUseHexLogo: true,
        size: 'xxsmall'
    })), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        size: "small",
        color: "color.text"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).rovo_summary_loading)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $9da33f5667df82ae$var$newStyles.ellipsesContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $47538ce06fe09831$export$c0e6915bcce7d1d0), {
        isAnimated: true
    }))));
     // Otherwise, show placeholder if provided
    if (placeholder) return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, placeholder);
    return null;
};
var $9da33f5667df82ae$export$2e2bcd8739ae039 = $9da33f5667df82ae$var$AISummaryBlockResolvedView;


/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $37cabc1db20a37d1$var$AISummaryBlock = ({ testId: testId = 'smart-ai-summary-block', ...props })=>{
    const cardContext = (0, $9PA4G.useFlexibleCardContext)();
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $4yYAm.InternalActionName).AISummaryAction];
    if (cardContext?.status !== (0, $4yYAm.SmartLinkStatus).Resolved) return null;
    if (!actionData?.url) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9da33f5667df82ae$export$2e2bcd8739ae039), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId,
        url: actionData.url
    });
};
var $37cabc1db20a37d1$export$2e2bcd8739ae039 = $37cabc1db20a37d1$var$AISummaryBlock;
module.exports["default"] = $37cabc1db20a37d1$export$2e2bcd8739ae039;

});

parcelRegister("8v3AV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");











var $fCf6x = parcelRequire("fCf6x");


var $3qg1D = parcelRequire("3qg1D");





var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $gC0KQ = parcelRequire("gC0KQ");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $lpNn5 = parcelRequire("lpNn5");


var $dM7c5 = parcelRequire("dM7c5");


var $euBHF = parcelRequire("euBHF");





var $fodiz = parcelRequire("fodiz");

const $fb266bb3a6e3891f$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        color: props.color || 'currentColor',
        ...props
    });


const $880107268f4b308a$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    (0, $6cFsl.di)((0, $euBHF.default));
    const { state: { status: status } } = (0, $euBHF.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).ai_summarized_info_short),
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fb266bb3a6e3891f$export$2957fc44b3d2481), {
            label: "Information",
            color: "var(--ds-icon-subtle, #505258)"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC0KQ))), {
        label: "AI",
        color: "var(--ds-icon-subtle, #505258)"
    }));
};


const $7c294d42de00b7e6$var$AIFooterBlockResolvedView = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $4yYAm.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3qg1D.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fCf6x.default), {
        appearance: "subtle",
        testId: `${testId}-provider`
    }), actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $880107268f4b308a$export$175228cc2c92b3b6), {
        ...actionData,
        testId: `${testId}-ai-metadata`
    }) : null);
};
var $7c294d42de00b7e6$export$2e2bcd8739ae039 = $7c294d42de00b7e6$var$AIFooterBlockResolvedView;


/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $7846684e20fcf82a$var$AIFooterBlock = ({ testId: testId = 'smart-ai-footer-block', ...props })=>{
    const cardContext = (0, $9PA4G.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $4yYAm.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7c294d42de00b7e6$export$2e2bcd8739ae039), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId
    });
};
var $7846684e20fcf82a$export$2e2bcd8739ae039 = $7846684e20fcf82a$var$AIFooterBlock;
module.exports["default"] = $7846684e20fcf82a$export$2e2bcd8739ae039;

});

parcelRegister("9PQfP", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6cFsl = parcelRequire("6cFsl");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $7K8i3 = parcelRequire("7K8i3");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $24dy7 = parcelRequire("24dy7");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $oYjIk = parcelRequire("oYjIk");

const $21a638afd8e71cc8$var$styles = {
    containerStyles: "_kkk2n7od _2rko12b0 _1rjc12x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _1bsb1osq _fiawglyw",
    errorContentStyles: "_bozgv77o",
    titleStyles: "_11c8wadc _syazazsu"
};
const $21a638afd8e71cc8$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "compact",
                label: "Error",
                testId: "action-error-icon",
                size: "small"
            });
        default:
            return null;
    }
};
const $21a638afd8e71cc8$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        backgroundColor: message.appearance === 'error' ? 'color.background.danger' : undefined,
        testId: `${testId}-footer`,
        style: {
            width: `calc(100% - var(--container-padding-left) - var(--container-padding-right))`
        },
        xcss: $21a638afd8e71cc8$var$styles.containerStyles
    }, /*#__PURE__*/ $cozmU.createElement((0, $oYjIk.default), {
        isFadeIn: true,
        show: true,
        showTransition: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        alignBlock: "start",
        grow: "fill",
        space: "space.075",
        xcss: $21a638afd8e71cc8$var$styles.errorContentStyles
    }, message.icon || $21a638afd8e71cc8$var$getIcon(message.appearance), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $21a638afd8e71cc8$var$styles.titleStyles
    }, message.title))));
};


const $733a7410919e6a84$var$ignoreContainerPaddingStyles = null;
const $733a7410919e6a84$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $733a7410919e6a84$var$sort = (a, b)=>{
    let idxA = $733a7410919e6a84$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $733a7410919e6a84$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $733a7410919e6a84$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $733a7410919e6a84$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
}; /**
    * Get container padding based on smart link size
    * To replace container/index.tsx getPadding() with space token for primitives
    */ 
const $733a7410919e6a84$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $4yYAm.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $4yYAm.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $4yYAm.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $4yYAm.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $733a7410919e6a84$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, className: className, testId: testId = 'smart-block-action' })=>{
    (0, $6cFsl.di)((0, $21a638afd8e71cc8$export$2d2b754ac238f9aa));
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const ui = (0, $9PA4G.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $cozmU.useState)();
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const onLoadingChange = (0, $cozmU.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? $733a7410919e6a84$export$1af10e3728e3a644(ui?.size || (0, $4yYAm.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $cozmU.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $cozmU.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $cozmU.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = Object.keys(context.actions).filter((name)=>name !== (0, $4yYAm.ActionName).RovoChatAction);
        arr.sort($733a7410919e6a84$var$sort);
        const renderAction = (name)=>{
            const Action = name in $7K8i3 ? $7K8i3[name] : undefined;
            if (!Action) return null;
            return /*#__PURE__*/ $cozmU.createElement(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                key: name,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size || ui?.size,
                style: padding ? {
                    paddingInline: padding
                } : undefined,
                hideTooltip: isLoading
            });
        };
        return arr.map((name)=>renderAction(name));
    }, [
        context?.actions,
        spaceInline,
        onError,
        onLoadingChange,
        size,
        ui?.size,
        padding,
        isLoading,
        onClick
    ]);
    if (!actions) return null;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        ref: blockRef,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb129b _18u01ivi _2hwxc10g",
            className
        ])
    }, actions, /*#__PURE__*/ $cozmU.createElement((0, $21a638afd8e71cc8$export$2d2b754ac238f9aa), {
        message: message,
        testId: testId
    }));
};
var $733a7410919e6a84$export$2e2bcd8739ae039 = $733a7410919e6a84$var$ActionBlock;
module.exports["default"] = $733a7410919e6a84$export$2e2bcd8739ae039;

});

parcelRegister("1384B", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bDFeF = parcelRequire("bDFeF");


var $h1uyX = parcelRequire("h1uyX");

const $39b024679e6e9750$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h1uyX.CardLinkView), {
        key: 'lazy-render-key',
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bDFeF.loadingPlaceholderClassName),
        placeholder: placeholder
    });
};
module.exports["LoadingCardLink"] = $39b024679e6e9750$export$1ca0544321134ad6;

});

parcelRegister("bDFeF", function(module, exports) {

const $9f0273b80d56b60e$export$889f1c7c5c7ba2f = 'smart-link-content-footer';
const $9f0273b80d56b60e$export$9747a645aa1216c7 = 'smart-link-metadata-list';
const $9f0273b80d56b60e$export$d4b64e3ae38899a3 = 'block-card-resolving-view';
const $9f0273b80d56b60e$export$7b62853ead5e547c = 'block-card-resolved-view';
const $9f0273b80d56b60e$export$3f9f9653bc75f33d = 'block-card-resolved-view-by';
const $9f0273b80d56b60e$export$a21bb776ab2c28b5 = 'block-card-forbidden-view';
const $9f0273b80d56b60e$export$e9fa69ca91e22a09 = 'block-card-forbidden-view-link';
const $9f0273b80d56b60e$export$d17e5383afeb158c = 'block-card-content';
const $9f0273b80d56b60e$export$8c59795ed52e92b3 = 'block-card-content-header';
const $9f0273b80d56b60e$export$a76ed4d75b5db5f = 'block-card-content-header-name';
const $9f0273b80d56b60e$export$7fbeca230aee4e1a = 'block-card-not-found-view';
const $9f0273b80d56b60e$export$38dcd9bf8c681d21 = 'block-card-errored-view';
const $9f0273b80d56b60e$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';
module.exports["loadingPlaceholderClassName"] = $9f0273b80d56b60e$export$4b2b7d155f69aed4;

});

parcelRegister("h1uyX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5HpbM = parcelRequire("5HpbM");

class $96d7254cc2f1d9b2$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HpbM.Frame), {
            withoutBackground: true,
            ...this.props
        }, this.props.placeholder || this.props.link);
    }
}
module.exports["CardLinkView"] = $96d7254cc2f1d9b2$export$ce508304ed2dd145;

});

parcelRegister("5HpbM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3tPPd = parcelRequire("3tPPd");

/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");




const $37e477ca9cc27a20$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: _isInteractive, isSelected: isSelected, viewType: viewType, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ref: ref,
        ...props,
        className: (0, $hekY6.default)([
            "_1yt4x7n9 _2rko1ssi _v56415x0 _1e0c1nu9 _16d9qvcn _syaz13af _1rkwglyw _4cvx1w55",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && viewType === 'unauthorised' && "_syaz15cr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19itia51 _bfhkhp5a _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
            isHovered && "_1h6d1w55",
            isHovered && !withoutBackground && "_4bfu1r31 _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qsw5lj _uiztglyw _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _bfw7ia51 _1nrm1r31 _c2waglyw _1iohnqa1" : "_uizt1kdv"
        ])
    }, props.children);
});
const $37e477ca9cc27a20$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, viewType: viewType, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
        href: href,
        ref: ref,
        ...props,
        className: (0, $hekY6.default)([
            "_1yt4x7n9 _2rko1ssi _v56415x0 _1e0c1nu9 _16d9qvcn _syaz13af _1rkwglyw _4cvx1w55",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && viewType === 'unauthorised' && "_syaz15cr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19itia51 _bfhkhp5a _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
            isHovered && "_1h6d1w55",
            isHovered && !withoutBackground && "_4bfu1r31 _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qsw5lj _uiztglyw _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _bfw7ia51 _1nrm1r31 _c2waglyw _1iohnqa1" : "_uizt1kdv",
            isInteractive && "_nt751r31 _49pcglyw _1hvw1o36 _1372tlke _7ehiw5lj _1j5pglyw _1di615s3",
            viewType === 'errored' && "_4bfu1r31 _1hms8stv _ajmmnqa1 _9oik1r31 _1bnxglyw _jf4cnqa1"
        ])
    }, props.children);
});
const $37e477ca9cc27a20$var$baseWrapperStyles = null; // if the parent instruct the wrapper to be interactive, and the wrapper is in focus, apply selectedStyles
const $37e477ca9cc27a20$var$interactiveStyles = null;
const $37e477ca9cc27a20$var$hoveredStyles = null;
const $37e477ca9cc27a20$var$hoveredWithBackgroundStyles = null;
const $37e477ca9cc27a20$var$errorViewTypeStyles = null;
const $37e477ca9cc27a20$var$withoutBackgroundStyles = null;
const $37e477ca9cc27a20$var$withBackgroundStyles = null;
const $37e477ca9cc27a20$var$truncateStyles = null;
const $37e477ca9cc27a20$var$unauthorisedTruncateStyles = null;
const $37e477ca9cc27a20$var$notSelectedStyle = null;
const $37e477ca9cc27a20$var$selectedStyles = null;


const $302c4a7232ea4e89$export$b89a827e9254211a = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, link: link, viewType: viewType, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
    const handleClick = (0, $cozmU.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $cozmU.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $3tPPd.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    const isAnchor = Boolean(link || onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = isAnchor ? (0, $37e477ca9cc27a20$export$6e4bde711df5c2ab) : (0, $37e477ca9cc27a20$export$8b5c95e985c4ec9a);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive && !link ? 0 : undefined,
        role: isInteractive && !link ? 'button' : undefined,
        onClick: handleClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered,
        truncateInline: truncateInline,
        viewType: viewType
    }, children);
});
module.exports["Frame"] = $302c4a7232ea4e89$export$b89a827e9254211a;

});

parcelRegister("gGqlT", function(module, exports) {

let $c255028cfb06d7ed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c255028cfb06d7ed$var$load("lOm4J"),
    $c255028cfb06d7ed$var$load("8thxw"),
    $c255028cfb06d7ed$var$load("7FMMX"),
    $c255028cfb06d7ed$var$load("eRhBr"),
    $c255028cfb06d7ed$var$load("6HpsR"),
    $c255028cfb06d7ed$var$load("N3oqb"),
    $c255028cfb06d7ed$var$load("hZ2FX"),
    $c255028cfb06d7ed$var$load("9ZFGK"),
    $c255028cfb06d7ed$var$load("2hLAI"),
    $c255028cfb06d7ed$var$load("dCilB"),
    $c255028cfb06d7ed$var$load("h1yOv"),
    $c255028cfb06d7ed$var$load("1T8H1"),
    $c255028cfb06d7ed$var$load("fyKFO"),
    $c255028cfb06d7ed$var$load("d9sg7"),
    $c255028cfb06d7ed$var$load("l0N35"),
    $c255028cfb06d7ed$var$load("bU9L5"),
    $c255028cfb06d7ed$var$load("fuOfV"),
    $c255028cfb06d7ed$var$load("iZR3N"),
    $c255028cfb06d7ed$var$load("4zz48"),
    $c255028cfb06d7ed$var$load("jXM1T"),
    $c255028cfb06d7ed$var$load("cvcNg"),
    $c255028cfb06d7ed$var$load("jw3lv"),
    $c255028cfb06d7ed$var$load("7rqWx"),
    $c255028cfb06d7ed$var$load("aIze1"),
    $c255028cfb06d7ed$var$load("il8bj"),
    $c255028cfb06d7ed$var$load("4N1MY"),
    $c255028cfb06d7ed$var$load("kG5Ju"),
    $c255028cfb06d7ed$var$load("39XCn"),
    $c255028cfb06d7ed$var$load("3Cky6"),
    $c255028cfb06d7ed$var$load("jL1Ke"),
    $c255028cfb06d7ed$var$load("5MQ0D"),
    $c255028cfb06d7ed$var$load("aFLSJ"),
    $c255028cfb06d7ed$var$load("6fJCf"),
    $c255028cfb06d7ed$var$load("duEFL"),
    $c255028cfb06d7ed$var$load("6wr18"),
    $c255028cfb06d7ed$var$load("1pJPT"),
    $c255028cfb06d7ed$var$load("8zMmc"),
    $c255028cfb06d7ed$var$load("4x9Jx"),
    $c255028cfb06d7ed$var$load("7EorR"),
    $c255028cfb06d7ed$var$load("ffEVr"),
    $c255028cfb06d7ed$var$load("2EIkU"),
    $c255028cfb06d7ed$var$load("Wowvf"),
    $c255028cfb06d7ed$var$load("hhss7"),
    $c255028cfb06d7ed$var$load("cbF85")
]).then(()=>parcelRequire('9gHOR'));

});

parcelRegister("454YE", function(module, exports) {
/**
 * @generated SignedSource<<6bd05e2e2b9097d8dbf3e4020cd14185>>
 * @relayHash 61901cb86a068ab7b9df9bbc44f9c05a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4a0700bc188b20753c05c10b3c1ce40c8d6df7c1fbc9e0a04730a0473c5df0b5
const $3b461e95a816e67a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipKnowledgeDiscovery"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userAri"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userId"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userIdString"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewerId"
    }, v7 = {
        "kind": "Variable",
        "name": "orgId",
        "variableName": "orgId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v11 = {
        "kind": "ScalarField",
        "name": "jobTitle"
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = [
        {
            "kind": "ScalarField",
            "name": "base"
        },
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ], v14 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluencePageLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v13 /*: any*/ 
            }
        ],
        "type": "ConfluencePage"
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluenceBlogPostLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v13 /*: any*/ 
            }
        ],
        "type": "ConfluenceBlogPost"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluenceWhiteboardLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v13 /*: any*/ 
            }
        ],
        "type": "ConfluenceWhiteboard"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            v12 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v18 = [
        {
            "concreteType": "ConfluenceCommentLinks",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": v13 /*: any*/ 
        },
        {
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
                v8 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ 
            ]
        }
    ], v19 = {
        "kind": "ScalarField",
        "name": "url"
    }, v20 = [
        v19 /*: any*/ 
    ], v21 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v22 = [
        v21 /*: any*/ ,
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
                v21 /*: any*/ ,
                v12 /*: any*/ 
            ]
        }
    ], v23 = [
        {
            "alias": "trelloUrl",
            "kind": "ScalarField",
            "name": "url"
        }
    ], v24 = [
        {
            "alias": "webUrl",
            "kind": "ScalarField",
            "name": "url"
        }
    ], v25 = [
        v19 /*: any*/ ,
        v12 /*: any*/ 
    ], v26 = [
        {
            "concreteType": "AssetsLinks",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "web"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "UserProfileCardEntryPointQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "skipKnowledgeDiscovery",
                            "variableName": "skipKnowledgeDiscovery"
                        },
                        {
                            "kind": "Variable",
                            "name": "userAri",
                            "variableName": "userAri"
                        },
                        {
                            "kind": "Variable",
                            "name": "userId",
                            "variableName": "userId"
                        },
                        {
                            "kind": "Variable",
                            "name": "userIdString",
                            "variableName": "userIdString"
                        },
                        {
                            "kind": "Variable",
                            "name": "viewerId",
                            "variableName": "viewerId"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "UserProfileCardRelay_query"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "UserProfileCardEntryPointQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "accountId",
                            "variableName": "userId"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "accountStatus"
                        },
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "email"
                                },
                                {
                                    "concreteType": "AtlassianAccountUserExtendedProfile",
                                    "kind": "LinkedField",
                                    "name": "extendedProfile",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "department"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "location"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "organization"
                                        }
                                    ]
                                }
                            ],
                            "type": "AtlassianAccountUser"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "appType"
                                }
                            ],
                            "type": "AppUser"
                        },
                        v12 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "fields": [
                                        {
                                            "items": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "actors.0",
                                                    "variableName": "userAri"
                                                }
                                            ],
                                            "kind": "ListValue",
                                            "name": "actors"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "filter"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 50
                                }
                            ],
                            "concreteType": "ActivityConnection",
                            "kind": "LinkedField",
                            "name": "workedOn",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ActivityItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "ActivityObject",
                                                    "kind": "LinkedField",
                                                    "name": "object",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "data",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                v14 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ConfluenceDatabaseLinks",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": false,
                                                                            "selections": v13 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ConfluenceDatabase"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ConfluenceEmbedLinks",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": false,
                                                                            "selections": v13 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ConfluenceEmbed"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v18 /*: any*/ ,
                                                                    "type": "ConfluenceFooterComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v18 /*: any*/ ,
                                                                    "type": "ConfluenceInlineComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v20 /*: any*/ ,
                                                                    "type": "TownsquareGoal"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v20 /*: any*/ ,
                                                                    "type": "TownsquareProject"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v20 /*: any*/ ,
                                                                    "type": "TownsquareComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v21 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraIssue"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v22 /*: any*/ ,
                                                                    "type": "JiraPlatformComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v22 /*: any*/ ,
                                                                    "type": "JiraServiceManagementComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v23 /*: any*/ ,
                                                                    "type": "TrelloBoard"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v23 /*: any*/ ,
                                                                    "type": "TrelloCard"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v24 /*: any*/ ,
                                                                    "type": "DevOpsDocument"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v20 /*: any*/ ,
                                                                    "type": "ExternalDocument"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v25 /*: any*/ ,
                                                                    "type": "DevOpsPullRequestDetails"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v20 /*: any*/ ,
                                                                    "type": "ExternalPullRequest"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v24 /*: any*/ ,
                                                                    "type": "DevOpsDesign"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v20 /*: any*/ ,
                                                                    "type": "ExternalRemoteLink"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v20 /*: any*/ ,
                                                                    "type": "MercuryFocusArea"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v25 /*: any*/ ,
                                                                    "type": "MercuryPortfolio"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v20 /*: any*/ ,
                                                                    "type": "RadarPosition"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v20 /*: any*/ ,
                                                                    "type": "RadarView"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v20 /*: any*/ ,
                                                                    "type": "CompassComponent"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "href"
                                                                        }
                                                                    ],
                                                                    "type": "BitbucketPullRequest"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": "loomUrl",
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "LoomVideo"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v26 /*: any*/ ,
                                                                    "type": "AssetsObject"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v26 /*: any*/ ,
                                                                    "type": "AssetsObjectType"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v26 /*: any*/ ,
                                                                    "type": "AssetsSchema"
                                                                },
                                                                v17 /*: any*/ 
                                                            ]
                                                        },
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                v12 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "skipKnowledgeDiscovery",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "KnowledgeDiscoveryQueryApi",
                            "kind": "LinkedField",
                            "name": "knowledgeDiscovery",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "accountId",
                                            "variableName": "userIdString"
                                        },
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "Variable",
                                            "name": "requestingUserId",
                                            "variableName": "viewerId"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "tenantId",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "singleUser",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "KnowledgeDiscoveryUserProfile",
                                                    "kind": "LinkedField",
                                                    "name": "user",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "KnowledgeDiscoveryUserManager",
                                                            "kind": "LinkedField",
                                                            "name": "manager",
                                                            "plural": false,
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                v11 /*: any*/ ,
                                                                v10 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                                                            "kind": "LinkedField",
                                                            "name": "thirdPartyIntegrations",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "externalId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "integrationId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "product"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "KnowledgeDiscoverySingleUser"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4a0700bc188b20753c05c10b3c1ce40c8d6df7c1fbc9e0a04730a0473c5df0b5",
            "metadata": {},
            "name": "UserProfileCardEntryPointQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3b461e95a816e67a$var$node.hash = "bd465fb67955379e19bc4ffef9145f96";
var $3b461e95a816e67a$export$2e2bcd8739ae039 = $3b461e95a816e67a$var$node;
module.exports["default"] = $3b461e95a816e67a$export$2e2bcd8739ae039;

});

parcelRegister("7lnAX", function(module, exports) {

let $558ccc12ee09af34$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $558ccc12ee09af34$var$load("fGYoU").then(()=>parcelRequire('9tb7H'));

});

parcelRegister("eRfpr", function(module, exports) {

var $g0RaX = parcelRequire("g0RaX");

function $c6281ea988ae57a1$export$935a1f551ec13075(profileData) {
    if (!profileData) return 0;
    let count = 0;
    if (profileData.accountId) count += 1;
    const isDeactivated = profileData.accountStatus === 'inactive' || profileData.accountStatus === 'closed';
    if (!isDeactivated && profileData.thirdPartyIntegrations && profileData.thirdPartyIntegrations.length > 0) count += 1;
    return count;
}
const $c6281ea988ae57a1$export$feb180212387929b = ()=>Math.round((0, $g0RaX.getPageTime)());
const $c6281ea988ae57a1$export$6ad9e7706a4ee0f8 = (error)=>{
    const statusCode = $c6281ea988ae57a1$var$readNumericField(error, 'statusCode') ?? $c6281ea988ae57a1$var$readNumericField(error, 'status') ?? $c6281ea988ae57a1$var$readRelayExtensionsStatusCode(error);
    if (statusCode === 404 || $c6281ea988ae57a1$var$isNotFoundLikeError(error, statusCode)) return statusCode !== undefined ? {
        errorType: 'NotFound',
        statusCode: statusCode
    } : {
        errorType: 'NotFound'
    };
    return statusCode !== undefined ? {
        errorType: 'default',
        statusCode: statusCode
    } : {
        errorType: 'default'
    };
};
/**
 * Relay surfaces network errors as `{ errors: [{ extensions: { statusCode, errorType, ... } }] }`.
 * Reads the first error's `extensions.statusCode` so the SLO classification works against the
 * common Relay error envelope, not just hand-rolled `{ statusCode }` objects.
 */ const $c6281ea988ae57a1$var$readRelayExtensionsStatusCode = (error)=>{
    if (!error || typeof error !== 'object' || !('errors' in error)) return undefined;
    const errors = error.errors;
    if (!Array.isArray(errors) || errors.length === 0) return undefined;
    const first = errors[0];
    if (!first || typeof first !== 'object' || !('extensions' in first)) return undefined;
    const extensions = first.extensions;
    if (!extensions || typeof extensions !== 'object') return undefined;
    return $c6281ea988ae57a1$var$readNumericField(extensions, 'statusCode') ?? $c6281ea988ae57a1$var$readNumericField(extensions, 'status');
};
const $c6281ea988ae57a1$var$readNumericField = (error, field)=>{
    if (error && typeof error === 'object' && field in error) {
        const value = error[field];
        if (typeof value === 'number' && Number.isFinite(value)) return value;
    }
    return undefined;
};
/** Returns true for unambiguous not-found signals. Message-pattern matching is last-resort — only used when statusCode is absent to avoid misclassifying generic errors (e.g. a 500 whose message contains "not found"). */ const $c6281ea988ae57a1$var$isNotFoundLikeError = (error, statusCode)=>{
    if (!error || typeof error !== 'object') return false;
    const code = $c6281ea988ae57a1$var$readStringField(error, 'code');
    if (code && /NOT_FOUND/i.test(code)) return true;
    // Only match message patterns when there is no statusCode — a 500 with "not found" in its message must not be misclassified as NotFound.
    if (statusCode === undefined) {
        const message = $c6281ea988ae57a1$var$readStringField(error, 'message');
        if (message && /\bnot\s*found\b/i.test(message)) return true;
    }
    return false;
};
const $c6281ea988ae57a1$var$readStringField = (error, field)=>{
    if (field in error) {
        const value = error[field];
        if (typeof value === 'string') return value;
    }
    return undefined;
};
module.exports["countRenderedActions"] = $c6281ea988ae57a1$export$935a1f551ec13075;
module.exports["firedAt"] = $c6281ea988ae57a1$export$feb180212387929b;
module.exports["getErrorAttributes"] = $c6281ea988ae57a1$export$6ad9e7706a4ee0f8;

});

parcelRegister("kKnPE", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lUcpS = parcelRequire("lUcpS");


var $eRfpr = parcelRequire("eRfpr");


var $bIiaK = parcelRequire("bIiaK");

// Cast payload superset to `never` so `fireEvent` accepts extra SLO fields.
const $5204e5464349947f$var$asExtendedPayload = (payload)=>payload;
function $5204e5464349947f$export$97ec6f6769110fe4() {
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    return ()=>{
        fireEvent('operational.profilecard.triggered.request', {
            firedAt: (0, $eRfpr.firedAt)()
        });
    };
}
function $5204e5464349947f$export$f7831696c122c106() {
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const firedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (firedRef.current) return;
        firedRef.current = true;
        fireEvent('ui.profilecard.rendered.spinner', {
            firedAt: (0, $eRfpr.firedAt)()
        });
    }, [
        fireEvent
    ]);
}
function $5204e5464349947f$export$38eb2c63ddf3e3a3(hasProfileData) {
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $bIiaK.useCardOpenTimer)();
    const firedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!hasProfileData || firedRef.current) return;
        firedRef.current = true;
        fireEvent('operational.profilecard.succeeded.request', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0
        });
    }, [
        hasProfileData,
        fireEvent,
        getDurationSinceInteraction
    ]);
}
function $5204e5464349947f$export$20c24f03e0a7c8fc(profileData) {
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $bIiaK.useCardOpenTimer)();
    const firedRef = (0, $cozmU.useRef)(false);
    const profileDataRef = (0, $cozmU.useRef)(profileData);
    profileDataRef.current = profileData;
    (0, $cozmU.useEffect)(()=>{
        if (firedRef.current) return;
        firedRef.current = true;
        fireEvent('ui.profilecard.rendered.content', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            numActions: (0, $eRfpr.countRenderedActions)(profileDataRef.current)
        });
    }, [
        fireEvent,
        getDurationSinceInteraction
    ]);
}
function $5204e5464349947f$export$5fc91356da713d06(error) {
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $bIiaK.useCardOpenTimer)();
    const firedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (error === undefined || firedRef.current) return;
        firedRef.current = true;
        const attributes = error === null ? {
            errorType: 'NotFound'
        } : (0, $eRfpr.getErrorAttributes)(error);
        if (attributes.errorType === 'NotFound') {
            fireEvent('operational.profilecard.succeeded.request', {
                firedAt: (0, $eRfpr.firedAt)(),
                duration: getDurationSinceInteraction() ?? 0
            });
            return;
        }
        fireEvent('operational.profilecard.failed.request', $5204e5464349947f$var$asExtendedPayload({
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            // schema requires `errorMessage`; send the classified type to avoid PII.
            errorMessage: attributes.errorType,
            errorType: attributes.errorType,
            ...attributes.statusCode !== undefined ? {
                errorStatusCode: attributes.statusCode
            } : {}
        }));
    }, [
        error,
        fireEvent,
        getDurationSinceInteraction
    ]);
}
module.exports["useFireTriggeredRequest"] = $5204e5464349947f$export$97ec6f6769110fe4;
module.exports["useFireRenderedSpinner"] = $5204e5464349947f$export$f7831696c122c106;
module.exports["useFireRequestSucceeded"] = $5204e5464349947f$export$38eb2c63ddf3e3a3;
module.exports["useFireContentRendered"] = $5204e5464349947f$export$20c24f03e0a7c8fc;
module.exports["useFireRequestFailed"] = $5204e5464349947f$export$5fc91356da713d06;

});

parcelRegister("bIiaK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $g0RaX = parcelRequire("g0RaX");

const $1aeaee3bd13c0f7b$var$noopContext = {
    markInteractionStart: ()=>{},
    getDurationSinceInteraction: ()=>undefined
};
const $1aeaee3bd13c0f7b$var$CardOpenTimerContext = /*#__PURE__*/ (0, $cozmU.createContext)($1aeaee3bd13c0f7b$var$noopContext);
function $1aeaee3bd13c0f7b$export$8f61ff484d9ed897({ children: children }) {
    const outer = (0, $cozmU.useContext)($1aeaee3bd13c0f7b$var$CardOpenTimerContext);
    const interactionStartRef = (0, $cozmU.useRef)(null);
    const markInteractionStart = (0, $cozmU.useCallback)(()=>{
        // Re-arm per interaction so successive opens each measure from their own t=0.
        interactionStartRef.current = (0, $g0RaX.getPageTime)();
    }, []);
    const getDurationSinceInteraction = (0, $cozmU.useCallback)(()=>{
        if (interactionStartRef.current === null) return undefined;
        return Math.max(0, (0, $g0RaX.getPageTime)() - interactionStartRef.current);
    }, []);
    const value = (0, $cozmU.useMemo)(()=>({
            markInteractionStart: markInteractionStart,
            getDurationSinceInteraction: getDurationSinceInteraction
        }), [
        markInteractionStart,
        getDurationSinceInteraction
    ]);
    if (outer !== $1aeaee3bd13c0f7b$var$noopContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1aeaee3bd13c0f7b$var$CardOpenTimerContext.Provider, {
        value: value
    }, children);
}
function $1aeaee3bd13c0f7b$export$d0c3a3e820a371d6() {
    return (0, $cozmU.useContext)($1aeaee3bd13c0f7b$var$CardOpenTimerContext);
}
module.exports["CardOpenTimerProvider"] = $1aeaee3bd13c0f7b$export$8f61ff484d9ed897;
module.exports["useCardOpenTimer"] = $1aeaee3bd13c0f7b$export$d0c3a3e820a371d6;

});

parcelRegister("9gll8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/** Sentinel identity used to detect "no outer provider" without an explicit flag. */ const $c070228ab88c7aa0$export$ff993edec5f1dba3 = ()=>undefined;
const $c070228ab88c7aa0$export$24fd9e960a1a443b = /*#__PURE__*/ (0, $cozmU.createContext)({
    cloudId: '',
    townsquareApp: undefined,
    onProfileClick: undefined,
    getTestId: $c070228ab88c7aa0$export$ff993edec5f1dba3
});
module.exports["defaultGetTestId"] = $c070228ab88c7aa0$export$ff993edec5f1dba3;
module.exports["UserProfileCardContext"] = $c070228ab88c7aa0$export$24fd9e960a1a443b;

});

parcelRegister("bXEsj", function(module, exports) {
/**
 * Default testId used by the user profile card when the consumer does not pass one.
 * Centralised so the `getTestId` factory in `UserProfileCard` and
 * `UserProfileCardWithTrigger` agrees on what counts as "default".
 */ const $a9a5f85cd687888c$export$d0c64eda5f53987e = 'user-profile-card';
const $a9a5f85cd687888c$export$51b2da6fcb5ae549 = (userId, testId)=>{
    const baseTestId = `user-profile-card-${userId}`;
    const isDefaultTestId = !testId || testId === $a9a5f85cd687888c$export$d0c64eda5f53987e;
    const suffixModifier = isDefaultTestId ? '' : `--${testId}`;
    return (suffix)=>userId ? `${baseTestId}-${suffix}${suffixModifier}` : undefined;
};
module.exports["makeGetTestId"] = $a9a5f85cd687888c$export$51b2da6fcb5ae549;

});

parcelRegister("d35qR", function(module, exports) {
/* CardPopupWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $03ac0dbc50e02241$var$styles = {
    wrapper: "_2rko1mok _1reo15vq _18m915vq _1bsb1gwv _16qs1nax"
};
function $03ac0dbc50e02241$export$aefd550f0f72fff8({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $03ac0dbc50e02241$var$styles.wrapper,
        backgroundColor: "elevation.surface.overlay"
    }, children);
}
module.exports["CardPopupWrapper"] = $03ac0dbc50e02241$export$aefd550f0f72fff8;

});

parcelRegister("l7FKw", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $7K8i3 = parcelRequire("7K8i3");


var $fCf6x = parcelRequire("fCf6x");


var $3qg1D = parcelRequire("3qg1D");

const $dffaffb44f533d82$var$HIDDEN_HOVER_CARD_FOOTER_ACTIONS = [
    (0, $4yYAm.ActionName).RovoChatAction
];
const $dffaffb44f533d82$var$ignoreContainerMarginStyles = null;
const $dffaffb44f533d82$var$elevatedFooterStyles = null;
const $dffaffb44f533d82$var$providerStyles = null;
const $dffaffb44f533d82$var$actionsStyles = null; /**
                             * Footer block for HoverCard resolved view: Provider on the left, ActionGroup (up to 4 actions) on the right.
                             * @internal
                             * @param {ResolvedHoverCardFooterBlockProps} ResolvedHoverCardFooterBlockProps
                             * @see Block
                             */ 
const $dffaffb44f533d82$var$ResolvedHoverCardFooterBlock = ({ testId: testId = 'smart-hover-card-footer-block', onActionClick: onActionClick, hideProvider: hideProvider, ...props })=>{
    const cardContext = (0, $9PA4G.useFlexibleCardContext)();
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const size = props.size ?? cardContext?.ui?.size;
    const actions = (0, $cozmU.useMemo)(()=>{
        if (!context?.actions) return [];
        let arr = Object.keys(context.actions);
        arr = arr.filter((name)=>!$dffaffb44f533d82$var$HIDDEN_HOVER_CARD_FOOTER_ACTIONS.includes(name));
        return arr.map((name)=>{
            const Action = name in $7K8i3 ? $7K8i3[name] : undefined; // Note: For the spinner to render properly, e.g. AI summary action,
            // the spinner need to be updated. See FIX-ME comment on ActionButton
            return Action ? /*#__PURE__*/ $cozmU.createElement(Action, {
                key: name,
                as: "stack-item",
                content: "",
                onClick: ()=>onActionClick?.(name),
                size: size,
                iconSize: 'small'
            }) : null;
        });
    }, [
        context?.actions,
        onActionClick,
        size
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        ...props,
        size: size,
        testId: `${testId}-resolved-view`,
        className: (0, $hekY6.default)([
            "_18zrpxbi _1rjcutpp _vchhusvi _1bsb129b _18u01ivi _2hwxc10g _otyr1ya9 _4t3ioahv",
            "_zulpu2gc _x3doj0fz _bfhkhfxm _mrkb1mok _1o0z1mok"
        ])
    }, !hideProvider && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_4t3i1ejb _1e0c1txw _4cvr1h6o _1bah1y6m _vchhusvi _16jlkb7n"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $fCf6x.default), {
        appearance: "subtle",
        testId: `${testId}-provider`
    })), actions.length > 0 ? /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": `${testId}-actions`,
        className: (0, $hekY6.default)([
            "_zulpidpf _1e0c1txw _18u01wug _4cvr1h6o _vchhusvi _7386ze3t _1xdd12b0 _17zize3t _19p4ze3t _6zimze3t _f9lhze3t _rvy9ze3t _ue4dze3t _zgrbze3t _10cuze3t _6syfze3t _3hv7ze3t"
        ])
    }, actions) : null);
};
var $dffaffb44f533d82$export$2e2bcd8739ae039 = $dffaffb44f533d82$var$ResolvedHoverCardFooterBlock;
module.exports["default"] = $dffaffb44f533d82$export$2e2bcd8739ae039;

});

parcelRegister("4cPhH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $9PA4G = parcelRequire("9PA4G");


var $cZnAt = parcelRequire("cZnAt");

const $dab65d4e2e68d680$var$AssignedToElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $cZnAt.toFormattedTextProps)((0, $dM7c5.messages).assigned_to, context.assignedTo) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZnAt.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).AssignedTo
    }) : null;
};
var $dab65d4e2e68d680$export$2e2bcd8739ae039 = $dab65d4e2e68d680$var$AssignedToElement;
module.exports["default"] = $dab65d4e2e68d680$export$2e2bcd8739ae039;

});

parcelRegister("ktdgI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $le41x = parcelRequire("le41x");

const $9f1fdf181f083d55$var$AssignedToGroupElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $le41x.toAvatarGroupProps)(context.assignedToGroup, true) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $le41x.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).AssignedToGroup
    }) : null;
};
var $9f1fdf181f083d55$export$2e2bcd8739ae039 = $9f1fdf181f083d55$var$AssignedToGroupElement;
module.exports["default"] = $9f1fdf181f083d55$export$2e2bcd8739ae039;

});

parcelRegister("cA0ah", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $jJP7n = parcelRequire("jJP7n");

const $166e8b61b546e359$var$AttachmentCountElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $jJP7n.toBadgeProps)(context.attachmentCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        icon: (0, $4yYAm.IconType).Attachment,
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).AttachmentCount
    }) : null;
};
var $166e8b61b546e359$export$2e2bcd8739ae039 = $166e8b61b546e359$var$AttachmentCountElement;
module.exports["default"] = $166e8b61b546e359$export$2e2bcd8739ae039;

});

parcelRegister("jqres", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $le41x = parcelRequire("le41x");

const $ddf90da8931b7d21$var$AuthorGroupElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $le41x.toAvatarGroupProps)(context.authorGroup, false) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $le41x.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).AuthorGroup
    }) : null;
};
var $ddf90da8931b7d21$export$2e2bcd8739ae039 = $ddf90da8931b7d21$var$AuthorGroupElement;
module.exports["default"] = $ddf90da8931b7d21$export$2e2bcd8739ae039;

});

parcelRegister("a8wJH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $jJP7n = parcelRequire("jJP7n");

const $ecfa86c6b4ffbff9$var$ChecklistProgressElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $jJP7n.toBadgeProps)(context.checklistProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        icon: (0, $4yYAm.IconType).CheckItem,
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).ChecklistProgress
    }) : null;
};
var $ecfa86c6b4ffbff9$export$2e2bcd8739ae039 = $ecfa86c6b4ffbff9$var$ChecklistProgressElement;
module.exports["default"] = $ecfa86c6b4ffbff9$export$2e2bcd8739ae039;

});

parcelRegister("56DiX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $le41x = parcelRequire("le41x");

const $5a3d8a5264b2b296$var$CollaboratorGroupElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $le41x.toAvatarGroupProps)(context.collaboratorGroup, false) : undefined;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $le41x.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).CollaboratorGroup
    }) : null;
};
var $5a3d8a5264b2b296$export$2e2bcd8739ae039 = $5a3d8a5264b2b296$var$CollaboratorGroupElement;
module.exports["default"] = $5a3d8a5264b2b296$export$2e2bcd8739ae039;

});

parcelRegister("ikX3P", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $9ox4X = parcelRequire("9ox4X");

const $6f0d5f807f040dda$var$CreatedOnElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $9ox4X.toDateTimeProps)('created', context.createdOn) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ox4X.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).CreatedOn
    }) : null;
};
var $6f0d5f807f040dda$export$2e2bcd8739ae039 = $6f0d5f807f040dda$var$CreatedOnElement;
module.exports["default"] = $6f0d5f807f040dda$export$2e2bcd8739ae039;

});

parcelRegister("gsQuB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $9PA4G = parcelRequire("9PA4G");


var $cZnAt = parcelRequire("cZnAt");

const $201bd7de6b69c2e6$var$CreatedByElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $cZnAt.toFormattedTextProps)((0, $dM7c5.messages).created_by, context.createdBy) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZnAt.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).CreatedBy
    }) : null;
};
var $201bd7de6b69c2e6$export$2e2bcd8739ae039 = $201bd7de6b69c2e6$var$CreatedByElement;
module.exports["default"] = $201bd7de6b69c2e6$export$2e2bcd8739ae039;

});

parcelRegister("jUXZW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $bYlCi = parcelRequire("bYlCi");

const $060af5e2139ab2e7$var$DueOnElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $bYlCi.toDateLozengeProps)(context.dueOn) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bYlCi.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).DueOn,
        isDateTag: true
    }) : null;
};
var $060af5e2139ab2e7$export$2e2bcd8739ae039 = $060af5e2139ab2e7$var$DueOnElement;
module.exports["default"] = $060af5e2139ab2e7$export$2e2bcd8739ae039;

});

parcelRegister("2VRbJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $jJP7n = parcelRequire("jJP7n");

const $79f37e8a63c6e4c7$var$LatestCommitElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $jJP7n.toBadgeProps)(context.latestCommit?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        icon: (0, $4yYAm.IconType).Commit,
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).LatestCommit
    }) : null;
};
var $79f37e8a63c6e4c7$export$2e2bcd8739ae039 = $79f37e8a63c6e4c7$var$LatestCommitElement;
module.exports["default"] = $79f37e8a63c6e4c7$export$2e2bcd8739ae039;

});

parcelRegister("8y6iW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $jdGU5 = parcelRequire("jdGU5");

const $43a900c32f2a690d$var$LocationElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context?.location ?? null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdGU5.default), {
        theme: (0, $4yYAm.SmartLinkInternalTheme).Grey,
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).Location
    }) : null;
};
var $43a900c32f2a690d$export$2e2bcd8739ae039 = $43a900c32f2a690d$var$LocationElement;
module.exports["default"] = $43a900c32f2a690d$export$2e2bcd8739ae039;

});

parcelRegister("72lc5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $9PA4G = parcelRequire("9PA4G");


var $cZnAt = parcelRequire("cZnAt");

const $2ebfb6cd7421d9a3$var$ModifiedByElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $cZnAt.toFormattedTextProps)((0, $dM7c5.messages).modified_by, context.modifiedBy) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZnAt.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).ModifiedBy
    }) : null;
};
var $2ebfb6cd7421d9a3$export$2e2bcd8739ae039 = $2ebfb6cd7421d9a3$var$ModifiedByElement;
module.exports["default"] = $2ebfb6cd7421d9a3$export$2e2bcd8739ae039;

});

parcelRegister("khRQO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $hekY6 = parcelRequire("hekY6");





var $aGLwK = parcelRequire("aGLwK");

const $eb4553b3010e85ab$var$styles = null;
const $eb4553b3010e85ab$var$MediaElement = ({ name: name, className: className, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    const ui = (0, $9PA4G.useFlexibleUiOptionContext)();
    if (!type || !url) return null;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_1h1tcq2i _1e0c1txw _1bsb1osq _4t3i1ns9 _jqez1osq _1lg71osq _6slq1osq _x1m21osq _1chb1osq _1usb1osq _5c331osq _l9z01osq _6o691dfr _vr2g1dfr _173baqso _1niwaqso _t0h9stnw _1ulbstnw _byj21ooe _3hvr1ooe _1c0s1ssb _15j31ssb _1npy1ssb _19he1ssb _n3vc1wug _1qj91wug _4fdy1wug _18cv1wug _1aoq15vq _1iqz15vq _6fioj63w _l0jmidpf _12zuh2mm",
            className
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $aGLwK.default), {
        hideLoadingSkeleton: ui?.hideLoadingSkeleton,
        testId: `${testId}-image`,
        url: url,
        onError: onError,
        onLoad: onLoad,
        defaultIcon: null
    }));
};
var $eb4553b3010e85ab$export$2e2bcd8739ae039 = $eb4553b3010e85ab$var$MediaElement;


const $dcb10cd4b057c2eb$var$PreviewElement = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $4yYAm.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eb4553b3010e85ab$export$2e2bcd8739ae039), {
        ...rest,
        ...data
    });
};
var $dcb10cd4b057c2eb$export$2e2bcd8739ae039 = $dcb10cd4b057c2eb$var$PreviewElement;
module.exports["default"] = $dcb10cd4b057c2eb$export$2e2bcd8739ae039;

});

parcelRegister("i64z9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $jJP7n = parcelRequire("jJP7n");

const $c1f965687d6e4984$var$PriorityElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context?.priority ?? null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).Priority
    }) : null;
};
var $c1f965687d6e4984$export$2e2bcd8739ae039 = $c1f965687d6e4984$var$PriorityElement;
module.exports["default"] = $c1f965687d6e4984$export$2e2bcd8739ae039;

});

parcelRegister("7bJZv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $jJP7n = parcelRequire("jJP7n");

const $c107b1c1373e69fb$var$ProgrammingLanguageElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $jJP7n.toBadgeProps)(context.programmingLanguage) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        icon: (0, $4yYAm.IconType).ProgrammingLanguage,
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).ProgrammingLanguage
    }) : null;
};
var $c107b1c1373e69fb$export$2e2bcd8739ae039 = $c107b1c1373e69fb$var$ProgrammingLanguageElement;
module.exports["default"] = $c107b1c1373e69fb$export$2e2bcd8739ae039;

});

parcelRegister("fCf6x", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $jJP7n = parcelRequire("jJP7n");

const $858b70b399909400$var$ProviderElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context?.provider ?? null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).Provider
    }) : null;
};
var $858b70b399909400$export$2e2bcd8739ae039 = $858b70b399909400$var$ProviderElement;
module.exports["default"] = $858b70b399909400$export$2e2bcd8739ae039;

});

parcelRegister("7Q48s", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $9PA4G = parcelRequire("9PA4G");


var $cZnAt = parcelRequire("cZnAt");

const $6b917c9ea0468b0a$var$ReadTimeElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $cZnAt.toFormattedTextProps)((0, $dM7c5.messages).read_time, context.readTime) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZnAt.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).ReadTime
    }) : null;
};
var $6b917c9ea0468b0a$export$2e2bcd8739ae039 = $6b917c9ea0468b0a$var$ReadTimeElement;
module.exports["default"] = $6b917c9ea0468b0a$export$2e2bcd8739ae039;

});

parcelRegister("9vYj2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $9ox4X = parcelRequire("9ox4X");

const $2650347969d1867f$var$SentOnElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $9ox4X.toDateTimeProps)('sent', context.sentOn) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ox4X.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).SentOn
    }) : null;
};
var $2650347969d1867f$export$2e2bcd8739ae039 = $2650347969d1867f$var$SentOnElement;
module.exports["default"] = $2650347969d1867f$export$2e2bcd8739ae039;

});

parcelRegister("s4fzU", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $9PA4G = parcelRequire("9PA4G");


var $cZnAt = parcelRequire("cZnAt");

const $3ace4e57de674240$var$SNIPPET_DEFAULT_MAX_LINES = 3;
const $3ace4e57de674240$var$snippetBaseStyle = null;
const $3ace4e57de674240$var$SnippetElement = (props)=>{
    const { content: overrideContent, maxLines: maxLines = $3ace4e57de674240$var$SNIPPET_DEFAULT_MAX_LINES, className: className, ...restOfProps } = props ?? {};
    const context = (0, $9PA4G.useFlexibleUiContext)();
    return /*#__PURE__*/ $cozmU.createElement((0, $cZnAt.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        className: (0, $hekY6.default)([
            "_syazi7uo _1ul9idpf _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        ...restOfProps
    });
};
var $3ace4e57de674240$export$2e2bcd8739ae039 = $3ace4e57de674240$var$SnippetElement;
module.exports["default"] = $3ace4e57de674240$export$2e2bcd8739ae039;

});

parcelRegister("alGk9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $cZnAt = parcelRequire("cZnAt");

const $fe80467b8157e565$var$SourceBranchElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $cZnAt.toTextProps)(context.sourceBranch) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZnAt.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).SourceBranch
    }) : null;
};
var $fe80467b8157e565$export$2e2bcd8739ae039 = $fe80467b8157e565$var$SourceBranchElement;
module.exports["default"] = $fe80467b8157e565$export$2e2bcd8739ae039;

});

parcelRegister("ixgii", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ixfCV = parcelRequire("ixfCV");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $bYlCi = parcelRequire("bYlCi");

const $626942334d6c6fee$var$STATE_METRIC_REGEX = /^(.+?)\s+-\s+(\d+(?:\.\d+)?)$/;
const $626942334d6c6fee$var$StateElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context?.state ?? null;
    const metricProps = (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $cozmU.useMemo)(()=>{
        if (data && typeof data.text === 'string') {
            const match = data.text.match($626942334d6c6fee$var$STATE_METRIC_REGEX);
            if (match) return {
                text: match[1],
                trailingMetric: match[2]
            };
        }
        return null;
    }, [
        data
    ]) : undefined;
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bYlCi.default), {
        ...data,
        ...props,
        ...metricProps,
        name: (0, $4yYAm.ElementName).State
    });
};
var $626942334d6c6fee$export$2e2bcd8739ae039 = $626942334d6c6fee$var$StateElement;
module.exports["default"] = $626942334d6c6fee$export$2e2bcd8739ae039;

});

parcelRegister("kfBIC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $jJP7n = parcelRequire("jJP7n");

const $0c8068f0605185a4$var$SubscriberCountElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $jJP7n.toBadgeProps)(context.subscriberCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        icon: (0, $4yYAm.IconType).Subscriber,
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).SubscriberCount
    }) : null;
};
var $0c8068f0605185a4$export$2e2bcd8739ae039 = $0c8068f0605185a4$var$SubscriberCountElement;
module.exports["default"] = $0c8068f0605185a4$export$2e2bcd8739ae039;

});

parcelRegister("hKI6m", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $jJP7n = parcelRequire("jJP7n");

const $75719457775595b4$var$SubTasksProgressElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $jJP7n.toBadgeProps)(context.subTasksProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        icon: (0, $4yYAm.IconType).SubTasksProgress,
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).SubTasksProgress
    }) : null;
};
var $75719457775595b4$export$2e2bcd8739ae039 = $75719457775595b4$var$SubTasksProgressElement;
module.exports["default"] = $75719457775595b4$export$2e2bcd8739ae039;

});

parcelRegister("8CvOu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $hekY6 = parcelRequire("hekY6");


var $jLnA6 = parcelRequire("jLnA6");

const $e04abc48d41c7945$var$badgeStyles = null; /**
                           * A base element that displays a visual indicator for a numeric value
                           * @internal
                           * @see StoryPoints
                           * */ 
const $e04abc48d41c7945$var$BaseAtlaskitElementBadge = ({ value: value, name: name, className: className, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $jLnA6.default), null, value));
};
var $e04abc48d41c7945$export$2e2bcd8739ae039 = $e04abc48d41c7945$var$BaseAtlaskitElementBadge;
const $e04abc48d41c7945$export$731812b93bd90554 = (value)=>{
    return value ? {
        value: value
    } : undefined;
};


const $a9b6966b9f844797$var$StoryPointsElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $e04abc48d41c7945$export$731812b93bd90554)(context.storyPoints) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e04abc48d41c7945$export$2e2bcd8739ae039), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).StoryPoints
    }) : null;
};
var $a9b6966b9f844797$export$2e2bcd8739ae039 = $a9b6966b9f844797$var$StoryPointsElement;
module.exports["default"] = $a9b6966b9f844797$export$2e2bcd8739ae039;

});

parcelRegister("gDO6D", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $cZnAt = parcelRequire("cZnAt");

const $0255f346a9fc2010$var$TargetBranchElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $cZnAt.toTextProps)(context.targetBranch) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZnAt.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).TargetBranch
    }) : null;
};
var $0255f346a9fc2010$export$2e2bcd8739ae039 = $0255f346a9fc2010$var$TargetBranchElement;
module.exports["default"] = $0255f346a9fc2010$export$2e2bcd8739ae039;

});

parcelRegister("8xQB8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $9PA4G = parcelRequire("9PA4G");


var $cZnAt = parcelRequire("cZnAt");

const $b36f8cfb192a5fc3$var$MAX_TEAM_MEMBER_LIMIT = 50;
const $b36f8cfb192a5fc3$var$TeamMemberCountElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    if (!context?.teamMemberCount) return null;
    const count = context?.teamMemberCount && context?.teamMemberCount > $b36f8cfb192a5fc3$var$MAX_TEAM_MEMBER_LIMIT ? `${$b36f8cfb192a5fc3$var$MAX_TEAM_MEMBER_LIMIT}+` : context?.teamMemberCount?.toString();
    const data = count ? (0, $cZnAt.toFormattedTextProps)((0, $dM7c5.messages).team_members_count, count) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZnAt.default), {
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).TeamMemberCount
    }) : null;
};
var $b36f8cfb192a5fc3$export$2e2bcd8739ae039 = $b36f8cfb192a5fc3$var$TeamMemberCountElement;
module.exports["default"] = $b36f8cfb192a5fc3$export$2e2bcd8739ae039;

});

parcelRegister("fO7nk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $9PA4G = parcelRequire("9PA4G");


var $cZnAt = parcelRequire("cZnAt");

const $f6b6d2f50b462776$var$UserAttributesElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const renderUserAttributes = (userAttributes)=>{
        if (!userAttributes) return null;
        const attributeKeys = [
            'pronouns',
            'role',
            'department',
            'location'
        ];
        const attributes = [];
        attributeKeys.forEach((key)=>{
            if (userAttributes[key]) {
                const data = (0, $cZnAt.toFormattedTextProps)((0, $dM7c5.messages).user_attributes, userAttributes[key]);
                if (data) attributes.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZnAt.default), {
                    key: key,
                    ...data,
                    testId: `smart-element-text-${key}`,
                    ...props,
                    name: (0, $4yYAm.ElementName).UserAttributes
                }));
            }
        });
        return attributes.length > 0 ? attributes : null;
    };
    const elements = context ? renderUserAttributes(context.userAttributes) : null;
    return elements ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, elements) : null;
};
var $f6b6d2f50b462776$export$2e2bcd8739ae039 = $f6b6d2f50b462776$var$UserAttributesElement;
module.exports["default"] = $f6b6d2f50b462776$export$2e2bcd8739ae039;

});

parcelRegister("leiiU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $cZnAt = parcelRequire("cZnAt");

const $fba2805a8ad6b102$var$HostNameElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleCardContext)();
    const hostName = context?.data?.hostName;
    return hostName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZnAt.default), {
        content: hostName,
        ...props,
        name: (0, $4yYAm.ElementName).HostName
    }) : null;
};
var $fba2805a8ad6b102$export$2e2bcd8739ae039 = $fba2805a8ad6b102$var$HostNameElement;
module.exports["default"] = $fba2805a8ad6b102$export$2e2bcd8739ae039;

});

parcelRegister("415JS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $jJP7n = parcelRequire("jJP7n");

const $78c49f266ba351d0$var$ViewCountElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $jJP7n.toBadgeProps)(context.viewCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        icon: (0, $4yYAm.IconType).View,
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).ViewCount
    }) : null;
};
var $78c49f266ba351d0$export$2e2bcd8739ae039 = $78c49f266ba351d0$var$ViewCountElement;
module.exports["default"] = $78c49f266ba351d0$export$2e2bcd8739ae039;

});

parcelRegister("emHHi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $jJP7n = parcelRequire("jJP7n");

const $27011927457b62cf$var$VoteCountElement = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context ? (0, $jJP7n.toBadgeProps)(context.voteCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        icon: (0, $4yYAm.IconType).Vote,
        ...data,
        ...props,
        name: (0, $4yYAm.ElementName).VoteCount
    }) : null;
};
var $27011927457b62cf$export$2e2bcd8739ae039 = $27011927457b62cf$var$VoteCountElement;
module.exports["default"] = $27011927457b62cf$export$2e2bcd8739ae039;

});

parcelRegister("fj0wU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $9PA4G = parcelRequire("9PA4G");


var $jJP7n = parcelRequire("jJP7n");

const $d5f7874bbde1d059$var$AppliedToComponentsCountElement = (props)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const context = (0, $9PA4G.useFlexibleUiContext)();
    if (// Check for null and undefined, render if it's 0.
    context?.appliedToComponentsCount === null || context?.appliedToComponentsCount === undefined) return null;
    const label = formatMessage((0, $dM7c5.messages).compass_applied_components_count, {
        numberOfComponents: context.appliedToComponentsCount
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJP7n.default), {
        icon: (0, $4yYAm.IconType).Component,
        label: label,
        ...props
    });
};
var $d5f7874bbde1d059$export$2e2bcd8739ae039 = $d5f7874bbde1d059$var$AppliedToComponentsCountElement;
module.exports["default"] = $d5f7874bbde1d059$export$2e2bcd8739ae039;

});

parcelRegister("9JK0j", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $cZnAt = parcelRequire("cZnAt");

const $af3bbc13982d0467$var$baseStyle = null;
const $af3bbc13982d0467$var$isMessageDescriptor = (x)=>!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(x);
const $af3bbc13982d0467$var$fontOverrideStyleMap = {
    'font.body': "_11c8fhey",
    'font.body.large': "_11c81d4k",
    'font.body.small': "_11c8wadc"
};
const $af3bbc13982d0467$var$maxLinesCss = null; /**
                           * Public API — exported externally. Do not add props without external support intent.
                           */ 
const $af3bbc13982d0467$var$CustomElementByAccessType = ({ className: className, testId: testId = 'custom-by-access-type-element', ...props })=>{
    const context = (0, $9PA4G.useFlexibleCardContext)();
    const accessType = context?.data?.meta?.accessType;
    const contentForAccessType = props[accessType] ?? props.fallback;
    if (!contentForAccessType) return null;
    const values = context?.data?.actions?.[(0, $4yYAm.InternalActionName).UnresolvedAction]?.values;
    if ($af3bbc13982d0467$var$isMessageDescriptor(contentForAccessType)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZnAt.default), {
        ...props,
        message: {
            descriptor: contentForAccessType,
            values: values
        },
        className: className,
        testId: testId,
        hideFormat: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        style: {
            color: props.color
        },
        "data-separator": true,
        "data-smart-element-text": true,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_11c8wadc _1reo15vq _18m915vq _syazazsu _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            props.fontSize !== undefined && $af3bbc13982d0467$var$fontOverrideStyleMap[props.fontSize],
            "_1yyjkb7n _102k1j6v",
            className
        ])
    }, contentForAccessType);
};
var $af3bbc13982d0467$export$2e2bcd8739ae039 = $af3bbc13982d0467$var$CustomElementByAccessType;
module.exports["default"] = $af3bbc13982d0467$export$2e2bcd8739ae039;

});

parcelRegister("9dF9H", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9PA4G = parcelRequire("9PA4G");

/**
 * Public API — exported externally. Do not add props without external support intent.
 */ const $cfaea8a2c856937c$var$CustomByStatusElement = ({ className: className, testId: testId = 'custom-by-status-element', ...props })=>{
    const context = (0, $9PA4G.useFlexibleCardContext)();
    const status = context?.status;
    if (!status) return null;
    const component = props[status];
    if (!component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-separator": true,
        "data-smart-element": "custom-element",
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className
    }, component);
};
var $cfaea8a2c856937c$export$2e2bcd8739ae039 = $cfaea8a2c856937c$var$CustomByStatusElement;
module.exports["default"] = $cfaea8a2c856937c$export$2e2bcd8739ae039;

});

parcelRegister("cOVCp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");





var $k12R1 = parcelRequire("k12R1");


var $vIR70 = parcelRequire("vIR70");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");

var $eKMV3 = parcelRequire("eKMV3");

var $7WEaj = parcelRequire("7WEaj");


var $iMnC5 = parcelRequire("iMnC5");


var $lpNn5 = parcelRequire("lpNn5");





var $9PA4G = parcelRequire("9PA4G");


var $8QLAc = parcelRequire("8QLAc");


var $ckM0L = parcelRequire("ckM0L");


var $acUNT = parcelRequire("acUNT");

const $8532231a1a6a0a08$var$IconOnlyLarge = null;
const $8532231a1a6a0a08$var$SizeSmall = null;
const $8532231a1a6a0a08$var$styles = {
    textSmall: "_13bowadc _1q9t1wq8 _1rlg1g80 _bdn61h6o"
};
const $8532231a1a6a0a08$var$SizeSmallIconOnly = null;
const $8532231a1a6a0a08$var$SizeSmallNotIconOnly = null;
const $8532231a1a6a0a08$var$IconButtonAppearanceMap = {
    default: 'default',
    danger: undefined,
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: undefined
};
const $8532231a1a6a0a08$var$ButtonAppearanceMap = {
    default: 'default',
    danger: 'danger',
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: 'warning'
};
const $8532231a1a6a0a08$var$tooltipOptions = {
    hideTooltipOnClick: true
};
const $8532231a1a6a0a08$var$ActionButtonRefresh = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel }, ref)=>{
    const iconOnly = !content;
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const { product: product } = (0, $8QLAc.default)();
    const isRovoSupported = !!context?.actions?.[(0, $4yYAm.ActionName).RovoChatAction] && !!product && product === 'CONFLUENCE';
    const onButtonClick = (0, $cozmU.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    const button = (0, $cozmU.useMemo)(()=>{
        const isLinkButton = !!href;
        const spacing = size === (0, $4yYAm.SmartLinkSize).Large || size === (0, $4yYAm.SmartLinkSize).XLarge ? 'default' : 'compact';
        const icon = iconBefore || iconAfter;
        const iconFn = icon ? ()=>icon : undefined;
        if (iconOnly && iconFn) {
            if (isLinkButton && iconFn) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
                appearance: $8532231a1a6a0a08$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                href: href,
                isDisabled: isDisabled,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $8532231a1a6a0a08$var$tooltipOptions
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                appearance: $8532231a1a6a0a08$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $8532231a1a6a0a08$var$tooltipOptions
            });
        }
        const iconBeforeFn = iconBefore ? ()=>iconBefore : undefined;
        const iconAfterFn = iconAfter ? ()=>iconAfter : undefined;
        if (isLinkButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            appearance: $8532231a1a6a0a08$var$ButtonAppearanceMap[appearance],
            "aria-label": ariaLabel,
            iconAfter: iconAfterFn,
            iconBefore: iconBeforeFn,
            isDisabled: isDisabled,
            href: href,
            onClick: onButtonClick(onClick),
            spacing: spacing,
            testId: testId
        }, content));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: $8532231a1a6a0a08$var$ButtonAppearanceMap[appearance],
            "aria-label": ariaLabel,
            iconAfter: iconAfterFn,
            iconBefore: iconBeforeFn,
            isDisabled: isDisabled,
            isLoading: isLoading,
            onClick: onButtonClick(onClick),
            spacing: spacing,
            testId: testId
        }, content));
    }, [
        appearance,
        ariaLabel,
        content,
        href,
        iconAfter,
        iconBefore,
        iconOnly,
        isDisabled,
        isLoading,
        onButtonClick,
        onClick,
        size,
        testId,
        tooltipMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        testId: `${testId}-button-wrapper`,
        ref: ref,
        xcss: (0, $k12R1.cx)(isRovoSupported && size === (0, $4yYAm.SmartLinkSize).Small && $8532231a1a6a0a08$var$styles.textSmall)
    }, button);
});
const $8532231a1a6a0a08$var$ActionButtonRefreshWithOverrideCss = (0, $ckM0L.withOverrideCss)($8532231a1a6a0a08$var$ActionButtonRefresh);
const $8532231a1a6a0a08$var$ActionButtonNew = ({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, className: className })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $cozmU.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            size === (0, $4yYAm.SmartLinkSize).Large && iconOnly && "_1gflidpf _or3fidpf _1ddvidpf _1hhaidpf _yhjmidpf _1trnidpf _1fstidpf _1xceidpf _1gqnidpf _1qdmidpf _df2ridpf _j1twidpf _11lvidpf _192bidpf _vbn7idpf _wfu3idpf _1i3bidpf _13gwidpf _4wlcidpf _rehaidpf _mp2fidpf _ro8midpf _1l0qidpf _1bnaidpf _3kh9idpf _i2vxidpf _8pvjidpf _1e1oidpf _1vtwidpf _ijvwidpf _tpwpidpf _1ad8idpf",
            size === (0, $4yYAm.SmartLinkSize).Small && "_11c8wadc _k48p1wq8",
            size === (0, $4yYAm.SmartLinkSize).Small && iconOnly && "_1gflv77o _or3fv77o _1ddvv77o _1hhav77o _yhjmv77o _1trnv77o _1fstv77o _1xcev77o _1gqnv77o _1qdmv77o _df2rv77o _j1twv77o _11lvv77o _192bv77o _vbn7v77o _wfu3v77o",
            size === (0, $4yYAm.SmartLinkSize).Small && !iconOnly && "_11lv1b66 _192b1b66 _vbn71b66 _wfu31b66 _yhjm1b66 _1trn1b66 _1fst1b66 _1xce1b66",
            className
        ]),
        "data-testid": `${testId}-button-wrapper`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: tooltipMessage,
        hideTooltipOnClick: true,
        testId: `${testId}-tooltip`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $vIR70.default), {
        appearance: appearance,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onButtonClick(onClick),
        spacing: (0, $acUNT.sizeToButtonSpacing)[size],
        testId: testId,
        href: href,
        "aria-label": ariaLabel
    }, content)));
};
const $8532231a1a6a0a08$var$ActionButton = (props)=>{
    const ui = (0, $9PA4G.useFlexibleUiOptionContext)();
    if (ui?.hideLegacyButton || ui?.removeBlockRestriction) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8532231a1a6a0a08$var$ActionButtonRefreshWithOverrideCss, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8532231a1a6a0a08$var$ActionButtonNew, props);
};
var $8532231a1a6a0a08$export$2e2bcd8739ae039 = $8532231a1a6a0a08$var$ActionButton;






var $is1T6 = parcelRequire("is1T6");


var $16kNn = parcelRequire("16kNn");

const $f6a96b6f05617437$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $16kNn.handleOnClick)(onClick),
        testId: testId
    }, content);
var $f6a96b6f05617437$export$2e2bcd8739ae039 = $f6a96b6f05617437$var$ActionDropdownItem;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $07bb28f8f9a17497$var$stackItemIconStylesCompiled = null;
const $07bb28f8f9a17497$var$ActionIcon = ({ testId: testId, icon: icon })=>{
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $hekY6.default)([
            "_1e0c116y"
        ])
    }, icon);
};
var $07bb28f8f9a17497$export$2e2bcd8739ae039 = $07bb28f8f9a17497$var$ActionIcon;








/* action-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $w6R6I = parcelRequire("w6R6I");


var $ixfCV = parcelRequire("ixfCV");




var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");


var $lfoFx = parcelRequire("lfoFx");





const $b17373f47a070578$var$styles = {
    button: "_bfhksm61 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _1ah31i6y _irr31dpa _1di6fcek",
    content: "_11c8wadc _syazi7uo",
    spinner: "_1bsb1tcg _4t3i1tcg _1e0c116y _4cvr1h6o _1bah1h6o"
};
const $b17373f47a070578$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, style: style, ariaLabel: ariaLabel })=>{
    const space = spaceOption ?? (0, $acUNT.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $cozmU.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]); // FIX-ME: This is required for ResolvedHoverCardFooterBlock action to show proper size
    // ResolvedHoverCardFooterBlock is currently not used but keeping inside the code base for
    // upcoming experiment to refresh HoverCard design
    // If ResolvedHoverCardFooterBlock is cleaned up, this code can be removed.
    const showSpinnerSize24 = false;
    const icon = iconOption && isLoading ? /*#__PURE__*/ $cozmU.createElement((0, $07bb28f8f9a17497$export$2e2bcd8739ae039), {
        icon: showSpinnerSize24 ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: $b17373f47a070578$var$styles.spinner
        }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            size: 16,
            testId: `${testId}-loading`
        })) : /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            testId: `${testId}-loading`
        })
    }) : iconOption;
    return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.default), {
        xcss: (0, $w6R6I.cx)($b17373f47a070578$var$styles.button),
        ...tooltipProps,
        onClick: onClick,
        testId: testId,
        style: style,
        ...(0, $ixfCV.fg)('platform_sl_action_refactoring') ? {
            'aria-label': ariaLabel
        } : {}
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        alignBlock: "center",
        grow: "fill",
        space: space
    }, icon, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($b17373f47a070578$var$styles.content)
    }, content)));
};
var $b17373f47a070578$export$2e2bcd8739ae039 = $b17373f47a070578$var$ActionButton;


const $62d59e5b8825e398$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>{
    return hideTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b17373f47a070578$export$2e2bcd8739ae039), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b17373f47a070578$export$2e2bcd8739ae039), {
            ...props,
            content: content,
            tooltipProps: tooltipProps
        }));
};
var $62d59e5b8825e398$export$2e2bcd8739ae039 = $62d59e5b8825e398$var$ActionStackItem;


/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $d4ea2cbf7473627f$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $4yYAm.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, style: style, asDropDownItem: asDropDownItem, className: className, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $07bb28f8f9a17497$export$2e2bcd8739ae039), {
        icon: icon,
        testId: testId
    }) : undefined;
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $62d59e5b8825e398$export$2e2bcd8739ae039), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip,
        ariaLabel: ariaLabel
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f6a96b6f05617437$export$2e2bcd8739ae039), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8532231a1a6a0a08$export$2e2bcd8739ae039), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, null, button) : button;
};
var $d4ea2cbf7473627f$export$2e2bcd8739ae039 = $d4ea2cbf7473627f$var$Action;
module.exports["default"] = $d4ea2cbf7473627f$export$2e2bcd8739ae039;

});

parcelRegister("fhinp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $l3wuH = parcelRequire("l3wuH");


var $dM7c5 = parcelRequire("dM7c5");


var $cOVCp = parcelRequire("cOVCp");

const $f88a7db3804e0f77$var$DeleteAction = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOVCp.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).delete),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).delete),
        ...props
    });
var $f88a7db3804e0f77$export$2e2bcd8739ae039 = $f88a7db3804e0f77$var$DeleteAction;
module.exports["default"] = $f88a7db3804e0f77$export$2e2bcd8739ae039;

});

parcelRegister("78OZj", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $gC2EJ = parcelRequire("gC2EJ");


var $dM7c5 = parcelRequire("dM7c5");


var $cOVCp = parcelRequire("cOVCp");

const $e14a96ed4e7b2165$var$EditAction = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOVCp.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).edit),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).edit),
        ...props
    });
var $e14a96ed4e7b2165$export$2e2bcd8739ae039 = $e14a96ed4e7b2165$var$EditAction;
module.exports["default"] = $e14a96ed4e7b2165$export$2e2bcd8739ae039;

});

parcelRegister("kD7T6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6Fmj3 = parcelRequire("6Fmj3");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $9PA4G = parcelRequire("9PA4G");


var $kfxZm = parcelRequire("kfxZm");


var $cOVCp = parcelRequire("cOVCp");

const $dae9a0dddf9a7f28$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const invoke = (0, $kfxZm.default)({});
    const data = context?.actions?.[(0, $4yYAm.ActionName).DownloadAction];
    const onClick = (0, $cozmU.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $dM7c5.messages).download_file : (0, $dM7c5.messages).download;
    const tooltipMessage = isStackItem ? (0, $dM7c5.messages).download_description : (0, $dM7c5.messages).download;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOVCp.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Fmj3))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), tooltipMessage),
        ...data,
        ...props
    }) : null;
};
var $dae9a0dddf9a7f28$export$2e2bcd8739ae039 = $dae9a0dddf9a7f28$var$DownloadAction;
module.exports["default"] = $dae9a0dddf9a7f28$export$2e2bcd8739ae039;

});

parcelRegister("1fKLY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $cXtTj = parcelRequire("cXtTj");


var $ixfCV = parcelRequire("ixfCV");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $9PA4G = parcelRequire("9PA4G");


var $acUNT = parcelRequire("acUNT");





var $6Vsq4 = parcelRequire("6Vsq4");


var $bwJAe = parcelRequire("bwJAe");


var $k9Bpe = parcelRequire("k9Bpe");


var $cEvdy = parcelRequire("cEvdy");

const $249c069e40bf5370$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $249c069e40bf5370$export$2e2bcd8739ae039 = $249c069e40bf5370$var$createInvokeRequest;



var $cOVCp = parcelRequire("cOVCp");

const $91b3cd2514901f8a$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const invoke = (0, $bwJAe.default)();
    const reload = (0, $cEvdy.default)();
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const handleClick = (0, $cozmU.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                if (smartLinkActionType === 'FollowEntityAction' || smartLinkActionType === 'UnfollowEntityAction') fireEvent('ui.button.clicked.smartLinkFollowButton', {});
                else fireEvent(`ui.button.clicked.${smartLinkActionType}`, {});
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $249c069e40bf5370$export$2e2bcd8739ae039)(action);
                await invoke(request);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload({
                    url: action.reload.url,
                    isReloading: true,
                    id: action.reload.id
                });
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                fireEvent('track.smartLinkQuickAction.failed', {
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $k9Bpe.getInvokeFailureReason)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        invoke,
        onClick,
        onErrorCallback,
        reload,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOVCp.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $91b3cd2514901f8a$export$2e2bcd8739ae039 = $91b3cd2514901f8a$var$ServerAction;








const $1fa8e2f128b6af29$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $cXtTj.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $dM7c5.messages).follow_project_errorGalaxia : (0, $dM7c5.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $cXtTj.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $dM7c5.messages).unfollow_project_errorGalaxia : (0, $dM7c5.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $dM7c5.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $dM7c5.messages).unfollow_goal_error;
    return (0, $dM7c5.messages).generic_error_message;
};




const $2f7ca412ccba39f5$var$importIconMapper = {
    goal: ()=>(parcelRequire("9U5KN")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("bC5Km")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $2f7ca412ccba39f5$var$getIcon = (stackIconType)=>{
    const importFn = $2f7ca412ccba39f5$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $acUNT.importIcon)(importFn);
};
const $2f7ca412ccba39f5$var$FollowAction = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const intl = (0, $kSwu1.useIntl)();
    const actionData = context?.actions?.[(0, $4yYAm.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $dM7c5.messages).follow : (0, $dM7c5.messages).unfollow;
    const projectMessage = value ? (0, $dM7c5.messages).follow_project : (0, $dM7c5.messages).unfollow_project;
    const goalMessage = value ? (0, $dM7c5.messages).follow_goal : (0, $dM7c5.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $cXtTj.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $dM7c5.messages).follow_project_descriptionGalaxia : (0, $dM7c5.messages).follow_project_description : (0, $cXtTj.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $dM7c5.messages).unfollow_project_descriptionGalaxia : (0, $dM7c5.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $dM7c5.messages).follow_goal_description : (0, $dM7c5.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $2f7ca412ccba39f5$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $1fa8e2f128b6af29$export$49248678d3914625)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), errorMessage),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91b3cd2514901f8a$export$2e2bcd8739ae039), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label),
        ...(0, $ixfCV.fg)('platform_sl_action_refactoring') ? {
            ariaLabel: intl.formatMessage(label)
        } : {},
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), tooltipMessage),
        ...data,
        ...props,
        onError: handleError
    });
};
var $2f7ca412ccba39f5$export$2e2bcd8739ae039 = $2f7ca412ccba39f5$var$FollowAction;
module.exports["default"] = $2f7ca412ccba39f5$export$2e2bcd8739ae039;

});

parcelRegister("e8Ej5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $8VfSP = parcelRequire("8VfSP");


var $gDx2k = parcelRequire("gDx2k");


var $ieeJu = parcelRequire("ieeJu");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $9PA4G = parcelRequire("9PA4G");


var $kfxZm = parcelRequire("kfxZm");


var $cOVCp = parcelRequire("cOVCp");

const $e5cd9fcfba897113$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    const intl = (0, $kSwu1.useIntl)();
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const invoke = (0, $kfxZm.default)({});
    const data = context?.actions?.[(0, $4yYAm.ActionName).PreviewAction];
    const hasPreviewPanel = data?.hasPreviewPanel;
    const onClick = (0, $cozmU.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $dM7c5.messages).preview_description : (0, $dM7c5.messages).preview_improved;
    const actionIcon = (0, $cozmU.useCallback)(()=>{
        // Only use panel icon if experiment is enabled and hasPreviewPanel is true
        if ((0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && hasPreviewPanel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDx2k))), {
            color: "currentColor",
            spacing: "spacious",
            label: "",
            size: props.iconSize
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))), {
            color: "currentColor",
            spacing: "spacious",
            label: "",
            size: props.iconSize
        });
    }, [
        hasPreviewPanel,
        props.iconSize
    ]);
    const actionLabel = (0, $cozmU.useMemo)(()=>{
        // Only use panel message if experiment is enabled and hasPreviewPanel is true
        if ((0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && hasPreviewPanel) return (0, $dM7c5.messages).preview_panel;
        // Fall back to modal message if experiment is enabled, otherwise use original preview message
        if ((0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test')) return (0, $dM7c5.messages).preview_modal;
        return (0, $dM7c5.messages).preview_improved;
    }, [
        hasPreviewPanel
    ]);
    const actionMessage = intl.formatMessage(actionLabel);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOVCp.default), {
        ariaLabel: actionMessage,
        content: actionMessage,
        icon: actionIcon(),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), tooltipMessage),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $e5cd9fcfba897113$export$2e2bcd8739ae039 = $e5cd9fcfba897113$var$PreviewAction;
module.exports["default"] = $e5cd9fcfba897113$export$2e2bcd8739ae039;

});

parcelRegister("1FScK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kTb7m = parcelRequire("kTb7m");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $9PA4G = parcelRequire("9PA4G");


var $kfxZm = parcelRequire("kfxZm");


var $cOVCp = parcelRequire("cOVCp");

const $36397dcac95c69a1$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    const intl = (0, $kSwu1.useIntl)();
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const invoke = (0, $kfxZm.default)({});
    const data = context?.actions?.[(0, $4yYAm.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $cozmU.useState)((0, $dM7c5.messages).copy_url_to_clipboard);
    const onClick = (0, $cozmU.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke({
                ...data.invokeAction,
                actionFn: async ()=>{
                    await data.invokeAction?.actionFn();
                    setTooltipMessage((0, $dM7c5.messages).copied_url_to_clipboard);
                }
            });
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOVCp.default), {
        ariaLabel: intl.formatMessage((0, $dM7c5.messages).copy_url_to_clipboard),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).copy_url_to_clipboard),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
            color: "currentColor",
            label: "",
            spacing: "spacious",
            size: props.iconSize
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $dM7c5.messages).copy_url_to_clipboard),
        ...data,
        ...props
    }) : null;
};
var $36397dcac95c69a1$export$2e2bcd8739ae039 = $36397dcac95c69a1$var$CopyLinkAction;
module.exports["default"] = $36397dcac95c69a1$export$2e2bcd8739ae039;

});

parcelRegister("5Nciw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");





var $6cFsl = parcelRequire("6cFsl");


var $ixfCV = parcelRequire("ixfCV");


var $euBHF = parcelRequire("euBHF");





var $kSwu1 = parcelRequire("kSwu1");


var $gC0KQ = parcelRequire("gC0KQ");


var $6Vsq4 = parcelRequire("6Vsq4");


var $dM7c5 = parcelRequire("dM7c5");


var $cOVCp = parcelRequire("cOVCp");








var $lOOiS = parcelRequire("lOOiS");







const $e73565c1b07bf983$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $e73565c1b07bf983$export$2e2bcd8739ae039 = $e73565c1b07bf983$var$AIEventErrorViewed;






var $i1t43 = parcelRequire("i1t43");




const $e209b8ee56caeb94$var$AILearnMoreAnchor = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: (0, $4yYAm.CONTENT_URL_ROVO),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props
    }, children);
var $e209b8ee56caeb94$export$2e2bcd8739ae039 = $e209b8ee56caeb94$var$AILearnMoreAnchor;


const $53a45ab7b94caa46$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $lOOiS.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e73565c1b07bf983$export$2e2bcd8739ae039), {
            reason: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...message,
            values: {
                a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e209b8ee56caeb94$export$2e2bcd8739ae039), {
                        href: url
                    }, chunks)
            }
        }))
    };
};


function $415dfd9ed8e9cb23$export$75a19de44af58722({ onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const onCompleted = (0, $cozmU.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $53a45ab7b94caa46$export$82f46aa4e6535a45)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $cozmU.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOVCp.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).ai_summary_action_rebrand),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC0KQ))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Summarise with AI",
            size: props.iconSize
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).ai_summary_action_description_rebrand),
        ...props
    });
}









var $fHs3z = parcelRequire("fHs3z");










function $0aa7654887d48ff1$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $cozmU.useState)((0, $dM7c5.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $cozmU.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content ?? '');
        setTooltipMessage((0, $dM7c5.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOVCp.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).copy_summary_action),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $dM7c5.messages).copy_summary_action_description),
        ...props
    });
}
function $0aa7654887d48ff1$export$7e8c7a0de1a37bfe({ url: url, onClick: onClickCallback, summary: summary = '', testId: testId, ...props }) {
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $cozmU.useState)((0, $dM7c5.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $cozmU.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(summary);
        setTooltipMessage((0, $dM7c5.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        summary
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOVCp.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).copy_summary_action),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary",
            size: props.iconSize
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $dM7c5.messages).copy_summary_action_description),
        ...props
    });
}


const $ef162c0474978f45$export$8eed96bc6d982595 = (props)=>{
    (0, $6cFsl.di)((0, $euBHF.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $euBHF.default)(url);
    (0, $cozmU.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? (0, $ixfCV.fg)('platform_sl_action_refactoring') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0aa7654887d48ff1$export$7e8c7a0de1a37bfe), {
        ...props,
        summary: content,
        testId: testId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0aa7654887d48ff1$export$cfa1d3eed9a61059), {
        ...props,
        testId: testId,
        content: content
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $415dfd9ed8e9cb23$export$75a19de44af58722), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};


const $2e2681fee114ae51$var$AISummaryAction = (props)=>{
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $4yYAm.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ef162c0474978f45$export$8eed96bc6d982595), {
        ...actionData,
        ...props
    }) : null;
};
var $2e2681fee114ae51$export$2e2bcd8739ae039 = $2e2681fee114ae51$var$AISummaryAction;
module.exports["default"] = $2e2681fee114ae51$export$2e2bcd8739ae039;

});

parcelRegister("5IFQc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $hMcNB = parcelRequire("hMcNB");


var $4aRua = parcelRequire("4aRua");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $9PA4G = parcelRequire("9PA4G");


var $hsgLh = parcelRequire("hsgLh");


var $cOVCp = parcelRequire("cOVCp");




const $1c7abd7b34efb0ba$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $dM7c5.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $dM7c5.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};



const $5c24e4c3132e9e87$var$AutomationModal = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("5M5Ho")));
const $5c24e4c3132e9e87$var$AutomationAction = (props)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const modal = (0, $hsgLh.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $4yYAm.ActionName).AutomationAction];
    const automationActionOnClick = (0, $cozmU.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $1c7abd7b34efb0ba$export$93e707b363eaf5c8)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), modalTitle) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
                        as: "strong"
                    }, chunks),
                br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null)
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5c24e4c3132e9e87$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).automation_action_title);
    const automationActionTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).automation_action_tooltip);
    const automationActionIconLabel = formatMessage((0, $dM7c5.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOVCp.default), {
        content: automationActionTitle,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMcNB))), {
            spacing: "spacious",
            color: "currentColor",
            label: automationActionIconLabel,
            size: props.iconSize
        }),
        testId: "smart-action-automation-action",
        tooltipMessage: automationActionTooltip,
        ...props,
        onClick: ()=>automationActionOnClick(automationActionData)
    }));
};
var $5c24e4c3132e9e87$export$2e2bcd8739ae039 = $5c24e4c3132e9e87$var$AutomationAction;
module.exports["default"] = $5c24e4c3132e9e87$export$2e2bcd8739ae039;

});

parcelRegister("kI1Tj", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $kfxZm = parcelRequire("kfxZm");


var $4ZDKy = parcelRequire("4ZDKy");


var $edVsK = parcelRequire("edVsK");


var $cOVCp = parcelRequire("cOVCp");

const $270625602ddd6621$var$DEFAULT_PROMPTS = [];
const $270625602ddd6621$var$RovoChatAction = ({ onClick: onClickCallback, prompts: prompts, testId: testId = 'smart-action-rovo-chat-action', ...props })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { isRovoChatEnabled: isRovoChatEnabled, sendPromptMessage: sendPromptMessage } = (0, $4ZDKy.default)();
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const data = context?.actions?.[(0, $4yYAm.ActionName).RovoChatAction];
    const resolvedPrompts = (0, $cozmU.useMemo)(()=>{
        if (prompts) return prompts;
        return $270625602ddd6621$var$DEFAULT_PROMPTS;
    }, [
        prompts
    ]);
    const invoke = (0, $kfxZm.default)({});
    const onClick = (0, $cozmU.useCallback)((promptData, promptKey)=>{
        if (promptData && data?.invokeAction) {
            invoke({
                ...data?.invokeAction,
                actionFn: async ()=>sendPromptMessage(promptData),
                prompt: promptKey
            });
            onClickCallback?.();
        }
    }, [
        data?.invokeAction,
        invoke,
        onClickCallback,
        sendPromptMessage
    ]);
    const promptActions = (0, $cozmU.useMemo)(()=>{
        return resolvedPrompts.map((promptKey, idx)=>{
            const { icon: icon, content: content, tooltipMessage: tooltipMessage, data: promptData } = (0, $edVsK.getPromptAction)({
                promptKey: promptKey,
                intl: intl,
                url: data?.url,
                product: data?.product,
                iconSize: props.iconSize,
                cardAppearance: props.cardAppearance
            }) || {};
            return promptData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOVCp.default), {
                content: content,
                icon: icon,
                key: promptKey,
                onClick: ()=>onClick(promptData, promptKey),
                testId: `${testId}-${idx + 1}`,
                tooltipMessage: tooltipMessage,
                ...props
            }) : null;
        });
    }, [
        data,
        intl,
        onClick,
        resolvedPrompts,
        props,
        testId
    ]);
    return isRovoChatEnabled && data && promptActions?.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, promptActions) : null;
};
var $270625602ddd6621$export$2e2bcd8739ae039 = $270625602ddd6621$var$RovoChatAction;
module.exports["default"] = $270625602ddd6621$export$2e2bcd8739ae039;

});

parcelRegister("cpdvP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ixfCV = parcelRequire("ixfCV");


var $6Vsq4 = parcelRequire("6Vsq4");


var $dM7c5 = parcelRequire("dM7c5");


var $9PA4G = parcelRequire("9PA4G");


var $hsgLh = parcelRequire("hsgLh");


var $cOVCp = parcelRequire("cOVCp");





var $5ZtfK = parcelRequire("5ZtfK");

const $0e88aae6564d7c8f$var$RelatedLinksActionIcon = ({ iconSize: iconSize })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
        color: "currentColor",
        spacing: "spacious",
        label: '',
        size: iconSize
    });
var $0e88aae6564d7c8f$export$2e2bcd8739ae039 = $0e88aae6564d7c8f$var$RelatedLinksActionIcon;



const $8383284991048575$var$RelatedLinksModal = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("2rTmu")));
const $8383284991048575$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $hsgLh.useSmartLinkModal)();
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const onClick = (0, $cozmU.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8383284991048575$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback?.();
    }, [
        actionData?.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOVCp.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).related_links_view_related_links),
        ...(0, $ixfCV.fg)('platform_sl_action_refactoring') ? {
            tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).related_links_view_related_links)
        } : {},
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0e88aae6564d7c8f$export$2e2bcd8739ae039), (0, $ixfCV.fg)('platform_sl_action_refactoring') ? {
            iconSize: props.iconSize
        } : {}),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $8383284991048575$export$2e2bcd8739ae039 = $8383284991048575$var$ViewRelatedLinksAction;
module.exports["default"] = $8383284991048575$export$2e2bcd8739ae039;

});

parcelRegister("bHsBU", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");

const $5a21383db9cb3b7a$var$styles = {
    button: "_1e0c1bgi",
    message: "_1rjcze3t _18zrze3t"
};
const $5a21383db9cb3b7a$var$validErrorStatuses = [
    (0, $4yYAm.SmartLinkStatus).Forbidden,
    (0, $4yYAm.SmartLinkStatus).Unauthorized
];
const $5a21383db9cb3b7a$var$validateErrorStatus = (status)=>{
    return status !== undefined && $5a21383db9cb3b7a$var$validErrorStatuses.includes(status);
};
const $5a21383db9cb3b7a$var$getMessageDescriptor = (status, accessType, props)=>{
    if (!$5a21383db9cb3b7a$var$validateErrorStatus(status)) return undefined;
    const message = props?.[status]?.[accessType ?? 'FALLBACK'];
    return message;
}; /**
    * Public API — exported externally. Do not add props without external support intent.
    */ 
const $5a21383db9cb3b7a$var$CustomUnresolvedAction = ({ testId: testId = 'custom-unresolved-action', onlyShowIfAction: onlyShowIfAction = false, Container: Container, ...props })=>{
    const context = (0, $9PA4G.useFlexibleCardContext)();
    const data = context?.data?.actions?.[(0, $4yYAm.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const { status: status } = context;
    const accessType = context?.data?.meta?.accessType;
    const hasAction = onClick !== undefined;
    if (onlyShowIfAction && !hasAction) return null;
    const messageDescriptor = $5a21383db9cb3b7a$var$getMessageDescriptor(status, accessType, props) ?? descriptor;
    if (!messageDescriptor) return null;
    const message = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: $5a21383db9cb3b7a$var$styles.message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...messageDescriptor,
        values: values
    }));
    const component = hasAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $5a21383db9cb3b7a$var$styles.button
    }, message) : message;
    return Container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Container, null, component) : component;
};
var $5a21383db9cb3b7a$export$2e2bcd8739ae039 = $5a21383db9cb3b7a$var$CustomUnresolvedAction;
module.exports["default"] = $5a21383db9cb3b7a$export$2e2bcd8739ae039;

});

parcelRegister("li470", function(module, exports) {
$parcel$export(module.exports, "AssignedTo", () => (parcelRequire("4cPhH")).default);
$parcel$export(module.exports, "AssignedToGroup", () => (parcelRequire("ktdgI")).default);
$parcel$export(module.exports, "AttachmentCount", () => (parcelRequire("cA0ah")).default);
$parcel$export(module.exports, "AuthorGroup", () => (parcelRequire("jqres")).default);
$parcel$export(module.exports, "ChecklistProgress", () => (parcelRequire("a8wJH")).default);
$parcel$export(module.exports, "CollaboratorGroup", () => (parcelRequire("56DiX")).default);
$parcel$export(module.exports, "CommentCount", () => (parcelRequire("LvVJP")).default);
$parcel$export(module.exports, "CreatedOn", () => (parcelRequire("ikX3P")).default);
$parcel$export(module.exports, "CreatedBy", () => (parcelRequire("gsQuB")).default);
$parcel$export(module.exports, "DueOn", () => (parcelRequire("jUXZW")).default);
$parcel$export(module.exports, "LatestCommit", () => (parcelRequire("2VRbJ")).default);
$parcel$export(module.exports, "LinkIcon", () => (parcelRequire("hsIfr")).default);
$parcel$export(module.exports, "Location", () => (parcelRequire("8y6iW")).default);
$parcel$export(module.exports, "ModifiedBy", () => (parcelRequire("72lc5")).default);
$parcel$export(module.exports, "ModifiedOn", () => (parcelRequire("7sCIj")).default);
$parcel$export(module.exports, "OwnedBy", () => (parcelRequire("4GRqQ")).default);
$parcel$export(module.exports, "OwnedByGroup", () => (parcelRequire("cl3v4")).default);
$parcel$export(module.exports, "Preview", () => (parcelRequire("khRQO")).default);
$parcel$export(module.exports, "Priority", () => (parcelRequire("i64z9")).default);
$parcel$export(module.exports, "ProgrammingLanguage", () => (parcelRequire("7bJZv")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("fCf6x")).default);
$parcel$export(module.exports, "ReactCount", () => (parcelRequire("eIk5O")).default);
$parcel$export(module.exports, "ReadTime", () => (parcelRequire("7Q48s")).default);
$parcel$export(module.exports, "SentOn", () => (parcelRequire("9vYj2")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("s4fzU")).default);
$parcel$export(module.exports, "SourceBranch", () => (parcelRequire("alGk9")).default);
$parcel$export(module.exports, "State", () => (parcelRequire("ixgii")).default);
$parcel$export(module.exports, "SubscriberCount", () => (parcelRequire("kfBIC")).default);
$parcel$export(module.exports, "SubTasksProgress", () => (parcelRequire("hKI6m")).default);
$parcel$export(module.exports, "StoryPoints", () => (parcelRequire("8CvOu")).default);
$parcel$export(module.exports, "TargetBranch", () => (parcelRequire("gDO6D")).default);
$parcel$export(module.exports, "TeamMemberCount", () => (parcelRequire("8xQB8")).default);
$parcel$export(module.exports, "Title", () => (parcelRequire("fIakH")).default);
$parcel$export(module.exports, "UserAttributes", () => (parcelRequire("fO7nk")).default);
$parcel$export(module.exports, "HostName", () => (parcelRequire("leiiU")).default);
$parcel$export(module.exports, "ViewCount", () => (parcelRequire("415JS")).default);
$parcel$export(module.exports, "VoteCount", () => (parcelRequire("emHHi")).default);
$parcel$export(module.exports, "AppliedToComponentsCount", () => (parcelRequire("fj0wU")).default);
$parcel$export(module.exports, "CustomByAccessTypeElement", () => (parcelRequire("9JK0j")).default);
$parcel$export(module.exports, "CustomByStatusElement", () => (parcelRequire("9dF9H")).default);

var $4cPhH = parcelRequire("4cPhH");


var $ktdgI = parcelRequire("ktdgI");


var $cA0ah = parcelRequire("cA0ah");


var $jqres = parcelRequire("jqres");


var $a8wJH = parcelRequire("a8wJH");


var $56DiX = parcelRequire("56DiX");


var $LvVJP = parcelRequire("LvVJP");


var $ikX3P = parcelRequire("ikX3P");


var $gsQuB = parcelRequire("gsQuB");


var $jUXZW = parcelRequire("jUXZW");


var $2VRbJ = parcelRequire("2VRbJ");


var $hsIfr = parcelRequire("hsIfr");


var $8y6iW = parcelRequire("8y6iW");


var $72lc5 = parcelRequire("72lc5");


var $7sCIj = parcelRequire("7sCIj");


var $4GRqQ = parcelRequire("4GRqQ");


var $cl3v4 = parcelRequire("cl3v4");


var $khRQO = parcelRequire("khRQO");


var $i64z9 = parcelRequire("i64z9");


var $7bJZv = parcelRequire("7bJZv");


var $fCf6x = parcelRequire("fCf6x");


var $eIk5O = parcelRequire("eIk5O");


var $7Q48s = parcelRequire("7Q48s");


var $9vYj2 = parcelRequire("9vYj2");


var $s4fzU = parcelRequire("s4fzU");


var $alGk9 = parcelRequire("alGk9");


var $ixgii = parcelRequire("ixgii");


var $kfBIC = parcelRequire("kfBIC");


var $hKI6m = parcelRequire("hKI6m");


var $8CvOu = parcelRequire("8CvOu");


var $gDO6D = parcelRequire("gDO6D");


var $8xQB8 = parcelRequire("8xQB8");


var $fIakH = parcelRequire("fIakH");


var $fO7nk = parcelRequire("fO7nk");


var $leiiU = parcelRequire("leiiU");


var $415JS = parcelRequire("415JS");


var $emHHi = parcelRequire("emHHi");


var $fj0wU = parcelRequire("fj0wU");


var $9JK0j = parcelRequire("9JK0j");


var $9dF9H = parcelRequire("9dF9H");


});

parcelRegister("acUNT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4wH3g = parcelRequire("4wH3g");


var $4yYAm = parcelRequire("4yYAm");

const $83ca216da4462ba1$export$9d642f65a919fb93 = {
    [(0, $4yYAm.SmartLinkSize).Small]: 'none',
    [(0, $4yYAm.SmartLinkSize).Medium]: 'compact',
    [(0, $4yYAm.SmartLinkSize).Large]: 'compact',
    [(0, $4yYAm.SmartLinkSize).XLarge]: 'default'
};
const $83ca216da4462ba1$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...descriptor,
            values: values
        });
    }
};
const $83ca216da4462ba1$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
const $83ca216da4462ba1$export$fb10bc5609c6347e = (size)=>{
    switch(size){
        case (0, $4yYAm.SmartLinkSize).XLarge:
        case (0, $4yYAm.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $4yYAm.SmartLinkSize).Medium:
        case (0, $4yYAm.SmartLinkSize).Small:
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $83ca216da4462ba1$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "tmnOu",
        name: "importIcon",
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $83ca216da4462ba1$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $4yYAm.SmartLinkSize).XLarge:
        case (0, $4yYAm.SmartLinkSize).Large:
            return 1.75;
        case (0, $4yYAm.SmartLinkSize).Medium:
        case (0, $4yYAm.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $83ca216da4462ba1$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $83ca216da4462ba1$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $4yYAm.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $4yYAm.SmartLinkSize).Large:
            return 'space.200';
        case (0, $4yYAm.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $4yYAm.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $83ca216da4462ba1$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};
module.exports["sizeToButtonSpacing"] = $83ca216da4462ba1$export$9d642f65a919fb93;
module.exports["getFormattedMessage"] = $83ca216da4462ba1$export$f1aa79f2218fb713;
module.exports["getFormattedMessageAsString"] = $83ca216da4462ba1$export$66ecb50a9dd1768;
module.exports["getIconWidth"] = $83ca216da4462ba1$export$fb10bc5609c6347e;
module.exports["importIcon"] = $83ca216da4462ba1$export$6dc831e1a0a7a851;
module.exports["getMaxLines"] = $83ca216da4462ba1$export$c2293adf1794c09;
module.exports["getPrimitivesInlineSpaceBySize"] = $83ca216da4462ba1$export$475c391af8171fec;
module.exports["hasWhiteSpace"] = $83ca216da4462ba1$export$619e376a425cb759;

});

parcelRegister("5IVlB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $2Fmt9 = parcelRequire("2Fmt9");


var $bltJZ = parcelRequire("bltJZ");


var $ixfCV = parcelRequire("ixfCV");


var $88149 = parcelRequire("88149");


var $4yYAm = parcelRequire("4yYAm");


var $16kNn = parcelRequire("16kNn");

const $5025f0bf7c5e18db$var$getIconImportFn = (icon, size)=>{
    const item = (0, $16kNn.getLazyIcons)()[icon];
    if ((0, $16kNn.isIconSizeLarge)(size) && item?.large) return item.large;
    return item?.default;
};
const $5025f0bf7c5e18db$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "rynap",
        name: "importIcon",
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};

const $5025f0bf7c5e18db$var$getBlogIcon = ()=>(parcelRequire("lYcSC")).default;

const $5025f0bf7c5e18db$var$getDocumentIcon = ()=>(parcelRequire("2jRrx")).default;

const $5025f0bf7c5e18db$var$getLiveDocumentIcon = ()=>(parcelRequire("66hVV")).default;
const $5025f0bf7c5e18db$var$isCoreIcon = (icon)=>{
    return [
        (0, $4yYAm.IconType).Project,
        (0, $4yYAm.IconType).Template,
        (0, $4yYAm.IconType).Forbidden,
        (0, $4yYAm.IconType).Default,
        (0, $4yYAm.IconType).Error,
        (0, $4yYAm.IconType).Attachment,
        (0, $4yYAm.IconType).CheckItem,
        (0, $4yYAm.IconType).Component,
        (0, $4yYAm.IconType).Comment,
        (0, $4yYAm.IconType).View,
        (0, $4yYAm.IconType).React,
        (0, $4yYAm.IconType).Vote,
        (0, $4yYAm.IconType).PriorityUndefined,
        (0, $4yYAm.IconType).ProgrammingLanguage,
        (0, $4yYAm.IconType).Subscriber,
        (0, $4yYAm.IconType).SubTasksProgress
    ].includes(icon);
};
const $5025f0bf7c5e18db$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId, size: size = (0, $4yYAm.SmartLinkSize).Medium, isTiledIcon: isTiledIcon })=>{
    // Intentionally keep these three icon types synchronous and outside lazy imports.
    // These icons should be present in SSR markup so hydration does not cause a
    // visible empty-state-then-pop-in transition in Smart Link consumers.
    switch(icon){
        case (0, $4yYAm.IconType).Document:
            {
                const DocumentIcon = $5025f0bf7c5e18db$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DocumentIcon, {
                    label: label ?? 'document',
                    testId: testId,
                    size: size,
                    isTiledIcon: isTiledIcon
                });
            }
        case (0, $4yYAm.IconType).Blog:
            {
                const BlogIcon = $5025f0bf7c5e18db$var$getBlogIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BlogIcon, {
                    label: label ?? 'blog',
                    testId: testId,
                    size: size,
                    isTiledIcon: isTiledIcon
                });
            }
        case (0, $4yYAm.IconType).LiveDocument:
            {
                const LiveDocumentIcon = $5025f0bf7c5e18db$var$getLiveDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LiveDocumentIcon, {
                    label: label ?? 'live-doc',
                    testId: testId,
                    size: size,
                    isTiledIcon: isTiledIcon
                });
            }
    }
    const importFn = $5025f0bf7c5e18db$var$getIconImportFn(icon, size);
    if (!importFn) return null;
    const ImportedIcon = $5025f0bf7c5e18db$var$importIcon(importFn);
    if ($5025f0bf7c5e18db$var$isCoreIcon(icon) && (0, $ixfCV.fg)('platform_sl_icons_refactor')) {
        let color;
        if (icon === (0, $4yYAm.IconType).Error || icon === (0, $4yYAm.IconType).Forbidden) color = "var(--ds-icon-danger, #C9372C)";
        switch(size){
            case (0, $4yYAm.SmartLinkSize).Small:
            case (0, $4yYAm.SmartLinkSize).Medium:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ImportedIcon, {
                    label: label,
                    testId: testId,
                    color: color
                });
            case (0, $4yYAm.SmartLinkSize).Large:
            case (0, $4yYAm.SmartLinkSize).XLarge:
                let appearance;
                if (icon === (0, $4yYAm.IconType).Error || icon === (0, $4yYAm.IconType).Forbidden) appearance = 'redBold';
                else appearance = 'grayBold';
                const iconTileSize = (0, $88149.transformSmartLinkSizeToIconTileSize)(size);
                if (iconTileSize) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Fmt9.IconTile), {
                    appearance: appearance,
                    icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ImportedIcon, {
                            ...iconProps,
                            spacing: "spacious"
                        }) : ImportedIcon,
                    size: iconTileSize,
                    label: label ?? ''
                });
                else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ImportedIcon, {
                    label: label,
                    testId: testId,
                    color: color
                });
        }
    }
    switch(icon){
        case (0, $4yYAm.IconType).Confluence:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.ConfluenceIcon), {
                appearance: "brand",
                testId: testId,
                ...(0, $ixfCV.fg)('billplat_a11y_icon_label_fix') ? {
                    label: ''
                } : undefined,
                size: size === (0, $4yYAm.SmartLinkSize).Large || size === (0, $4yYAm.SmartLinkSize).XLarge ? 'small' : 'xxsmall',
                ...(0, $ixfCV.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined
            });
        case (0, $4yYAm.IconType).Jira:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.JiraIcon), {
                appearance: "brand",
                testId: testId,
                ...(0, $ixfCV.fg)('billplat_a11y_icon_label_fix') ? {
                    label: ''
                } : undefined,
                size: size === (0, $4yYAm.SmartLinkSize).Large || size === (0, $4yYAm.SmartLinkSize).XLarge ? 'small' : 'xxsmall',
                ...(0, $ixfCV.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined
            });
        case (0, $4yYAm.IconType).Error:
        case (0, $4yYAm.IconType).Forbidden:
            if ((0, $ixfCV.fg)('platform_sl_icons_refactor')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ImportedIcon, {
                label: label,
                testId: testId,
                size: size,
                isTiledIcon: isTiledIcon
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ImportedIcon, {
                label: label,
                testId: testId,
                color: "var(--ds-icon-danger, #C9372C)"
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ImportedIcon, {
                label: label,
                testId: testId,
                size: size,
                isTiledIcon: isTiledIcon
            });
    }
};
var $5025f0bf7c5e18db$export$2e2bcd8739ae039 = $5025f0bf7c5e18db$var$AtlaskitIcon;
module.exports["default"] = $5025f0bf7c5e18db$export$2e2bcd8739ae039;

});

parcelRegister("jJP7n", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $9PA4G = parcelRequire("9PA4G");


var $8QLAc = parcelRequire("8QLAc");


var $aGLwK = parcelRequire("aGLwK");


var $5IVlB = parcelRequire("5IVlB");


var $ckM0L = parcelRequire("ckM0L");


var $acUNT = parcelRequire("acUNT");

const $85c0dffca2d5c229$var$styles = {
    container: "_zulp1b66 _1e0c116y _4cvr1h6o _1ul91ns9",
    icon: "_1e0c116y _v4pn116y _1b94116y _1ii7116y _4t3i7vkz _bna77vkz _1xjx7vkz _17527vkz _ca0qze3t _14bqze3t _1oh2ze3t _i2i3ze3t _u5f3ze3t _3tceze3t _99ztze3t _uhasze3t _n3tdze3t _1ym6ze3t _1m2uze3t _5jw9ze3t _19bvze3t _1xr1ze3t _9n9oze3t _7wy9ze3t _1bsb7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _s7n4nkob _rtqbnkob _e4kmnkob _z239nkob",
    text: "_11c8wadc"
};
const $85c0dffca2d5c229$var$colorMap = {
    subtle: "_syaz1rpy",
    default: "_syazazsu"
};
const $85c0dffca2d5c229$var$messageMapper = {
    [(0, $4yYAm.IconType).PriorityBlocker]: (0, $dM7c5.messages).priority_blocker,
    [(0, $4yYAm.IconType).PriorityCritical]: (0, $dM7c5.messages).priority_critical,
    [(0, $4yYAm.IconType).PriorityHigh]: (0, $dM7c5.messages).priority_high,
    [(0, $4yYAm.IconType).PriorityHighest]: (0, $dM7c5.messages).priority_highest,
    [(0, $4yYAm.IconType).PriorityLow]: (0, $dM7c5.messages).priority_low,
    [(0, $4yYAm.IconType).PriorityLowest]: (0, $dM7c5.messages).priority_lowest,
    [(0, $4yYAm.IconType).PriorityMajor]: (0, $dM7c5.messages).priority_major,
    [(0, $4yYAm.IconType).PriorityMedium]: (0, $dM7c5.messages).priority_medium,
    [(0, $4yYAm.IconType).PriorityMinor]: (0, $dM7c5.messages).priority_minor,
    [(0, $4yYAm.IconType).PriorityTrivial]: (0, $dM7c5.messages).priority_trivial,
    [(0, $4yYAm.IconType).PriorityUndefined]: (0, $dM7c5.messages).priority_undefined
};
const $85c0dffca2d5c229$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $85c0dffca2d5c229$var$messageMapper[icon];
        if (descriptor) return (0, $acUNT.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $85c0dffca2d5c229$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5IVlB.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $85c0dffca2d5c229$var$renderImageIcon = (url, testId, hideLoadingSkeleton)=>{
    if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aGLwK.default), {
        testId: testId,
        url: url,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
};
const $85c0dffca2d5c229$var$BaseBadgeRefreshNew = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ appearance: appearance = 'default', hideIcon: hideIcon = false, icon: icon, label: label, name: name, testId: testId = 'smart-element-badge', url: url, color: color, hideLabel: hideLabel = false }, ref)=>{
    const ui = (0, $9PA4G.useFlexibleUiOptionContext)();
    const { product: product } = (0, $8QLAc.default)();
    const formattedMessageOrLabel = $85c0dffca2d5c229$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $85c0dffca2d5c229$var$renderAtlaskitIcon(icon, testId) || $85c0dffca2d5c229$var$renderImageIcon(url, testId, ui?.hideLoadingSkeleton);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    const shouldHideLabel = hideLabel && !!product && product === 'CONFLUENCE';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        ref: ref,
        style: {
            color: color
        },
        className: (0, $hekY6.default)([
            $85c0dffca2d5c229$var$styles.container,
            $85c0dffca2d5c229$var$colorMap[appearance]
        ])
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        as: "span",
        xcss: $85c0dffca2d5c229$var$styles.icon
    }, badgeIcon), !shouldHideLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        as: "span",
        testId: `${testId}-label`,
        xcss: $85c0dffca2d5c229$var$styles.text
    }, formattedMessageOrLabel));
});
const $85c0dffca2d5c229$var$_default_1 = (0, $ckM0L.withOverrideCss)($85c0dffca2d5c229$var$BaseBadgeRefreshNew);
var $85c0dffca2d5c229$export$2e2bcd8739ae039 = $85c0dffca2d5c229$var$_default_1;
const $85c0dffca2d5c229$export$a2fb457791942ba4 = (label)=>{
    // Don't render the element if its 0
    return label !== '0' && label ? {
        label: label
    } : undefined;
};
module.exports["default"] = $85c0dffca2d5c229$export$2e2bcd8739ae039;
module.exports["toBadgeProps"] = $85c0dffca2d5c229$export$a2fb457791942ba4;

});

parcelRegister("7K8i3", function(module, exports) {
$parcel$export(module.exports, "CustomAction", () => (parcelRequire("cOVCp")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("fhinp")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("78OZj")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("kD7T6")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("1fKLY")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("e8Ej5")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("1FScK")).default);
$parcel$export(module.exports, "UnresolvedAction", () => (parcelRequire("8Mb1e")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("5Nciw")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("5IFQc")).default);
$parcel$export(module.exports, "RovoChatAction", () => (parcelRequire("kI1Tj")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("cpdvP")).default);
$parcel$export(module.exports, "CustomUnresolvedAction", () => (parcelRequire("bHsBU")).default);

var $cOVCp = parcelRequire("cOVCp");


var $fhinp = parcelRequire("fhinp");


var $78OZj = parcelRequire("78OZj");


var $kD7T6 = parcelRequire("kD7T6");


var $1fKLY = parcelRequire("1fKLY");


var $e8Ej5 = parcelRequire("e8Ej5");


var $1FScK = parcelRequire("1FScK");


var $8Mb1e = parcelRequire("8Mb1e");


var $5Nciw = parcelRequire("5Nciw");


var $5IFQc = parcelRequire("5IFQc");


var $kI1Tj = parcelRequire("kI1Tj");


var $cpdvP = parcelRequire("cpdvP");


var $bHsBU = parcelRequire("bHsBU");


});

parcelRegister("oYjIk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $83fb3cab53de2f1c$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $cozmU.useState)(0);
    const ref = (0, $cozmU.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $cozmU.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref
    }, children) : null;
};
var $83fb3cab53de2f1c$export$2e2bcd8739ae039 = $83fb3cab53de2f1c$export$6118ed0013927eb2;
module.exports["default"] = $83fb3cab53de2f1c$export$2e2bcd8739ae039;

});

parcelRegister("le41x", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $bcDqz = parcelRequire("bcDqz");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $acUNT = parcelRequire("acUNT");

const $2ec34253a6b00462$var$styles = null;
const $2ec34253a6b00462$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $4yYAm.ElementName).AssignedToGroup:
            return (0, $acUNT.getFormattedMessageAsString)(intl, (0, $dM7c5.messages).assigned_to, personName);
        case (0, $4yYAm.ElementName).OwnedByGroup:
            return (0, $acUNT.getFormattedMessageAsString)(intl, (0, $dM7c5.messages).owned_by, personName);
        case (0, $4yYAm.ElementName).AuthorGroup:
            return (0, $acUNT.getFormattedMessageAsString)(intl, (0, $dM7c5.messages).created_by, personName);
        default:
            return personName;
    }
};
const $2ec34253a6b00462$var$BaseAvatarGroup = ({ items: items = [], maxCount: maxCount = 4, name: name, className: className, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $kSwu1.useIntl)();
    const data = (0, $cozmU.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $4yYAm.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $acUNT.getFormattedMessageAsString)(intl, (0, $dM7c5.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
         //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $2ec34253a6b00462$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ $cozmU.createElement("span" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    , {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_1ul91ns9 _1e0c116y _1kvxu2gc _102oidpf",
            className
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $bcDqz.default), {
        maxCount: maxCount,
        appearance: "stack",
        size: "small",
        data: data,
        testId: testId
    }));
};
var $2ec34253a6b00462$export$2e2bcd8739ae039 = $2ec34253a6b00462$var$BaseAvatarGroup;
const $2ec34253a6b00462$export$91ba8651475968bd = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};
module.exports["default"] = $2ec34253a6b00462$export$2e2bcd8739ae039;
module.exports["toAvatarGroupProps"] = $2ec34253a6b00462$export$91ba8651475968bd;

});

parcelRegister("9ox4X", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $2Pib0 = parcelRequire("2Pib0");


var $kSwu1 = parcelRequire("kSwu1");


var $ixfCV = parcelRequire("ixfCV");


var $dM7c5 = parcelRequire("dM7c5");

const $c6488c9b7bc1f612$var$styles = null;
const $c6488c9b7bc1f612$var$ABSOLUTE_DATE_FORMAT = {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
};
const $c6488c9b7bc1f612$var$isValidTimeZone = (timeZone)=>{
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZone
        });
        return true;
    } catch  {
        return false;
    }
};
const $c6488c9b7bc1f612$var$formatAbsoluteDateWithOptionalTimeZone = ({ date: date, formatDate: formatDate, timeZone: timeZone })=>{
    if (!timeZone || !$c6488c9b7bc1f612$var$isValidTimeZone(timeZone)) return formatDate(date, $c6488c9b7bc1f612$var$ABSOLUTE_DATE_FORMAT);
    return formatDate(date, {
        ...$c6488c9b7bc1f612$var$ABSOLUTE_DATE_FORMAT,
        timeZone: timeZone
    });
};
const $c6488c9b7bc1f612$var$typeToDescriptorMap = {
    created: {
        relative: (0, $dM7c5.messages).created_on_relative,
        absolute: (0, $dM7c5.messages).created_on_absolute
    },
    modified: {
        relative: (0, $dM7c5.messages).modified_on_relative,
        absolute: (0, $dM7c5.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $dM7c5.messages).sent_on_relative,
        absolute: (0, $dM7c5.messages).sent_on_absolute
    }
};
const $c6488c9b7bc1f612$var$fontOverrideStyleMap = {
    'font.body': "_11c8fhey",
    'font.body.large': "_11c81d4k",
    'font.body.small': "_11c8wadc"
};
const $c6488c9b7bc1f612$var$BaseDateTimeElement = ({ date: date, name: name, className: className, type: type, testId: testId = 'smart-element-date-time', text: text, hideDatePrefix: hideDatePrefix = false, color: color, fontSize: fontSize, timeZone: timeZone })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = (0, $ixfCV.fg)('dfo_issue_view_remote_data_srr_group') ? $c6488c9b7bc1f612$var$formatAbsoluteDateWithOptionalTimeZone({
            date: date,
            formatDate: formatDate,
            timeZone: timeZone
        }) : formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $2Pib0.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    let content;
    if (hideDatePrefix) content = context;
    else if (text) content = `${text} ${context}`;
    else content = /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...$c6488c9b7bc1f612$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    });
    return /*#__PURE__*/ $cozmU.createElement("span", {
        style: {
            color: color
        },
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_11c8wadc _1reo15vq _18m915vq _syazazsu _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k7vkz",
            fontSize !== undefined && $c6488c9b7bc1f612$var$fontOverrideStyleMap[fontSize],
            className
        ])
    }, content);
};
var $c6488c9b7bc1f612$export$2e2bcd8739ae039 = $c6488c9b7bc1f612$var$BaseDateTimeElement;
const $c6488c9b7bc1f612$export$2d4384e6b150cbe3 = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};
module.exports["default"] = $c6488c9b7bc1f612$export$2e2bcd8739ae039;
module.exports["toDateTimeProps"] = $c6488c9b7bc1f612$export$2d4384e6b150cbe3;

});

parcelRegister("jdGU5", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $lpNn5 = parcelRequire("lpNn5");


var $4yYAm = parcelRequire("4yYAm");


var $3tPPd = parcelRequire("3tPPd");


var $acUNT = parcelRequire("acUNT");

const $0233df0f75012bd0$var$DEFAULT_MAX_LINES = 2;
const $0233df0f75012bd0$var$MAXIMUM_MAX_LINES = 2;
const $0233df0f75012bd0$var$MINIMUM_MAX_LINES = 1;
const $0233df0f75012bd0$var$containerStyles = null;
const $0233df0f75012bd0$var$getMaxLines = (maxLines)=>{
    if (maxLines > $0233df0f75012bd0$var$MAXIMUM_MAX_LINES) return $0233df0f75012bd0$var$DEFAULT_MAX_LINES;
    if (maxLines < $0233df0f75012bd0$var$MINIMUM_MAX_LINES) return $0233df0f75012bd0$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $0233df0f75012bd0$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span"
    }, trigger);
const $0233df0f75012bd0$var$linkStyleSizeMap = {
    xlarge: "_11c81af2 _k48pi7a9 _vwz41k8s",
    large: "_11c8fhey _k48pi7a9 _vwz41j6v",
    medium: "_11c8fhey _k48pi7a9 _vwz41j6v",
    small: "_11c8wadc _k48pi7a9 _vwz41j6v"
};
const $0233df0f75012bd0$var$baseAnchorStyle = null;
const $0233df0f75012bd0$var$workBreakStyleMap = {
    true: "_1nmz1hna",
    false: "_1nmz9jpi"
};
const $0233df0f75012bd0$var$anchorConstantsStyles = null;
const $0233df0f75012bd0$var$anchorLineClampMap = {
    1: "_1yyjkb7n",
    2: "_1yyjcs5v"
};
const $0233df0f75012bd0$var$anchorLinkLineHeight1Map = {
    xlarge: "_102k1k8s",
    large: "_102k1j6v",
    medium: "_102k1j6v",
    small: "_102k1j6v"
};
const $0233df0f75012bd0$var$anchorLinkLineHeight2Map = {
    xlarge: "_102k1wto",
    large: "_102kviql",
    medium: "_102kviql",
    small: "_102kviql"
};
const $0233df0f75012bd0$var$themeStyleMap = {
    grey: "_fjv61r31 _93u91r31 _g2lk1r31 _pnzf1r31 _hlwq8stv _1e2m8stv _1l4b8stv _ue8d8stv _yni7nqa1 _1bianqa1 _93jhnqa1 _64n6nqa1 _1ray1rpy _dlb71rpy _rnxt1rpy _1h4d1rpy _10uewadc _ye101rpy",
    black: "_syazazsu _1nrm1r31 _1a3b1r31 _9oik1r31 _1ydc1r31 _c2wa8stv _4fpr8stv _1bnx8stv _1x288stv _1iohnqa1 _5goinqa1 _jf4cnqa1 _1726nqa1 _9h8hazsu _f8pjazsu _30l3azsu _1053azsu",
    link: "_syaz13af _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz"
};
const $0233df0f75012bd0$var$BaseLinkElement = ({ hideTooltip: hideTooltip, maxLines: maxLines = $0233df0f75012bd0$var$DEFAULT_MAX_LINES, name: name, className: className, size: size = (0, $4yYAm.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $4yYAm.SmartLinkTheme).Link, url: url, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, target: target = '_blank', anchorRef: anchorRef })=>{
    const onMouseDown = (0, $3tPPd.useMouseDownEvent)();
    const hasSpace = (0, $cozmU.useMemo)(()=>text ? (0, $acUNT.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        onMouseDown: onMouseDown,
        href: url,
        className: (0, $hekY6.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            $0233df0f75012bd0$var$linkStyleSizeMap[size],
            $0233df0f75012bd0$var$anchorLineClampMap[$0233df0f75012bd0$var$getMaxLines(maxLines)],
            "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _sudp1e54",
            $0233df0f75012bd0$var$workBreakStyleMap[hasSpace ? 'true' : 'false'],
            $0233df0f75012bd0$var$getMaxLines(maxLines) === 1 && $0233df0f75012bd0$var$anchorLinkLineHeight1Map[size],
            $0233df0f75012bd0$var$getMaxLines(maxLines) === 2 && $0233df0f75012bd0$var$anchorLinkLineHeight2Map[size],
            $0233df0f75012bd0$var$themeStyleMap[theme],
            className
        ]),
        ...target !== '_self' && {
            target: target
        },
        ref: anchorRef
    }, text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug"
        ])
    }, hideTooltip || text === undefined ? anchor : $0233df0f75012bd0$var$withTooltip(anchor, url?.includes(text) ? url : text, testId));
};
var $0233df0f75012bd0$export$2e2bcd8739ae039 = $0233df0f75012bd0$var$BaseLinkElement;
const $0233df0f75012bd0$export$d58e465a9e5297f4 = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};
module.exports["default"] = $0233df0f75012bd0$export$2e2bcd8739ae039;

});

parcelRegister("bYlCi", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");


var $ixfCV = parcelRequire("ixfCV");


var $eY4uS = parcelRequire("eY4uS");


var $9PA4G = parcelRequire("9PA4G");


var $fjPbo = parcelRequire("fjPbo");

const $cd825829ae2f70d5$var$styles = null;
const $cd825829ae2f70d5$var$dueOnStyles = null;
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {BaseLozengeElementProps} BaseLozengeElementProps - The props necessary for the Lozenge element.
 * @see State
 */ const $cd825829ae2f70d5$var$BaseLozengeElement = ({ action: action, appearance: appearance = 'default', className: className, maxWidth: maxWidth, name: name, onAfterChanged: onAfterChanged, style: style, text: text, testId: testId = 'smart-element-lozenge', isDateTag: isDateTag, trailingMetric: trailingMetric })=>{
    const ui = (0, $9PA4G.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ $cozmU.createElement((0, $fjPbo.default), {
        action: action,
        appearance: appearance,
        maxWidth: maxWidth,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex,
        onAfterChanged: onAfterChanged,
        ...trailingMetric && (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? {
            trailingMetric: trailingMetric
        } : undefined
    }) : isDateTag ? /*#__PURE__*/ $cozmU.createElement((0, $eY4uS.default), {
        text: text,
        migration_fallback: "lozenge"
    }) : /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
        appearance: appearance,
        isBold: true,
        maxWidth: maxWidth,
        style: style,
        testId: `${testId}-lozenge`,
        ...trailingMetric && (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? {
            trailingMetric: trailingMetric
        } : undefined
    }, text);
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_1e0c116y _1ul91ns9",
            isDateTag && (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && "_19pkr5cr _2hwxr5cr _otyrr5cr _18u0r5cr",
            className
        ])
    }, lozenge);
};
var $cd825829ae2f70d5$export$2e2bcd8739ae039 = $cd825829ae2f70d5$var$BaseLozengeElement;
const $cd825829ae2f70d5$export$8f9f58f7bac50fbe = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};
module.exports["default"] = $cd825829ae2f70d5$export$2e2bcd8739ae039;
module.exports["toDateLozengeProps"] = $cd825829ae2f70d5$export$8f9f58f7bac50fbe;

});

parcelRegister("ckM0L", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $c764d7c8e3c7c13d$export$e0bdcacb944f1da6(Component) {
    return (props)=>{
        const ref = (0, $cozmU.useRef)(null);
        (0, $cozmU.useEffect)(()=>{
            if (props?.className && ref.current) ref.current.className = `${ref.current.className} ${props.className}`;
        }, [
            props?.className
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ...props,
            ref: ref
        });
    };
}
module.exports["withOverrideCss"] = $c764d7c8e3c7c13d$export$e0bdcacb944f1da6;

});

parcelRegister("bwJAe", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $j2eru = parcelRequire("j2eru");


var $cMyWi = parcelRequire("cMyWi");

const $21355f4f099ffb95$var$useInvoke = ()=>{
    const { connections: connections } = (0, $cMyWi.useSmartLinkContext)();
    const clientExt = (0, $j2eru.useSmartLinkClientExtension)(connections.client);
    return (0, $cozmU.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $21355f4f099ffb95$export$2e2bcd8739ae039 = $21355f4f099ffb95$var$useInvoke;
module.exports["default"] = $21355f4f099ffb95$export$2e2bcd8739ae039;

});

parcelRegister("k9Bpe", function(module, exports) {

var $6GOAK = parcelRequire("6GOAK");

const $2337494c658b69a0$export$65b3f792dff0bd60 = (err)=>{
    if (!$2337494c658b69a0$export$1694272377fa07d8(err)) return (0, $6GOAK.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $6GOAK.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $6GOAK.TrackQuickActionFailureReason).UnknownError;
    }
};
const $2337494c658b69a0$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;
module.exports["getInvokeFailureReason"] = $2337494c658b69a0$export$65b3f792dff0bd60;
module.exports["isInvokeCustomError"] = $2337494c658b69a0$export$1694272377fa07d8;

});

parcelRegister("2Pib0", function(module, exports) {
var $20ee71a6d547a2a3$var$__assign = undefined && undefined.__assign || function() {
    $20ee71a6d547a2a3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $20ee71a6d547a2a3$var$__assign.apply(this, arguments);
};
var $20ee71a6d547a2a3$var$MS_PER_SECOND = 1e3;
var $20ee71a6d547a2a3$var$SECS_PER_MIN = 60;
var $20ee71a6d547a2a3$var$SECS_PER_HOUR = $20ee71a6d547a2a3$var$SECS_PER_MIN * 60;
var $20ee71a6d547a2a3$var$SECS_PER_DAY = $20ee71a6d547a2a3$var$SECS_PER_HOUR * 24;
var $20ee71a6d547a2a3$var$SECS_PER_WEEK = $20ee71a6d547a2a3$var$SECS_PER_DAY * 7;
function $20ee71a6d547a2a3$export$b8f7189986dd5395(from, to, thresholds) {
    if (to === void 0) to = Date.now();
    if (thresholds === void 0) thresholds = {};
    var resolvedThresholds = $20ee71a6d547a2a3$var$__assign($20ee71a6d547a2a3$var$__assign({}, $20ee71a6d547a2a3$export$f4fd60e41371f80d), thresholds || {});
    var secs = (+from - +to) / $20ee71a6d547a2a3$var$MS_PER_SECOND;
    if (Math.abs(secs) < resolvedThresholds.second) return {
        value: Math.round(secs),
        unit: 'second'
    };
    var mins = secs / $20ee71a6d547a2a3$var$SECS_PER_MIN;
    if (Math.abs(mins) < resolvedThresholds.minute) return {
        value: Math.round(mins),
        unit: 'minute'
    };
    var hours = secs / $20ee71a6d547a2a3$var$SECS_PER_HOUR;
    if (Math.abs(hours) < resolvedThresholds.hour) return {
        value: Math.round(hours),
        unit: 'hour'
    };
    var days = secs / $20ee71a6d547a2a3$var$SECS_PER_DAY;
    if (Math.abs(days) < resolvedThresholds.day) return {
        value: Math.round(days),
        unit: 'day'
    };
    var fromDate = new Date(from);
    var toDate = new Date(to);
    var years = fromDate.getFullYear() - toDate.getFullYear();
    if (Math.round(Math.abs(years)) > 0) return {
        value: Math.round(years),
        unit: 'year'
    };
    var months = years * 12 + fromDate.getMonth() - toDate.getMonth();
    if (Math.round(Math.abs(months)) > 0) return {
        value: Math.round(months),
        unit: 'month'
    };
    var weeks = secs / $20ee71a6d547a2a3$var$SECS_PER_WEEK;
    return {
        value: Math.round(weeks),
        unit: 'week'
    };
}
var $20ee71a6d547a2a3$export$f4fd60e41371f80d = {
    second: 45,
    minute: 45,
    hour: 22,
    day: 5
};
module.exports["selectUnit"] = $20ee71a6d547a2a3$export$b8f7189986dd5395;

});

parcelRegister("fjPbo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3vgx3 = parcelRequire("3vgx3");


var $ixfCV = parcelRequire("ixfCV");


var $6Vsq4 = parcelRequire("6Vsq4");


var $f92oS = parcelRequire("f92oS");


var $bwJAe = parcelRequire("bwJAe");


var $k9Bpe = parcelRequire("k9Bpe");


var $cEvdy = parcelRequire("cEvdy");


var $iaxrH = parcelRequire("iaxrH");


var $6GOAK = parcelRequire("6GOAK");


var $dKFXD = parcelRequire("dKFXD");


var $4oSKE = parcelRequire("4oSKE");


var $iM6Ch = parcelRequire("iM6Ch");


var $84UG4 = parcelRequire("84UG4");


var $8dbeV = parcelRequire("8dbeV");


var $3vexH = parcelRequire("3vexH");

const $9cbbde11c9060b49$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $9cbbde11c9060b49$var$LozengeAction = ({ action: action, appearance: appearance, maxWidth: maxWidth, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex, onAfterChanged: onAfterChanged, trailingMetric: trailingMetric, shouldRenderToParent: shouldRenderToParent = false })=>{
    const [selected, setSelected] = (0, $cozmU.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $cozmU.useState)(false);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [items, setItems] = (0, $cozmU.useState)();
    const [errorMessage, setErrorMessage] = (0, $cozmU.useState)();
    const reload = (0, $cEvdy.default)();
    const invoke = (0, $bwJAe.default)();
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, invokePreviewAction: invokePreviewAction } = action?.update?.details || {};
    const handleOpenChange = (0, $cozmU.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            fireEvent('ui.button.clicked.smartLinkStatusLozenge', {});
            fireEvent('track.smartLinkQuickAction.started', {
                smartLinkActionType: (0, $6GOAK.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $f92oS.default));
                const validItems = typeof text === 'string' ? $9cbbde11c9060b49$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    fireEvent('track.smartLinkQuickAction.failed', (0, $4oSKE.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $ixfCV.fg)('confluence-issue-terminology-refresh') ? (0, $84UG4.LozengeActionErrorMessages).noDataIssueTermRefresh : (0, $84UG4.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch  {
                setErrorMessage((0, $84UG4.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                fireEvent('track.smartLinkQuickAction.failed', (0, $4oSKE.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        invoke,
        isLoaded,
        text,
        fireEvent
    ]);
    const trigger = (0, $cozmU.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vexH.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            maxWidth: maxWidth,
            testId: testId,
            text: selected.text,
            trailingMetric: trailingMetric
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        maxWidth,
        testId,
        trailingMetric
    ]);
    const handleItemClick = (0, $cozmU.useCallback)(async (id, text, appearance)=>{
        try {
            fireEvent('ui.button.clicked.smartLinkStatusListItem', {});
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $iaxrH.default)(updateAction, id);
                await invoke(request);
                onAfterChanged?.();
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: (0, $6GOAK.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload({
                    url: url,
                    isReloading: true,
                    id: linkId
                });
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $k9Bpe.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                fireEvent('track.smartLinkQuickAction.failed', (0, $4oSKE.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $84UG4.LozengeActionErrorMessages).updateFailed);
                fireEvent('track.smartLinkQuickAction.failed', (0, $4oSKE.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        invoke,
        linkId,
        reload,
        url,
        fireEvent,
        onAfterChanged
    ]);
    const dropdownItemGroup = (0, $cozmU.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iM6Ch.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            invokePreviewAction: invokePreviewAction
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8dbeV.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        invokePreviewAction,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex,
        shouldRenderToParent: shouldRenderToParent
    }, dropdownItemGroup);
};
const $9cbbde11c9060b49$var$_default_1 = (0, $dKFXD.default)($9cbbde11c9060b49$var$LozengeAction);
var $9cbbde11c9060b49$export$2e2bcd8739ae039 = $9cbbde11c9060b49$var$_default_1;
module.exports["default"] = $9cbbde11c9060b49$export$2e2bcd8739ae039;

});

parcelRegister("j2eru", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $j39Hd = parcelRequire("j39Hd");


var $eWtDJ = parcelRequire("eWtDJ");


var $c7dFC = parcelRequire("c7dFC");

const $f0965a811968f271$export$303ede4eed148855 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (cardClient)=>{
    const $ = (0, $bDgLe.c)(4);
    const resolverUrl = (0, $c7dFC.useResolverUrl)(cardClient);
    let t0;
    if ($[0] !== resolverUrl) {
        t0 = async (data)=>{
            try {
                return await (0, $j39Hd.request)("post", `${resolverUrl}/invoke`, data, undefined, [
                    200,
                    201,
                    202,
                    203,
                    204
                ]);
            } catch (t1) {
                const err = t1;
                if (err && err.json && typeof err.json === "function") {
                    const errorBody = await err.json();
                    if (errorBody) throw new (0, $eWtDJ.InvokeError)(errorBody?.error.message, errorBody?.error.status);
                }
                throw err;
            }
        };
        $[0] = resolverUrl;
        $[1] = t0;
    } else t0 = $[1];
    const invoke = t0;
    let t1;
    if ($[2] !== invoke) {
        t1 = {
            invoke: invoke
        };
        $[2] = invoke;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (cardClient)=>{
    const resolverUrl = (0, $c7dFC.useResolverUrl)(cardClient);
    const invoke = (0, $cozmU.useCallback)(async (data)=>{
        try {
            return await (0, $j39Hd.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $eWtDJ.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    return (0, $cozmU.useMemo)(()=>({
            invoke: invoke
        }), [
        invoke
    ]);
};
module.exports["useSmartLinkClientExtension"] = $f0965a811968f271$export$303ede4eed148855;

});

parcelRegister("f92oS", function(module, exports) {
const $f0be3113a19fee73$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $f0be3113a19fee73$export$2e2bcd8739ae039 = $f0be3113a19fee73$var$extractLozengeActionItems;
module.exports["default"] = $f0be3113a19fee73$export$2e2bcd8739ae039;

});

parcelRegister("iaxrH", function(module, exports) {
const $12322a86b2d18f7a$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $12322a86b2d18f7a$export$2e2bcd8739ae039 = $12322a86b2d18f7a$var$createStatusUpdateRequest;
module.exports["default"] = $12322a86b2d18f7a$export$2e2bcd8739ae039;

});

parcelRegister("dKFXD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $9KSWX = parcelRequire("9KSWX");

const $e5c8e130a6b36b08$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
                appearance: props?.appearance,
                isBold: true,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`,
                trailingMetric: props?.trailingMetric
            }, props?.text), [
            props?.appearance,
            props?.testId,
            props?.text,
            props?.trailingMetric
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props));
    };
var $e5c8e130a6b36b08$export$2e2bcd8739ae039 = $e5c8e130a6b36b08$var$withErrorBoundary;
module.exports["default"] = $e5c8e130a6b36b08$export$2e2bcd8739ae039;

});

parcelRegister("4oSKE", function(module, exports) {
const $7a40eaa9d3d6b29e$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $7a40eaa9d3d6b29e$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $7a40eaa9d3d6b29e$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $7a40eaa9d3d6b29e$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};
module.exports["unknownLoadErrorAnalyticsPayload"] = $7a40eaa9d3d6b29e$export$2a568ff99500df53;
module.exports["permissionLoadErrorAnalyticsPayload"] = $7a40eaa9d3d6b29e$export$2de2d0ccc17b915f;
module.exports["unknownUpdateErrorAnalyticsPayload"] = $7a40eaa9d3d6b29e$export$c1c05f9d51f7c467;
module.exports["validationUpdateErrorAnalyticsPayload"] = $7a40eaa9d3d6b29e$export$618660b8f2aa87e2;

});

parcelRegister("iM6Ch", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $kSwu1 = parcelRequire("kSwu1");


var $is1T6 = parcelRequire("is1T6");

var $9erVg = parcelRequire("9erVg");


var $24dy7 = parcelRequire("24dy7");


var $ixfCV = parcelRequire("ixfCV");


var $hBYtq = parcelRequire("hBYtq");


var $6Vsq4 = parcelRequire("6Vsq4");


var $dM7c5 = parcelRequire("dM7c5");


var $kfxZm = parcelRequire("kfxZm");


var $acUNT = parcelRequire("acUNT");

const $13a1bb7803caef18$var$MAX_LINE_NUMBER = 8;
const $13a1bb7803caef18$var$styles = {
    contentStyles: "_zulpu2gc _11c81d4k _1reo15vq _18m915vq _1e0c1txw _1ul9idpf _2lx2vrvc _19pkv77o _4cvr1y6m _pqmefhey _102efhey _ngc0i7uo _1t4pi7uo",
    linkStyles: "_zulpu2gc _1reo15vq _18m915vq _11c8fhey _1e0c1txw _1ul9idpf _2lx2vrvc _4cvr1h6o _80omtlke _19pku2gc _18u0xy5q _otyrv77o",
    textStylesBase: "_11c81d4k _1reo15vq _18m915vq _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
    dropdownItemGroupStyles: "_14hp1wdt _6pup1kw7 _1eo073ad",
    openIssueInJiraStyles: "_11c8fhey _bfhk1j28 _1bah1e5h _1e0c1kw7 _syaz13af _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik1r31 _1bnx8stv _jf4cnqa1 _30l312zz"
};
const $13a1bb7803caef18$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $13a1bb7803caef18$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const invoke = (0, $kfxZm.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $cozmU.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const dynamicCss = null;
    const content = (0, $cozmU.useMemo)(()=>{
        return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $13a1bb7803caef18$var$styles.contentStyles
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            testId: `${testId}-icon`,
            color: "var(--ds-icon-danger, #C9372C)",
            label: 'error',
            spacing: "spacious"
        }), /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": `${testId}-error-message`,
            className: (0, $hekY6.default)([
                $13a1bb7803caef18$var$styles.textStylesBase,
                "_1yyj1n6p _102k16q4"
            ]),
            style: {
                "--_t4prqe": (0, $9aYkv.default)(maxLineNumber)
            }
        }, typeof errorMessage === 'string' ? errorMessage : (0, $acUNT.getFormattedMessage)(errorMessage))), isPreviewAvailable ? /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $13a1bb7803caef18$var$styles.linkStyles
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.default), {
            testId: `${testId}-open-embed`,
            onClick: handlePreviewOpen,
            xcss: $13a1bb7803caef18$var$styles.openIssueInJiraStyles
        }, (0, $ixfCV.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).open_issue_in_jiraIssueTermRefresh) : /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).open_issue_in_jira))) : null);
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        testId,
        dynamicCss
    ]);
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": `${testId}-error-item-group`,
        className: (0, $hekY6.default)([
            $13a1bb7803caef18$var$styles.dropdownItemGroupStyles
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9erVg.default), null, /*#__PURE__*/ $cozmU.createElement((0, $is1T6.default), {
        testId: `${testId}-error`
    }, content)));
};
var $13a1bb7803caef18$export$2e2bcd8739ae039 = $13a1bb7803caef18$var$LozengeActionError;
module.exports["default"] = $13a1bb7803caef18$export$2e2bcd8739ae039;

});

parcelRegister("84UG4", function(module, exports) {

var $dM7c5 = parcelRequire("dM7c5");

const $ab784d52386de0cb$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $dM7c5.messages)['status_change_permission_error']
    },
    noDataIssueTermRefresh: {
        descriptor: (0, $dM7c5.messages)['status_change_permission_errorIssueTermRefresh']
    },
    unknown: {
        descriptor: (0, $dM7c5.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $dM7c5.messages)['status_change_update_error']
    }
};
module.exports["LozengeActionErrorMessages"] = $ab784d52386de0cb$export$4f2e371a667ad688;

});

parcelRegister("8dbeV", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $9erVg = parcelRequire("9erVg");


var $jgAjn = parcelRequire("jgAjn");

const $c576d9384b193cdf$var$dropdownItemGroupStyles = null;
const $c576d9384b193cdf$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>/*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": `${testId}-item-group`,
        className: (0, $hekY6.default)([
            "_c71l1mjv _18m91wug _1pv01r31 _1m1b1r31 _qh55glyw _lt2aglyw _ph3k1o36 _1twe1o36 _1ll71dpa _qprf1dpa _n6y8usvi _109gusvi _z29h1x9r _wlxp1x9r _1gfl12x7 _yhjmutpp _1gqn12x7 _11lvutpp _d4lf1f4h _14hp1wdt _6pup1kw7"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9erVg.default), null, items.map((item, idx)=>/*#__PURE__*/ $cozmU.createElement((0, $jgAjn.default), {
            ...item,
            key: idx,
            onClick: onClick,
            testId: `${testId}-item-${idx}`
        }))));
var $c576d9384b193cdf$export$2e2bcd8739ae039 = $c576d9384b193cdf$var$LozengeActionItemsGroup;
module.exports["default"] = $c576d9384b193cdf$export$2e2bcd8739ae039;

});

parcelRegister("3vexH", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $kSwu1 = parcelRequire("kSwu1");


var $7sJoX = parcelRequire("7sJoX");


var $9KSWX = parcelRequire("9KSWX");

var $1glfF = parcelRequire("1glfF");


var $ixfCV = parcelRequire("ixfCV");


var $iMnC5 = parcelRequire("iMnC5");


var $dM7c5 = parcelRequire("dM7c5");

const $2588de3e72138c31$var$styles = {
    chevronDown: "_18u012x7 _1e0c1txw",
    lozengeContainer: "_kkk2n7od _2rko12b0 _1dqonqa1 _189ee4h9 _1h6d1j28 _bfhk1j28 _1e0c1txw _4cvr1h6o _4t3i7vkz",
    lozengeContainerSelected: "_1reo15vq _18m915vq _1h6d1v1w",
    lozengeDropdownContainer: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
const $2588de3e72138c31$var$textStyles = null;
const $2588de3e72138c31$var$triggerLozengeStyles = null;
const $2588de3e72138c31$var$triggerButtonStyles = null;
const $2588de3e72138c31$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, maxWidth: maxWidth, testId: testId, text: text, triggerRef: triggerRef, trailingMetric: trailingMetric, ...props })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [isPressing, setIsPressing] = (0, $cozmU.useState)(false);
    const [lozengeBackgroundColor, setLozengeBackgroundColor] = (0, $cozmU.useState)(undefined);
    const [lozengeForegroundColor, setLozengeForegroundColor] = (0, $cozmU.useState)(undefined);
    const onMouseOrKeyDown = (0, $cozmU.useCallback)(()=>setIsPressing(true), []);
    const onMouseOrKeyUp = (0, $cozmU.useCallback)(()=>setIsPressing(false), []);
    (0, $cozmU.useEffect)(()=>{
        if (isPressing) {
            setLozengeBackgroundColor("var(--ds-background-selected-pressed, #8FB8F6)");
            setLozengeForegroundColor("var(--ds-text-selected, #1868DB)");
        } else if (isOpen) {
            setLozengeBackgroundColor("var(--ds-background-selected, #E9F2FE)");
            setLozengeForegroundColor("var(--ds-text-selected, #1868DB)");
        } else {
            setLozengeBackgroundColor(undefined);
            setLozengeForegroundColor(undefined);
        }
    }, [
        isPressing,
        isOpen
    ]);
    const lozenge = (0, $cozmU.useMemo)(()=>{
        return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: (0, $k12R1.cx)($2588de3e72138c31$var$styles.lozengeContainer, (isOpen || isPressing) && $2588de3e72138c31$var$styles.lozengeContainerSelected),
            as: "span"
        }, /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
            appearance: appearance,
            isBold: true,
            maxWidth: maxWidth,
            style: {
                backgroundColor: lozengeBackgroundColor,
                color: lozengeForegroundColor
            }
        }, /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                "_4cvr1h6o _1e0c1txw"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
            ])
        }, text), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            as: "span",
            xcss: $2588de3e72138c31$var$styles.chevronDown
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            color: "currentColor",
            label: "options",
            size: "small",
            "aria-hidden": true
        })))));
    }, [
        appearance,
        isPressing,
        text,
        isOpen,
        lozengeBackgroundColor,
        lozengeForegroundColor,
        maxWidth
    ]);
    return (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $2588de3e72138c31$var$styles.lozengeDropdownContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $1glfF.default), {
        ...props,
        appearance: appearance,
        trailingMetric: trailingMetric,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        maxWidth: maxWidth,
        testId: testId,
        ref: triggerRef,
        "aria-label": // The `as unknown` type cast is needed for react-intl v7 upgrade
        intl.formatMessage((0, $dM7c5.messages).change_status, {
            status: text
        })
    }, text)) : /*#__PURE__*/ $cozmU.createElement("button", {
        type: "button",
        ...props,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        style: {
            maxWidth: maxWidth
        },
        onMouseDown: onMouseOrKeyDown,
        onMouseUp: onMouseOrKeyUp,
        onKeyDown: onMouseOrKeyDown,
        onKeyUp: onMouseOrKeyUp,
        ref: triggerRef,
        "aria-label": // The `as unknown` type cast is needed for react-intl v7 upgrade
        intl.formatMessage((0, $dM7c5.messages).change_status, {
            status: text
        }),
        className: (0, $hekY6.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189e1dm9 _1h6d1j28 _bfhk1j28 _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas1qi0 _19h61qi0 _1d391qi0 _1ejj1y54 _1u6l1y54 _6ssh1y54"
        ])
    }, lozenge);
};
var $2588de3e72138c31$export$2e2bcd8739ae039 = $2588de3e72138c31$var$LozengeActionTrigger;
module.exports["default"] = $2588de3e72138c31$export$2e2bcd8739ae039;

});

parcelRegister("jgAjn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $is1T6 = parcelRequire("is1T6");


var $9KSWX = parcelRequire("9KSWX");

const $a1691ad9902b975e$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $cozmU.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $cozmU.useCallback)((e)=>{
        e.currentTarget?.firstElementChild?.focus();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        onFocus: handleMouseEnter,
        onMouseEnter: handleMouseEnter,
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        onClick: handleClick,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: appearance,
        isBold: true
    }, text)));
};
var $a1691ad9902b975e$export$2e2bcd8739ae039 = $a1691ad9902b975e$var$LozengeActionItem;
module.exports["default"] = $a1691ad9902b975e$export$2e2bcd8739ae039;

});


$parcel$global.rlb("lOm4J")
//# sourceMappingURL=MainButtons.1601596e.js.map
